(function () {
  const l = document.createElement("link").relList;
  if (l && l.supports && l.supports("modulepreload")) return;
  for (const c of document.querySelectorAll('link[rel="modulepreload"]')) r(c);
  new MutationObserver((c) => {
    for (const d of c)
      if (d.type === "childList")
        for (const h of d.addedNodes)
          h.tagName === "LINK" && h.rel === "modulepreload" && r(h);
  }).observe(document, { childList: !0, subtree: !0 });
  function u(c) {
    const d = {};
    return (
      c.integrity && (d.integrity = c.integrity),
      c.referrerPolicy && (d.referrerPolicy = c.referrerPolicy),
      c.crossOrigin === "use-credentials"
        ? (d.credentials = "include")
        : c.crossOrigin === "anonymous"
          ? (d.credentials = "omit")
          : (d.credentials = "same-origin"),
      d
    );
  }
  function r(c) {
    if (c.ep) return;
    c.ep = !0;
    const d = u(c);
    fetch(c.href, d);
  }
})();
function N1(a) {
  return a && a.__esModule && Object.prototype.hasOwnProperty.call(a, "default")
    ? a.default
    : a;
}
var Or = { exports: {} },
  sl = {};
var ny;
function j1() {
  if (ny) return sl;
  ny = 1;
  var a = Symbol.for("react.transitional.element"),
    l = Symbol.for("react.fragment");
  function u(r, c, d) {
    var h = null;
    if (
      (d !== void 0 && (h = "" + d),
      c.key !== void 0 && (h = "" + c.key),
      "key" in c)
    ) {
      d = {};
      for (var g in c) g !== "key" && (d[g] = c[g]);
    } else d = c;
    return (
      (c = d.ref),
      { $$typeof: a, type: r, key: h, ref: c !== void 0 ? c : null, props: d }
    );
  }
  return ((sl.Fragment = l), (sl.jsx = u), (sl.jsxs = u), sl);
}
var iy;
function L1() {
  return (iy || ((iy = 1), (Or.exports = j1())), Or.exports);
}
var Ht = L1(),
  Rr = { exports: {} },
  ul = {},
  Vr = { exports: {} },
  _r = {};
var ay;
function H1() {
  return (
    ay ||
      ((ay = 1),
      (function (a) {
        function l(V, w) {
          var F = V.length;
          V.push(w);
          t: for (; 0 < F; ) {
            var ct = (F - 1) >>> 1,
              mt = V[ct];
            if (0 < c(mt, w)) ((V[ct] = w), (V[F] = mt), (F = ct));
            else break t;
          }
        }
        function u(V) {
          return V.length === 0 ? null : V[0];
        }
        function r(V) {
          if (V.length === 0) return null;
          var w = V[0],
            F = V.pop();
          if (F !== w) {
            V[0] = F;
            t: for (var ct = 0, mt = V.length, A = mt >>> 1; ct < A; ) {
              var N = 2 * (ct + 1) - 1,
                G = V[N],
                J = N + 1,
                at = V[J];
              if (0 > c(G, F))
                J < mt && 0 > c(at, G)
                  ? ((V[ct] = at), (V[J] = F), (ct = J))
                  : ((V[ct] = G), (V[N] = F), (ct = N));
              else if (J < mt && 0 > c(at, F))
                ((V[ct] = at), (V[J] = F), (ct = J));
              else break t;
            }
          }
          return w;
        }
        function c(V, w) {
          var F = V.sortIndex - w.sortIndex;
          return F !== 0 ? F : V.id - w.id;
        }
        if (
          ((a.unstable_now = void 0),
          typeof performance == "object" &&
            typeof performance.now == "function")
        ) {
          var d = performance;
          a.unstable_now = function () {
            return d.now();
          };
        } else {
          var h = Date,
            g = h.now();
          a.unstable_now = function () {
            return h.now() - g;
          };
        }
        var p = [],
          y = [],
          v = 1,
          S = null,
          E = 3,
          z = !1,
          _ = !1,
          j = !1,
          Y = !1,
          H = typeof setTimeout == "function" ? setTimeout : null,
          q = typeof clearTimeout == "function" ? clearTimeout : null,
          L = typeof setImmediate < "u" ? setImmediate : null;
        function W(V) {
          for (var w = u(y); w !== null; ) {
            if (w.callback === null) r(y);
            else if (w.startTime <= V)
              (r(y), (w.sortIndex = w.expirationTime), l(p, w));
            else break;
            w = u(y);
          }
        }
        function P(V) {
          if (((j = !1), W(V), !_))
            if (u(p) !== null) ((_ = !0), et || ((et = !0), wt()));
            else {
              var w = u(y);
              w !== null && ue(P, w.startTime - V);
            }
        }
        var et = !1,
          $ = -1,
          K = 5,
          it = -1;
        function xt() {
          return Y ? !0 : !(a.unstable_now() - it < K);
        }
        function Bt() {
          if (((Y = !1), et)) {
            var V = a.unstable_now();
            it = V;
            var w = !0;
            try {
              t: {
                ((_ = !1), j && ((j = !1), q($), ($ = -1)), (z = !0));
                var F = E;
                try {
                  e: {
                    for (
                      W(V), S = u(p);
                      S !== null && !(S.expirationTime > V && xt());
                    ) {
                      var ct = S.callback;
                      if (typeof ct == "function") {
                        ((S.callback = null), (E = S.priorityLevel));
                        var mt = ct(S.expirationTime <= V);
                        if (((V = a.unstable_now()), typeof mt == "function")) {
                          ((S.callback = mt), W(V), (w = !0));
                          break e;
                        }
                        (S === u(p) && r(p), W(V));
                      } else r(p);
                      S = u(p);
                    }
                    if (S !== null) w = !0;
                    else {
                      var A = u(y);
                      (A !== null && ue(P, A.startTime - V), (w = !1));
                    }
                  }
                  break t;
                } finally {
                  ((S = null), (E = F), (z = !1));
                }
                w = void 0;
              }
            } finally {
              w ? wt() : (et = !1);
            }
          }
        }
        var wt;
        if (typeof L == "function")
          wt = function () {
            L(Bt);
          };
        else if (typeof MessageChannel < "u") {
          var Ye = new MessageChannel(),
            De = Ye.port2;
          ((Ye.port1.onmessage = Bt),
            (wt = function () {
              De.postMessage(null);
            }));
        } else
          wt = function () {
            H(Bt, 0);
          };
        function ue(V, w) {
          $ = H(function () {
            V(a.unstable_now());
          }, w);
        }
        ((a.unstable_IdlePriority = 5),
          (a.unstable_ImmediatePriority = 1),
          (a.unstable_LowPriority = 4),
          (a.unstable_NormalPriority = 3),
          (a.unstable_Profiling = null),
          (a.unstable_UserBlockingPriority = 2),
          (a.unstable_cancelCallback = function (V) {
            V.callback = null;
          }),
          (a.unstable_forceFrameRate = function (V) {
            0 > V || 125 < V
              ? console.error(
                  "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported",
                )
              : (K = 0 < V ? Math.floor(1e3 / V) : 5);
          }),
          (a.unstable_getCurrentPriorityLevel = function () {
            return E;
          }),
          (a.unstable_next = function (V) {
            switch (E) {
              case 1:
              case 2:
              case 3:
                var w = 3;
                break;
              default:
                w = E;
            }
            var F = E;
            E = w;
            try {
              return V();
            } finally {
              E = F;
            }
          }),
          (a.unstable_requestPaint = function () {
            Y = !0;
          }),
          (a.unstable_runWithPriority = function (V, w) {
            switch (V) {
              case 1:
              case 2:
              case 3:
              case 4:
              case 5:
                break;
              default:
                V = 3;
            }
            var F = E;
            E = V;
            try {
              return w();
            } finally {
              E = F;
            }
          }),
          (a.unstable_scheduleCallback = function (V, w, F) {
            var ct = a.unstable_now();
            switch (
              (typeof F == "object" && F !== null
                ? ((F = F.delay),
                  (F = typeof F == "number" && 0 < F ? ct + F : ct))
                : (F = ct),
              V)
            ) {
              case 1:
                var mt = -1;
                break;
              case 2:
                mt = 250;
                break;
              case 5:
                mt = 1073741823;
                break;
              case 4:
                mt = 1e4;
                break;
              default:
                mt = 5e3;
            }
            return (
              (mt = F + mt),
              (V = {
                id: v++,
                callback: w,
                priorityLevel: V,
                startTime: F,
                expirationTime: mt,
                sortIndex: -1,
              }),
              F > ct
                ? ((V.sortIndex = F),
                  l(y, V),
                  u(p) === null &&
                    V === u(y) &&
                    (j ? (q($), ($ = -1)) : (j = !0), ue(P, F - ct)))
                : ((V.sortIndex = mt),
                  l(p, V),
                  _ || z || ((_ = !0), et || ((et = !0), wt()))),
              V
            );
          }),
          (a.unstable_shouldYield = xt),
          (a.unstable_wrapCallback = function (V) {
            var w = E;
            return function () {
              var F = E;
              E = w;
              try {
                return V.apply(this, arguments);
              } finally {
                E = F;
              }
            };
          }));
      })(_r)),
    _r
  );
}
var ly;
function w1() {
  return (ly || ((ly = 1), (Vr.exports = H1())), Vr.exports);
}
var Ur = { exports: {} },
  nt = {};
var sy;
function Y1() {
  if (sy) return nt;
  sy = 1;
  var a = Symbol.for("react.transitional.element"),
    l = Symbol.for("react.portal"),
    u = Symbol.for("react.fragment"),
    r = Symbol.for("react.strict_mode"),
    c = Symbol.for("react.profiler"),
    d = Symbol.for("react.consumer"),
    h = Symbol.for("react.context"),
    g = Symbol.for("react.forward_ref"),
    p = Symbol.for("react.suspense"),
    y = Symbol.for("react.memo"),
    v = Symbol.for("react.lazy"),
    S = Symbol.for("react.activity"),
    E = Symbol.iterator;
  function z(A) {
    return A === null || typeof A != "object"
      ? null
      : ((A = (E && A[E]) || A["@@iterator"]),
        typeof A == "function" ? A : null);
  }
  var _ = {
      isMounted: function () {
        return !1;
      },
      enqueueForceUpdate: function () {},
      enqueueReplaceState: function () {},
      enqueueSetState: function () {},
    },
    j = Object.assign,
    Y = {};
  function H(A, N, G) {
    ((this.props = A),
      (this.context = N),
      (this.refs = Y),
      (this.updater = G || _));
  }
  ((H.prototype.isReactComponent = {}),
    (H.prototype.setState = function (A, N) {
      if (typeof A != "object" && typeof A != "function" && A != null)
        throw Error(
          "takes an object of state variables to update or a function which returns an object of state variables.",
        );
      this.updater.enqueueSetState(this, A, N, "setState");
    }),
    (H.prototype.forceUpdate = function (A) {
      this.updater.enqueueForceUpdate(this, A, "forceUpdate");
    }));
  function q() {}
  q.prototype = H.prototype;
  function L(A, N, G) {
    ((this.props = A),
      (this.context = N),
      (this.refs = Y),
      (this.updater = G || _));
  }
  var W = (L.prototype = new q());
  ((W.constructor = L), j(W, H.prototype), (W.isPureReactComponent = !0));
  var P = Array.isArray;
  function et() {}
  var $ = { H: null, A: null, T: null, S: null },
    K = Object.prototype.hasOwnProperty;
  function it(A, N, G) {
    var J = G.ref;
    return {
      $$typeof: a,
      type: A,
      key: N,
      ref: J !== void 0 ? J : null,
      props: G,
    };
  }
  function xt(A, N) {
    return it(A.type, N, A.props);
  }
  function Bt(A) {
    return typeof A == "object" && A !== null && A.$$typeof === a;
  }
  function wt(A) {
    var N = { "=": "=0", ":": "=2" };
    return (
      "$" +
      A.replace(/[=:]/g, function (G) {
        return N[G];
      })
    );
  }
  var Ye = /\/+/g;
  function De(A, N) {
    return typeof A == "object" && A !== null && A.key != null
      ? wt("" + A.key)
      : N.toString(36);
  }
  function ue(A) {
    switch (A.status) {
      case "fulfilled":
        return A.value;
      case "rejected":
        throw A.reason;
      default:
        switch (
          (typeof A.status == "string"
            ? A.then(et, et)
            : ((A.status = "pending"),
              A.then(
                function (N) {
                  A.status === "pending" &&
                    ((A.status = "fulfilled"), (A.value = N));
                },
                function (N) {
                  A.status === "pending" &&
                    ((A.status = "rejected"), (A.reason = N));
                },
              )),
          A.status)
        ) {
          case "fulfilled":
            return A.value;
          case "rejected":
            throw A.reason;
        }
    }
    throw A;
  }
  function V(A, N, G, J, at) {
    var ut = typeof A;
    (ut === "undefined" || ut === "boolean") && (A = null);
    var vt = !1;
    if (A === null) vt = !0;
    else
      switch (ut) {
        case "bigint":
        case "string":
        case "number":
          vt = !0;
          break;
        case "object":
          switch (A.$$typeof) {
            case a:
            case l:
              vt = !0;
              break;
            case v:
              return ((vt = A._init), V(vt(A._payload), N, G, J, at));
          }
      }
    if (vt)
      return (
        (at = at(A)),
        (vt = J === "" ? "." + De(A, 0) : J),
        P(at)
          ? ((G = ""),
            vt != null && (G = vt.replace(Ye, "$&/") + "/"),
            V(at, N, G, "", function (da) {
              return da;
            }))
          : at != null &&
            (Bt(at) &&
              (at = xt(
                at,
                G +
                  (at.key == null || (A && A.key === at.key)
                    ? ""
                    : ("" + at.key).replace(Ye, "$&/") + "/") +
                  vt,
              )),
            N.push(at)),
        1
      );
    vt = 0;
    var ie = J === "" ? "." : J + ":";
    if (P(A))
      for (var Nt = 0; Nt < A.length; Nt++)
        ((J = A[Nt]), (ut = ie + De(J, Nt)), (vt += V(J, N, G, ut, at)));
    else if (((Nt = z(A)), typeof Nt == "function"))
      for (A = Nt.call(A), Nt = 0; !(J = A.next()).done; )
        ((J = J.value), (ut = ie + De(J, Nt++)), (vt += V(J, N, G, ut, at)));
    else if (ut === "object") {
      if (typeof A.then == "function") return V(ue(A), N, G, J, at);
      throw (
        (N = String(A)),
        Error(
          "Objects are not valid as a React child (found: " +
            (N === "[object Object]"
              ? "object with keys {" + Object.keys(A).join(", ") + "}"
              : N) +
            "). If you meant to render a collection of children, use an array instead.",
        )
      );
    }
    return vt;
  }
  function w(A, N, G) {
    if (A == null) return A;
    var J = [],
      at = 0;
    return (
      V(A, J, "", "", function (ut) {
        return N.call(G, ut, at++);
      }),
      J
    );
  }
  function F(A) {
    if (A._status === -1) {
      var N = A._result;
      ((N = N()),
        N.then(
          function (G) {
            (A._status === 0 || A._status === -1) &&
              ((A._status = 1), (A._result = G));
          },
          function (G) {
            (A._status === 0 || A._status === -1) &&
              ((A._status = 2), (A._result = G));
          },
        ),
        A._status === -1 && ((A._status = 0), (A._result = N)));
    }
    if (A._status === 1) return A._result.default;
    throw A._result;
  }
  var ct =
      typeof reportError == "function"
        ? reportError
        : function (A) {
            if (
              typeof window == "object" &&
              typeof window.ErrorEvent == "function"
            ) {
              var N = new window.ErrorEvent("error", {
                bubbles: !0,
                cancelable: !0,
                message:
                  typeof A == "object" &&
                  A !== null &&
                  typeof A.message == "string"
                    ? String(A.message)
                    : String(A),
                error: A,
              });
              if (!window.dispatchEvent(N)) return;
            } else if (
              typeof process == "object" &&
              typeof process.emit == "function"
            ) {
              process.emit("uncaughtException", A);
              return;
            }
            console.error(A);
          },
    mt = {
      map: w,
      forEach: function (A, N, G) {
        w(
          A,
          function () {
            N.apply(this, arguments);
          },
          G,
        );
      },
      count: function (A) {
        var N = 0;
        return (
          w(A, function () {
            N++;
          }),
          N
        );
      },
      toArray: function (A) {
        return (
          w(A, function (N) {
            return N;
          }) || []
        );
      },
      only: function (A) {
        if (!Bt(A))
          throw Error(
            "React.Children.only expected to receive a single React element child.",
          );
        return A;
      },
    };
  return (
    (nt.Activity = S),
    (nt.Children = mt),
    (nt.Component = H),
    (nt.Fragment = u),
    (nt.Profiler = c),
    (nt.PureComponent = L),
    (nt.StrictMode = r),
    (nt.Suspense = p),
    (nt.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = $),
    (nt.__COMPILER_RUNTIME = {
      __proto__: null,
      c: function (A) {
        return $.H.useMemoCache(A);
      },
    }),
    (nt.cache = function (A) {
      return function () {
        return A.apply(null, arguments);
      };
    }),
    (nt.cacheSignal = function () {
      return null;
    }),
    (nt.cloneElement = function (A, N, G) {
      if (A == null)
        throw Error(
          "The argument must be a React element, but you passed " + A + ".",
        );
      var J = j({}, A.props),
        at = A.key;
      if (N != null)
        for (ut in (N.key !== void 0 && (at = "" + N.key), N))
          !K.call(N, ut) ||
            ut === "key" ||
            ut === "__self" ||
            ut === "__source" ||
            (ut === "ref" && N.ref === void 0) ||
            (J[ut] = N[ut]);
      var ut = arguments.length - 2;
      if (ut === 1) J.children = G;
      else if (1 < ut) {
        for (var vt = Array(ut), ie = 0; ie < ut; ie++)
          vt[ie] = arguments[ie + 2];
        J.children = vt;
      }
      return it(A.type, at, J);
    }),
    (nt.createContext = function (A) {
      return (
        (A = {
          $$typeof: h,
          _currentValue: A,
          _currentValue2: A,
          _threadCount: 0,
          Provider: null,
          Consumer: null,
        }),
        (A.Provider = A),
        (A.Consumer = { $$typeof: d, _context: A }),
        A
      );
    }),
    (nt.createElement = function (A, N, G) {
      var J,
        at = {},
        ut = null;
      if (N != null)
        for (J in (N.key !== void 0 && (ut = "" + N.key), N))
          K.call(N, J) &&
            J !== "key" &&
            J !== "__self" &&
            J !== "__source" &&
            (at[J] = N[J]);
      var vt = arguments.length - 2;
      if (vt === 1) at.children = G;
      else if (1 < vt) {
        for (var ie = Array(vt), Nt = 0; Nt < vt; Nt++)
          ie[Nt] = arguments[Nt + 2];
        at.children = ie;
      }
      if (A && A.defaultProps)
        for (J in ((vt = A.defaultProps), vt))
          at[J] === void 0 && (at[J] = vt[J]);
      return it(A, ut, at);
    }),
    (nt.createRef = function () {
      return { current: null };
    }),
    (nt.forwardRef = function (A) {
      return { $$typeof: g, render: A };
    }),
    (nt.isValidElement = Bt),
    (nt.lazy = function (A) {
      return { $$typeof: v, _payload: { _status: -1, _result: A }, _init: F };
    }),
    (nt.memo = function (A, N) {
      return { $$typeof: y, type: A, compare: N === void 0 ? null : N };
    }),
    (nt.startTransition = function (A) {
      var N = $.T,
        G = {};
      $.T = G;
      try {
        var J = A(),
          at = $.S;
        (at !== null && at(G, J),
          typeof J == "object" &&
            J !== null &&
            typeof J.then == "function" &&
            J.then(et, ct));
      } catch (ut) {
        ct(ut);
      } finally {
        (N !== null && G.types !== null && (N.types = G.types), ($.T = N));
      }
    }),
    (nt.unstable_useCacheRefresh = function () {
      return $.H.useCacheRefresh();
    }),
    (nt.use = function (A) {
      return $.H.use(A);
    }),
    (nt.useActionState = function (A, N, G) {
      return $.H.useActionState(A, N, G);
    }),
    (nt.useCallback = function (A, N) {
      return $.H.useCallback(A, N);
    }),
    (nt.useContext = function (A) {
      return $.H.useContext(A);
    }),
    (nt.useDebugValue = function () {}),
    (nt.useDeferredValue = function (A, N) {
      return $.H.useDeferredValue(A, N);
    }),
    (nt.useEffect = function (A, N) {
      return $.H.useEffect(A, N);
    }),
    (nt.useEffectEvent = function (A) {
      return $.H.useEffectEvent(A);
    }),
    (nt.useId = function () {
      return $.H.useId();
    }),
    (nt.useImperativeHandle = function (A, N, G) {
      return $.H.useImperativeHandle(A, N, G);
    }),
    (nt.useInsertionEffect = function (A, N) {
      return $.H.useInsertionEffect(A, N);
    }),
    (nt.useLayoutEffect = function (A, N) {
      return $.H.useLayoutEffect(A, N);
    }),
    (nt.useMemo = function (A, N) {
      return $.H.useMemo(A, N);
    }),
    (nt.useOptimistic = function (A, N) {
      return $.H.useOptimistic(A, N);
    }),
    (nt.useReducer = function (A, N, G) {
      return $.H.useReducer(A, N, G);
    }),
    (nt.useRef = function (A) {
      return $.H.useRef(A);
    }),
    (nt.useState = function (A) {
      return $.H.useState(A);
    }),
    (nt.useSyncExternalStore = function (A, N, G) {
      return $.H.useSyncExternalStore(A, N, G);
    }),
    (nt.useTransition = function () {
      return $.H.useTransition();
    }),
    (nt.version = "19.2.3"),
    nt
  );
}
var uy;
function bc() {
  return (uy || ((uy = 1), (Ur.exports = Y1())), Ur.exports);
}
var Br = { exports: {} },
  ee = {};
var oy;
function q1() {
  if (oy) return ee;
  oy = 1;
  var a = bc();
  function l(p) {
    var y = "https://react.dev/errors/" + p;
    if (1 < arguments.length) {
      y += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var v = 2; v < arguments.length; v++)
        y += "&args[]=" + encodeURIComponent(arguments[v]);
    }
    return (
      "Minified React error #" +
      p +
      "; visit " +
      y +
      " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
    );
  }
  function u() {}
  var r = {
      d: {
        f: u,
        r: function () {
          throw Error(l(522));
        },
        D: u,
        C: u,
        L: u,
        m: u,
        X: u,
        S: u,
        M: u,
      },
      p: 0,
      findDOMNode: null,
    },
    c = Symbol.for("react.portal");
  function d(p, y, v) {
    var S =
      3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return {
      $$typeof: c,
      key: S == null ? null : "" + S,
      children: p,
      containerInfo: y,
      implementation: v,
    };
  }
  var h = a.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  function g(p, y) {
    if (p === "font") return "";
    if (typeof y == "string") return y === "use-credentials" ? y : "";
  }
  return (
    (ee.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = r),
    (ee.createPortal = function (p, y) {
      var v =
        2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
      if (!y || (y.nodeType !== 1 && y.nodeType !== 9 && y.nodeType !== 11))
        throw Error(l(299));
      return d(p, y, null, v);
    }),
    (ee.flushSync = function (p) {
      var y = h.T,
        v = r.p;
      try {
        if (((h.T = null), (r.p = 2), p)) return p();
      } finally {
        ((h.T = y), (r.p = v), r.d.f());
      }
    }),
    (ee.preconnect = function (p, y) {
      typeof p == "string" &&
        (y
          ? ((y = y.crossOrigin),
            (y =
              typeof y == "string"
                ? y === "use-credentials"
                  ? y
                  : ""
                : void 0))
          : (y = null),
        r.d.C(p, y));
    }),
    (ee.prefetchDNS = function (p) {
      typeof p == "string" && r.d.D(p);
    }),
    (ee.preinit = function (p, y) {
      if (typeof p == "string" && y && typeof y.as == "string") {
        var v = y.as,
          S = g(v, y.crossOrigin),
          E = typeof y.integrity == "string" ? y.integrity : void 0,
          z = typeof y.fetchPriority == "string" ? y.fetchPriority : void 0;
        v === "style"
          ? r.d.S(p, typeof y.precedence == "string" ? y.precedence : void 0, {
              crossOrigin: S,
              integrity: E,
              fetchPriority: z,
            })
          : v === "script" &&
            r.d.X(p, {
              crossOrigin: S,
              integrity: E,
              fetchPriority: z,
              nonce: typeof y.nonce == "string" ? y.nonce : void 0,
            });
      }
    }),
    (ee.preinitModule = function (p, y) {
      if (typeof p == "string")
        if (typeof y == "object" && y !== null) {
          if (y.as == null || y.as === "script") {
            var v = g(y.as, y.crossOrigin);
            r.d.M(p, {
              crossOrigin: v,
              integrity: typeof y.integrity == "string" ? y.integrity : void 0,
              nonce: typeof y.nonce == "string" ? y.nonce : void 0,
            });
          }
        } else y == null && r.d.M(p);
    }),
    (ee.preload = function (p, y) {
      if (
        typeof p == "string" &&
        typeof y == "object" &&
        y !== null &&
        typeof y.as == "string"
      ) {
        var v = y.as,
          S = g(v, y.crossOrigin);
        r.d.L(p, v, {
          crossOrigin: S,
          integrity: typeof y.integrity == "string" ? y.integrity : void 0,
          nonce: typeof y.nonce == "string" ? y.nonce : void 0,
          type: typeof y.type == "string" ? y.type : void 0,
          fetchPriority:
            typeof y.fetchPriority == "string" ? y.fetchPriority : void 0,
          referrerPolicy:
            typeof y.referrerPolicy == "string" ? y.referrerPolicy : void 0,
          imageSrcSet:
            typeof y.imageSrcSet == "string" ? y.imageSrcSet : void 0,
          imageSizes: typeof y.imageSizes == "string" ? y.imageSizes : void 0,
          media: typeof y.media == "string" ? y.media : void 0,
        });
      }
    }),
    (ee.preloadModule = function (p, y) {
      if (typeof p == "string")
        if (y) {
          var v = g(y.as, y.crossOrigin);
          r.d.m(p, {
            as: typeof y.as == "string" && y.as !== "script" ? y.as : void 0,
            crossOrigin: v,
            integrity: typeof y.integrity == "string" ? y.integrity : void 0,
          });
        } else r.d.m(p);
    }),
    (ee.requestFormReset = function (p) {
      r.d.r(p);
    }),
    (ee.unstable_batchedUpdates = function (p, y) {
      return p(y);
    }),
    (ee.useFormState = function (p, y, v) {
      return h.H.useFormState(p, y, v);
    }),
    (ee.useFormStatus = function () {
      return h.H.useHostTransitionStatus();
    }),
    (ee.version = "19.2.3"),
    ee
  );
}
var ry;
function G1() {
  if (ry) return Br.exports;
  ry = 1;
  function a() {
    if (
      !(
        typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" ||
        typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"
      )
    )
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(a);
      } catch (l) {
        console.error(l);
      }
  }
  return (a(), (Br.exports = q1()), Br.exports);
}
var cy;
function X1() {
  if (cy) return ul;
  cy = 1;
  var a = w1(),
    l = bc(),
    u = G1();
  function r(t) {
    var e = "https://react.dev/errors/" + t;
    if (1 < arguments.length) {
      e += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var n = 2; n < arguments.length; n++)
        e += "&args[]=" + encodeURIComponent(arguments[n]);
    }
    return (
      "Minified React error #" +
      t +
      "; visit " +
      e +
      " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
    );
  }
  function c(t) {
    return !(!t || (t.nodeType !== 1 && t.nodeType !== 9 && t.nodeType !== 11));
  }
  function d(t) {
    var e = t,
      n = t;
    if (t.alternate) for (; e.return; ) e = e.return;
    else {
      t = e;
      do ((e = t), (e.flags & 4098) !== 0 && (n = e.return), (t = e.return));
      while (t);
    }
    return e.tag === 3 ? n : null;
  }
  function h(t) {
    if (t.tag === 13) {
      var e = t.memoizedState;
      if (
        (e === null && ((t = t.alternate), t !== null && (e = t.memoizedState)),
        e !== null)
      )
        return e.dehydrated;
    }
    return null;
  }
  function g(t) {
    if (t.tag === 31) {
      var e = t.memoizedState;
      if (
        (e === null && ((t = t.alternate), t !== null && (e = t.memoizedState)),
        e !== null)
      )
        return e.dehydrated;
    }
    return null;
  }
  function p(t) {
    if (d(t) !== t) throw Error(r(188));
  }
  function y(t) {
    var e = t.alternate;
    if (!e) {
      if (((e = d(t)), e === null)) throw Error(r(188));
      return e !== t ? null : t;
    }
    for (var n = t, i = e; ; ) {
      var s = n.return;
      if (s === null) break;
      var o = s.alternate;
      if (o === null) {
        if (((i = s.return), i !== null)) {
          n = i;
          continue;
        }
        break;
      }
      if (s.child === o.child) {
        for (o = s.child; o; ) {
          if (o === n) return (p(s), t);
          if (o === i) return (p(s), e);
          o = o.sibling;
        }
        throw Error(r(188));
      }
      if (n.return !== i.return) ((n = s), (i = o));
      else {
        for (var f = !1, m = s.child; m; ) {
          if (m === n) {
            ((f = !0), (n = s), (i = o));
            break;
          }
          if (m === i) {
            ((f = !0), (i = s), (n = o));
            break;
          }
          m = m.sibling;
        }
        if (!f) {
          for (m = o.child; m; ) {
            if (m === n) {
              ((f = !0), (n = o), (i = s));
              break;
            }
            if (m === i) {
              ((f = !0), (i = o), (n = s));
              break;
            }
            m = m.sibling;
          }
          if (!f) throw Error(r(189));
        }
      }
      if (n.alternate !== i) throw Error(r(190));
    }
    if (n.tag !== 3) throw Error(r(188));
    return n.stateNode.current === n ? t : e;
  }
  function v(t) {
    var e = t.tag;
    if (e === 5 || e === 26 || e === 27 || e === 6) return t;
    for (t = t.child; t !== null; ) {
      if (((e = v(t)), e !== null)) return e;
      t = t.sibling;
    }
    return null;
  }
  var S = Object.assign,
    E = Symbol.for("react.element"),
    z = Symbol.for("react.transitional.element"),
    _ = Symbol.for("react.portal"),
    j = Symbol.for("react.fragment"),
    Y = Symbol.for("react.strict_mode"),
    H = Symbol.for("react.profiler"),
    q = Symbol.for("react.consumer"),
    L = Symbol.for("react.context"),
    W = Symbol.for("react.forward_ref"),
    P = Symbol.for("react.suspense"),
    et = Symbol.for("react.suspense_list"),
    $ = Symbol.for("react.memo"),
    K = Symbol.for("react.lazy"),
    it = Symbol.for("react.activity"),
    xt = Symbol.for("react.memo_cache_sentinel"),
    Bt = Symbol.iterator;
  function wt(t) {
    return t === null || typeof t != "object"
      ? null
      : ((t = (Bt && t[Bt]) || t["@@iterator"]),
        typeof t == "function" ? t : null);
  }
  var Ye = Symbol.for("react.client.reference");
  function De(t) {
    if (t == null) return null;
    if (typeof t == "function")
      return t.$$typeof === Ye ? null : t.displayName || t.name || null;
    if (typeof t == "string") return t;
    switch (t) {
      case j:
        return "Fragment";
      case H:
        return "Profiler";
      case Y:
        return "StrictMode";
      case P:
        return "Suspense";
      case et:
        return "SuspenseList";
      case it:
        return "Activity";
    }
    if (typeof t == "object")
      switch (t.$$typeof) {
        case _:
          return "Portal";
        case L:
          return t.displayName || "Context";
        case q:
          return (t._context.displayName || "Context") + ".Consumer";
        case W:
          var e = t.render;
          return (
            (t = t.displayName),
            t ||
              ((t = e.displayName || e.name || ""),
              (t = t !== "" ? "ForwardRef(" + t + ")" : "ForwardRef")),
            t
          );
        case $:
          return (
            (e = t.displayName || null),
            e !== null ? e : De(t.type) || "Memo"
          );
        case K:
          ((e = t._payload), (t = t._init));
          try {
            return De(t(e));
          } catch {}
      }
    return null;
  }
  var ue = Array.isArray,
    V = l.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
    w = u.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
    F = { pending: !1, data: null, method: null, action: null },
    ct = [],
    mt = -1;
  function A(t) {
    return { current: t };
  }
  function N(t) {
    0 > mt || ((t.current = ct[mt]), (ct[mt] = null), mt--);
  }
  function G(t, e) {
    (mt++, (ct[mt] = t.current), (t.current = e));
  }
  var J = A(null),
    at = A(null),
    ut = A(null),
    vt = A(null);
  function ie(t, e) {
    switch ((G(ut, e), G(at, t), G(J, null), e.nodeType)) {
      case 9:
      case 11:
        t = (t = e.documentElement) && (t = t.namespaceURI) ? xm(t) : 0;
        break;
      default:
        if (((t = e.tagName), (e = e.namespaceURI)))
          ((e = xm(e)), (t = Dm(e, t)));
        else
          switch (t) {
            case "svg":
              t = 1;
              break;
            case "math":
              t = 2;
              break;
            default:
              t = 0;
          }
    }
    (N(J), G(J, t));
  }
  function Nt() {
    (N(J), N(at), N(ut));
  }
  function da(t) {
    t.memoizedState !== null && G(vt, t);
    var e = J.current,
      n = Dm(e, t.type);
    e !== n && (G(at, t), G(J, n));
  }
  function xl(t) {
    (at.current === t && (N(J), N(at)),
      vt.current === t && (N(vt), (nl._currentValue = F)));
  }
  var cu, tf;
  function kn(t) {
    if (cu === void 0)
      try {
        throw Error();
      } catch (n) {
        var e = n.stack.trim().match(/\n( *(at )?)/);
        ((cu = (e && e[1]) || ""),
          (tf =
            -1 <
            n.stack.indexOf(`
    at`)
              ? " (<anonymous>)"
              : -1 < n.stack.indexOf("@")
                ? "@unknown:0:0"
                : ""));
      }
    return (
      `
` +
      cu +
      t +
      tf
    );
  }
  var fu = !1;
  function hu(t, e) {
    if (!t || fu) return "";
    fu = !0;
    var n = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var i = {
        DetermineComponentFrameRoot: function () {
          try {
            if (e) {
              var B = function () {
                throw Error();
              };
              if (
                (Object.defineProperty(B.prototype, "props", {
                  set: function () {
                    throw Error();
                  },
                }),
                typeof Reflect == "object" && Reflect.construct)
              ) {
                try {
                  Reflect.construct(B, []);
                } catch (O) {
                  var C = O;
                }
                Reflect.construct(t, [], B);
              } else {
                try {
                  B.call();
                } catch (O) {
                  C = O;
                }
                t.call(B.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (O) {
                C = O;
              }
              (B = t()) &&
                typeof B.catch == "function" &&
                B.catch(function () {});
            }
          } catch (O) {
            if (O && C && typeof O.stack == "string") return [O.stack, C.stack];
          }
          return [null, null];
        },
      };
      i.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var s = Object.getOwnPropertyDescriptor(
        i.DetermineComponentFrameRoot,
        "name",
      );
      s &&
        s.configurable &&
        Object.defineProperty(i.DetermineComponentFrameRoot, "name", {
          value: "DetermineComponentFrameRoot",
        });
      var o = i.DetermineComponentFrameRoot(),
        f = o[0],
        m = o[1];
      if (f && m) {
        var T = f.split(`
`),
          D = m.split(`
`);
        for (
          s = i = 0;
          i < T.length && !T[i].includes("DetermineComponentFrameRoot");
        )
          i++;
        for (; s < D.length && !D[s].includes("DetermineComponentFrameRoot"); )
          s++;
        if (i === T.length || s === D.length)
          for (
            i = T.length - 1, s = D.length - 1;
            1 <= i && 0 <= s && T[i] !== D[s];
          )
            s--;
        for (; 1 <= i && 0 <= s; i--, s--)
          if (T[i] !== D[s]) {
            if (i !== 1 || s !== 1)
              do
                if ((i--, s--, 0 > s || T[i] !== D[s])) {
                  var R =
                    `
` + T[i].replace(" at new ", " at ");
                  return (
                    t.displayName &&
                      R.includes("<anonymous>") &&
                      (R = R.replace("<anonymous>", t.displayName)),
                    R
                  );
                }
              while (1 <= i && 0 <= s);
            break;
          }
      }
    } finally {
      ((fu = !1), (Error.prepareStackTrace = n));
    }
    return (n = t ? t.displayName || t.name : "") ? kn(n) : "";
  }
  function h0(t, e) {
    switch (t.tag) {
      case 26:
      case 27:
      case 5:
        return kn(t.type);
      case 16:
        return kn("Lazy");
      case 13:
        return t.child !== e && e !== null
          ? kn("Suspense Fallback")
          : kn("Suspense");
      case 19:
        return kn("SuspenseList");
      case 0:
      case 15:
        return hu(t.type, !1);
      case 11:
        return hu(t.type.render, !1);
      case 1:
        return hu(t.type, !0);
      case 31:
        return kn("Activity");
      default:
        return "";
    }
  }
  function ef(t) {
    try {
      var e = "",
        n = null;
      do ((e += h0(t, n)), (n = t), (t = t.return));
      while (t);
      return e;
    } catch (i) {
      return (
        `
Error generating stack: ` +
        i.message +
        `
` +
        i.stack
      );
    }
  }
  var du = Object.prototype.hasOwnProperty,
    mu = a.unstable_scheduleCallback,
    yu = a.unstable_cancelCallback,
    d0 = a.unstable_shouldYield,
    m0 = a.unstable_requestPaint,
    ye = a.unstable_now,
    y0 = a.unstable_getCurrentPriorityLevel,
    nf = a.unstable_ImmediatePriority,
    af = a.unstable_UserBlockingPriority,
    Dl = a.unstable_NormalPriority,
    p0 = a.unstable_LowPriority,
    lf = a.unstable_IdlePriority,
    g0 = a.log,
    v0 = a.unstable_setDisableYieldValue,
    ma = null,
    pe = null;
  function Sn(t) {
    if (
      (typeof g0 == "function" && v0(t),
      pe && typeof pe.setStrictMode == "function")
    )
      try {
        pe.setStrictMode(ma, t);
      } catch {}
  }
  var ge = Math.clz32 ? Math.clz32 : b0,
    S0 = Math.log,
    T0 = Math.LN2;
  function b0(t) {
    return ((t >>>= 0), t === 0 ? 32 : (31 - ((S0(t) / T0) | 0)) | 0);
  }
  var Cl = 256,
    zl = 262144,
    Ol = 4194304;
  function Wn(t) {
    var e = t & 42;
    if (e !== 0) return e;
    switch (t & -t) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
        return t & 261888;
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return t & 3932160;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return t & 62914560;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return t;
    }
  }
  function Rl(t, e, n) {
    var i = t.pendingLanes;
    if (i === 0) return 0;
    var s = 0,
      o = t.suspendedLanes,
      f = t.pingedLanes;
    t = t.warmLanes;
    var m = i & 134217727;
    return (
      m !== 0
        ? ((i = m & ~o),
          i !== 0
            ? (s = Wn(i))
            : ((f &= m),
              f !== 0
                ? (s = Wn(f))
                : n || ((n = m & ~t), n !== 0 && (s = Wn(n)))))
        : ((m = i & ~o),
          m !== 0
            ? (s = Wn(m))
            : f !== 0
              ? (s = Wn(f))
              : n || ((n = i & ~t), n !== 0 && (s = Wn(n)))),
      s === 0
        ? 0
        : e !== 0 &&
            e !== s &&
            (e & o) === 0 &&
            ((o = s & -s),
            (n = e & -e),
            o >= n || (o === 32 && (n & 4194048) !== 0))
          ? e
          : s
    );
  }
  function ya(t, e) {
    return (t.pendingLanes & ~(t.suspendedLanes & ~t.pingedLanes) & e) === 0;
  }
  function A0(t, e) {
    switch (t) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return e + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return e + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return -1;
      case 67108864:
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function sf() {
    var t = Ol;
    return ((Ol <<= 1), (Ol & 62914560) === 0 && (Ol = 4194304), t);
  }
  function pu(t) {
    for (var e = [], n = 0; 31 > n; n++) e.push(t);
    return e;
  }
  function pa(t, e) {
    ((t.pendingLanes |= e),
      e !== 268435456 &&
        ((t.suspendedLanes = 0), (t.pingedLanes = 0), (t.warmLanes = 0)));
  }
  function E0(t, e, n, i, s, o) {
    var f = t.pendingLanes;
    ((t.pendingLanes = n),
      (t.suspendedLanes = 0),
      (t.pingedLanes = 0),
      (t.warmLanes = 0),
      (t.expiredLanes &= n),
      (t.entangledLanes &= n),
      (t.errorRecoveryDisabledLanes &= n),
      (t.shellSuspendCounter = 0));
    var m = t.entanglements,
      T = t.expirationTimes,
      D = t.hiddenUpdates;
    for (n = f & ~n; 0 < n; ) {
      var R = 31 - ge(n),
        B = 1 << R;
      ((m[R] = 0), (T[R] = -1));
      var C = D[R];
      if (C !== null)
        for (D[R] = null, R = 0; R < C.length; R++) {
          var O = C[R];
          O !== null && (O.lane &= -536870913);
        }
      n &= ~B;
    }
    (i !== 0 && uf(t, i, 0),
      o !== 0 && s === 0 && t.tag !== 0 && (t.suspendedLanes |= o & ~(f & ~e)));
  }
  function uf(t, e, n) {
    ((t.pendingLanes |= e), (t.suspendedLanes &= ~e));
    var i = 31 - ge(e);
    ((t.entangledLanes |= e),
      (t.entanglements[i] = t.entanglements[i] | 1073741824 | (n & 261930)));
  }
  function of(t, e) {
    var n = (t.entangledLanes |= e);
    for (t = t.entanglements; n; ) {
      var i = 31 - ge(n),
        s = 1 << i;
      ((s & e) | (t[i] & e) && (t[i] |= e), (n &= ~s));
    }
  }
  function rf(t, e) {
    var n = e & -e;
    return (
      (n = (n & 42) !== 0 ? 1 : gu(n)),
      (n & (t.suspendedLanes | e)) !== 0 ? 0 : n
    );
  }
  function gu(t) {
    switch (t) {
      case 2:
        t = 1;
        break;
      case 8:
        t = 4;
        break;
      case 32:
        t = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        t = 128;
        break;
      case 268435456:
        t = 134217728;
        break;
      default:
        t = 0;
    }
    return t;
  }
  function vu(t) {
    return (
      (t &= -t),
      2 < t ? (8 < t ? ((t & 134217727) !== 0 ? 32 : 268435456) : 8) : 2
    );
  }
  function cf() {
    var t = w.p;
    return t !== 0 ? t : ((t = window.event), t === void 0 ? 32 : km(t.type));
  }
  function ff(t, e) {
    var n = w.p;
    try {
      return ((w.p = t), e());
    } finally {
      w.p = n;
    }
  }
  var Tn = Math.random().toString(36).slice(2),
    kt = "__reactFiber$" + Tn,
    oe = "__reactProps$" + Tn,
    Ti = "__reactContainer$" + Tn,
    Su = "__reactEvents$" + Tn,
    M0 = "__reactListeners$" + Tn,
    x0 = "__reactHandles$" + Tn,
    hf = "__reactResources$" + Tn,
    ga = "__reactMarker$" + Tn;
  function Tu(t) {
    (delete t[kt], delete t[oe], delete t[Su], delete t[M0], delete t[x0]);
  }
  function bi(t) {
    var e = t[kt];
    if (e) return e;
    for (var n = t.parentNode; n; ) {
      if ((e = n[Ti] || n[kt])) {
        if (
          ((n = e.alternate),
          e.child !== null || (n !== null && n.child !== null))
        )
          for (t = Um(t); t !== null; ) {
            if ((n = t[kt])) return n;
            t = Um(t);
          }
        return e;
      }
      ((t = n), (n = t.parentNode));
    }
    return null;
  }
  function Ai(t) {
    if ((t = t[kt] || t[Ti])) {
      var e = t.tag;
      if (
        e === 5 ||
        e === 6 ||
        e === 13 ||
        e === 31 ||
        e === 26 ||
        e === 27 ||
        e === 3
      )
        return t;
    }
    return null;
  }
  function va(t) {
    var e = t.tag;
    if (e === 5 || e === 26 || e === 27 || e === 6) return t.stateNode;
    throw Error(r(33));
  }
  function Ei(t) {
    var e = t[hf];
    return (
      e ||
        (e = t[hf] =
          { hoistableStyles: new Map(), hoistableScripts: new Map() }),
      e
    );
  }
  function Jt(t) {
    t[ga] = !0;
  }
  var df = new Set(),
    mf = {};
  function Pn(t, e) {
    (Mi(t, e), Mi(t + "Capture", e));
  }
  function Mi(t, e) {
    for (mf[t] = e, t = 0; t < e.length; t++) df.add(e[t]);
  }
  var D0 = RegExp(
      "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$",
    ),
    yf = {},
    pf = {};
  function C0(t) {
    return du.call(pf, t)
      ? !0
      : du.call(yf, t)
        ? !1
        : D0.test(t)
          ? (pf[t] = !0)
          : ((yf[t] = !0), !1);
  }
  function Vl(t, e, n) {
    if (C0(e))
      if (n === null) t.removeAttribute(e);
      else {
        switch (typeof n) {
          case "undefined":
          case "function":
          case "symbol":
            t.removeAttribute(e);
            return;
          case "boolean":
            var i = e.toLowerCase().slice(0, 5);
            if (i !== "data-" && i !== "aria-") {
              t.removeAttribute(e);
              return;
            }
        }
        t.setAttribute(e, "" + n);
      }
  }
  function _l(t, e, n) {
    if (n === null) t.removeAttribute(e);
    else {
      switch (typeof n) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          t.removeAttribute(e);
          return;
      }
      t.setAttribute(e, "" + n);
    }
  }
  function $e(t, e, n, i) {
    if (i === null) t.removeAttribute(n);
    else {
      switch (typeof i) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          t.removeAttribute(n);
          return;
      }
      t.setAttributeNS(e, n, "" + i);
    }
  }
  function Ce(t) {
    switch (typeof t) {
      case "bigint":
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return t;
      case "object":
        return t;
      default:
        return "";
    }
  }
  function gf(t) {
    var e = t.type;
    return (
      (t = t.nodeName) &&
      t.toLowerCase() === "input" &&
      (e === "checkbox" || e === "radio")
    );
  }
  function z0(t, e, n) {
    var i = Object.getOwnPropertyDescriptor(t.constructor.prototype, e);
    if (
      !t.hasOwnProperty(e) &&
      typeof i < "u" &&
      typeof i.get == "function" &&
      typeof i.set == "function"
    ) {
      var s = i.get,
        o = i.set;
      return (
        Object.defineProperty(t, e, {
          configurable: !0,
          get: function () {
            return s.call(this);
          },
          set: function (f) {
            ((n = "" + f), o.call(this, f));
          },
        }),
        Object.defineProperty(t, e, { enumerable: i.enumerable }),
        {
          getValue: function () {
            return n;
          },
          setValue: function (f) {
            n = "" + f;
          },
          stopTracking: function () {
            ((t._valueTracker = null), delete t[e]);
          },
        }
      );
    }
  }
  function bu(t) {
    if (!t._valueTracker) {
      var e = gf(t) ? "checked" : "value";
      t._valueTracker = z0(t, e, "" + t[e]);
    }
  }
  function vf(t) {
    if (!t) return !1;
    var e = t._valueTracker;
    if (!e) return !0;
    var n = e.getValue(),
      i = "";
    return (
      t && (i = gf(t) ? (t.checked ? "true" : "false") : t.value),
      (t = i),
      t !== n ? (e.setValue(t), !0) : !1
    );
  }
  function Ul(t) {
    if (
      ((t = t || (typeof document < "u" ? document : void 0)), typeof t > "u")
    )
      return null;
    try {
      return t.activeElement || t.body;
    } catch {
      return t.body;
    }
  }
  var O0 = /[\n"\\]/g;
  function ze(t) {
    return t.replace(O0, function (e) {
      return "\\" + e.charCodeAt(0).toString(16) + " ";
    });
  }
  function Au(t, e, n, i, s, o, f, m) {
    ((t.name = ""),
      f != null &&
      typeof f != "function" &&
      typeof f != "symbol" &&
      typeof f != "boolean"
        ? (t.type = f)
        : t.removeAttribute("type"),
      e != null
        ? f === "number"
          ? ((e === 0 && t.value === "") || t.value != e) &&
            (t.value = "" + Ce(e))
          : t.value !== "" + Ce(e) && (t.value = "" + Ce(e))
        : (f !== "submit" && f !== "reset") || t.removeAttribute("value"),
      e != null
        ? Eu(t, f, Ce(e))
        : n != null
          ? Eu(t, f, Ce(n))
          : i != null && t.removeAttribute("value"),
      s == null && o != null && (t.defaultChecked = !!o),
      s != null &&
        (t.checked = s && typeof s != "function" && typeof s != "symbol"),
      m != null &&
      typeof m != "function" &&
      typeof m != "symbol" &&
      typeof m != "boolean"
        ? (t.name = "" + Ce(m))
        : t.removeAttribute("name"));
  }
  function Sf(t, e, n, i, s, o, f, m) {
    if (
      (o != null &&
        typeof o != "function" &&
        typeof o != "symbol" &&
        typeof o != "boolean" &&
        (t.type = o),
      e != null || n != null)
    ) {
      if (!((o !== "submit" && o !== "reset") || e != null)) {
        bu(t);
        return;
      }
      ((n = n != null ? "" + Ce(n) : ""),
        (e = e != null ? "" + Ce(e) : n),
        m || e === t.value || (t.value = e),
        (t.defaultValue = e));
    }
    ((i = i ?? s),
      (i = typeof i != "function" && typeof i != "symbol" && !!i),
      (t.checked = m ? t.checked : !!i),
      (t.defaultChecked = !!i),
      f != null &&
        typeof f != "function" &&
        typeof f != "symbol" &&
        typeof f != "boolean" &&
        (t.name = f),
      bu(t));
  }
  function Eu(t, e, n) {
    (e === "number" && Ul(t.ownerDocument) === t) ||
      t.defaultValue === "" + n ||
      (t.defaultValue = "" + n);
  }
  function xi(t, e, n, i) {
    if (((t = t.options), e)) {
      e = {};
      for (var s = 0; s < n.length; s++) e["$" + n[s]] = !0;
      for (n = 0; n < t.length; n++)
        ((s = e.hasOwnProperty("$" + t[n].value)),
          t[n].selected !== s && (t[n].selected = s),
          s && i && (t[n].defaultSelected = !0));
    } else {
      for (n = "" + Ce(n), e = null, s = 0; s < t.length; s++) {
        if (t[s].value === n) {
          ((t[s].selected = !0), i && (t[s].defaultSelected = !0));
          return;
        }
        e !== null || t[s].disabled || (e = t[s]);
      }
      e !== null && (e.selected = !0);
    }
  }
  function Tf(t, e, n) {
    if (
      e != null &&
      ((e = "" + Ce(e)), e !== t.value && (t.value = e), n == null)
    ) {
      t.defaultValue !== e && (t.defaultValue = e);
      return;
    }
    t.defaultValue = n != null ? "" + Ce(n) : "";
  }
  function bf(t, e, n, i) {
    if (e == null) {
      if (i != null) {
        if (n != null) throw Error(r(92));
        if (ue(i)) {
          if (1 < i.length) throw Error(r(93));
          i = i[0];
        }
        n = i;
      }
      (n == null && (n = ""), (e = n));
    }
    ((n = Ce(e)),
      (t.defaultValue = n),
      (i = t.textContent),
      i === n && i !== "" && i !== null && (t.value = i),
      bu(t));
  }
  function Di(t, e) {
    if (e) {
      var n = t.firstChild;
      if (n && n === t.lastChild && n.nodeType === 3) {
        n.nodeValue = e;
        return;
      }
    }
    t.textContent = e;
  }
  var R0 = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " ",
    ),
  );
  function Af(t, e, n) {
    var i = e.indexOf("--") === 0;
    n == null || typeof n == "boolean" || n === ""
      ? i
        ? t.setProperty(e, "")
        : e === "float"
          ? (t.cssFloat = "")
          : (t[e] = "")
      : i
        ? t.setProperty(e, n)
        : typeof n != "number" || n === 0 || R0.has(e)
          ? e === "float"
            ? (t.cssFloat = n)
            : (t[e] = ("" + n).trim())
          : (t[e] = n + "px");
  }
  function Ef(t, e, n) {
    if (e != null && typeof e != "object") throw Error(r(62));
    if (((t = t.style), n != null)) {
      for (var i in n)
        !n.hasOwnProperty(i) ||
          (e != null && e.hasOwnProperty(i)) ||
          (i.indexOf("--") === 0
            ? t.setProperty(i, "")
            : i === "float"
              ? (t.cssFloat = "")
              : (t[i] = ""));
      for (var s in e)
        ((i = e[s]), e.hasOwnProperty(s) && n[s] !== i && Af(t, s, i));
    } else for (var o in e) e.hasOwnProperty(o) && Af(t, o, e[o]);
  }
  function Mu(t) {
    if (t.indexOf("-") === -1) return !1;
    switch (t) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var V0 = new Map([
      ["acceptCharset", "accept-charset"],
      ["htmlFor", "for"],
      ["httpEquiv", "http-equiv"],
      ["crossOrigin", "crossorigin"],
      ["accentHeight", "accent-height"],
      ["alignmentBaseline", "alignment-baseline"],
      ["arabicForm", "arabic-form"],
      ["baselineShift", "baseline-shift"],
      ["capHeight", "cap-height"],
      ["clipPath", "clip-path"],
      ["clipRule", "clip-rule"],
      ["colorInterpolation", "color-interpolation"],
      ["colorInterpolationFilters", "color-interpolation-filters"],
      ["colorProfile", "color-profile"],
      ["colorRendering", "color-rendering"],
      ["dominantBaseline", "dominant-baseline"],
      ["enableBackground", "enable-background"],
      ["fillOpacity", "fill-opacity"],
      ["fillRule", "fill-rule"],
      ["floodColor", "flood-color"],
      ["floodOpacity", "flood-opacity"],
      ["fontFamily", "font-family"],
      ["fontSize", "font-size"],
      ["fontSizeAdjust", "font-size-adjust"],
      ["fontStretch", "font-stretch"],
      ["fontStyle", "font-style"],
      ["fontVariant", "font-variant"],
      ["fontWeight", "font-weight"],
      ["glyphName", "glyph-name"],
      ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
      ["glyphOrientationVertical", "glyph-orientation-vertical"],
      ["horizAdvX", "horiz-adv-x"],
      ["horizOriginX", "horiz-origin-x"],
      ["imageRendering", "image-rendering"],
      ["letterSpacing", "letter-spacing"],
      ["lightingColor", "lighting-color"],
      ["markerEnd", "marker-end"],
      ["markerMid", "marker-mid"],
      ["markerStart", "marker-start"],
      ["overlinePosition", "overline-position"],
      ["overlineThickness", "overline-thickness"],
      ["paintOrder", "paint-order"],
      ["panose-1", "panose-1"],
      ["pointerEvents", "pointer-events"],
      ["renderingIntent", "rendering-intent"],
      ["shapeRendering", "shape-rendering"],
      ["stopColor", "stop-color"],
      ["stopOpacity", "stop-opacity"],
      ["strikethroughPosition", "strikethrough-position"],
      ["strikethroughThickness", "strikethrough-thickness"],
      ["strokeDasharray", "stroke-dasharray"],
      ["strokeDashoffset", "stroke-dashoffset"],
      ["strokeLinecap", "stroke-linecap"],
      ["strokeLinejoin", "stroke-linejoin"],
      ["strokeMiterlimit", "stroke-miterlimit"],
      ["strokeOpacity", "stroke-opacity"],
      ["strokeWidth", "stroke-width"],
      ["textAnchor", "text-anchor"],
      ["textDecoration", "text-decoration"],
      ["textRendering", "text-rendering"],
      ["transformOrigin", "transform-origin"],
      ["underlinePosition", "underline-position"],
      ["underlineThickness", "underline-thickness"],
      ["unicodeBidi", "unicode-bidi"],
      ["unicodeRange", "unicode-range"],
      ["unitsPerEm", "units-per-em"],
      ["vAlphabetic", "v-alphabetic"],
      ["vHanging", "v-hanging"],
      ["vIdeographic", "v-ideographic"],
      ["vMathematical", "v-mathematical"],
      ["vectorEffect", "vector-effect"],
      ["vertAdvY", "vert-adv-y"],
      ["vertOriginX", "vert-origin-x"],
      ["vertOriginY", "vert-origin-y"],
      ["wordSpacing", "word-spacing"],
      ["writingMode", "writing-mode"],
      ["xmlnsXlink", "xmlns:xlink"],
      ["xHeight", "x-height"],
    ]),
    _0 =
      /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function Bl(t) {
    return _0.test("" + t)
      ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')"
      : t;
  }
  function Ie() {}
  var xu = null;
  function Du(t) {
    return (
      (t = t.target || t.srcElement || window),
      t.correspondingUseElement && (t = t.correspondingUseElement),
      t.nodeType === 3 ? t.parentNode : t
    );
  }
  var Ci = null,
    zi = null;
  function Mf(t) {
    var e = Ai(t);
    if (e && (t = e.stateNode)) {
      var n = t[oe] || null;
      t: switch (((t = e.stateNode), e.type)) {
        case "input":
          if (
            (Au(
              t,
              n.value,
              n.defaultValue,
              n.defaultValue,
              n.checked,
              n.defaultChecked,
              n.type,
              n.name,
            ),
            (e = n.name),
            n.type === "radio" && e != null)
          ) {
            for (n = t; n.parentNode; ) n = n.parentNode;
            for (
              n = n.querySelectorAll(
                'input[name="' + ze("" + e) + '"][type="radio"]',
              ),
                e = 0;
              e < n.length;
              e++
            ) {
              var i = n[e];
              if (i !== t && i.form === t.form) {
                var s = i[oe] || null;
                if (!s) throw Error(r(90));
                Au(
                  i,
                  s.value,
                  s.defaultValue,
                  s.defaultValue,
                  s.checked,
                  s.defaultChecked,
                  s.type,
                  s.name,
                );
              }
            }
            for (e = 0; e < n.length; e++)
              ((i = n[e]), i.form === t.form && vf(i));
          }
          break t;
        case "textarea":
          Tf(t, n.value, n.defaultValue);
          break t;
        case "select":
          ((e = n.value), e != null && xi(t, !!n.multiple, e, !1));
      }
    }
  }
  var Cu = !1;
  function xf(t, e, n) {
    if (Cu) return t(e, n);
    Cu = !0;
    try {
      var i = t(e);
      return i;
    } finally {
      if (
        ((Cu = !1),
        (Ci !== null || zi !== null) &&
          (bs(), Ci && ((e = Ci), (t = zi), (zi = Ci = null), Mf(e), t)))
      )
        for (e = 0; e < t.length; e++) Mf(t[e]);
    }
  }
  function Sa(t, e) {
    var n = t.stateNode;
    if (n === null) return null;
    var i = n[oe] || null;
    if (i === null) return null;
    n = i[e];
    t: switch (e) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        ((i = !i.disabled) ||
          ((t = t.type),
          (i = !(
            t === "button" ||
            t === "input" ||
            t === "select" ||
            t === "textarea"
          ))),
          (t = !i));
        break t;
      default:
        t = !1;
    }
    if (t) return null;
    if (n && typeof n != "function") throw Error(r(231, e, typeof n));
    return n;
  }
  var tn = !(
      typeof window > "u" ||
      typeof window.document > "u" ||
      typeof window.document.createElement > "u"
    ),
    zu = !1;
  if (tn)
    try {
      var Ta = {};
      (Object.defineProperty(Ta, "passive", {
        get: function () {
          zu = !0;
        },
      }),
        window.addEventListener("test", Ta, Ta),
        window.removeEventListener("test", Ta, Ta));
    } catch {
      zu = !1;
    }
  var bn = null,
    Ou = null,
    Nl = null;
  function Df() {
    if (Nl) return Nl;
    var t,
      e = Ou,
      n = e.length,
      i,
      s = "value" in bn ? bn.value : bn.textContent,
      o = s.length;
    for (t = 0; t < n && e[t] === s[t]; t++);
    var f = n - t;
    for (i = 1; i <= f && e[n - i] === s[o - i]; i++);
    return (Nl = s.slice(t, 1 < i ? 1 - i : void 0));
  }
  function jl(t) {
    var e = t.keyCode;
    return (
      "charCode" in t
        ? ((t = t.charCode), t === 0 && e === 13 && (t = 13))
        : (t = e),
      t === 10 && (t = 13),
      32 <= t || t === 13 ? t : 0
    );
  }
  function Ll() {
    return !0;
  }
  function Cf() {
    return !1;
  }
  function re(t) {
    function e(n, i, s, o, f) {
      ((this._reactName = n),
        (this._targetInst = s),
        (this.type = i),
        (this.nativeEvent = o),
        (this.target = f),
        (this.currentTarget = null));
      for (var m in t)
        t.hasOwnProperty(m) && ((n = t[m]), (this[m] = n ? n(o) : o[m]));
      return (
        (this.isDefaultPrevented = (
          o.defaultPrevented != null ? o.defaultPrevented : o.returnValue === !1
        )
          ? Ll
          : Cf),
        (this.isPropagationStopped = Cf),
        this
      );
    }
    return (
      S(e.prototype, {
        preventDefault: function () {
          this.defaultPrevented = !0;
          var n = this.nativeEvent;
          n &&
            (n.preventDefault
              ? n.preventDefault()
              : typeof n.returnValue != "unknown" && (n.returnValue = !1),
            (this.isDefaultPrevented = Ll));
        },
        stopPropagation: function () {
          var n = this.nativeEvent;
          n &&
            (n.stopPropagation
              ? n.stopPropagation()
              : typeof n.cancelBubble != "unknown" && (n.cancelBubble = !0),
            (this.isPropagationStopped = Ll));
        },
        persist: function () {},
        isPersistent: Ll,
      }),
      e
    );
  }
  var $n = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function (t) {
        return t.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0,
    },
    Hl = re($n),
    ba = S({}, $n, { view: 0, detail: 0 }),
    U0 = re(ba),
    Ru,
    Vu,
    Aa,
    wl = S({}, ba, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: Uu,
      button: 0,
      buttons: 0,
      relatedTarget: function (t) {
        return t.relatedTarget === void 0
          ? t.fromElement === t.srcElement
            ? t.toElement
            : t.fromElement
          : t.relatedTarget;
      },
      movementX: function (t) {
        return "movementX" in t
          ? t.movementX
          : (t !== Aa &&
              (Aa && t.type === "mousemove"
                ? ((Ru = t.screenX - Aa.screenX), (Vu = t.screenY - Aa.screenY))
                : (Vu = Ru = 0),
              (Aa = t)),
            Ru);
      },
      movementY: function (t) {
        return "movementY" in t ? t.movementY : Vu;
      },
    }),
    zf = re(wl),
    B0 = S({}, wl, { dataTransfer: 0 }),
    N0 = re(B0),
    j0 = S({}, ba, { relatedTarget: 0 }),
    _u = re(j0),
    L0 = S({}, $n, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }),
    H0 = re(L0),
    w0 = S({}, $n, {
      clipboardData: function (t) {
        return "clipboardData" in t ? t.clipboardData : window.clipboardData;
      },
    }),
    Y0 = re(w0),
    q0 = S({}, $n, { data: 0 }),
    Of = re(q0),
    G0 = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified",
    },
    X0 = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta",
    },
    Q0 = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey",
    };
  function Z0(t) {
    var e = this.nativeEvent;
    return e.getModifierState
      ? e.getModifierState(t)
      : (t = Q0[t])
        ? !!e[t]
        : !1;
  }
  function Uu() {
    return Z0;
  }
  var K0 = S({}, ba, {
      key: function (t) {
        if (t.key) {
          var e = G0[t.key] || t.key;
          if (e !== "Unidentified") return e;
        }
        return t.type === "keypress"
          ? ((t = jl(t)), t === 13 ? "Enter" : String.fromCharCode(t))
          : t.type === "keydown" || t.type === "keyup"
            ? X0[t.keyCode] || "Unidentified"
            : "";
      },
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: Uu,
      charCode: function (t) {
        return t.type === "keypress" ? jl(t) : 0;
      },
      keyCode: function (t) {
        return t.type === "keydown" || t.type === "keyup" ? t.keyCode : 0;
      },
      which: function (t) {
        return t.type === "keypress"
          ? jl(t)
          : t.type === "keydown" || t.type === "keyup"
            ? t.keyCode
            : 0;
      },
    }),
    J0 = re(K0),
    F0 = S({}, wl, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0,
    }),
    Rf = re(F0),
    k0 = S({}, ba, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: Uu,
    }),
    W0 = re(k0),
    P0 = S({}, $n, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }),
    $0 = re(P0),
    I0 = S({}, wl, {
      deltaX: function (t) {
        return "deltaX" in t
          ? t.deltaX
          : "wheelDeltaX" in t
            ? -t.wheelDeltaX
            : 0;
      },
      deltaY: function (t) {
        return "deltaY" in t
          ? t.deltaY
          : "wheelDeltaY" in t
            ? -t.wheelDeltaY
            : "wheelDelta" in t
              ? -t.wheelDelta
              : 0;
      },
      deltaZ: 0,
      deltaMode: 0,
    }),
    tv = re(I0),
    ev = S({}, $n, { newState: 0, oldState: 0 }),
    nv = re(ev),
    iv = [9, 13, 27, 32],
    Bu = tn && "CompositionEvent" in window,
    Ea = null;
  tn && "documentMode" in document && (Ea = document.documentMode);
  var av = tn && "TextEvent" in window && !Ea,
    Vf = tn && (!Bu || (Ea && 8 < Ea && 11 >= Ea)),
    _f = " ",
    Uf = !1;
  function Bf(t, e) {
    switch (t) {
      case "keyup":
        return iv.indexOf(e.keyCode) !== -1;
      case "keydown":
        return e.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function Nf(t) {
    return (
      (t = t.detail),
      typeof t == "object" && "data" in t ? t.data : null
    );
  }
  var Oi = !1;
  function lv(t, e) {
    switch (t) {
      case "compositionend":
        return Nf(e);
      case "keypress":
        return e.which !== 32 ? null : ((Uf = !0), _f);
      case "textInput":
        return ((t = e.data), t === _f && Uf ? null : t);
      default:
        return null;
    }
  }
  function sv(t, e) {
    if (Oi)
      return t === "compositionend" || (!Bu && Bf(t, e))
        ? ((t = Df()), (Nl = Ou = bn = null), (Oi = !1), t)
        : null;
    switch (t) {
      case "paste":
        return null;
      case "keypress":
        if (!(e.ctrlKey || e.altKey || e.metaKey) || (e.ctrlKey && e.altKey)) {
          if (e.char && 1 < e.char.length) return e.char;
          if (e.which) return String.fromCharCode(e.which);
        }
        return null;
      case "compositionend":
        return Vf && e.locale !== "ko" ? null : e.data;
      default:
        return null;
    }
  }
  var uv = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0,
  };
  function jf(t) {
    var e = t && t.nodeName && t.nodeName.toLowerCase();
    return e === "input" ? !!uv[t.type] : e === "textarea";
  }
  function Lf(t, e, n, i) {
    (Ci ? (zi ? zi.push(i) : (zi = [i])) : (Ci = i),
      (e = zs(e, "onChange")),
      0 < e.length &&
        ((n = new Hl("onChange", "change", null, n, i)),
        t.push({ event: n, listeners: e })));
  }
  var Ma = null,
    xa = null;
  function ov(t) {
    Sm(t, 0);
  }
  function Yl(t) {
    var e = va(t);
    if (vf(e)) return t;
  }
  function Hf(t, e) {
    if (t === "change") return e;
  }
  var wf = !1;
  if (tn) {
    var Nu;
    if (tn) {
      var ju = "oninput" in document;
      if (!ju) {
        var Yf = document.createElement("div");
        (Yf.setAttribute("oninput", "return;"),
          (ju = typeof Yf.oninput == "function"));
      }
      Nu = ju;
    } else Nu = !1;
    wf = Nu && (!document.documentMode || 9 < document.documentMode);
  }
  function qf() {
    Ma && (Ma.detachEvent("onpropertychange", Gf), (xa = Ma = null));
  }
  function Gf(t) {
    if (t.propertyName === "value" && Yl(xa)) {
      var e = [];
      (Lf(e, xa, t, Du(t)), xf(ov, e));
    }
  }
  function rv(t, e, n) {
    t === "focusin"
      ? (qf(), (Ma = e), (xa = n), Ma.attachEvent("onpropertychange", Gf))
      : t === "focusout" && qf();
  }
  function cv(t) {
    if (t === "selectionchange" || t === "keyup" || t === "keydown")
      return Yl(xa);
  }
  function fv(t, e) {
    if (t === "click") return Yl(e);
  }
  function hv(t, e) {
    if (t === "input" || t === "change") return Yl(e);
  }
  function dv(t, e) {
    return (t === e && (t !== 0 || 1 / t === 1 / e)) || (t !== t && e !== e);
  }
  var ve = typeof Object.is == "function" ? Object.is : dv;
  function Da(t, e) {
    if (ve(t, e)) return !0;
    if (
      typeof t != "object" ||
      t === null ||
      typeof e != "object" ||
      e === null
    )
      return !1;
    var n = Object.keys(t),
      i = Object.keys(e);
    if (n.length !== i.length) return !1;
    for (i = 0; i < n.length; i++) {
      var s = n[i];
      if (!du.call(e, s) || !ve(t[s], e[s])) return !1;
    }
    return !0;
  }
  function Xf(t) {
    for (; t && t.firstChild; ) t = t.firstChild;
    return t;
  }
  function Qf(t, e) {
    var n = Xf(t);
    t = 0;
    for (var i; n; ) {
      if (n.nodeType === 3) {
        if (((i = t + n.textContent.length), t <= e && i >= e))
          return { node: n, offset: e - t };
        t = i;
      }
      t: {
        for (; n; ) {
          if (n.nextSibling) {
            n = n.nextSibling;
            break t;
          }
          n = n.parentNode;
        }
        n = void 0;
      }
      n = Xf(n);
    }
  }
  function Zf(t, e) {
    return t && e
      ? t === e
        ? !0
        : t && t.nodeType === 3
          ? !1
          : e && e.nodeType === 3
            ? Zf(t, e.parentNode)
            : "contains" in t
              ? t.contains(e)
              : t.compareDocumentPosition
                ? !!(t.compareDocumentPosition(e) & 16)
                : !1
      : !1;
  }
  function Kf(t) {
    t =
      t != null &&
      t.ownerDocument != null &&
      t.ownerDocument.defaultView != null
        ? t.ownerDocument.defaultView
        : window;
    for (var e = Ul(t.document); e instanceof t.HTMLIFrameElement; ) {
      try {
        var n = typeof e.contentWindow.location.href == "string";
      } catch {
        n = !1;
      }
      if (n) t = e.contentWindow;
      else break;
      e = Ul(t.document);
    }
    return e;
  }
  function Lu(t) {
    var e = t && t.nodeName && t.nodeName.toLowerCase();
    return (
      e &&
      ((e === "input" &&
        (t.type === "text" ||
          t.type === "search" ||
          t.type === "tel" ||
          t.type === "url" ||
          t.type === "password")) ||
        e === "textarea" ||
        t.contentEditable === "true")
    );
  }
  var mv = tn && "documentMode" in document && 11 >= document.documentMode,
    Ri = null,
    Hu = null,
    Ca = null,
    wu = !1;
  function Jf(t, e, n) {
    var i =
      n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
    wu ||
      Ri == null ||
      Ri !== Ul(i) ||
      ((i = Ri),
      "selectionStart" in i && Lu(i)
        ? (i = { start: i.selectionStart, end: i.selectionEnd })
        : ((i = (
            (i.ownerDocument && i.ownerDocument.defaultView) ||
            window
          ).getSelection()),
          (i = {
            anchorNode: i.anchorNode,
            anchorOffset: i.anchorOffset,
            focusNode: i.focusNode,
            focusOffset: i.focusOffset,
          })),
      (Ca && Da(Ca, i)) ||
        ((Ca = i),
        (i = zs(Hu, "onSelect")),
        0 < i.length &&
          ((e = new Hl("onSelect", "select", null, e, n)),
          t.push({ event: e, listeners: i }),
          (e.target = Ri))));
  }
  function In(t, e) {
    var n = {};
    return (
      (n[t.toLowerCase()] = e.toLowerCase()),
      (n["Webkit" + t] = "webkit" + e),
      (n["Moz" + t] = "moz" + e),
      n
    );
  }
  var Vi = {
      animationend: In("Animation", "AnimationEnd"),
      animationiteration: In("Animation", "AnimationIteration"),
      animationstart: In("Animation", "AnimationStart"),
      transitionrun: In("Transition", "TransitionRun"),
      transitionstart: In("Transition", "TransitionStart"),
      transitioncancel: In("Transition", "TransitionCancel"),
      transitionend: In("Transition", "TransitionEnd"),
    },
    Yu = {},
    Ff = {};
  tn &&
    ((Ff = document.createElement("div").style),
    "AnimationEvent" in window ||
      (delete Vi.animationend.animation,
      delete Vi.animationiteration.animation,
      delete Vi.animationstart.animation),
    "TransitionEvent" in window || delete Vi.transitionend.transition);
  function ti(t) {
    if (Yu[t]) return Yu[t];
    if (!Vi[t]) return t;
    var e = Vi[t],
      n;
    for (n in e) if (e.hasOwnProperty(n) && n in Ff) return (Yu[t] = e[n]);
    return t;
  }
  var kf = ti("animationend"),
    Wf = ti("animationiteration"),
    Pf = ti("animationstart"),
    yv = ti("transitionrun"),
    pv = ti("transitionstart"),
    gv = ti("transitioncancel"),
    $f = ti("transitionend"),
    If = new Map(),
    qu =
      "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
        " ",
      );
  qu.push("scrollEnd");
  function qe(t, e) {
    (If.set(t, e), Pn(e, [t]));
  }
  var ql =
      typeof reportError == "function"
        ? reportError
        : function (t) {
            if (
              typeof window == "object" &&
              typeof window.ErrorEvent == "function"
            ) {
              var e = new window.ErrorEvent("error", {
                bubbles: !0,
                cancelable: !0,
                message:
                  typeof t == "object" &&
                  t !== null &&
                  typeof t.message == "string"
                    ? String(t.message)
                    : String(t),
                error: t,
              });
              if (!window.dispatchEvent(e)) return;
            } else if (
              typeof process == "object" &&
              typeof process.emit == "function"
            ) {
              process.emit("uncaughtException", t);
              return;
            }
            console.error(t);
          },
    Oe = [],
    _i = 0,
    Gu = 0;
  function Gl() {
    for (var t = _i, e = (Gu = _i = 0); e < t; ) {
      var n = Oe[e];
      Oe[e++] = null;
      var i = Oe[e];
      Oe[e++] = null;
      var s = Oe[e];
      Oe[e++] = null;
      var o = Oe[e];
      if (((Oe[e++] = null), i !== null && s !== null)) {
        var f = i.pending;
        (f === null ? (s.next = s) : ((s.next = f.next), (f.next = s)),
          (i.pending = s));
      }
      o !== 0 && th(n, s, o);
    }
  }
  function Xl(t, e, n, i) {
    ((Oe[_i++] = t),
      (Oe[_i++] = e),
      (Oe[_i++] = n),
      (Oe[_i++] = i),
      (Gu |= i),
      (t.lanes |= i),
      (t = t.alternate),
      t !== null && (t.lanes |= i));
  }
  function Xu(t, e, n, i) {
    return (Xl(t, e, n, i), Ql(t));
  }
  function ei(t, e) {
    return (Xl(t, null, null, e), Ql(t));
  }
  function th(t, e, n) {
    t.lanes |= n;
    var i = t.alternate;
    i !== null && (i.lanes |= n);
    for (var s = !1, o = t.return; o !== null; )
      ((o.childLanes |= n),
        (i = o.alternate),
        i !== null && (i.childLanes |= n),
        o.tag === 22 &&
          ((t = o.stateNode), t === null || t._visibility & 1 || (s = !0)),
        (t = o),
        (o = o.return));
    return t.tag === 3
      ? ((o = t.stateNode),
        s &&
          e !== null &&
          ((s = 31 - ge(n)),
          (t = o.hiddenUpdates),
          (i = t[s]),
          i === null ? (t[s] = [e]) : i.push(e),
          (e.lane = n | 536870912)),
        o)
      : null;
  }
  function Ql(t) {
    if (50 < ka) throw ((ka = 0), (Io = null), Error(r(185)));
    for (var e = t.return; e !== null; ) ((t = e), (e = t.return));
    return t.tag === 3 ? t.stateNode : null;
  }
  var Ui = {};
  function vv(t, e, n, i) {
    ((this.tag = t),
      (this.key = n),
      (this.sibling =
        this.child =
        this.return =
        this.stateNode =
        this.type =
        this.elementType =
          null),
      (this.index = 0),
      (this.refCleanup = this.ref = null),
      (this.pendingProps = e),
      (this.dependencies =
        this.memoizedState =
        this.updateQueue =
        this.memoizedProps =
          null),
      (this.mode = i),
      (this.subtreeFlags = this.flags = 0),
      (this.deletions = null),
      (this.childLanes = this.lanes = 0),
      (this.alternate = null));
  }
  function Se(t, e, n, i) {
    return new vv(t, e, n, i);
  }
  function Qu(t) {
    return ((t = t.prototype), !(!t || !t.isReactComponent));
  }
  function en(t, e) {
    var n = t.alternate;
    return (
      n === null
        ? ((n = Se(t.tag, e, t.key, t.mode)),
          (n.elementType = t.elementType),
          (n.type = t.type),
          (n.stateNode = t.stateNode),
          (n.alternate = t),
          (t.alternate = n))
        : ((n.pendingProps = e),
          (n.type = t.type),
          (n.flags = 0),
          (n.subtreeFlags = 0),
          (n.deletions = null)),
      (n.flags = t.flags & 65011712),
      (n.childLanes = t.childLanes),
      (n.lanes = t.lanes),
      (n.child = t.child),
      (n.memoizedProps = t.memoizedProps),
      (n.memoizedState = t.memoizedState),
      (n.updateQueue = t.updateQueue),
      (e = t.dependencies),
      (n.dependencies =
        e === null ? null : { lanes: e.lanes, firstContext: e.firstContext }),
      (n.sibling = t.sibling),
      (n.index = t.index),
      (n.ref = t.ref),
      (n.refCleanup = t.refCleanup),
      n
    );
  }
  function eh(t, e) {
    t.flags &= 65011714;
    var n = t.alternate;
    return (
      n === null
        ? ((t.childLanes = 0),
          (t.lanes = e),
          (t.child = null),
          (t.subtreeFlags = 0),
          (t.memoizedProps = null),
          (t.memoizedState = null),
          (t.updateQueue = null),
          (t.dependencies = null),
          (t.stateNode = null))
        : ((t.childLanes = n.childLanes),
          (t.lanes = n.lanes),
          (t.child = n.child),
          (t.subtreeFlags = 0),
          (t.deletions = null),
          (t.memoizedProps = n.memoizedProps),
          (t.memoizedState = n.memoizedState),
          (t.updateQueue = n.updateQueue),
          (t.type = n.type),
          (e = n.dependencies),
          (t.dependencies =
            e === null
              ? null
              : { lanes: e.lanes, firstContext: e.firstContext })),
      t
    );
  }
  function Zl(t, e, n, i, s, o) {
    var f = 0;
    if (((i = t), typeof t == "function")) Qu(t) && (f = 1);
    else if (typeof t == "string")
      f = E1(t, n, J.current)
        ? 26
        : t === "html" || t === "head" || t === "body"
          ? 27
          : 5;
    else
      t: switch (t) {
        case it:
          return (
            (t = Se(31, n, e, s)),
            (t.elementType = it),
            (t.lanes = o),
            t
          );
        case j:
          return ni(n.children, s, o, e);
        case Y:
          ((f = 8), (s |= 24));
          break;
        case H:
          return (
            (t = Se(12, n, e, s | 2)),
            (t.elementType = H),
            (t.lanes = o),
            t
          );
        case P:
          return ((t = Se(13, n, e, s)), (t.elementType = P), (t.lanes = o), t);
        case et:
          return (
            (t = Se(19, n, e, s)),
            (t.elementType = et),
            (t.lanes = o),
            t
          );
        default:
          if (typeof t == "object" && t !== null)
            switch (t.$$typeof) {
              case L:
                f = 10;
                break t;
              case q:
                f = 9;
                break t;
              case W:
                f = 11;
                break t;
              case $:
                f = 14;
                break t;
              case K:
                ((f = 16), (i = null));
                break t;
            }
          ((f = 29),
            (n = Error(r(130, t === null ? "null" : typeof t, ""))),
            (i = null));
      }
    return (
      (e = Se(f, n, e, s)),
      (e.elementType = t),
      (e.type = i),
      (e.lanes = o),
      e
    );
  }
  function ni(t, e, n, i) {
    return ((t = Se(7, t, i, e)), (t.lanes = n), t);
  }
  function Zu(t, e, n) {
    return ((t = Se(6, t, null, e)), (t.lanes = n), t);
  }
  function nh(t) {
    var e = Se(18, null, null, 0);
    return ((e.stateNode = t), e);
  }
  function Ku(t, e, n) {
    return (
      (e = Se(4, t.children !== null ? t.children : [], t.key, e)),
      (e.lanes = n),
      (e.stateNode = {
        containerInfo: t.containerInfo,
        pendingChildren: null,
        implementation: t.implementation,
      }),
      e
    );
  }
  var ih = new WeakMap();
  function Re(t, e) {
    if (typeof t == "object" && t !== null) {
      var n = ih.get(t);
      return n !== void 0
        ? n
        : ((e = { value: t, source: e, stack: ef(e) }), ih.set(t, e), e);
    }
    return { value: t, source: e, stack: ef(e) };
  }
  var Bi = [],
    Ni = 0,
    Kl = null,
    za = 0,
    Ve = [],
    _e = 0,
    An = null,
    Ke = 1,
    Je = "";
  function nn(t, e) {
    ((Bi[Ni++] = za), (Bi[Ni++] = Kl), (Kl = t), (za = e));
  }
  function ah(t, e, n) {
    ((Ve[_e++] = Ke), (Ve[_e++] = Je), (Ve[_e++] = An), (An = t));
    var i = Ke;
    t = Je;
    var s = 32 - ge(i) - 1;
    ((i &= ~(1 << s)), (n += 1));
    var o = 32 - ge(e) + s;
    if (30 < o) {
      var f = s - (s % 5);
      ((o = (i & ((1 << f) - 1)).toString(32)),
        (i >>= f),
        (s -= f),
        (Ke = (1 << (32 - ge(e) + s)) | (n << s) | i),
        (Je = o + t));
    } else ((Ke = (1 << o) | (n << s) | i), (Je = t));
  }
  function Ju(t) {
    t.return !== null && (nn(t, 1), ah(t, 1, 0));
  }
  function Fu(t) {
    for (; t === Kl; )
      ((Kl = Bi[--Ni]), (Bi[Ni] = null), (za = Bi[--Ni]), (Bi[Ni] = null));
    for (; t === An; )
      ((An = Ve[--_e]),
        (Ve[_e] = null),
        (Je = Ve[--_e]),
        (Ve[_e] = null),
        (Ke = Ve[--_e]),
        (Ve[_e] = null));
  }
  function lh(t, e) {
    ((Ve[_e++] = Ke),
      (Ve[_e++] = Je),
      (Ve[_e++] = An),
      (Ke = e.id),
      (Je = e.overflow),
      (An = t));
  }
  var Wt = null,
    Dt = null,
    dt = !1,
    En = null,
    Ue = !1,
    ku = Error(r(519));
  function Mn(t) {
    var e = Error(
      r(
        418,
        1 < arguments.length && arguments[1] !== void 0 && arguments[1]
          ? "text"
          : "HTML",
        "",
      ),
    );
    throw (Oa(Re(e, t)), ku);
  }
  function sh(t) {
    var e = t.stateNode,
      n = t.type,
      i = t.memoizedProps;
    switch (((e[kt] = t), (e[oe] = i), n)) {
      case "dialog":
        (rt("cancel", e), rt("close", e));
        break;
      case "iframe":
      case "object":
      case "embed":
        rt("load", e);
        break;
      case "video":
      case "audio":
        for (n = 0; n < Pa.length; n++) rt(Pa[n], e);
        break;
      case "source":
        rt("error", e);
        break;
      case "img":
      case "image":
      case "link":
        (rt("error", e), rt("load", e));
        break;
      case "details":
        rt("toggle", e);
        break;
      case "input":
        (rt("invalid", e),
          Sf(
            e,
            i.value,
            i.defaultValue,
            i.checked,
            i.defaultChecked,
            i.type,
            i.name,
            !0,
          ));
        break;
      case "select":
        rt("invalid", e);
        break;
      case "textarea":
        (rt("invalid", e), bf(e, i.value, i.defaultValue, i.children));
    }
    ((n = i.children),
      (typeof n != "string" && typeof n != "number" && typeof n != "bigint") ||
      e.textContent === "" + n ||
      i.suppressHydrationWarning === !0 ||
      Em(e.textContent, n)
        ? (i.popover != null && (rt("beforetoggle", e), rt("toggle", e)),
          i.onScroll != null && rt("scroll", e),
          i.onScrollEnd != null && rt("scrollend", e),
          i.onClick != null && (e.onclick = Ie),
          (e = !0))
        : (e = !1),
      e || Mn(t, !0));
  }
  function uh(t) {
    for (Wt = t.return; Wt; )
      switch (Wt.tag) {
        case 5:
        case 31:
        case 13:
          Ue = !1;
          return;
        case 27:
        case 3:
          Ue = !0;
          return;
        default:
          Wt = Wt.return;
      }
  }
  function ji(t) {
    if (t !== Wt) return !1;
    if (!dt) return (uh(t), (dt = !0), !1);
    var e = t.tag,
      n;
    if (
      ((n = e !== 3 && e !== 27) &&
        ((n = e === 5) &&
          ((n = t.type),
          (n =
            !(n !== "form" && n !== "button") || mr(t.type, t.memoizedProps))),
        (n = !n)),
      n && Dt && Mn(t),
      uh(t),
      e === 13)
    ) {
      if (((t = t.memoizedState), (t = t !== null ? t.dehydrated : null), !t))
        throw Error(r(317));
      Dt = _m(t);
    } else if (e === 31) {
      if (((t = t.memoizedState), (t = t !== null ? t.dehydrated : null), !t))
        throw Error(r(317));
      Dt = _m(t);
    } else
      e === 27
        ? ((e = Dt), Hn(t.type) ? ((t = Sr), (Sr = null), (Dt = t)) : (Dt = e))
        : (Dt = Wt ? Ne(t.stateNode.nextSibling) : null);
    return !0;
  }
  function ii() {
    ((Dt = Wt = null), (dt = !1));
  }
  function Wu() {
    var t = En;
    return (
      t !== null &&
        (de === null ? (de = t) : de.push.apply(de, t), (En = null)),
      t
    );
  }
  function Oa(t) {
    En === null ? (En = [t]) : En.push(t);
  }
  var Pu = A(null),
    ai = null,
    an = null;
  function xn(t, e, n) {
    (G(Pu, e._currentValue), (e._currentValue = n));
  }
  function ln(t) {
    ((t._currentValue = Pu.current), N(Pu));
  }
  function $u(t, e, n) {
    for (; t !== null; ) {
      var i = t.alternate;
      if (
        ((t.childLanes & e) !== e
          ? ((t.childLanes |= e), i !== null && (i.childLanes |= e))
          : i !== null && (i.childLanes & e) !== e && (i.childLanes |= e),
        t === n)
      )
        break;
      t = t.return;
    }
  }
  function Iu(t, e, n, i) {
    var s = t.child;
    for (s !== null && (s.return = t); s !== null; ) {
      var o = s.dependencies;
      if (o !== null) {
        var f = s.child;
        o = o.firstContext;
        t: for (; o !== null; ) {
          var m = o;
          o = s;
          for (var T = 0; T < e.length; T++)
            if (m.context === e[T]) {
              ((o.lanes |= n),
                (m = o.alternate),
                m !== null && (m.lanes |= n),
                $u(o.return, n, t),
                i || (f = null));
              break t;
            }
          o = m.next;
        }
      } else if (s.tag === 18) {
        if (((f = s.return), f === null)) throw Error(r(341));
        ((f.lanes |= n),
          (o = f.alternate),
          o !== null && (o.lanes |= n),
          $u(f, n, t),
          (f = null));
      } else f = s.child;
      if (f !== null) f.return = s;
      else
        for (f = s; f !== null; ) {
          if (f === t) {
            f = null;
            break;
          }
          if (((s = f.sibling), s !== null)) {
            ((s.return = f.return), (f = s));
            break;
          }
          f = f.return;
        }
      s = f;
    }
  }
  function Li(t, e, n, i) {
    t = null;
    for (var s = e, o = !1; s !== null; ) {
      if (!o) {
        if ((s.flags & 524288) !== 0) o = !0;
        else if ((s.flags & 262144) !== 0) break;
      }
      if (s.tag === 10) {
        var f = s.alternate;
        if (f === null) throw Error(r(387));
        if (((f = f.memoizedProps), f !== null)) {
          var m = s.type;
          ve(s.pendingProps.value, f.value) ||
            (t !== null ? t.push(m) : (t = [m]));
        }
      } else if (s === vt.current) {
        if (((f = s.alternate), f === null)) throw Error(r(387));
        f.memoizedState.memoizedState !== s.memoizedState.memoizedState &&
          (t !== null ? t.push(nl) : (t = [nl]));
      }
      s = s.return;
    }
    (t !== null && Iu(e, t, n, i), (e.flags |= 262144));
  }
  function Jl(t) {
    for (t = t.firstContext; t !== null; ) {
      if (!ve(t.context._currentValue, t.memoizedValue)) return !0;
      t = t.next;
    }
    return !1;
  }
  function li(t) {
    ((ai = t),
      (an = null),
      (t = t.dependencies),
      t !== null && (t.firstContext = null));
  }
  function Pt(t) {
    return oh(ai, t);
  }
  function Fl(t, e) {
    return (ai === null && li(t), oh(t, e));
  }
  function oh(t, e) {
    var n = e._currentValue;
    if (((e = { context: e, memoizedValue: n, next: null }), an === null)) {
      if (t === null) throw Error(r(308));
      ((an = e),
        (t.dependencies = { lanes: 0, firstContext: e }),
        (t.flags |= 524288));
    } else an = an.next = e;
    return n;
  }
  var Sv =
      typeof AbortController < "u"
        ? AbortController
        : function () {
            var t = [],
              e = (this.signal = {
                aborted: !1,
                addEventListener: function (n, i) {
                  t.push(i);
                },
              });
            this.abort = function () {
              ((e.aborted = !0),
                t.forEach(function (n) {
                  return n();
                }));
            };
          },
    Tv = a.unstable_scheduleCallback,
    bv = a.unstable_NormalPriority,
    Yt = {
      $$typeof: L,
      Consumer: null,
      Provider: null,
      _currentValue: null,
      _currentValue2: null,
      _threadCount: 0,
    };
  function to() {
    return { controller: new Sv(), data: new Map(), refCount: 0 };
  }
  function Ra(t) {
    (t.refCount--,
      t.refCount === 0 &&
        Tv(bv, function () {
          t.controller.abort();
        }));
  }
  var Va = null,
    eo = 0,
    Hi = 0,
    wi = null;
  function Av(t, e) {
    if (Va === null) {
      var n = (Va = []);
      ((eo = 0),
        (Hi = lr()),
        (wi = {
          status: "pending",
          value: void 0,
          then: function (i) {
            n.push(i);
          },
        }));
    }
    return (eo++, e.then(rh, rh), e);
  }
  function rh() {
    if (--eo === 0 && Va !== null) {
      wi !== null && (wi.status = "fulfilled");
      var t = Va;
      ((Va = null), (Hi = 0), (wi = null));
      for (var e = 0; e < t.length; e++) (0, t[e])();
    }
  }
  function Ev(t, e) {
    var n = [],
      i = {
        status: "pending",
        value: null,
        reason: null,
        then: function (s) {
          n.push(s);
        },
      };
    return (
      t.then(
        function () {
          ((i.status = "fulfilled"), (i.value = e));
          for (var s = 0; s < n.length; s++) (0, n[s])(e);
        },
        function (s) {
          for (i.status = "rejected", i.reason = s, s = 0; s < n.length; s++)
            (0, n[s])(void 0);
        },
      ),
      i
    );
  }
  var ch = V.S;
  V.S = function (t, e) {
    ((Jd = ye()),
      typeof e == "object" &&
        e !== null &&
        typeof e.then == "function" &&
        Av(t, e),
      ch !== null && ch(t, e));
  };
  var si = A(null);
  function no() {
    var t = si.current;
    return t !== null ? t : Mt.pooledCache;
  }
  function kl(t, e) {
    e === null ? G(si, si.current) : G(si, e.pool);
  }
  function fh() {
    var t = no();
    return t === null ? null : { parent: Yt._currentValue, pool: t };
  }
  var Yi = Error(r(460)),
    io = Error(r(474)),
    Wl = Error(r(542)),
    Pl = { then: function () {} };
  function hh(t) {
    return ((t = t.status), t === "fulfilled" || t === "rejected");
  }
  function dh(t, e, n) {
    switch (
      ((n = t[n]),
      n === void 0 ? t.push(e) : n !== e && (e.then(Ie, Ie), (e = n)),
      e.status)
    ) {
      case "fulfilled":
        return e.value;
      case "rejected":
        throw ((t = e.reason), yh(t), t);
      default:
        if (typeof e.status == "string") e.then(Ie, Ie);
        else {
          if (((t = Mt), t !== null && 100 < t.shellSuspendCounter))
            throw Error(r(482));
          ((t = e),
            (t.status = "pending"),
            t.then(
              function (i) {
                if (e.status === "pending") {
                  var s = e;
                  ((s.status = "fulfilled"), (s.value = i));
                }
              },
              function (i) {
                if (e.status === "pending") {
                  var s = e;
                  ((s.status = "rejected"), (s.reason = i));
                }
              },
            ));
        }
        switch (e.status) {
          case "fulfilled":
            return e.value;
          case "rejected":
            throw ((t = e.reason), yh(t), t);
        }
        throw ((oi = e), Yi);
    }
  }
  function ui(t) {
    try {
      var e = t._init;
      return e(t._payload);
    } catch (n) {
      throw n !== null && typeof n == "object" && typeof n.then == "function"
        ? ((oi = n), Yi)
        : n;
    }
  }
  var oi = null;
  function mh() {
    if (oi === null) throw Error(r(459));
    var t = oi;
    return ((oi = null), t);
  }
  function yh(t) {
    if (t === Yi || t === Wl) throw Error(r(483));
  }
  var qi = null,
    _a = 0;
  function $l(t) {
    var e = _a;
    return ((_a += 1), qi === null && (qi = []), dh(qi, t, e));
  }
  function Ua(t, e) {
    ((e = e.props.ref), (t.ref = e !== void 0 ? e : null));
  }
  function Il(t, e) {
    throw e.$$typeof === E
      ? Error(r(525))
      : ((t = Object.prototype.toString.call(e)),
        Error(
          r(
            31,
            t === "[object Object]"
              ? "object with keys {" + Object.keys(e).join(", ") + "}"
              : t,
          ),
        ));
  }
  function ph(t) {
    function e(M, b) {
      if (t) {
        var x = M.deletions;
        x === null ? ((M.deletions = [b]), (M.flags |= 16)) : x.push(b);
      }
    }
    function n(M, b) {
      if (!t) return null;
      for (; b !== null; ) (e(M, b), (b = b.sibling));
      return null;
    }
    function i(M) {
      for (var b = new Map(); M !== null; )
        (M.key !== null ? b.set(M.key, M) : b.set(M.index, M), (M = M.sibling));
      return b;
    }
    function s(M, b) {
      return ((M = en(M, b)), (M.index = 0), (M.sibling = null), M);
    }
    function o(M, b, x) {
      return (
        (M.index = x),
        t
          ? ((x = M.alternate),
            x !== null
              ? ((x = x.index), x < b ? ((M.flags |= 67108866), b) : x)
              : ((M.flags |= 67108866), b))
          : ((M.flags |= 1048576), b)
      );
    }
    function f(M) {
      return (t && M.alternate === null && (M.flags |= 67108866), M);
    }
    function m(M, b, x, U) {
      return b === null || b.tag !== 6
        ? ((b = Zu(x, M.mode, U)), (b.return = M), b)
        : ((b = s(b, x)), (b.return = M), b);
    }
    function T(M, b, x, U) {
      var I = x.type;
      return I === j
        ? R(M, b, x.props.children, U, x.key)
        : b !== null &&
            (b.elementType === I ||
              (typeof I == "object" &&
                I !== null &&
                I.$$typeof === K &&
                ui(I) === b.type))
          ? ((b = s(b, x.props)), Ua(b, x), (b.return = M), b)
          : ((b = Zl(x.type, x.key, x.props, null, M.mode, U)),
            Ua(b, x),
            (b.return = M),
            b);
    }
    function D(M, b, x, U) {
      return b === null ||
        b.tag !== 4 ||
        b.stateNode.containerInfo !== x.containerInfo ||
        b.stateNode.implementation !== x.implementation
        ? ((b = Ku(x, M.mode, U)), (b.return = M), b)
        : ((b = s(b, x.children || [])), (b.return = M), b);
    }
    function R(M, b, x, U, I) {
      return b === null || b.tag !== 7
        ? ((b = ni(x, M.mode, U, I)), (b.return = M), b)
        : ((b = s(b, x)), (b.return = M), b);
    }
    function B(M, b, x) {
      if (
        (typeof b == "string" && b !== "") ||
        typeof b == "number" ||
        typeof b == "bigint"
      )
        return ((b = Zu("" + b, M.mode, x)), (b.return = M), b);
      if (typeof b == "object" && b !== null) {
        switch (b.$$typeof) {
          case z:
            return (
              (x = Zl(b.type, b.key, b.props, null, M.mode, x)),
              Ua(x, b),
              (x.return = M),
              x
            );
          case _:
            return ((b = Ku(b, M.mode, x)), (b.return = M), b);
          case K:
            return ((b = ui(b)), B(M, b, x));
        }
        if (ue(b) || wt(b))
          return ((b = ni(b, M.mode, x, null)), (b.return = M), b);
        if (typeof b.then == "function") return B(M, $l(b), x);
        if (b.$$typeof === L) return B(M, Fl(M, b), x);
        Il(M, b);
      }
      return null;
    }
    function C(M, b, x, U) {
      var I = b !== null ? b.key : null;
      if (
        (typeof x == "string" && x !== "") ||
        typeof x == "number" ||
        typeof x == "bigint"
      )
        return I !== null ? null : m(M, b, "" + x, U);
      if (typeof x == "object" && x !== null) {
        switch (x.$$typeof) {
          case z:
            return x.key === I ? T(M, b, x, U) : null;
          case _:
            return x.key === I ? D(M, b, x, U) : null;
          case K:
            return ((x = ui(x)), C(M, b, x, U));
        }
        if (ue(x) || wt(x)) return I !== null ? null : R(M, b, x, U, null);
        if (typeof x.then == "function") return C(M, b, $l(x), U);
        if (x.$$typeof === L) return C(M, b, Fl(M, x), U);
        Il(M, x);
      }
      return null;
    }
    function O(M, b, x, U, I) {
      if (
        (typeof U == "string" && U !== "") ||
        typeof U == "number" ||
        typeof U == "bigint"
      )
        return ((M = M.get(x) || null), m(b, M, "" + U, I));
      if (typeof U == "object" && U !== null) {
        switch (U.$$typeof) {
          case z:
            return (
              (M = M.get(U.key === null ? x : U.key) || null),
              T(b, M, U, I)
            );
          case _:
            return (
              (M = M.get(U.key === null ? x : U.key) || null),
              D(b, M, U, I)
            );
          case K:
            return ((U = ui(U)), O(M, b, x, U, I));
        }
        if (ue(U) || wt(U))
          return ((M = M.get(x) || null), R(b, M, U, I, null));
        if (typeof U.then == "function") return O(M, b, x, $l(U), I);
        if (U.$$typeof === L) return O(M, b, x, Fl(b, U), I);
        Il(b, U);
      }
      return null;
    }
    function Q(M, b, x, U) {
      for (
        var I = null, yt = null, k = b, st = (b = 0), ht = null;
        k !== null && st < x.length;
        st++
      ) {
        k.index > st ? ((ht = k), (k = null)) : (ht = k.sibling);
        var pt = C(M, k, x[st], U);
        if (pt === null) {
          k === null && (k = ht);
          break;
        }
        (t && k && pt.alternate === null && e(M, k),
          (b = o(pt, b, st)),
          yt === null ? (I = pt) : (yt.sibling = pt),
          (yt = pt),
          (k = ht));
      }
      if (st === x.length) return (n(M, k), dt && nn(M, st), I);
      if (k === null) {
        for (; st < x.length; st++)
          ((k = B(M, x[st], U)),
            k !== null &&
              ((b = o(k, b, st)),
              yt === null ? (I = k) : (yt.sibling = k),
              (yt = k)));
        return (dt && nn(M, st), I);
      }
      for (k = i(k); st < x.length; st++)
        ((ht = O(k, M, st, x[st], U)),
          ht !== null &&
            (t &&
              ht.alternate !== null &&
              k.delete(ht.key === null ? st : ht.key),
            (b = o(ht, b, st)),
            yt === null ? (I = ht) : (yt.sibling = ht),
            (yt = ht)));
      return (
        t &&
          k.forEach(function (Xn) {
            return e(M, Xn);
          }),
        dt && nn(M, st),
        I
      );
    }
    function tt(M, b, x, U) {
      if (x == null) throw Error(r(151));
      for (
        var I = null, yt = null, k = b, st = (b = 0), ht = null, pt = x.next();
        k !== null && !pt.done;
        st++, pt = x.next()
      ) {
        k.index > st ? ((ht = k), (k = null)) : (ht = k.sibling);
        var Xn = C(M, k, pt.value, U);
        if (Xn === null) {
          k === null && (k = ht);
          break;
        }
        (t && k && Xn.alternate === null && e(M, k),
          (b = o(Xn, b, st)),
          yt === null ? (I = Xn) : (yt.sibling = Xn),
          (yt = Xn),
          (k = ht));
      }
      if (pt.done) return (n(M, k), dt && nn(M, st), I);
      if (k === null) {
        for (; !pt.done; st++, pt = x.next())
          ((pt = B(M, pt.value, U)),
            pt !== null &&
              ((b = o(pt, b, st)),
              yt === null ? (I = pt) : (yt.sibling = pt),
              (yt = pt)));
        return (dt && nn(M, st), I);
      }
      for (k = i(k); !pt.done; st++, pt = x.next())
        ((pt = O(k, M, st, pt.value, U)),
          pt !== null &&
            (t &&
              pt.alternate !== null &&
              k.delete(pt.key === null ? st : pt.key),
            (b = o(pt, b, st)),
            yt === null ? (I = pt) : (yt.sibling = pt),
            (yt = pt)));
      return (
        t &&
          k.forEach(function (B1) {
            return e(M, B1);
          }),
        dt && nn(M, st),
        I
      );
    }
    function Et(M, b, x, U) {
      if (
        (typeof x == "object" &&
          x !== null &&
          x.type === j &&
          x.key === null &&
          (x = x.props.children),
        typeof x == "object" && x !== null)
      ) {
        switch (x.$$typeof) {
          case z:
            t: {
              for (var I = x.key; b !== null; ) {
                if (b.key === I) {
                  if (((I = x.type), I === j)) {
                    if (b.tag === 7) {
                      (n(M, b.sibling),
                        (U = s(b, x.props.children)),
                        (U.return = M),
                        (M = U));
                      break t;
                    }
                  } else if (
                    b.elementType === I ||
                    (typeof I == "object" &&
                      I !== null &&
                      I.$$typeof === K &&
                      ui(I) === b.type)
                  ) {
                    (n(M, b.sibling),
                      (U = s(b, x.props)),
                      Ua(U, x),
                      (U.return = M),
                      (M = U));
                    break t;
                  }
                  n(M, b);
                  break;
                } else e(M, b);
                b = b.sibling;
              }
              x.type === j
                ? ((U = ni(x.props.children, M.mode, U, x.key)),
                  (U.return = M),
                  (M = U))
                : ((U = Zl(x.type, x.key, x.props, null, M.mode, U)),
                  Ua(U, x),
                  (U.return = M),
                  (M = U));
            }
            return f(M);
          case _:
            t: {
              for (I = x.key; b !== null; ) {
                if (b.key === I)
                  if (
                    b.tag === 4 &&
                    b.stateNode.containerInfo === x.containerInfo &&
                    b.stateNode.implementation === x.implementation
                  ) {
                    (n(M, b.sibling),
                      (U = s(b, x.children || [])),
                      (U.return = M),
                      (M = U));
                    break t;
                  } else {
                    n(M, b);
                    break;
                  }
                else e(M, b);
                b = b.sibling;
              }
              ((U = Ku(x, M.mode, U)), (U.return = M), (M = U));
            }
            return f(M);
          case K:
            return ((x = ui(x)), Et(M, b, x, U));
        }
        if (ue(x)) return Q(M, b, x, U);
        if (wt(x)) {
          if (((I = wt(x)), typeof I != "function")) throw Error(r(150));
          return ((x = I.call(x)), tt(M, b, x, U));
        }
        if (typeof x.then == "function") return Et(M, b, $l(x), U);
        if (x.$$typeof === L) return Et(M, b, Fl(M, x), U);
        Il(M, x);
      }
      return (typeof x == "string" && x !== "") ||
        typeof x == "number" ||
        typeof x == "bigint"
        ? ((x = "" + x),
          b !== null && b.tag === 6
            ? (n(M, b.sibling), (U = s(b, x)), (U.return = M), (M = U))
            : (n(M, b), (U = Zu(x, M.mode, U)), (U.return = M), (M = U)),
          f(M))
        : n(M, b);
    }
    return function (M, b, x, U) {
      try {
        _a = 0;
        var I = Et(M, b, x, U);
        return ((qi = null), I);
      } catch (k) {
        if (k === Yi || k === Wl) throw k;
        var yt = Se(29, k, null, M.mode);
        return ((yt.lanes = U), (yt.return = M), yt);
      }
    };
  }
  var ri = ph(!0),
    gh = ph(!1),
    Dn = !1;
  function ao(t) {
    t.updateQueue = {
      baseState: t.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: { pending: null, lanes: 0, hiddenCallbacks: null },
      callbacks: null,
    };
  }
  function lo(t, e) {
    ((t = t.updateQueue),
      e.updateQueue === t &&
        (e.updateQueue = {
          baseState: t.baseState,
          firstBaseUpdate: t.firstBaseUpdate,
          lastBaseUpdate: t.lastBaseUpdate,
          shared: t.shared,
          callbacks: null,
        }));
  }
  function Cn(t) {
    return { lane: t, tag: 0, payload: null, callback: null, next: null };
  }
  function zn(t, e, n) {
    var i = t.updateQueue;
    if (i === null) return null;
    if (((i = i.shared), (gt & 2) !== 0)) {
      var s = i.pending;
      return (
        s === null ? (e.next = e) : ((e.next = s.next), (s.next = e)),
        (i.pending = e),
        (e = Ql(t)),
        th(t, null, n),
        e
      );
    }
    return (Xl(t, i, e, n), Ql(t));
  }
  function Ba(t, e, n) {
    if (
      ((e = e.updateQueue), e !== null && ((e = e.shared), (n & 4194048) !== 0))
    ) {
      var i = e.lanes;
      ((i &= t.pendingLanes), (n |= i), (e.lanes = n), of(t, n));
    }
  }
  function so(t, e) {
    var n = t.updateQueue,
      i = t.alternate;
    if (i !== null && ((i = i.updateQueue), n === i)) {
      var s = null,
        o = null;
      if (((n = n.firstBaseUpdate), n !== null)) {
        do {
          var f = {
            lane: n.lane,
            tag: n.tag,
            payload: n.payload,
            callback: null,
            next: null,
          };
          (o === null ? (s = o = f) : (o = o.next = f), (n = n.next));
        } while (n !== null);
        o === null ? (s = o = e) : (o = o.next = e);
      } else s = o = e;
      ((n = {
        baseState: i.baseState,
        firstBaseUpdate: s,
        lastBaseUpdate: o,
        shared: i.shared,
        callbacks: i.callbacks,
      }),
        (t.updateQueue = n));
      return;
    }
    ((t = n.lastBaseUpdate),
      t === null ? (n.firstBaseUpdate = e) : (t.next = e),
      (n.lastBaseUpdate = e));
  }
  var uo = !1;
  function Na() {
    if (uo) {
      var t = wi;
      if (t !== null) throw t;
    }
  }
  function ja(t, e, n, i) {
    uo = !1;
    var s = t.updateQueue;
    Dn = !1;
    var o = s.firstBaseUpdate,
      f = s.lastBaseUpdate,
      m = s.shared.pending;
    if (m !== null) {
      s.shared.pending = null;
      var T = m,
        D = T.next;
      ((T.next = null), f === null ? (o = D) : (f.next = D), (f = T));
      var R = t.alternate;
      R !== null &&
        ((R = R.updateQueue),
        (m = R.lastBaseUpdate),
        m !== f &&
          (m === null ? (R.firstBaseUpdate = D) : (m.next = D),
          (R.lastBaseUpdate = T)));
    }
    if (o !== null) {
      var B = s.baseState;
      ((f = 0), (R = D = T = null), (m = o));
      do {
        var C = m.lane & -536870913,
          O = C !== m.lane;
        if (O ? (ft & C) === C : (i & C) === C) {
          (C !== 0 && C === Hi && (uo = !0),
            R !== null &&
              (R = R.next =
                {
                  lane: 0,
                  tag: m.tag,
                  payload: m.payload,
                  callback: null,
                  next: null,
                }));
          t: {
            var Q = t,
              tt = m;
            C = e;
            var Et = n;
            switch (tt.tag) {
              case 1:
                if (((Q = tt.payload), typeof Q == "function")) {
                  B = Q.call(Et, B, C);
                  break t;
                }
                B = Q;
                break t;
              case 3:
                Q.flags = (Q.flags & -65537) | 128;
              case 0:
                if (
                  ((Q = tt.payload),
                  (C = typeof Q == "function" ? Q.call(Et, B, C) : Q),
                  C == null)
                )
                  break t;
                B = S({}, B, C);
                break t;
              case 2:
                Dn = !0;
            }
          }
          ((C = m.callback),
            C !== null &&
              ((t.flags |= 64),
              O && (t.flags |= 8192),
              (O = s.callbacks),
              O === null ? (s.callbacks = [C]) : O.push(C)));
        } else
          ((O = {
            lane: C,
            tag: m.tag,
            payload: m.payload,
            callback: m.callback,
            next: null,
          }),
            R === null ? ((D = R = O), (T = B)) : (R = R.next = O),
            (f |= C));
        if (((m = m.next), m === null)) {
          if (((m = s.shared.pending), m === null)) break;
          ((O = m),
            (m = O.next),
            (O.next = null),
            (s.lastBaseUpdate = O),
            (s.shared.pending = null));
        }
      } while (!0);
      (R === null && (T = B),
        (s.baseState = T),
        (s.firstBaseUpdate = D),
        (s.lastBaseUpdate = R),
        o === null && (s.shared.lanes = 0),
        (Un |= f),
        (t.lanes = f),
        (t.memoizedState = B));
    }
  }
  function vh(t, e) {
    if (typeof t != "function") throw Error(r(191, t));
    t.call(e);
  }
  function Sh(t, e) {
    var n = t.callbacks;
    if (n !== null)
      for (t.callbacks = null, t = 0; t < n.length; t++) vh(n[t], e);
  }
  var Gi = A(null),
    ts = A(0);
  function Th(t, e) {
    ((t = mn), G(ts, t), G(Gi, e), (mn = t | e.baseLanes));
  }
  function oo() {
    (G(ts, mn), G(Gi, Gi.current));
  }
  function ro() {
    ((mn = ts.current), N(Gi), N(ts));
  }
  var Te = A(null),
    Be = null;
  function On(t) {
    var e = t.alternate;
    (G(jt, jt.current & 1),
      G(Te, t),
      Be === null &&
        (e === null || Gi.current !== null || e.memoizedState !== null) &&
        (Be = t));
  }
  function co(t) {
    (G(jt, jt.current), G(Te, t), Be === null && (Be = t));
  }
  function bh(t) {
    t.tag === 22
      ? (G(jt, jt.current), G(Te, t), Be === null && (Be = t))
      : Rn();
  }
  function Rn() {
    (G(jt, jt.current), G(Te, Te.current));
  }
  function be(t) {
    (N(Te), Be === t && (Be = null), N(jt));
  }
  var jt = A(0);
  function es(t) {
    for (var e = t; e !== null; ) {
      if (e.tag === 13) {
        var n = e.memoizedState;
        if (n !== null && ((n = n.dehydrated), n === null || gr(n) || vr(n)))
          return e;
      } else if (
        e.tag === 19 &&
        (e.memoizedProps.revealOrder === "forwards" ||
          e.memoizedProps.revealOrder === "backwards" ||
          e.memoizedProps.revealOrder === "unstable_legacy-backwards" ||
          e.memoizedProps.revealOrder === "together")
      ) {
        if ((e.flags & 128) !== 0) return e;
      } else if (e.child !== null) {
        ((e.child.return = e), (e = e.child));
        continue;
      }
      if (e === t) break;
      for (; e.sibling === null; ) {
        if (e.return === null || e.return === t) return null;
        e = e.return;
      }
      ((e.sibling.return = e.return), (e = e.sibling));
    }
    return null;
  }
  var sn = 0,
    lt = null,
    bt = null,
    qt = null,
    ns = !1,
    Xi = !1,
    ci = !1,
    is = 0,
    La = 0,
    Qi = null,
    Mv = 0;
  function Vt() {
    throw Error(r(321));
  }
  function fo(t, e) {
    if (e === null) return !1;
    for (var n = 0; n < e.length && n < t.length; n++)
      if (!ve(t[n], e[n])) return !1;
    return !0;
  }
  function ho(t, e, n, i, s, o) {
    return (
      (sn = o),
      (lt = e),
      (e.memoizedState = null),
      (e.updateQueue = null),
      (e.lanes = 0),
      (V.H = t === null || t.memoizedState === null ? ad : zo),
      (ci = !1),
      (o = n(i, s)),
      (ci = !1),
      Xi && (o = Eh(e, n, i, s)),
      Ah(t),
      o
    );
  }
  function Ah(t) {
    V.H = Ya;
    var e = bt !== null && bt.next !== null;
    if (((sn = 0), (qt = bt = lt = null), (ns = !1), (La = 0), (Qi = null), e))
      throw Error(r(300));
    t === null ||
      Gt ||
      ((t = t.dependencies), t !== null && Jl(t) && (Gt = !0));
  }
  function Eh(t, e, n, i) {
    lt = t;
    var s = 0;
    do {
      if ((Xi && (Qi = null), (La = 0), (Xi = !1), 25 <= s))
        throw Error(r(301));
      if (((s += 1), (qt = bt = null), t.updateQueue != null)) {
        var o = t.updateQueue;
        ((o.lastEffect = null),
          (o.events = null),
          (o.stores = null),
          o.memoCache != null && (o.memoCache.index = 0));
      }
      ((V.H = ld), (o = e(n, i)));
    } while (Xi);
    return o;
  }
  function xv() {
    var t = V.H,
      e = t.useState()[0];
    return (
      (e = typeof e.then == "function" ? Ha(e) : e),
      (t = t.useState()[0]),
      (bt !== null ? bt.memoizedState : null) !== t && (lt.flags |= 1024),
      e
    );
  }
  function mo() {
    var t = is !== 0;
    return ((is = 0), t);
  }
  function yo(t, e, n) {
    ((e.updateQueue = t.updateQueue), (e.flags &= -2053), (t.lanes &= ~n));
  }
  function po(t) {
    if (ns) {
      for (t = t.memoizedState; t !== null; ) {
        var e = t.queue;
        (e !== null && (e.pending = null), (t = t.next));
      }
      ns = !1;
    }
    ((sn = 0), (qt = bt = lt = null), (Xi = !1), (La = is = 0), (Qi = null));
  }
  function ae() {
    var t = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null,
    };
    return (qt === null ? (lt.memoizedState = qt = t) : (qt = qt.next = t), qt);
  }
  function Lt() {
    if (bt === null) {
      var t = lt.alternate;
      t = t !== null ? t.memoizedState : null;
    } else t = bt.next;
    var e = qt === null ? lt.memoizedState : qt.next;
    if (e !== null) ((qt = e), (bt = t));
    else {
      if (t === null)
        throw lt.alternate === null ? Error(r(467)) : Error(r(310));
      ((bt = t),
        (t = {
          memoizedState: bt.memoizedState,
          baseState: bt.baseState,
          baseQueue: bt.baseQueue,
          queue: bt.queue,
          next: null,
        }),
        qt === null ? (lt.memoizedState = qt = t) : (qt = qt.next = t));
    }
    return qt;
  }
  function as() {
    return { lastEffect: null, events: null, stores: null, memoCache: null };
  }
  function Ha(t) {
    var e = La;
    return (
      (La += 1),
      Qi === null && (Qi = []),
      (t = dh(Qi, t, e)),
      (e = lt),
      (qt === null ? e.memoizedState : qt.next) === null &&
        ((e = e.alternate),
        (V.H = e === null || e.memoizedState === null ? ad : zo)),
      t
    );
  }
  function ls(t) {
    if (t !== null && typeof t == "object") {
      if (typeof t.then == "function") return Ha(t);
      if (t.$$typeof === L) return Pt(t);
    }
    throw Error(r(438, String(t)));
  }
  function go(t) {
    var e = null,
      n = lt.updateQueue;
    if ((n !== null && (e = n.memoCache), e == null)) {
      var i = lt.alternate;
      i !== null &&
        ((i = i.updateQueue),
        i !== null &&
          ((i = i.memoCache),
          i != null &&
            (e = {
              data: i.data.map(function (s) {
                return s.slice();
              }),
              index: 0,
            })));
    }
    if (
      (e == null && (e = { data: [], index: 0 }),
      n === null && ((n = as()), (lt.updateQueue = n)),
      (n.memoCache = e),
      (n = e.data[e.index]),
      n === void 0)
    )
      for (n = e.data[e.index] = Array(t), i = 0; i < t; i++) n[i] = xt;
    return (e.index++, n);
  }
  function un(t, e) {
    return typeof e == "function" ? e(t) : e;
  }
  function ss(t) {
    var e = Lt();
    return vo(e, bt, t);
  }
  function vo(t, e, n) {
    var i = t.queue;
    if (i === null) throw Error(r(311));
    i.lastRenderedReducer = n;
    var s = t.baseQueue,
      o = i.pending;
    if (o !== null) {
      if (s !== null) {
        var f = s.next;
        ((s.next = o.next), (o.next = f));
      }
      ((e.baseQueue = s = o), (i.pending = null));
    }
    if (((o = t.baseState), s === null)) t.memoizedState = o;
    else {
      e = s.next;
      var m = (f = null),
        T = null,
        D = e,
        R = !1;
      do {
        var B = D.lane & -536870913;
        if (B !== D.lane ? (ft & B) === B : (sn & B) === B) {
          var C = D.revertLane;
          if (C === 0)
            (T !== null &&
              (T = T.next =
                {
                  lane: 0,
                  revertLane: 0,
                  gesture: null,
                  action: D.action,
                  hasEagerState: D.hasEagerState,
                  eagerState: D.eagerState,
                  next: null,
                }),
              B === Hi && (R = !0));
          else if ((sn & C) === C) {
            ((D = D.next), C === Hi && (R = !0));
            continue;
          } else
            ((B = {
              lane: 0,
              revertLane: D.revertLane,
              gesture: null,
              action: D.action,
              hasEagerState: D.hasEagerState,
              eagerState: D.eagerState,
              next: null,
            }),
              T === null ? ((m = T = B), (f = o)) : (T = T.next = B),
              (lt.lanes |= C),
              (Un |= C));
          ((B = D.action),
            ci && n(o, B),
            (o = D.hasEagerState ? D.eagerState : n(o, B)));
        } else
          ((C = {
            lane: B,
            revertLane: D.revertLane,
            gesture: D.gesture,
            action: D.action,
            hasEagerState: D.hasEagerState,
            eagerState: D.eagerState,
            next: null,
          }),
            T === null ? ((m = T = C), (f = o)) : (T = T.next = C),
            (lt.lanes |= B),
            (Un |= B));
        D = D.next;
      } while (D !== null && D !== e);
      if (
        (T === null ? (f = o) : (T.next = m),
        !ve(o, t.memoizedState) && ((Gt = !0), R && ((n = wi), n !== null)))
      )
        throw n;
      ((t.memoizedState = o),
        (t.baseState = f),
        (t.baseQueue = T),
        (i.lastRenderedState = o));
    }
    return (s === null && (i.lanes = 0), [t.memoizedState, i.dispatch]);
  }
  function So(t) {
    var e = Lt(),
      n = e.queue;
    if (n === null) throw Error(r(311));
    n.lastRenderedReducer = t;
    var i = n.dispatch,
      s = n.pending,
      o = e.memoizedState;
    if (s !== null) {
      n.pending = null;
      var f = (s = s.next);
      do ((o = t(o, f.action)), (f = f.next));
      while (f !== s);
      (ve(o, e.memoizedState) || (Gt = !0),
        (e.memoizedState = o),
        e.baseQueue === null && (e.baseState = o),
        (n.lastRenderedState = o));
    }
    return [o, i];
  }
  function Mh(t, e, n) {
    var i = lt,
      s = Lt(),
      o = dt;
    if (o) {
      if (n === void 0) throw Error(r(407));
      n = n();
    } else n = e();
    var f = !ve((bt || s).memoizedState, n);
    if (
      (f && ((s.memoizedState = n), (Gt = !0)),
      (s = s.queue),
      Ao(Ch.bind(null, i, s, t), [t]),
      s.getSnapshot !== e || f || (qt !== null && qt.memoizedState.tag & 1))
    ) {
      if (
        ((i.flags |= 2048),
        Zi(9, { destroy: void 0 }, Dh.bind(null, i, s, n, e), null),
        Mt === null)
      )
        throw Error(r(349));
      o || (sn & 127) !== 0 || xh(i, e, n);
    }
    return n;
  }
  function xh(t, e, n) {
    ((t.flags |= 16384),
      (t = { getSnapshot: e, value: n }),
      (e = lt.updateQueue),
      e === null
        ? ((e = as()), (lt.updateQueue = e), (e.stores = [t]))
        : ((n = e.stores), n === null ? (e.stores = [t]) : n.push(t)));
  }
  function Dh(t, e, n, i) {
    ((e.value = n), (e.getSnapshot = i), zh(e) && Oh(t));
  }
  function Ch(t, e, n) {
    return n(function () {
      zh(e) && Oh(t);
    });
  }
  function zh(t) {
    var e = t.getSnapshot;
    t = t.value;
    try {
      var n = e();
      return !ve(t, n);
    } catch {
      return !0;
    }
  }
  function Oh(t) {
    var e = ei(t, 2);
    e !== null && me(e, t, 2);
  }
  function To(t) {
    var e = ae();
    if (typeof t == "function") {
      var n = t;
      if (((t = n()), ci)) {
        Sn(!0);
        try {
          n();
        } finally {
          Sn(!1);
        }
      }
    }
    return (
      (e.memoizedState = e.baseState = t),
      (e.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: un,
        lastRenderedState: t,
      }),
      e
    );
  }
  function Rh(t, e, n, i) {
    return ((t.baseState = n), vo(t, bt, typeof i == "function" ? i : un));
  }
  function Dv(t, e, n, i, s) {
    if (rs(t)) throw Error(r(485));
    if (((t = e.action), t !== null)) {
      var o = {
        payload: s,
        action: t,
        next: null,
        isTransition: !0,
        status: "pending",
        value: null,
        reason: null,
        listeners: [],
        then: function (f) {
          o.listeners.push(f);
        },
      };
      (V.T !== null ? n(!0) : (o.isTransition = !1),
        i(o),
        (n = e.pending),
        n === null
          ? ((o.next = e.pending = o), Vh(e, o))
          : ((o.next = n.next), (e.pending = n.next = o)));
    }
  }
  function Vh(t, e) {
    var n = e.action,
      i = e.payload,
      s = t.state;
    if (e.isTransition) {
      var o = V.T,
        f = {};
      V.T = f;
      try {
        var m = n(s, i),
          T = V.S;
        (T !== null && T(f, m), _h(t, e, m));
      } catch (D) {
        bo(t, e, D);
      } finally {
        (o !== null && f.types !== null && (o.types = f.types), (V.T = o));
      }
    } else
      try {
        ((o = n(s, i)), _h(t, e, o));
      } catch (D) {
        bo(t, e, D);
      }
  }
  function _h(t, e, n) {
    n !== null && typeof n == "object" && typeof n.then == "function"
      ? n.then(
          function (i) {
            Uh(t, e, i);
          },
          function (i) {
            return bo(t, e, i);
          },
        )
      : Uh(t, e, n);
  }
  function Uh(t, e, n) {
    ((e.status = "fulfilled"),
      (e.value = n),
      Bh(e),
      (t.state = n),
      (e = t.pending),
      e !== null &&
        ((n = e.next),
        n === e ? (t.pending = null) : ((n = n.next), (e.next = n), Vh(t, n))));
  }
  function bo(t, e, n) {
    var i = t.pending;
    if (((t.pending = null), i !== null)) {
      i = i.next;
      do ((e.status = "rejected"), (e.reason = n), Bh(e), (e = e.next));
      while (e !== i);
    }
    t.action = null;
  }
  function Bh(t) {
    t = t.listeners;
    for (var e = 0; e < t.length; e++) (0, t[e])();
  }
  function Nh(t, e) {
    return e;
  }
  function jh(t, e) {
    if (dt) {
      var n = Mt.formState;
      if (n !== null) {
        t: {
          var i = lt;
          if (dt) {
            if (Dt) {
              e: {
                for (var s = Dt, o = Ue; s.nodeType !== 8; ) {
                  if (!o) {
                    s = null;
                    break e;
                  }
                  if (((s = Ne(s.nextSibling)), s === null)) {
                    s = null;
                    break e;
                  }
                }
                ((o = s.data), (s = o === "F!" || o === "F" ? s : null));
              }
              if (s) {
                ((Dt = Ne(s.nextSibling)), (i = s.data === "F!"));
                break t;
              }
            }
            Mn(i);
          }
          i = !1;
        }
        i && (e = n[0]);
      }
    }
    return (
      (n = ae()),
      (n.memoizedState = n.baseState = e),
      (i = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Nh,
        lastRenderedState: e,
      }),
      (n.queue = i),
      (n = ed.bind(null, lt, i)),
      (i.dispatch = n),
      (i = To(!1)),
      (o = Co.bind(null, lt, !1, i.queue)),
      (i = ae()),
      (s = { state: e, dispatch: null, action: t, pending: null }),
      (i.queue = s),
      (n = Dv.bind(null, lt, s, o, n)),
      (s.dispatch = n),
      (i.memoizedState = t),
      [e, n, !1]
    );
  }
  function Lh(t) {
    var e = Lt();
    return Hh(e, bt, t);
  }
  function Hh(t, e, n) {
    if (
      ((e = vo(t, e, Nh)[0]),
      (t = ss(un)[0]),
      typeof e == "object" && e !== null && typeof e.then == "function")
    )
      try {
        var i = Ha(e);
      } catch (f) {
        throw f === Yi ? Wl : f;
      }
    else i = e;
    e = Lt();
    var s = e.queue,
      o = s.dispatch;
    return (
      n !== e.memoizedState &&
        ((lt.flags |= 2048),
        Zi(9, { destroy: void 0 }, Cv.bind(null, s, n), null)),
      [i, o, t]
    );
  }
  function Cv(t, e) {
    t.action = e;
  }
  function wh(t) {
    var e = Lt(),
      n = bt;
    if (n !== null) return Hh(e, n, t);
    (Lt(), (e = e.memoizedState), (n = Lt()));
    var i = n.queue.dispatch;
    return ((n.memoizedState = t), [e, i, !1]);
  }
  function Zi(t, e, n, i) {
    return (
      (t = { tag: t, create: n, deps: i, inst: e, next: null }),
      (e = lt.updateQueue),
      e === null && ((e = as()), (lt.updateQueue = e)),
      (n = e.lastEffect),
      n === null
        ? (e.lastEffect = t.next = t)
        : ((i = n.next), (n.next = t), (t.next = i), (e.lastEffect = t)),
      t
    );
  }
  function Yh() {
    return Lt().memoizedState;
  }
  function us(t, e, n, i) {
    var s = ae();
    ((lt.flags |= t),
      (s.memoizedState = Zi(
        1 | e,
        { destroy: void 0 },
        n,
        i === void 0 ? null : i,
      )));
  }
  function os(t, e, n, i) {
    var s = Lt();
    i = i === void 0 ? null : i;
    var o = s.memoizedState.inst;
    bt !== null && i !== null && fo(i, bt.memoizedState.deps)
      ? (s.memoizedState = Zi(e, o, n, i))
      : ((lt.flags |= t), (s.memoizedState = Zi(1 | e, o, n, i)));
  }
  function qh(t, e) {
    us(8390656, 8, t, e);
  }
  function Ao(t, e) {
    os(2048, 8, t, e);
  }
  function zv(t) {
    lt.flags |= 4;
    var e = lt.updateQueue;
    if (e === null) ((e = as()), (lt.updateQueue = e), (e.events = [t]));
    else {
      var n = e.events;
      n === null ? (e.events = [t]) : n.push(t);
    }
  }
  function Gh(t) {
    var e = Lt().memoizedState;
    return (
      zv({ ref: e, nextImpl: t }),
      function () {
        if ((gt & 2) !== 0) throw Error(r(440));
        return e.impl.apply(void 0, arguments);
      }
    );
  }
  function Xh(t, e) {
    return os(4, 2, t, e);
  }
  function Qh(t, e) {
    return os(4, 4, t, e);
  }
  function Zh(t, e) {
    if (typeof e == "function") {
      t = t();
      var n = e(t);
      return function () {
        typeof n == "function" ? n() : e(null);
      };
    }
    if (e != null)
      return (
        (t = t()),
        (e.current = t),
        function () {
          e.current = null;
        }
      );
  }
  function Kh(t, e, n) {
    ((n = n != null ? n.concat([t]) : null), os(4, 4, Zh.bind(null, e, t), n));
  }
  function Eo() {}
  function Jh(t, e) {
    var n = Lt();
    e = e === void 0 ? null : e;
    var i = n.memoizedState;
    return e !== null && fo(e, i[1]) ? i[0] : ((n.memoizedState = [t, e]), t);
  }
  function Fh(t, e) {
    var n = Lt();
    e = e === void 0 ? null : e;
    var i = n.memoizedState;
    if (e !== null && fo(e, i[1])) return i[0];
    if (((i = t()), ci)) {
      Sn(!0);
      try {
        t();
      } finally {
        Sn(!1);
      }
    }
    return ((n.memoizedState = [i, e]), i);
  }
  function Mo(t, e, n) {
    return n === void 0 || ((sn & 1073741824) !== 0 && (ft & 261930) === 0)
      ? (t.memoizedState = e)
      : ((t.memoizedState = n), (t = kd()), (lt.lanes |= t), (Un |= t), n);
  }
  function kh(t, e, n, i) {
    return ve(n, e)
      ? n
      : Gi.current !== null
        ? ((t = Mo(t, n, i)), ve(t, e) || (Gt = !0), t)
        : (sn & 42) === 0 || ((sn & 1073741824) !== 0 && (ft & 261930) === 0)
          ? ((Gt = !0), (t.memoizedState = n))
          : ((t = kd()), (lt.lanes |= t), (Un |= t), e);
  }
  function Wh(t, e, n, i, s) {
    var o = w.p;
    w.p = o !== 0 && 8 > o ? o : 8;
    var f = V.T,
      m = {};
    ((V.T = m), Co(t, !1, e, n));
    try {
      var T = s(),
        D = V.S;
      if (
        (D !== null && D(m, T),
        T !== null && typeof T == "object" && typeof T.then == "function")
      ) {
        var R = Ev(T, i);
        wa(t, e, R, Me(t));
      } else wa(t, e, i, Me(t));
    } catch (B) {
      wa(t, e, { then: function () {}, status: "rejected", reason: B }, Me());
    } finally {
      ((w.p = o),
        f !== null && m.types !== null && (f.types = m.types),
        (V.T = f));
    }
  }
  function Ov() {}
  function xo(t, e, n, i) {
    if (t.tag !== 5) throw Error(r(476));
    var s = Ph(t).queue;
    Wh(
      t,
      s,
      e,
      F,
      n === null
        ? Ov
        : function () {
            return ($h(t), n(i));
          },
    );
  }
  function Ph(t) {
    var e = t.memoizedState;
    if (e !== null) return e;
    e = {
      memoizedState: F,
      baseState: F,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: un,
        lastRenderedState: F,
      },
      next: null,
    };
    var n = {};
    return (
      (e.next = {
        memoizedState: n,
        baseState: n,
        baseQueue: null,
        queue: {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: un,
          lastRenderedState: n,
        },
        next: null,
      }),
      (t.memoizedState = e),
      (t = t.alternate),
      t !== null && (t.memoizedState = e),
      e
    );
  }
  function $h(t) {
    var e = Ph(t);
    (e.next === null && (e = t.alternate.memoizedState),
      wa(t, e.next.queue, {}, Me()));
  }
  function Do() {
    return Pt(nl);
  }
  function Ih() {
    return Lt().memoizedState;
  }
  function td() {
    return Lt().memoizedState;
  }
  function Rv(t) {
    for (var e = t.return; e !== null; ) {
      switch (e.tag) {
        case 24:
        case 3:
          var n = Me();
          t = Cn(n);
          var i = zn(e, t, n);
          (i !== null && (me(i, e, n), Ba(i, e, n)),
            (e = { cache: to() }),
            (t.payload = e));
          return;
      }
      e = e.return;
    }
  }
  function Vv(t, e, n) {
    var i = Me();
    ((n = {
      lane: i,
      revertLane: 0,
      gesture: null,
      action: n,
      hasEagerState: !1,
      eagerState: null,
      next: null,
    }),
      rs(t)
        ? nd(e, n)
        : ((n = Xu(t, e, n, i)), n !== null && (me(n, t, i), id(n, e, i))));
  }
  function ed(t, e, n) {
    var i = Me();
    wa(t, e, n, i);
  }
  function wa(t, e, n, i) {
    var s = {
      lane: i,
      revertLane: 0,
      gesture: null,
      action: n,
      hasEagerState: !1,
      eagerState: null,
      next: null,
    };
    if (rs(t)) nd(e, s);
    else {
      var o = t.alternate;
      if (
        t.lanes === 0 &&
        (o === null || o.lanes === 0) &&
        ((o = e.lastRenderedReducer), o !== null)
      )
        try {
          var f = e.lastRenderedState,
            m = o(f, n);
          if (((s.hasEagerState = !0), (s.eagerState = m), ve(m, f)))
            return (Xl(t, e, s, 0), Mt === null && Gl(), !1);
        } catch {}
      if (((n = Xu(t, e, s, i)), n !== null))
        return (me(n, t, i), id(n, e, i), !0);
    }
    return !1;
  }
  function Co(t, e, n, i) {
    if (
      ((i = {
        lane: 2,
        revertLane: lr(),
        gesture: null,
        action: i,
        hasEagerState: !1,
        eagerState: null,
        next: null,
      }),
      rs(t))
    ) {
      if (e) throw Error(r(479));
    } else ((e = Xu(t, n, i, 2)), e !== null && me(e, t, 2));
  }
  function rs(t) {
    var e = t.alternate;
    return t === lt || (e !== null && e === lt);
  }
  function nd(t, e) {
    Xi = ns = !0;
    var n = t.pending;
    (n === null ? (e.next = e) : ((e.next = n.next), (n.next = e)),
      (t.pending = e));
  }
  function id(t, e, n) {
    if ((n & 4194048) !== 0) {
      var i = e.lanes;
      ((i &= t.pendingLanes), (n |= i), (e.lanes = n), of(t, n));
    }
  }
  var Ya = {
    readContext: Pt,
    use: ls,
    useCallback: Vt,
    useContext: Vt,
    useEffect: Vt,
    useImperativeHandle: Vt,
    useLayoutEffect: Vt,
    useInsertionEffect: Vt,
    useMemo: Vt,
    useReducer: Vt,
    useRef: Vt,
    useState: Vt,
    useDebugValue: Vt,
    useDeferredValue: Vt,
    useTransition: Vt,
    useSyncExternalStore: Vt,
    useId: Vt,
    useHostTransitionStatus: Vt,
    useFormState: Vt,
    useActionState: Vt,
    useOptimistic: Vt,
    useMemoCache: Vt,
    useCacheRefresh: Vt,
  };
  Ya.useEffectEvent = Vt;
  var ad = {
      readContext: Pt,
      use: ls,
      useCallback: function (t, e) {
        return ((ae().memoizedState = [t, e === void 0 ? null : e]), t);
      },
      useContext: Pt,
      useEffect: qh,
      useImperativeHandle: function (t, e, n) {
        ((n = n != null ? n.concat([t]) : null),
          us(4194308, 4, Zh.bind(null, e, t), n));
      },
      useLayoutEffect: function (t, e) {
        return us(4194308, 4, t, e);
      },
      useInsertionEffect: function (t, e) {
        us(4, 2, t, e);
      },
      useMemo: function (t, e) {
        var n = ae();
        e = e === void 0 ? null : e;
        var i = t();
        if (ci) {
          Sn(!0);
          try {
            t();
          } finally {
            Sn(!1);
          }
        }
        return ((n.memoizedState = [i, e]), i);
      },
      useReducer: function (t, e, n) {
        var i = ae();
        if (n !== void 0) {
          var s = n(e);
          if (ci) {
            Sn(!0);
            try {
              n(e);
            } finally {
              Sn(!1);
            }
          }
        } else s = e;
        return (
          (i.memoizedState = i.baseState = s),
          (t = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: t,
            lastRenderedState: s,
          }),
          (i.queue = t),
          (t = t.dispatch = Vv.bind(null, lt, t)),
          [i.memoizedState, t]
        );
      },
      useRef: function (t) {
        var e = ae();
        return ((t = { current: t }), (e.memoizedState = t));
      },
      useState: function (t) {
        t = To(t);
        var e = t.queue,
          n = ed.bind(null, lt, e);
        return ((e.dispatch = n), [t.memoizedState, n]);
      },
      useDebugValue: Eo,
      useDeferredValue: function (t, e) {
        var n = ae();
        return Mo(n, t, e);
      },
      useTransition: function () {
        var t = To(!1);
        return (
          (t = Wh.bind(null, lt, t.queue, !0, !1)),
          (ae().memoizedState = t),
          [!1, t]
        );
      },
      useSyncExternalStore: function (t, e, n) {
        var i = lt,
          s = ae();
        if (dt) {
          if (n === void 0) throw Error(r(407));
          n = n();
        } else {
          if (((n = e()), Mt === null)) throw Error(r(349));
          (ft & 127) !== 0 || xh(i, e, n);
        }
        s.memoizedState = n;
        var o = { value: n, getSnapshot: e };
        return (
          (s.queue = o),
          qh(Ch.bind(null, i, o, t), [t]),
          (i.flags |= 2048),
          Zi(9, { destroy: void 0 }, Dh.bind(null, i, o, n, e), null),
          n
        );
      },
      useId: function () {
        var t = ae(),
          e = Mt.identifierPrefix;
        if (dt) {
          var n = Je,
            i = Ke;
          ((n = (i & ~(1 << (32 - ge(i) - 1))).toString(32) + n),
            (e = "_" + e + "R_" + n),
            (n = is++),
            0 < n && (e += "H" + n.toString(32)),
            (e += "_"));
        } else ((n = Mv++), (e = "_" + e + "r_" + n.toString(32) + "_"));
        return (t.memoizedState = e);
      },
      useHostTransitionStatus: Do,
      useFormState: jh,
      useActionState: jh,
      useOptimistic: function (t) {
        var e = ae();
        e.memoizedState = e.baseState = t;
        var n = {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: null,
          lastRenderedState: null,
        };
        return (
          (e.queue = n),
          (e = Co.bind(null, lt, !0, n)),
          (n.dispatch = e),
          [t, e]
        );
      },
      useMemoCache: go,
      useCacheRefresh: function () {
        return (ae().memoizedState = Rv.bind(null, lt));
      },
      useEffectEvent: function (t) {
        var e = ae(),
          n = { impl: t };
        return (
          (e.memoizedState = n),
          function () {
            if ((gt & 2) !== 0) throw Error(r(440));
            return n.impl.apply(void 0, arguments);
          }
        );
      },
    },
    zo = {
      readContext: Pt,
      use: ls,
      useCallback: Jh,
      useContext: Pt,
      useEffect: Ao,
      useImperativeHandle: Kh,
      useInsertionEffect: Xh,
      useLayoutEffect: Qh,
      useMemo: Fh,
      useReducer: ss,
      useRef: Yh,
      useState: function () {
        return ss(un);
      },
      useDebugValue: Eo,
      useDeferredValue: function (t, e) {
        var n = Lt();
        return kh(n, bt.memoizedState, t, e);
      },
      useTransition: function () {
        var t = ss(un)[0],
          e = Lt().memoizedState;
        return [typeof t == "boolean" ? t : Ha(t), e];
      },
      useSyncExternalStore: Mh,
      useId: Ih,
      useHostTransitionStatus: Do,
      useFormState: Lh,
      useActionState: Lh,
      useOptimistic: function (t, e) {
        var n = Lt();
        return Rh(n, bt, t, e);
      },
      useMemoCache: go,
      useCacheRefresh: td,
    };
  zo.useEffectEvent = Gh;
  var ld = {
    readContext: Pt,
    use: ls,
    useCallback: Jh,
    useContext: Pt,
    useEffect: Ao,
    useImperativeHandle: Kh,
    useInsertionEffect: Xh,
    useLayoutEffect: Qh,
    useMemo: Fh,
    useReducer: So,
    useRef: Yh,
    useState: function () {
      return So(un);
    },
    useDebugValue: Eo,
    useDeferredValue: function (t, e) {
      var n = Lt();
      return bt === null ? Mo(n, t, e) : kh(n, bt.memoizedState, t, e);
    },
    useTransition: function () {
      var t = So(un)[0],
        e = Lt().memoizedState;
      return [typeof t == "boolean" ? t : Ha(t), e];
    },
    useSyncExternalStore: Mh,
    useId: Ih,
    useHostTransitionStatus: Do,
    useFormState: wh,
    useActionState: wh,
    useOptimistic: function (t, e) {
      var n = Lt();
      return bt !== null
        ? Rh(n, bt, t, e)
        : ((n.baseState = t), [t, n.queue.dispatch]);
    },
    useMemoCache: go,
    useCacheRefresh: td,
  };
  ld.useEffectEvent = Gh;
  function Oo(t, e, n, i) {
    ((e = t.memoizedState),
      (n = n(i, e)),
      (n = n == null ? e : S({}, e, n)),
      (t.memoizedState = n),
      t.lanes === 0 && (t.updateQueue.baseState = n));
  }
  var Ro = {
    enqueueSetState: function (t, e, n) {
      t = t._reactInternals;
      var i = Me(),
        s = Cn(i);
      ((s.payload = e),
        n != null && (s.callback = n),
        (e = zn(t, s, i)),
        e !== null && (me(e, t, i), Ba(e, t, i)));
    },
    enqueueReplaceState: function (t, e, n) {
      t = t._reactInternals;
      var i = Me(),
        s = Cn(i);
      ((s.tag = 1),
        (s.payload = e),
        n != null && (s.callback = n),
        (e = zn(t, s, i)),
        e !== null && (me(e, t, i), Ba(e, t, i)));
    },
    enqueueForceUpdate: function (t, e) {
      t = t._reactInternals;
      var n = Me(),
        i = Cn(n);
      ((i.tag = 2),
        e != null && (i.callback = e),
        (e = zn(t, i, n)),
        e !== null && (me(e, t, n), Ba(e, t, n)));
    },
  };
  function sd(t, e, n, i, s, o, f) {
    return (
      (t = t.stateNode),
      typeof t.shouldComponentUpdate == "function"
        ? t.shouldComponentUpdate(i, o, f)
        : e.prototype && e.prototype.isPureReactComponent
          ? !Da(n, i) || !Da(s, o)
          : !0
    );
  }
  function ud(t, e, n, i) {
    ((t = e.state),
      typeof e.componentWillReceiveProps == "function" &&
        e.componentWillReceiveProps(n, i),
      typeof e.UNSAFE_componentWillReceiveProps == "function" &&
        e.UNSAFE_componentWillReceiveProps(n, i),
      e.state !== t && Ro.enqueueReplaceState(e, e.state, null));
  }
  function fi(t, e) {
    var n = e;
    if ("ref" in e) {
      n = {};
      for (var i in e) i !== "ref" && (n[i] = e[i]);
    }
    if ((t = t.defaultProps)) {
      n === e && (n = S({}, n));
      for (var s in t) n[s] === void 0 && (n[s] = t[s]);
    }
    return n;
  }
  function od(t) {
    ql(t);
  }
  function rd(t) {
    console.error(t);
  }
  function cd(t) {
    ql(t);
  }
  function cs(t, e) {
    try {
      var n = t.onUncaughtError;
      n(e.value, { componentStack: e.stack });
    } catch (i) {
      setTimeout(function () {
        throw i;
      });
    }
  }
  function fd(t, e, n) {
    try {
      var i = t.onCaughtError;
      i(n.value, {
        componentStack: n.stack,
        errorBoundary: e.tag === 1 ? e.stateNode : null,
      });
    } catch (s) {
      setTimeout(function () {
        throw s;
      });
    }
  }
  function Vo(t, e, n) {
    return (
      (n = Cn(n)),
      (n.tag = 3),
      (n.payload = { element: null }),
      (n.callback = function () {
        cs(t, e);
      }),
      n
    );
  }
  function hd(t) {
    return ((t = Cn(t)), (t.tag = 3), t);
  }
  function dd(t, e, n, i) {
    var s = n.type.getDerivedStateFromError;
    if (typeof s == "function") {
      var o = i.value;
      ((t.payload = function () {
        return s(o);
      }),
        (t.callback = function () {
          fd(e, n, i);
        }));
    }
    var f = n.stateNode;
    f !== null &&
      typeof f.componentDidCatch == "function" &&
      (t.callback = function () {
        (fd(e, n, i),
          typeof s != "function" &&
            (Bn === null ? (Bn = new Set([this])) : Bn.add(this)));
        var m = i.stack;
        this.componentDidCatch(i.value, {
          componentStack: m !== null ? m : "",
        });
      });
  }
  function _v(t, e, n, i, s) {
    if (
      ((n.flags |= 32768),
      i !== null && typeof i == "object" && typeof i.then == "function")
    ) {
      if (
        ((e = n.alternate),
        e !== null && Li(e, n, s, !0),
        (n = Te.current),
        n !== null)
      ) {
        switch (n.tag) {
          case 31:
          case 13:
            return (
              Be === null ? As() : n.alternate === null && _t === 0 && (_t = 3),
              (n.flags &= -257),
              (n.flags |= 65536),
              (n.lanes = s),
              i === Pl
                ? (n.flags |= 16384)
                : ((e = n.updateQueue),
                  e === null ? (n.updateQueue = new Set([i])) : e.add(i),
                  nr(t, i, s)),
              !1
            );
          case 22:
            return (
              (n.flags |= 65536),
              i === Pl
                ? (n.flags |= 16384)
                : ((e = n.updateQueue),
                  e === null
                    ? ((e = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([i]),
                      }),
                      (n.updateQueue = e))
                    : ((n = e.retryQueue),
                      n === null ? (e.retryQueue = new Set([i])) : n.add(i)),
                  nr(t, i, s)),
              !1
            );
        }
        throw Error(r(435, n.tag));
      }
      return (nr(t, i, s), As(), !1);
    }
    if (dt)
      return (
        (e = Te.current),
        e !== null
          ? ((e.flags & 65536) === 0 && (e.flags |= 256),
            (e.flags |= 65536),
            (e.lanes = s),
            i !== ku && ((t = Error(r(422), { cause: i })), Oa(Re(t, n))))
          : (i !== ku && ((e = Error(r(423), { cause: i })), Oa(Re(e, n))),
            (t = t.current.alternate),
            (t.flags |= 65536),
            (s &= -s),
            (t.lanes |= s),
            (i = Re(i, n)),
            (s = Vo(t.stateNode, i, s)),
            so(t, s),
            _t !== 4 && (_t = 2)),
        !1
      );
    var o = Error(r(520), { cause: i });
    if (
      ((o = Re(o, n)),
      Fa === null ? (Fa = [o]) : Fa.push(o),
      _t !== 4 && (_t = 2),
      e === null)
    )
      return !0;
    ((i = Re(i, n)), (n = e));
    do {
      switch (n.tag) {
        case 3:
          return (
            (n.flags |= 65536),
            (t = s & -s),
            (n.lanes |= t),
            (t = Vo(n.stateNode, i, t)),
            so(n, t),
            !1
          );
        case 1:
          if (
            ((e = n.type),
            (o = n.stateNode),
            (n.flags & 128) === 0 &&
              (typeof e.getDerivedStateFromError == "function" ||
                (o !== null &&
                  typeof o.componentDidCatch == "function" &&
                  (Bn === null || !Bn.has(o)))))
          )
            return (
              (n.flags |= 65536),
              (s &= -s),
              (n.lanes |= s),
              (s = hd(s)),
              dd(s, t, n, i),
              so(n, s),
              !1
            );
      }
      n = n.return;
    } while (n !== null);
    return !1;
  }
  var _o = Error(r(461)),
    Gt = !1;
  function $t(t, e, n, i) {
    e.child = t === null ? gh(e, null, n, i) : ri(e, t.child, n, i);
  }
  function md(t, e, n, i, s) {
    n = n.render;
    var o = e.ref;
    if ("ref" in i) {
      var f = {};
      for (var m in i) m !== "ref" && (f[m] = i[m]);
    } else f = i;
    return (
      li(e),
      (i = ho(t, e, n, f, o, s)),
      (m = mo()),
      t !== null && !Gt
        ? (yo(t, e, s), on(t, e, s))
        : (dt && m && Ju(e), (e.flags |= 1), $t(t, e, i, s), e.child)
    );
  }
  function yd(t, e, n, i, s) {
    if (t === null) {
      var o = n.type;
      return typeof o == "function" &&
        !Qu(o) &&
        o.defaultProps === void 0 &&
        n.compare === null
        ? ((e.tag = 15), (e.type = o), pd(t, e, o, i, s))
        : ((t = Zl(n.type, null, i, e, e.mode, s)),
          (t.ref = e.ref),
          (t.return = e),
          (e.child = t));
    }
    if (((o = t.child), !Yo(t, s))) {
      var f = o.memoizedProps;
      if (
        ((n = n.compare), (n = n !== null ? n : Da), n(f, i) && t.ref === e.ref)
      )
        return on(t, e, s);
    }
    return (
      (e.flags |= 1),
      (t = en(o, i)),
      (t.ref = e.ref),
      (t.return = e),
      (e.child = t)
    );
  }
  function pd(t, e, n, i, s) {
    if (t !== null) {
      var o = t.memoizedProps;
      if (Da(o, i) && t.ref === e.ref)
        if (((Gt = !1), (e.pendingProps = i = o), Yo(t, s)))
          (t.flags & 131072) !== 0 && (Gt = !0);
        else return ((e.lanes = t.lanes), on(t, e, s));
    }
    return Uo(t, e, n, i, s);
  }
  function gd(t, e, n, i) {
    var s = i.children,
      o = t !== null ? t.memoizedState : null;
    if (
      (t === null &&
        e.stateNode === null &&
        (e.stateNode = {
          _visibility: 1,
          _pendingMarkers: null,
          _retryCache: null,
          _transitions: null,
        }),
      i.mode === "hidden")
    ) {
      if ((e.flags & 128) !== 0) {
        if (((o = o !== null ? o.baseLanes | n : n), t !== null)) {
          for (i = e.child = t.child, s = 0; i !== null; )
            ((s = s | i.lanes | i.childLanes), (i = i.sibling));
          i = s & ~o;
        } else ((i = 0), (e.child = null));
        return vd(t, e, o, n, i);
      }
      if ((n & 536870912) !== 0)
        ((e.memoizedState = { baseLanes: 0, cachePool: null }),
          t !== null && kl(e, o !== null ? o.cachePool : null),
          o !== null ? Th(e, o) : oo(),
          bh(e));
      else
        return (
          (i = e.lanes = 536870912),
          vd(t, e, o !== null ? o.baseLanes | n : n, n, i)
        );
    } else
      o !== null
        ? (kl(e, o.cachePool), Th(e, o), Rn(), (e.memoizedState = null))
        : (t !== null && kl(e, null), oo(), Rn());
    return ($t(t, e, s, n), e.child);
  }
  function qa(t, e) {
    return (
      (t !== null && t.tag === 22) ||
        e.stateNode !== null ||
        (e.stateNode = {
          _visibility: 1,
          _pendingMarkers: null,
          _retryCache: null,
          _transitions: null,
        }),
      e.sibling
    );
  }
  function vd(t, e, n, i, s) {
    var o = no();
    return (
      (o = o === null ? null : { parent: Yt._currentValue, pool: o }),
      (e.memoizedState = { baseLanes: n, cachePool: o }),
      t !== null && kl(e, null),
      oo(),
      bh(e),
      t !== null && Li(t, e, i, !0),
      (e.childLanes = s),
      null
    );
  }
  function fs(t, e) {
    return (
      (e = ds({ mode: e.mode, children: e.children }, t.mode)),
      (e.ref = t.ref),
      (t.child = e),
      (e.return = t),
      e
    );
  }
  function Sd(t, e, n) {
    return (
      ri(e, t.child, null, n),
      (t = fs(e, e.pendingProps)),
      (t.flags |= 2),
      be(e),
      (e.memoizedState = null),
      t
    );
  }
  function Uv(t, e, n) {
    var i = e.pendingProps,
      s = (e.flags & 128) !== 0;
    if (((e.flags &= -129), t === null)) {
      if (dt) {
        if (i.mode === "hidden")
          return ((t = fs(e, i)), (e.lanes = 536870912), qa(null, t));
        if (
          (co(e),
          (t = Dt)
            ? ((t = Vm(t, Ue)),
              (t = t !== null && t.data === "&" ? t : null),
              t !== null &&
                ((e.memoizedState = {
                  dehydrated: t,
                  treeContext: An !== null ? { id: Ke, overflow: Je } : null,
                  retryLane: 536870912,
                  hydrationErrors: null,
                }),
                (n = nh(t)),
                (n.return = e),
                (e.child = n),
                (Wt = e),
                (Dt = null)))
            : (t = null),
          t === null)
        )
          throw Mn(e);
        return ((e.lanes = 536870912), null);
      }
      return fs(e, i);
    }
    var o = t.memoizedState;
    if (o !== null) {
      var f = o.dehydrated;
      if ((co(e), s))
        if (e.flags & 256) ((e.flags &= -257), (e = Sd(t, e, n)));
        else if (e.memoizedState !== null)
          ((e.child = t.child), (e.flags |= 128), (e = null));
        else throw Error(r(558));
      else if (
        (Gt || Li(t, e, n, !1), (s = (n & t.childLanes) !== 0), Gt || s)
      ) {
        if (
          ((i = Mt),
          i !== null && ((f = rf(i, n)), f !== 0 && f !== o.retryLane))
        )
          throw ((o.retryLane = f), ei(t, f), me(i, t, f), _o);
        (As(), (e = Sd(t, e, n)));
      } else
        ((t = o.treeContext),
          (Dt = Ne(f.nextSibling)),
          (Wt = e),
          (dt = !0),
          (En = null),
          (Ue = !1),
          t !== null && lh(e, t),
          (e = fs(e, i)),
          (e.flags |= 4096));
      return e;
    }
    return (
      (t = en(t.child, { mode: i.mode, children: i.children })),
      (t.ref = e.ref),
      (e.child = t),
      (t.return = e),
      t
    );
  }
  function hs(t, e) {
    var n = e.ref;
    if (n === null) t !== null && t.ref !== null && (e.flags |= 4194816);
    else {
      if (typeof n != "function" && typeof n != "object") throw Error(r(284));
      (t === null || t.ref !== n) && (e.flags |= 4194816);
    }
  }
  function Uo(t, e, n, i, s) {
    return (
      li(e),
      (n = ho(t, e, n, i, void 0, s)),
      (i = mo()),
      t !== null && !Gt
        ? (yo(t, e, s), on(t, e, s))
        : (dt && i && Ju(e), (e.flags |= 1), $t(t, e, n, s), e.child)
    );
  }
  function Td(t, e, n, i, s, o) {
    return (
      li(e),
      (e.updateQueue = null),
      (n = Eh(e, i, n, s)),
      Ah(t),
      (i = mo()),
      t !== null && !Gt
        ? (yo(t, e, o), on(t, e, o))
        : (dt && i && Ju(e), (e.flags |= 1), $t(t, e, n, o), e.child)
    );
  }
  function bd(t, e, n, i, s) {
    if ((li(e), e.stateNode === null)) {
      var o = Ui,
        f = n.contextType;
      (typeof f == "object" && f !== null && (o = Pt(f)),
        (o = new n(i, o)),
        (e.memoizedState =
          o.state !== null && o.state !== void 0 ? o.state : null),
        (o.updater = Ro),
        (e.stateNode = o),
        (o._reactInternals = e),
        (o = e.stateNode),
        (o.props = i),
        (o.state = e.memoizedState),
        (o.refs = {}),
        ao(e),
        (f = n.contextType),
        (o.context = typeof f == "object" && f !== null ? Pt(f) : Ui),
        (o.state = e.memoizedState),
        (f = n.getDerivedStateFromProps),
        typeof f == "function" && (Oo(e, n, f, i), (o.state = e.memoizedState)),
        typeof n.getDerivedStateFromProps == "function" ||
          typeof o.getSnapshotBeforeUpdate == "function" ||
          (typeof o.UNSAFE_componentWillMount != "function" &&
            typeof o.componentWillMount != "function") ||
          ((f = o.state),
          typeof o.componentWillMount == "function" && o.componentWillMount(),
          typeof o.UNSAFE_componentWillMount == "function" &&
            o.UNSAFE_componentWillMount(),
          f !== o.state && Ro.enqueueReplaceState(o, o.state, null),
          ja(e, i, o, s),
          Na(),
          (o.state = e.memoizedState)),
        typeof o.componentDidMount == "function" && (e.flags |= 4194308),
        (i = !0));
    } else if (t === null) {
      o = e.stateNode;
      var m = e.memoizedProps,
        T = fi(n, m);
      o.props = T;
      var D = o.context,
        R = n.contextType;
      ((f = Ui), typeof R == "object" && R !== null && (f = Pt(R)));
      var B = n.getDerivedStateFromProps;
      ((R =
        typeof B == "function" ||
        typeof o.getSnapshotBeforeUpdate == "function"),
        (m = e.pendingProps !== m),
        R ||
          (typeof o.UNSAFE_componentWillReceiveProps != "function" &&
            typeof o.componentWillReceiveProps != "function") ||
          ((m || D !== f) && ud(e, o, i, f)),
        (Dn = !1));
      var C = e.memoizedState;
      ((o.state = C),
        ja(e, i, o, s),
        Na(),
        (D = e.memoizedState),
        m || C !== D || Dn
          ? (typeof B == "function" && (Oo(e, n, B, i), (D = e.memoizedState)),
            (T = Dn || sd(e, n, T, i, C, D, f))
              ? (R ||
                  (typeof o.UNSAFE_componentWillMount != "function" &&
                    typeof o.componentWillMount != "function") ||
                  (typeof o.componentWillMount == "function" &&
                    o.componentWillMount(),
                  typeof o.UNSAFE_componentWillMount == "function" &&
                    o.UNSAFE_componentWillMount()),
                typeof o.componentDidMount == "function" &&
                  (e.flags |= 4194308))
              : (typeof o.componentDidMount == "function" &&
                  (e.flags |= 4194308),
                (e.memoizedProps = i),
                (e.memoizedState = D)),
            (o.props = i),
            (o.state = D),
            (o.context = f),
            (i = T))
          : (typeof o.componentDidMount == "function" && (e.flags |= 4194308),
            (i = !1)));
    } else {
      ((o = e.stateNode),
        lo(t, e),
        (f = e.memoizedProps),
        (R = fi(n, f)),
        (o.props = R),
        (B = e.pendingProps),
        (C = o.context),
        (D = n.contextType),
        (T = Ui),
        typeof D == "object" && D !== null && (T = Pt(D)),
        (m = n.getDerivedStateFromProps),
        (D =
          typeof m == "function" ||
          typeof o.getSnapshotBeforeUpdate == "function") ||
          (typeof o.UNSAFE_componentWillReceiveProps != "function" &&
            typeof o.componentWillReceiveProps != "function") ||
          ((f !== B || C !== T) && ud(e, o, i, T)),
        (Dn = !1),
        (C = e.memoizedState),
        (o.state = C),
        ja(e, i, o, s),
        Na());
      var O = e.memoizedState;
      f !== B ||
      C !== O ||
      Dn ||
      (t !== null && t.dependencies !== null && Jl(t.dependencies))
        ? (typeof m == "function" && (Oo(e, n, m, i), (O = e.memoizedState)),
          (R =
            Dn ||
            sd(e, n, R, i, C, O, T) ||
            (t !== null && t.dependencies !== null && Jl(t.dependencies)))
            ? (D ||
                (typeof o.UNSAFE_componentWillUpdate != "function" &&
                  typeof o.componentWillUpdate != "function") ||
                (typeof o.componentWillUpdate == "function" &&
                  o.componentWillUpdate(i, O, T),
                typeof o.UNSAFE_componentWillUpdate == "function" &&
                  o.UNSAFE_componentWillUpdate(i, O, T)),
              typeof o.componentDidUpdate == "function" && (e.flags |= 4),
              typeof o.getSnapshotBeforeUpdate == "function" &&
                (e.flags |= 1024))
            : (typeof o.componentDidUpdate != "function" ||
                (f === t.memoizedProps && C === t.memoizedState) ||
                (e.flags |= 4),
              typeof o.getSnapshotBeforeUpdate != "function" ||
                (f === t.memoizedProps && C === t.memoizedState) ||
                (e.flags |= 1024),
              (e.memoizedProps = i),
              (e.memoizedState = O)),
          (o.props = i),
          (o.state = O),
          (o.context = T),
          (i = R))
        : (typeof o.componentDidUpdate != "function" ||
            (f === t.memoizedProps && C === t.memoizedState) ||
            (e.flags |= 4),
          typeof o.getSnapshotBeforeUpdate != "function" ||
            (f === t.memoizedProps && C === t.memoizedState) ||
            (e.flags |= 1024),
          (i = !1));
    }
    return (
      (o = i),
      hs(t, e),
      (i = (e.flags & 128) !== 0),
      o || i
        ? ((o = e.stateNode),
          (n =
            i && typeof n.getDerivedStateFromError != "function"
              ? null
              : o.render()),
          (e.flags |= 1),
          t !== null && i
            ? ((e.child = ri(e, t.child, null, s)),
              (e.child = ri(e, null, n, s)))
            : $t(t, e, n, s),
          (e.memoizedState = o.state),
          (t = e.child))
        : (t = on(t, e, s)),
      t
    );
  }
  function Ad(t, e, n, i) {
    return (ii(), (e.flags |= 256), $t(t, e, n, i), e.child);
  }
  var Bo = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null,
  };
  function No(t) {
    return { baseLanes: t, cachePool: fh() };
  }
  function jo(t, e, n) {
    return ((t = t !== null ? t.childLanes & ~n : 0), e && (t |= Ee), t);
  }
  function Ed(t, e, n) {
    var i = e.pendingProps,
      s = !1,
      o = (e.flags & 128) !== 0,
      f;
    if (
      ((f = o) ||
        (f =
          t !== null && t.memoizedState === null ? !1 : (jt.current & 2) !== 0),
      f && ((s = !0), (e.flags &= -129)),
      (f = (e.flags & 32) !== 0),
      (e.flags &= -33),
      t === null)
    ) {
      if (dt) {
        if (
          (s ? On(e) : Rn(),
          (t = Dt)
            ? ((t = Vm(t, Ue)),
              (t = t !== null && t.data !== "&" ? t : null),
              t !== null &&
                ((e.memoizedState = {
                  dehydrated: t,
                  treeContext: An !== null ? { id: Ke, overflow: Je } : null,
                  retryLane: 536870912,
                  hydrationErrors: null,
                }),
                (n = nh(t)),
                (n.return = e),
                (e.child = n),
                (Wt = e),
                (Dt = null)))
            : (t = null),
          t === null)
        )
          throw Mn(e);
        return (vr(t) ? (e.lanes = 32) : (e.lanes = 536870912), null);
      }
      var m = i.children;
      return (
        (i = i.fallback),
        s
          ? (Rn(),
            (s = e.mode),
            (m = ds({ mode: "hidden", children: m }, s)),
            (i = ni(i, s, n, null)),
            (m.return = e),
            (i.return = e),
            (m.sibling = i),
            (e.child = m),
            (i = e.child),
            (i.memoizedState = No(n)),
            (i.childLanes = jo(t, f, n)),
            (e.memoizedState = Bo),
            qa(null, i))
          : (On(e), Lo(e, m))
      );
    }
    var T = t.memoizedState;
    if (T !== null && ((m = T.dehydrated), m !== null)) {
      if (o)
        e.flags & 256
          ? (On(e), (e.flags &= -257), (e = Ho(t, e, n)))
          : e.memoizedState !== null
            ? (Rn(), (e.child = t.child), (e.flags |= 128), (e = null))
            : (Rn(),
              (m = i.fallback),
              (s = e.mode),
              (i = ds({ mode: "visible", children: i.children }, s)),
              (m = ni(m, s, n, null)),
              (m.flags |= 2),
              (i.return = e),
              (m.return = e),
              (i.sibling = m),
              (e.child = i),
              ri(e, t.child, null, n),
              (i = e.child),
              (i.memoizedState = No(n)),
              (i.childLanes = jo(t, f, n)),
              (e.memoizedState = Bo),
              (e = qa(null, i)));
      else if ((On(e), vr(m))) {
        if (((f = m.nextSibling && m.nextSibling.dataset), f)) var D = f.dgst;
        ((f = D),
          (i = Error(r(419))),
          (i.stack = ""),
          (i.digest = f),
          Oa({ value: i, source: null, stack: null }),
          (e = Ho(t, e, n)));
      } else if (
        (Gt || Li(t, e, n, !1), (f = (n & t.childLanes) !== 0), Gt || f)
      ) {
        if (
          ((f = Mt),
          f !== null && ((i = rf(f, n)), i !== 0 && i !== T.retryLane))
        )
          throw ((T.retryLane = i), ei(t, i), me(f, t, i), _o);
        (gr(m) || As(), (e = Ho(t, e, n)));
      } else
        gr(m)
          ? ((e.flags |= 192), (e.child = t.child), (e = null))
          : ((t = T.treeContext),
            (Dt = Ne(m.nextSibling)),
            (Wt = e),
            (dt = !0),
            (En = null),
            (Ue = !1),
            t !== null && lh(e, t),
            (e = Lo(e, i.children)),
            (e.flags |= 4096));
      return e;
    }
    return s
      ? (Rn(),
        (m = i.fallback),
        (s = e.mode),
        (T = t.child),
        (D = T.sibling),
        (i = en(T, { mode: "hidden", children: i.children })),
        (i.subtreeFlags = T.subtreeFlags & 65011712),
        D !== null ? (m = en(D, m)) : ((m = ni(m, s, n, null)), (m.flags |= 2)),
        (m.return = e),
        (i.return = e),
        (i.sibling = m),
        (e.child = i),
        qa(null, i),
        (i = e.child),
        (m = t.child.memoizedState),
        m === null
          ? (m = No(n))
          : ((s = m.cachePool),
            s !== null
              ? ((T = Yt._currentValue),
                (s = s.parent !== T ? { parent: T, pool: T } : s))
              : (s = fh()),
            (m = { baseLanes: m.baseLanes | n, cachePool: s })),
        (i.memoizedState = m),
        (i.childLanes = jo(t, f, n)),
        (e.memoizedState = Bo),
        qa(t.child, i))
      : (On(e),
        (n = t.child),
        (t = n.sibling),
        (n = en(n, { mode: "visible", children: i.children })),
        (n.return = e),
        (n.sibling = null),
        t !== null &&
          ((f = e.deletions),
          f === null ? ((e.deletions = [t]), (e.flags |= 16)) : f.push(t)),
        (e.child = n),
        (e.memoizedState = null),
        n);
  }
  function Lo(t, e) {
    return (
      (e = ds({ mode: "visible", children: e }, t.mode)),
      (e.return = t),
      (t.child = e)
    );
  }
  function ds(t, e) {
    return ((t = Se(22, t, null, e)), (t.lanes = 0), t);
  }
  function Ho(t, e, n) {
    return (
      ri(e, t.child, null, n),
      (t = Lo(e, e.pendingProps.children)),
      (t.flags |= 2),
      (e.memoizedState = null),
      t
    );
  }
  function Md(t, e, n) {
    t.lanes |= e;
    var i = t.alternate;
    (i !== null && (i.lanes |= e), $u(t.return, e, n));
  }
  function wo(t, e, n, i, s, o) {
    var f = t.memoizedState;
    f === null
      ? (t.memoizedState = {
          isBackwards: e,
          rendering: null,
          renderingStartTime: 0,
          last: i,
          tail: n,
          tailMode: s,
          treeForkCount: o,
        })
      : ((f.isBackwards = e),
        (f.rendering = null),
        (f.renderingStartTime = 0),
        (f.last = i),
        (f.tail = n),
        (f.tailMode = s),
        (f.treeForkCount = o));
  }
  function xd(t, e, n) {
    var i = e.pendingProps,
      s = i.revealOrder,
      o = i.tail;
    i = i.children;
    var f = jt.current,
      m = (f & 2) !== 0;
    if (
      (m ? ((f = (f & 1) | 2), (e.flags |= 128)) : (f &= 1),
      G(jt, f),
      $t(t, e, i, n),
      (i = dt ? za : 0),
      !m && t !== null && (t.flags & 128) !== 0)
    )
      t: for (t = e.child; t !== null; ) {
        if (t.tag === 13) t.memoizedState !== null && Md(t, n, e);
        else if (t.tag === 19) Md(t, n, e);
        else if (t.child !== null) {
          ((t.child.return = t), (t = t.child));
          continue;
        }
        if (t === e) break t;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === e) break t;
          t = t.return;
        }
        ((t.sibling.return = t.return), (t = t.sibling));
      }
    switch (s) {
      case "forwards":
        for (n = e.child, s = null; n !== null; )
          ((t = n.alternate),
            t !== null && es(t) === null && (s = n),
            (n = n.sibling));
        ((n = s),
          n === null
            ? ((s = e.child), (e.child = null))
            : ((s = n.sibling), (n.sibling = null)),
          wo(e, !1, s, n, o, i));
        break;
      case "backwards":
      case "unstable_legacy-backwards":
        for (n = null, s = e.child, e.child = null; s !== null; ) {
          if (((t = s.alternate), t !== null && es(t) === null)) {
            e.child = s;
            break;
          }
          ((t = s.sibling), (s.sibling = n), (n = s), (s = t));
        }
        wo(e, !0, n, null, o, i);
        break;
      case "together":
        wo(e, !1, null, null, void 0, i);
        break;
      default:
        e.memoizedState = null;
    }
    return e.child;
  }
  function on(t, e, n) {
    if (
      (t !== null && (e.dependencies = t.dependencies),
      (Un |= e.lanes),
      (n & e.childLanes) === 0)
    )
      if (t !== null) {
        if ((Li(t, e, n, !1), (n & e.childLanes) === 0)) return null;
      } else return null;
    if (t !== null && e.child !== t.child) throw Error(r(153));
    if (e.child !== null) {
      for (
        t = e.child, n = en(t, t.pendingProps), e.child = n, n.return = e;
        t.sibling !== null;
      )
        ((t = t.sibling),
          (n = n.sibling = en(t, t.pendingProps)),
          (n.return = e));
      n.sibling = null;
    }
    return e.child;
  }
  function Yo(t, e) {
    return (t.lanes & e) !== 0
      ? !0
      : ((t = t.dependencies), !!(t !== null && Jl(t)));
  }
  function Bv(t, e, n) {
    switch (e.tag) {
      case 3:
        (ie(e, e.stateNode.containerInfo),
          xn(e, Yt, t.memoizedState.cache),
          ii());
        break;
      case 27:
      case 5:
        da(e);
        break;
      case 4:
        ie(e, e.stateNode.containerInfo);
        break;
      case 10:
        xn(e, e.type, e.memoizedProps.value);
        break;
      case 31:
        if (e.memoizedState !== null) return ((e.flags |= 128), co(e), null);
        break;
      case 13:
        var i = e.memoizedState;
        if (i !== null)
          return i.dehydrated !== null
            ? (On(e), (e.flags |= 128), null)
            : (n & e.child.childLanes) !== 0
              ? Ed(t, e, n)
              : (On(e), (t = on(t, e, n)), t !== null ? t.sibling : null);
        On(e);
        break;
      case 19:
        var s = (t.flags & 128) !== 0;
        if (
          ((i = (n & e.childLanes) !== 0),
          i || (Li(t, e, n, !1), (i = (n & e.childLanes) !== 0)),
          s)
        ) {
          if (i) return xd(t, e, n);
          e.flags |= 128;
        }
        if (
          ((s = e.memoizedState),
          s !== null &&
            ((s.rendering = null), (s.tail = null), (s.lastEffect = null)),
          G(jt, jt.current),
          i)
        )
          break;
        return null;
      case 22:
        return ((e.lanes = 0), gd(t, e, n, e.pendingProps));
      case 24:
        xn(e, Yt, t.memoizedState.cache);
    }
    return on(t, e, n);
  }
  function Dd(t, e, n) {
    if (t !== null)
      if (t.memoizedProps !== e.pendingProps) Gt = !0;
      else {
        if (!Yo(t, n) && (e.flags & 128) === 0) return ((Gt = !1), Bv(t, e, n));
        Gt = (t.flags & 131072) !== 0;
      }
    else ((Gt = !1), dt && (e.flags & 1048576) !== 0 && ah(e, za, e.index));
    switch (((e.lanes = 0), e.tag)) {
      case 16:
        t: {
          var i = e.pendingProps;
          if (((t = ui(e.elementType)), (e.type = t), typeof t == "function"))
            Qu(t)
              ? ((i = fi(t, i)), (e.tag = 1), (e = bd(null, e, t, i, n)))
              : ((e.tag = 0), (e = Uo(null, e, t, i, n)));
          else {
            if (t != null) {
              var s = t.$$typeof;
              if (s === W) {
                ((e.tag = 11), (e = md(null, e, t, i, n)));
                break t;
              } else if (s === $) {
                ((e.tag = 14), (e = yd(null, e, t, i, n)));
                break t;
              }
            }
            throw ((e = De(t) || t), Error(r(306, e, "")));
          }
        }
        return e;
      case 0:
        return Uo(t, e, e.type, e.pendingProps, n);
      case 1:
        return ((i = e.type), (s = fi(i, e.pendingProps)), bd(t, e, i, s, n));
      case 3:
        t: {
          if ((ie(e, e.stateNode.containerInfo), t === null))
            throw Error(r(387));
          i = e.pendingProps;
          var o = e.memoizedState;
          ((s = o.element), lo(t, e), ja(e, i, null, n));
          var f = e.memoizedState;
          if (
            ((i = f.cache),
            xn(e, Yt, i),
            i !== o.cache && Iu(e, [Yt], n, !0),
            Na(),
            (i = f.element),
            o.isDehydrated)
          )
            if (
              ((o = { element: i, isDehydrated: !1, cache: f.cache }),
              (e.updateQueue.baseState = o),
              (e.memoizedState = o),
              e.flags & 256)
            ) {
              e = Ad(t, e, i, n);
              break t;
            } else if (i !== s) {
              ((s = Re(Error(r(424)), e)), Oa(s), (e = Ad(t, e, i, n)));
              break t;
            } else
              for (
                t = e.stateNode.containerInfo,
                  t.nodeType === 9
                    ? (t = t.body)
                    : (t = t.nodeName === "HTML" ? t.ownerDocument.body : t),
                  Dt = Ne(t.firstChild),
                  Wt = e,
                  dt = !0,
                  En = null,
                  Ue = !0,
                  n = gh(e, null, i, n),
                  e.child = n;
                n;
              )
                ((n.flags = (n.flags & -3) | 4096), (n = n.sibling));
          else {
            if ((ii(), i === s)) {
              e = on(t, e, n);
              break t;
            }
            $t(t, e, i, n);
          }
          e = e.child;
        }
        return e;
      case 26:
        return (
          hs(t, e),
          t === null
            ? (n = Lm(e.type, null, e.pendingProps, null))
              ? (e.memoizedState = n)
              : dt ||
                ((n = e.type),
                (t = e.pendingProps),
                (i = Os(ut.current).createElement(n)),
                (i[kt] = e),
                (i[oe] = t),
                It(i, n, t),
                Jt(i),
                (e.stateNode = i))
            : (e.memoizedState = Lm(
                e.type,
                t.memoizedProps,
                e.pendingProps,
                t.memoizedState,
              )),
          null
        );
      case 27:
        return (
          da(e),
          t === null &&
            dt &&
            ((i = e.stateNode = Bm(e.type, e.pendingProps, ut.current)),
            (Wt = e),
            (Ue = !0),
            (s = Dt),
            Hn(e.type) ? ((Sr = s), (Dt = Ne(i.firstChild))) : (Dt = s)),
          $t(t, e, e.pendingProps.children, n),
          hs(t, e),
          t === null && (e.flags |= 4194304),
          e.child
        );
      case 5:
        return (
          t === null &&
            dt &&
            ((s = i = Dt) &&
              ((i = c1(i, e.type, e.pendingProps, Ue)),
              i !== null
                ? ((e.stateNode = i),
                  (Wt = e),
                  (Dt = Ne(i.firstChild)),
                  (Ue = !1),
                  (s = !0))
                : (s = !1)),
            s || Mn(e)),
          da(e),
          (s = e.type),
          (o = e.pendingProps),
          (f = t !== null ? t.memoizedProps : null),
          (i = o.children),
          mr(s, o) ? (i = null) : f !== null && mr(s, f) && (e.flags |= 32),
          e.memoizedState !== null &&
            ((s = ho(t, e, xv, null, null, n)), (nl._currentValue = s)),
          hs(t, e),
          $t(t, e, i, n),
          e.child
        );
      case 6:
        return (
          t === null &&
            dt &&
            ((t = n = Dt) &&
              ((n = f1(n, e.pendingProps, Ue)),
              n !== null
                ? ((e.stateNode = n), (Wt = e), (Dt = null), (t = !0))
                : (t = !1)),
            t || Mn(e)),
          null
        );
      case 13:
        return Ed(t, e, n);
      case 4:
        return (
          ie(e, e.stateNode.containerInfo),
          (i = e.pendingProps),
          t === null ? (e.child = ri(e, null, i, n)) : $t(t, e, i, n),
          e.child
        );
      case 11:
        return md(t, e, e.type, e.pendingProps, n);
      case 7:
        return ($t(t, e, e.pendingProps, n), e.child);
      case 8:
        return ($t(t, e, e.pendingProps.children, n), e.child);
      case 12:
        return ($t(t, e, e.pendingProps.children, n), e.child);
      case 10:
        return (
          (i = e.pendingProps),
          xn(e, e.type, i.value),
          $t(t, e, i.children, n),
          e.child
        );
      case 9:
        return (
          (s = e.type._context),
          (i = e.pendingProps.children),
          li(e),
          (s = Pt(s)),
          (i = i(s)),
          (e.flags |= 1),
          $t(t, e, i, n),
          e.child
        );
      case 14:
        return yd(t, e, e.type, e.pendingProps, n);
      case 15:
        return pd(t, e, e.type, e.pendingProps, n);
      case 19:
        return xd(t, e, n);
      case 31:
        return Uv(t, e, n);
      case 22:
        return gd(t, e, n, e.pendingProps);
      case 24:
        return (
          li(e),
          (i = Pt(Yt)),
          t === null
            ? ((s = no()),
              s === null &&
                ((s = Mt),
                (o = to()),
                (s.pooledCache = o),
                o.refCount++,
                o !== null && (s.pooledCacheLanes |= n),
                (s = o)),
              (e.memoizedState = { parent: i, cache: s }),
              ao(e),
              xn(e, Yt, s))
            : ((t.lanes & n) !== 0 && (lo(t, e), ja(e, null, null, n), Na()),
              (s = t.memoizedState),
              (o = e.memoizedState),
              s.parent !== i
                ? ((s = { parent: i, cache: i }),
                  (e.memoizedState = s),
                  e.lanes === 0 &&
                    (e.memoizedState = e.updateQueue.baseState = s),
                  xn(e, Yt, i))
                : ((i = o.cache),
                  xn(e, Yt, i),
                  i !== s.cache && Iu(e, [Yt], n, !0))),
          $t(t, e, e.pendingProps.children, n),
          e.child
        );
      case 29:
        throw e.pendingProps;
    }
    throw Error(r(156, e.tag));
  }
  function rn(t) {
    t.flags |= 4;
  }
  function qo(t, e, n, i, s) {
    if (((e = (t.mode & 32) !== 0) && (e = !1), e)) {
      if (((t.flags |= 16777216), (s & 335544128) === s))
        if (t.stateNode.complete) t.flags |= 8192;
        else if (Id()) t.flags |= 8192;
        else throw ((oi = Pl), io);
    } else t.flags &= -16777217;
  }
  function Cd(t, e) {
    if (e.type !== "stylesheet" || (e.state.loading & 4) !== 0)
      t.flags &= -16777217;
    else if (((t.flags |= 16777216), !Gm(e)))
      if (Id()) t.flags |= 8192;
      else throw ((oi = Pl), io);
  }
  function ms(t, e) {
    (e !== null && (t.flags |= 4),
      t.flags & 16384 &&
        ((e = t.tag !== 22 ? sf() : 536870912), (t.lanes |= e), (ki |= e)));
  }
  function Ga(t, e) {
    if (!dt)
      switch (t.tailMode) {
        case "hidden":
          e = t.tail;
          for (var n = null; e !== null; )
            (e.alternate !== null && (n = e), (e = e.sibling));
          n === null ? (t.tail = null) : (n.sibling = null);
          break;
        case "collapsed":
          n = t.tail;
          for (var i = null; n !== null; )
            (n.alternate !== null && (i = n), (n = n.sibling));
          i === null
            ? e || t.tail === null
              ? (t.tail = null)
              : (t.tail.sibling = null)
            : (i.sibling = null);
      }
  }
  function Ct(t) {
    var e = t.alternate !== null && t.alternate.child === t.child,
      n = 0,
      i = 0;
    if (e)
      for (var s = t.child; s !== null; )
        ((n |= s.lanes | s.childLanes),
          (i |= s.subtreeFlags & 65011712),
          (i |= s.flags & 65011712),
          (s.return = t),
          (s = s.sibling));
    else
      for (s = t.child; s !== null; )
        ((n |= s.lanes | s.childLanes),
          (i |= s.subtreeFlags),
          (i |= s.flags),
          (s.return = t),
          (s = s.sibling));
    return ((t.subtreeFlags |= i), (t.childLanes = n), e);
  }
  function Nv(t, e, n) {
    var i = e.pendingProps;
    switch ((Fu(e), e.tag)) {
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return (Ct(e), null);
      case 1:
        return (Ct(e), null);
      case 3:
        return (
          (n = e.stateNode),
          (i = null),
          t !== null && (i = t.memoizedState.cache),
          e.memoizedState.cache !== i && (e.flags |= 2048),
          ln(Yt),
          Nt(),
          n.pendingContext &&
            ((n.context = n.pendingContext), (n.pendingContext = null)),
          (t === null || t.child === null) &&
            (ji(e)
              ? rn(e)
              : t === null ||
                (t.memoizedState.isDehydrated && (e.flags & 256) === 0) ||
                ((e.flags |= 1024), Wu())),
          Ct(e),
          null
        );
      case 26:
        var s = e.type,
          o = e.memoizedState;
        return (
          t === null
            ? (rn(e),
              o !== null ? (Ct(e), Cd(e, o)) : (Ct(e), qo(e, s, null, i, n)))
            : o
              ? o !== t.memoizedState
                ? (rn(e), Ct(e), Cd(e, o))
                : (Ct(e), (e.flags &= -16777217))
              : ((t = t.memoizedProps),
                t !== i && rn(e),
                Ct(e),
                qo(e, s, t, i, n)),
          null
        );
      case 27:
        if (
          (xl(e),
          (n = ut.current),
          (s = e.type),
          t !== null && e.stateNode != null)
        )
          t.memoizedProps !== i && rn(e);
        else {
          if (!i) {
            if (e.stateNode === null) throw Error(r(166));
            return (Ct(e), null);
          }
          ((t = J.current),
            ji(e) ? sh(e) : ((t = Bm(s, i, n)), (e.stateNode = t), rn(e)));
        }
        return (Ct(e), null);
      case 5:
        if ((xl(e), (s = e.type), t !== null && e.stateNode != null))
          t.memoizedProps !== i && rn(e);
        else {
          if (!i) {
            if (e.stateNode === null) throw Error(r(166));
            return (Ct(e), null);
          }
          if (((o = J.current), ji(e))) sh(e);
          else {
            var f = Os(ut.current);
            switch (o) {
              case 1:
                o = f.createElementNS("http://www.w3.org/2000/svg", s);
                break;
              case 2:
                o = f.createElementNS("http://www.w3.org/1998/Math/MathML", s);
                break;
              default:
                switch (s) {
                  case "svg":
                    o = f.createElementNS("http://www.w3.org/2000/svg", s);
                    break;
                  case "math":
                    o = f.createElementNS(
                      "http://www.w3.org/1998/Math/MathML",
                      s,
                    );
                    break;
                  case "script":
                    ((o = f.createElement("div")),
                      (o.innerHTML = "<script><\/script>"),
                      (o = o.removeChild(o.firstChild)));
                    break;
                  case "select":
                    ((o =
                      typeof i.is == "string"
                        ? f.createElement("select", { is: i.is })
                        : f.createElement("select")),
                      i.multiple
                        ? (o.multiple = !0)
                        : i.size && (o.size = i.size));
                    break;
                  default:
                    o =
                      typeof i.is == "string"
                        ? f.createElement(s, { is: i.is })
                        : f.createElement(s);
                }
            }
            ((o[kt] = e), (o[oe] = i));
            t: for (f = e.child; f !== null; ) {
              if (f.tag === 5 || f.tag === 6) o.appendChild(f.stateNode);
              else if (f.tag !== 4 && f.tag !== 27 && f.child !== null) {
                ((f.child.return = f), (f = f.child));
                continue;
              }
              if (f === e) break t;
              for (; f.sibling === null; ) {
                if (f.return === null || f.return === e) break t;
                f = f.return;
              }
              ((f.sibling.return = f.return), (f = f.sibling));
            }
            e.stateNode = o;
            t: switch ((It(o, s, i), s)) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                i = !!i.autoFocus;
                break t;
              case "img":
                i = !0;
                break t;
              default:
                i = !1;
            }
            i && rn(e);
          }
        }
        return (
          Ct(e),
          qo(e, e.type, t === null ? null : t.memoizedProps, e.pendingProps, n),
          null
        );
      case 6:
        if (t && e.stateNode != null) t.memoizedProps !== i && rn(e);
        else {
          if (typeof i != "string" && e.stateNode === null) throw Error(r(166));
          if (((t = ut.current), ji(e))) {
            if (
              ((t = e.stateNode),
              (n = e.memoizedProps),
              (i = null),
              (s = Wt),
              s !== null)
            )
              switch (s.tag) {
                case 27:
                case 5:
                  i = s.memoizedProps;
              }
            ((t[kt] = e),
              (t = !!(
                t.nodeValue === n ||
                (i !== null && i.suppressHydrationWarning === !0) ||
                Em(t.nodeValue, n)
              )),
              t || Mn(e, !0));
          } else
            ((t = Os(t).createTextNode(i)), (t[kt] = e), (e.stateNode = t));
        }
        return (Ct(e), null);
      case 31:
        if (((n = e.memoizedState), t === null || t.memoizedState !== null)) {
          if (((i = ji(e)), n !== null)) {
            if (t === null) {
              if (!i) throw Error(r(318));
              if (
                ((t = e.memoizedState),
                (t = t !== null ? t.dehydrated : null),
                !t)
              )
                throw Error(r(557));
              t[kt] = e;
            } else
              (ii(),
                (e.flags & 128) === 0 && (e.memoizedState = null),
                (e.flags |= 4));
            (Ct(e), (t = !1));
          } else
            ((n = Wu()),
              t !== null &&
                t.memoizedState !== null &&
                (t.memoizedState.hydrationErrors = n),
              (t = !0));
          if (!t) return e.flags & 256 ? (be(e), e) : (be(e), null);
          if ((e.flags & 128) !== 0) throw Error(r(558));
        }
        return (Ct(e), null);
      case 13:
        if (
          ((i = e.memoizedState),
          t === null ||
            (t.memoizedState !== null && t.memoizedState.dehydrated !== null))
        ) {
          if (((s = ji(e)), i !== null && i.dehydrated !== null)) {
            if (t === null) {
              if (!s) throw Error(r(318));
              if (
                ((s = e.memoizedState),
                (s = s !== null ? s.dehydrated : null),
                !s)
              )
                throw Error(r(317));
              s[kt] = e;
            } else
              (ii(),
                (e.flags & 128) === 0 && (e.memoizedState = null),
                (e.flags |= 4));
            (Ct(e), (s = !1));
          } else
            ((s = Wu()),
              t !== null &&
                t.memoizedState !== null &&
                (t.memoizedState.hydrationErrors = s),
              (s = !0));
          if (!s) return e.flags & 256 ? (be(e), e) : (be(e), null);
        }
        return (
          be(e),
          (e.flags & 128) !== 0
            ? ((e.lanes = n), e)
            : ((n = i !== null),
              (t = t !== null && t.memoizedState !== null),
              n &&
                ((i = e.child),
                (s = null),
                i.alternate !== null &&
                  i.alternate.memoizedState !== null &&
                  i.alternate.memoizedState.cachePool !== null &&
                  (s = i.alternate.memoizedState.cachePool.pool),
                (o = null),
                i.memoizedState !== null &&
                  i.memoizedState.cachePool !== null &&
                  (o = i.memoizedState.cachePool.pool),
                o !== s && (i.flags |= 2048)),
              n !== t && n && (e.child.flags |= 8192),
              ms(e, e.updateQueue),
              Ct(e),
              null)
        );
      case 4:
        return (Nt(), t === null && rr(e.stateNode.containerInfo), Ct(e), null);
      case 10:
        return (ln(e.type), Ct(e), null);
      case 19:
        if ((N(jt), (i = e.memoizedState), i === null)) return (Ct(e), null);
        if (((s = (e.flags & 128) !== 0), (o = i.rendering), o === null))
          if (s) Ga(i, !1);
          else {
            if (_t !== 0 || (t !== null && (t.flags & 128) !== 0))
              for (t = e.child; t !== null; ) {
                if (((o = es(t)), o !== null)) {
                  for (
                    e.flags |= 128,
                      Ga(i, !1),
                      t = o.updateQueue,
                      e.updateQueue = t,
                      ms(e, t),
                      e.subtreeFlags = 0,
                      t = n,
                      n = e.child;
                    n !== null;
                  )
                    (eh(n, t), (n = n.sibling));
                  return (
                    G(jt, (jt.current & 1) | 2),
                    dt && nn(e, i.treeForkCount),
                    e.child
                  );
                }
                t = t.sibling;
              }
            i.tail !== null &&
              ye() > Ss &&
              ((e.flags |= 128), (s = !0), Ga(i, !1), (e.lanes = 4194304));
          }
        else {
          if (!s)
            if (((t = es(o)), t !== null)) {
              if (
                ((e.flags |= 128),
                (s = !0),
                (t = t.updateQueue),
                (e.updateQueue = t),
                ms(e, t),
                Ga(i, !0),
                i.tail === null &&
                  i.tailMode === "hidden" &&
                  !o.alternate &&
                  !dt)
              )
                return (Ct(e), null);
            } else
              2 * ye() - i.renderingStartTime > Ss &&
                n !== 536870912 &&
                ((e.flags |= 128), (s = !0), Ga(i, !1), (e.lanes = 4194304));
          i.isBackwards
            ? ((o.sibling = e.child), (e.child = o))
            : ((t = i.last),
              t !== null ? (t.sibling = o) : (e.child = o),
              (i.last = o));
        }
        return i.tail !== null
          ? ((t = i.tail),
            (i.rendering = t),
            (i.tail = t.sibling),
            (i.renderingStartTime = ye()),
            (t.sibling = null),
            (n = jt.current),
            G(jt, s ? (n & 1) | 2 : n & 1),
            dt && nn(e, i.treeForkCount),
            t)
          : (Ct(e), null);
      case 22:
      case 23:
        return (
          be(e),
          ro(),
          (i = e.memoizedState !== null),
          t !== null
            ? (t.memoizedState !== null) !== i && (e.flags |= 8192)
            : i && (e.flags |= 8192),
          i
            ? (n & 536870912) !== 0 &&
              (e.flags & 128) === 0 &&
              (Ct(e), e.subtreeFlags & 6 && (e.flags |= 8192))
            : Ct(e),
          (n = e.updateQueue),
          n !== null && ms(e, n.retryQueue),
          (n = null),
          t !== null &&
            t.memoizedState !== null &&
            t.memoizedState.cachePool !== null &&
            (n = t.memoizedState.cachePool.pool),
          (i = null),
          e.memoizedState !== null &&
            e.memoizedState.cachePool !== null &&
            (i = e.memoizedState.cachePool.pool),
          i !== n && (e.flags |= 2048),
          t !== null && N(si),
          null
        );
      case 24:
        return (
          (n = null),
          t !== null && (n = t.memoizedState.cache),
          e.memoizedState.cache !== n && (e.flags |= 2048),
          ln(Yt),
          Ct(e),
          null
        );
      case 25:
        return null;
      case 30:
        return null;
    }
    throw Error(r(156, e.tag));
  }
  function jv(t, e) {
    switch ((Fu(e), e.tag)) {
      case 1:
        return (
          (t = e.flags),
          t & 65536 ? ((e.flags = (t & -65537) | 128), e) : null
        );
      case 3:
        return (
          ln(Yt),
          Nt(),
          (t = e.flags),
          (t & 65536) !== 0 && (t & 128) === 0
            ? ((e.flags = (t & -65537) | 128), e)
            : null
        );
      case 26:
      case 27:
      case 5:
        return (xl(e), null);
      case 31:
        if (e.memoizedState !== null) {
          if ((be(e), e.alternate === null)) throw Error(r(340));
          ii();
        }
        return (
          (t = e.flags),
          t & 65536 ? ((e.flags = (t & -65537) | 128), e) : null
        );
      case 13:
        if (
          (be(e), (t = e.memoizedState), t !== null && t.dehydrated !== null)
        ) {
          if (e.alternate === null) throw Error(r(340));
          ii();
        }
        return (
          (t = e.flags),
          t & 65536 ? ((e.flags = (t & -65537) | 128), e) : null
        );
      case 19:
        return (N(jt), null);
      case 4:
        return (Nt(), null);
      case 10:
        return (ln(e.type), null);
      case 22:
      case 23:
        return (
          be(e),
          ro(),
          t !== null && N(si),
          (t = e.flags),
          t & 65536 ? ((e.flags = (t & -65537) | 128), e) : null
        );
      case 24:
        return (ln(Yt), null);
      case 25:
        return null;
      default:
        return null;
    }
  }
  function zd(t, e) {
    switch ((Fu(e), e.tag)) {
      case 3:
        (ln(Yt), Nt());
        break;
      case 26:
      case 27:
      case 5:
        xl(e);
        break;
      case 4:
        Nt();
        break;
      case 31:
        e.memoizedState !== null && be(e);
        break;
      case 13:
        be(e);
        break;
      case 19:
        N(jt);
        break;
      case 10:
        ln(e.type);
        break;
      case 22:
      case 23:
        (be(e), ro(), t !== null && N(si));
        break;
      case 24:
        ln(Yt);
    }
  }
  function Xa(t, e) {
    try {
      var n = e.updateQueue,
        i = n !== null ? n.lastEffect : null;
      if (i !== null) {
        var s = i.next;
        n = s;
        do {
          if ((n.tag & t) === t) {
            i = void 0;
            var o = n.create,
              f = n.inst;
            ((i = o()), (f.destroy = i));
          }
          n = n.next;
        } while (n !== s);
      }
    } catch (m) {
      Tt(e, e.return, m);
    }
  }
  function Vn(t, e, n) {
    try {
      var i = e.updateQueue,
        s = i !== null ? i.lastEffect : null;
      if (s !== null) {
        var o = s.next;
        i = o;
        do {
          if ((i.tag & t) === t) {
            var f = i.inst,
              m = f.destroy;
            if (m !== void 0) {
              ((f.destroy = void 0), (s = e));
              var T = n,
                D = m;
              try {
                D();
              } catch (R) {
                Tt(s, T, R);
              }
            }
          }
          i = i.next;
        } while (i !== o);
      }
    } catch (R) {
      Tt(e, e.return, R);
    }
  }
  function Od(t) {
    var e = t.updateQueue;
    if (e !== null) {
      var n = t.stateNode;
      try {
        Sh(e, n);
      } catch (i) {
        Tt(t, t.return, i);
      }
    }
  }
  function Rd(t, e, n) {
    ((n.props = fi(t.type, t.memoizedProps)), (n.state = t.memoizedState));
    try {
      n.componentWillUnmount();
    } catch (i) {
      Tt(t, e, i);
    }
  }
  function Qa(t, e) {
    try {
      var n = t.ref;
      if (n !== null) {
        switch (t.tag) {
          case 26:
          case 27:
          case 5:
            var i = t.stateNode;
            break;
          case 30:
            i = t.stateNode;
            break;
          default:
            i = t.stateNode;
        }
        typeof n == "function" ? (t.refCleanup = n(i)) : (n.current = i);
      }
    } catch (s) {
      Tt(t, e, s);
    }
  }
  function Fe(t, e) {
    var n = t.ref,
      i = t.refCleanup;
    if (n !== null)
      if (typeof i == "function")
        try {
          i();
        } catch (s) {
          Tt(t, e, s);
        } finally {
          ((t.refCleanup = null),
            (t = t.alternate),
            t != null && (t.refCleanup = null));
        }
      else if (typeof n == "function")
        try {
          n(null);
        } catch (s) {
          Tt(t, e, s);
        }
      else n.current = null;
  }
  function Vd(t) {
    var e = t.type,
      n = t.memoizedProps,
      i = t.stateNode;
    try {
      t: switch (e) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          n.autoFocus && i.focus();
          break t;
        case "img":
          n.src ? (i.src = n.src) : n.srcSet && (i.srcset = n.srcSet);
      }
    } catch (s) {
      Tt(t, t.return, s);
    }
  }
  function Go(t, e, n) {
    try {
      var i = t.stateNode;
      (a1(i, t.type, n, e), (i[oe] = e));
    } catch (s) {
      Tt(t, t.return, s);
    }
  }
  function _d(t) {
    return (
      t.tag === 5 ||
      t.tag === 3 ||
      t.tag === 26 ||
      (t.tag === 27 && Hn(t.type)) ||
      t.tag === 4
    );
  }
  function Xo(t) {
    t: for (;;) {
      for (; t.sibling === null; ) {
        if (t.return === null || _d(t.return)) return null;
        t = t.return;
      }
      for (
        t.sibling.return = t.return, t = t.sibling;
        t.tag !== 5 && t.tag !== 6 && t.tag !== 18;
      ) {
        if (
          (t.tag === 27 && Hn(t.type)) ||
          t.flags & 2 ||
          t.child === null ||
          t.tag === 4
        )
          continue t;
        ((t.child.return = t), (t = t.child));
      }
      if (!(t.flags & 2)) return t.stateNode;
    }
  }
  function Qo(t, e, n) {
    var i = t.tag;
    if (i === 5 || i === 6)
      ((t = t.stateNode),
        e
          ? (n.nodeType === 9
              ? n.body
              : n.nodeName === "HTML"
                ? n.ownerDocument.body
                : n
            ).insertBefore(t, e)
          : ((e =
              n.nodeType === 9
                ? n.body
                : n.nodeName === "HTML"
                  ? n.ownerDocument.body
                  : n),
            e.appendChild(t),
            (n = n._reactRootContainer),
            n != null || e.onclick !== null || (e.onclick = Ie)));
    else if (
      i !== 4 &&
      (i === 27 && Hn(t.type) && ((n = t.stateNode), (e = null)),
      (t = t.child),
      t !== null)
    )
      for (Qo(t, e, n), t = t.sibling; t !== null; )
        (Qo(t, e, n), (t = t.sibling));
  }
  function ys(t, e, n) {
    var i = t.tag;
    if (i === 5 || i === 6)
      ((t = t.stateNode), e ? n.insertBefore(t, e) : n.appendChild(t));
    else if (
      i !== 4 &&
      (i === 27 && Hn(t.type) && (n = t.stateNode), (t = t.child), t !== null)
    )
      for (ys(t, e, n), t = t.sibling; t !== null; )
        (ys(t, e, n), (t = t.sibling));
  }
  function Ud(t) {
    var e = t.stateNode,
      n = t.memoizedProps;
    try {
      for (var i = t.type, s = e.attributes; s.length; )
        e.removeAttributeNode(s[0]);
      (It(e, i, n), (e[kt] = t), (e[oe] = n));
    } catch (o) {
      Tt(t, t.return, o);
    }
  }
  var cn = !1,
    Xt = !1,
    Zo = !1,
    Bd = typeof WeakSet == "function" ? WeakSet : Set,
    Ft = null;
  function Lv(t, e) {
    if (((t = t.containerInfo), (hr = js), (t = Kf(t)), Lu(t))) {
      if ("selectionStart" in t)
        var n = { start: t.selectionStart, end: t.selectionEnd };
      else
        t: {
          n = ((n = t.ownerDocument) && n.defaultView) || window;
          var i = n.getSelection && n.getSelection();
          if (i && i.rangeCount !== 0) {
            n = i.anchorNode;
            var s = i.anchorOffset,
              o = i.focusNode;
            i = i.focusOffset;
            try {
              (n.nodeType, o.nodeType);
            } catch {
              n = null;
              break t;
            }
            var f = 0,
              m = -1,
              T = -1,
              D = 0,
              R = 0,
              B = t,
              C = null;
            e: for (;;) {
              for (
                var O;
                B !== n || (s !== 0 && B.nodeType !== 3) || (m = f + s),
                  B !== o || (i !== 0 && B.nodeType !== 3) || (T = f + i),
                  B.nodeType === 3 && (f += B.nodeValue.length),
                  (O = B.firstChild) !== null;
              )
                ((C = B), (B = O));
              for (;;) {
                if (B === t) break e;
                if (
                  (C === n && ++D === s && (m = f),
                  C === o && ++R === i && (T = f),
                  (O = B.nextSibling) !== null)
                )
                  break;
                ((B = C), (C = B.parentNode));
              }
              B = O;
            }
            n = m === -1 || T === -1 ? null : { start: m, end: T };
          } else n = null;
        }
      n = n || { start: 0, end: 0 };
    } else n = null;
    for (
      dr = { focusedElem: t, selectionRange: n }, js = !1, Ft = e;
      Ft !== null;
    )
      if (
        ((e = Ft), (t = e.child), (e.subtreeFlags & 1028) !== 0 && t !== null)
      )
        ((t.return = e), (Ft = t));
      else
        for (; Ft !== null; ) {
          switch (((e = Ft), (o = e.alternate), (t = e.flags), e.tag)) {
            case 0:
              if (
                (t & 4) !== 0 &&
                ((t = e.updateQueue),
                (t = t !== null ? t.events : null),
                t !== null)
              )
                for (n = 0; n < t.length; n++)
                  ((s = t[n]), (s.ref.impl = s.nextImpl));
              break;
            case 11:
            case 15:
              break;
            case 1:
              if ((t & 1024) !== 0 && o !== null) {
                ((t = void 0),
                  (n = e),
                  (s = o.memoizedProps),
                  (o = o.memoizedState),
                  (i = n.stateNode));
                try {
                  var Q = fi(n.type, s);
                  ((t = i.getSnapshotBeforeUpdate(Q, o)),
                    (i.__reactInternalSnapshotBeforeUpdate = t));
                } catch (tt) {
                  Tt(n, n.return, tt);
                }
              }
              break;
            case 3:
              if ((t & 1024) !== 0) {
                if (
                  ((t = e.stateNode.containerInfo), (n = t.nodeType), n === 9)
                )
                  pr(t);
                else if (n === 1)
                  switch (t.nodeName) {
                    case "HEAD":
                    case "HTML":
                    case "BODY":
                      pr(t);
                      break;
                    default:
                      t.textContent = "";
                  }
              }
              break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
              break;
            default:
              if ((t & 1024) !== 0) throw Error(r(163));
          }
          if (((t = e.sibling), t !== null)) {
            ((t.return = e.return), (Ft = t));
            break;
          }
          Ft = e.return;
        }
  }
  function Nd(t, e, n) {
    var i = n.flags;
    switch (n.tag) {
      case 0:
      case 11:
      case 15:
        (hn(t, n), i & 4 && Xa(5, n));
        break;
      case 1:
        if ((hn(t, n), i & 4))
          if (((t = n.stateNode), e === null))
            try {
              t.componentDidMount();
            } catch (f) {
              Tt(n, n.return, f);
            }
          else {
            var s = fi(n.type, e.memoizedProps);
            e = e.memoizedState;
            try {
              t.componentDidUpdate(s, e, t.__reactInternalSnapshotBeforeUpdate);
            } catch (f) {
              Tt(n, n.return, f);
            }
          }
        (i & 64 && Od(n), i & 512 && Qa(n, n.return));
        break;
      case 3:
        if ((hn(t, n), i & 64 && ((t = n.updateQueue), t !== null))) {
          if (((e = null), n.child !== null))
            switch (n.child.tag) {
              case 27:
              case 5:
                e = n.child.stateNode;
                break;
              case 1:
                e = n.child.stateNode;
            }
          try {
            Sh(t, e);
          } catch (f) {
            Tt(n, n.return, f);
          }
        }
        break;
      case 27:
        e === null && i & 4 && Ud(n);
      case 26:
      case 5:
        (hn(t, n), e === null && i & 4 && Vd(n), i & 512 && Qa(n, n.return));
        break;
      case 12:
        hn(t, n);
        break;
      case 31:
        (hn(t, n), i & 4 && Hd(t, n));
        break;
      case 13:
        (hn(t, n),
          i & 4 && wd(t, n),
          i & 64 &&
            ((t = n.memoizedState),
            t !== null &&
              ((t = t.dehydrated),
              t !== null && ((n = Kv.bind(null, n)), h1(t, n)))));
        break;
      case 22:
        if (((i = n.memoizedState !== null || cn), !i)) {
          ((e = (e !== null && e.memoizedState !== null) || Xt), (s = cn));
          var o = Xt;
          ((cn = i),
            (Xt = e) && !o ? dn(t, n, (n.subtreeFlags & 8772) !== 0) : hn(t, n),
            (cn = s),
            (Xt = o));
        }
        break;
      case 30:
        break;
      default:
        hn(t, n);
    }
  }
  function jd(t) {
    var e = t.alternate;
    (e !== null && ((t.alternate = null), jd(e)),
      (t.child = null),
      (t.deletions = null),
      (t.sibling = null),
      t.tag === 5 && ((e = t.stateNode), e !== null && Tu(e)),
      (t.stateNode = null),
      (t.return = null),
      (t.dependencies = null),
      (t.memoizedProps = null),
      (t.memoizedState = null),
      (t.pendingProps = null),
      (t.stateNode = null),
      (t.updateQueue = null));
  }
  var Ot = null,
    ce = !1;
  function fn(t, e, n) {
    for (n = n.child; n !== null; ) (Ld(t, e, n), (n = n.sibling));
  }
  function Ld(t, e, n) {
    if (pe && typeof pe.onCommitFiberUnmount == "function")
      try {
        pe.onCommitFiberUnmount(ma, n);
      } catch {}
    switch (n.tag) {
      case 26:
        (Xt || Fe(n, e),
          fn(t, e, n),
          n.memoizedState
            ? n.memoizedState.count--
            : n.stateNode && ((n = n.stateNode), n.parentNode.removeChild(n)));
        break;
      case 27:
        Xt || Fe(n, e);
        var i = Ot,
          s = ce;
        (Hn(n.type) && ((Ot = n.stateNode), (ce = !1)),
          fn(t, e, n),
          Ia(n.stateNode),
          (Ot = i),
          (ce = s));
        break;
      case 5:
        Xt || Fe(n, e);
      case 6:
        if (
          ((i = Ot),
          (s = ce),
          (Ot = null),
          fn(t, e, n),
          (Ot = i),
          (ce = s),
          Ot !== null)
        )
          if (ce)
            try {
              (Ot.nodeType === 9
                ? Ot.body
                : Ot.nodeName === "HTML"
                  ? Ot.ownerDocument.body
                  : Ot
              ).removeChild(n.stateNode);
            } catch (o) {
              Tt(n, e, o);
            }
          else
            try {
              Ot.removeChild(n.stateNode);
            } catch (o) {
              Tt(n, e, o);
            }
        break;
      case 18:
        Ot !== null &&
          (ce
            ? ((t = Ot),
              Om(
                t.nodeType === 9
                  ? t.body
                  : t.nodeName === "HTML"
                    ? t.ownerDocument.body
                    : t,
                n.stateNode,
              ),
              ia(t))
            : Om(Ot, n.stateNode));
        break;
      case 4:
        ((i = Ot),
          (s = ce),
          (Ot = n.stateNode.containerInfo),
          (ce = !0),
          fn(t, e, n),
          (Ot = i),
          (ce = s));
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        (Vn(2, n, e), Xt || Vn(4, n, e), fn(t, e, n));
        break;
      case 1:
        (Xt ||
          (Fe(n, e),
          (i = n.stateNode),
          typeof i.componentWillUnmount == "function" && Rd(n, e, i)),
          fn(t, e, n));
        break;
      case 21:
        fn(t, e, n);
        break;
      case 22:
        ((Xt = (i = Xt) || n.memoizedState !== null), fn(t, e, n), (Xt = i));
        break;
      default:
        fn(t, e, n);
    }
  }
  function Hd(t, e) {
    if (
      e.memoizedState === null &&
      ((t = e.alternate), t !== null && ((t = t.memoizedState), t !== null))
    ) {
      t = t.dehydrated;
      try {
        ia(t);
      } catch (n) {
        Tt(e, e.return, n);
      }
    }
  }
  function wd(t, e) {
    if (
      e.memoizedState === null &&
      ((t = e.alternate),
      t !== null &&
        ((t = t.memoizedState), t !== null && ((t = t.dehydrated), t !== null)))
    )
      try {
        ia(t);
      } catch (n) {
        Tt(e, e.return, n);
      }
  }
  function Hv(t) {
    switch (t.tag) {
      case 31:
      case 13:
      case 19:
        var e = t.stateNode;
        return (e === null && (e = t.stateNode = new Bd()), e);
      case 22:
        return (
          (t = t.stateNode),
          (e = t._retryCache),
          e === null && (e = t._retryCache = new Bd()),
          e
        );
      default:
        throw Error(r(435, t.tag));
    }
  }
  function ps(t, e) {
    var n = Hv(t);
    e.forEach(function (i) {
      if (!n.has(i)) {
        n.add(i);
        var s = Jv.bind(null, t, i);
        i.then(s, s);
      }
    });
  }
  function fe(t, e) {
    var n = e.deletions;
    if (n !== null)
      for (var i = 0; i < n.length; i++) {
        var s = n[i],
          o = t,
          f = e,
          m = f;
        t: for (; m !== null; ) {
          switch (m.tag) {
            case 27:
              if (Hn(m.type)) {
                ((Ot = m.stateNode), (ce = !1));
                break t;
              }
              break;
            case 5:
              ((Ot = m.stateNode), (ce = !1));
              break t;
            case 3:
            case 4:
              ((Ot = m.stateNode.containerInfo), (ce = !0));
              break t;
          }
          m = m.return;
        }
        if (Ot === null) throw Error(r(160));
        (Ld(o, f, s),
          (Ot = null),
          (ce = !1),
          (o = s.alternate),
          o !== null && (o.return = null),
          (s.return = null));
      }
    if (e.subtreeFlags & 13886)
      for (e = e.child; e !== null; ) (Yd(e, t), (e = e.sibling));
  }
  var Ge = null;
  function Yd(t, e) {
    var n = t.alternate,
      i = t.flags;
    switch (t.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        (fe(e, t),
          he(t),
          i & 4 && (Vn(3, t, t.return), Xa(3, t), Vn(5, t, t.return)));
        break;
      case 1:
        (fe(e, t),
          he(t),
          i & 512 && (Xt || n === null || Fe(n, n.return)),
          i & 64 &&
            cn &&
            ((t = t.updateQueue),
            t !== null &&
              ((i = t.callbacks),
              i !== null &&
                ((n = t.shared.hiddenCallbacks),
                (t.shared.hiddenCallbacks = n === null ? i : n.concat(i))))));
        break;
      case 26:
        var s = Ge;
        if (
          (fe(e, t),
          he(t),
          i & 512 && (Xt || n === null || Fe(n, n.return)),
          i & 4)
        ) {
          var o = n !== null ? n.memoizedState : null;
          if (((i = t.memoizedState), n === null))
            if (i === null)
              if (t.stateNode === null) {
                t: {
                  ((i = t.type),
                    (n = t.memoizedProps),
                    (s = s.ownerDocument || s));
                  e: switch (i) {
                    case "title":
                      ((o = s.getElementsByTagName("title")[0]),
                        (!o ||
                          o[ga] ||
                          o[kt] ||
                          o.namespaceURI === "http://www.w3.org/2000/svg" ||
                          o.hasAttribute("itemprop")) &&
                          ((o = s.createElement(i)),
                          s.head.insertBefore(
                            o,
                            s.querySelector("head > title"),
                          )),
                        It(o, i, n),
                        (o[kt] = t),
                        Jt(o),
                        (i = o));
                      break t;
                    case "link":
                      var f = Ym("link", "href", s).get(i + (n.href || ""));
                      if (f) {
                        for (var m = 0; m < f.length; m++)
                          if (
                            ((o = f[m]),
                            o.getAttribute("href") ===
                              (n.href == null || n.href === ""
                                ? null
                                : n.href) &&
                              o.getAttribute("rel") ===
                                (n.rel == null ? null : n.rel) &&
                              o.getAttribute("title") ===
                                (n.title == null ? null : n.title) &&
                              o.getAttribute("crossorigin") ===
                                (n.crossOrigin == null ? null : n.crossOrigin))
                          ) {
                            f.splice(m, 1);
                            break e;
                          }
                      }
                      ((o = s.createElement(i)),
                        It(o, i, n),
                        s.head.appendChild(o));
                      break;
                    case "meta":
                      if (
                        (f = Ym("meta", "content", s).get(
                          i + (n.content || ""),
                        ))
                      ) {
                        for (m = 0; m < f.length; m++)
                          if (
                            ((o = f[m]),
                            o.getAttribute("content") ===
                              (n.content == null ? null : "" + n.content) &&
                              o.getAttribute("name") ===
                                (n.name == null ? null : n.name) &&
                              o.getAttribute("property") ===
                                (n.property == null ? null : n.property) &&
                              o.getAttribute("http-equiv") ===
                                (n.httpEquiv == null ? null : n.httpEquiv) &&
                              o.getAttribute("charset") ===
                                (n.charSet == null ? null : n.charSet))
                          ) {
                            f.splice(m, 1);
                            break e;
                          }
                      }
                      ((o = s.createElement(i)),
                        It(o, i, n),
                        s.head.appendChild(o));
                      break;
                    default:
                      throw Error(r(468, i));
                  }
                  ((o[kt] = t), Jt(o), (i = o));
                }
                t.stateNode = i;
              } else qm(s, t.type, t.stateNode);
            else t.stateNode = wm(s, i, t.memoizedProps);
          else
            o !== i
              ? (o === null
                  ? n.stateNode !== null &&
                    ((n = n.stateNode), n.parentNode.removeChild(n))
                  : o.count--,
                i === null
                  ? qm(s, t.type, t.stateNode)
                  : wm(s, i, t.memoizedProps))
              : i === null &&
                t.stateNode !== null &&
                Go(t, t.memoizedProps, n.memoizedProps);
        }
        break;
      case 27:
        (fe(e, t),
          he(t),
          i & 512 && (Xt || n === null || Fe(n, n.return)),
          n !== null && i & 4 && Go(t, t.memoizedProps, n.memoizedProps));
        break;
      case 5:
        if (
          (fe(e, t),
          he(t),
          i & 512 && (Xt || n === null || Fe(n, n.return)),
          t.flags & 32)
        ) {
          s = t.stateNode;
          try {
            Di(s, "");
          } catch (Q) {
            Tt(t, t.return, Q);
          }
        }
        (i & 4 &&
          t.stateNode != null &&
          ((s = t.memoizedProps), Go(t, s, n !== null ? n.memoizedProps : s)),
          i & 1024 && (Zo = !0));
        break;
      case 6:
        if ((fe(e, t), he(t), i & 4)) {
          if (t.stateNode === null) throw Error(r(162));
          ((i = t.memoizedProps), (n = t.stateNode));
          try {
            n.nodeValue = i;
          } catch (Q) {
            Tt(t, t.return, Q);
          }
        }
        break;
      case 3:
        if (
          ((_s = null),
          (s = Ge),
          (Ge = Rs(e.containerInfo)),
          fe(e, t),
          (Ge = s),
          he(t),
          i & 4 && n !== null && n.memoizedState.isDehydrated)
        )
          try {
            ia(e.containerInfo);
          } catch (Q) {
            Tt(t, t.return, Q);
          }
        Zo && ((Zo = !1), qd(t));
        break;
      case 4:
        ((i = Ge),
          (Ge = Rs(t.stateNode.containerInfo)),
          fe(e, t),
          he(t),
          (Ge = i));
        break;
      case 12:
        (fe(e, t), he(t));
        break;
      case 31:
        (fe(e, t),
          he(t),
          i & 4 &&
            ((i = t.updateQueue),
            i !== null && ((t.updateQueue = null), ps(t, i))));
        break;
      case 13:
        (fe(e, t),
          he(t),
          t.child.flags & 8192 &&
            (t.memoizedState !== null) !=
              (n !== null && n.memoizedState !== null) &&
            (vs = ye()),
          i & 4 &&
            ((i = t.updateQueue),
            i !== null && ((t.updateQueue = null), ps(t, i))));
        break;
      case 22:
        s = t.memoizedState !== null;
        var T = n !== null && n.memoizedState !== null,
          D = cn,
          R = Xt;
        if (
          ((cn = D || s),
          (Xt = R || T),
          fe(e, t),
          (Xt = R),
          (cn = D),
          he(t),
          i & 8192)
        )
          t: for (
            e = t.stateNode,
              e._visibility = s ? e._visibility & -2 : e._visibility | 1,
              s && (n === null || T || cn || Xt || hi(t)),
              n = null,
              e = t;
            ;
          ) {
            if (e.tag === 5 || e.tag === 26) {
              if (n === null) {
                T = n = e;
                try {
                  if (((o = T.stateNode), s))
                    ((f = o.style),
                      typeof f.setProperty == "function"
                        ? f.setProperty("display", "none", "important")
                        : (f.display = "none"));
                  else {
                    m = T.stateNode;
                    var B = T.memoizedProps.style,
                      C =
                        B != null && B.hasOwnProperty("display")
                          ? B.display
                          : null;
                    m.style.display =
                      C == null || typeof C == "boolean" ? "" : ("" + C).trim();
                  }
                } catch (Q) {
                  Tt(T, T.return, Q);
                }
              }
            } else if (e.tag === 6) {
              if (n === null) {
                T = e;
                try {
                  T.stateNode.nodeValue = s ? "" : T.memoizedProps;
                } catch (Q) {
                  Tt(T, T.return, Q);
                }
              }
            } else if (e.tag === 18) {
              if (n === null) {
                T = e;
                try {
                  var O = T.stateNode;
                  s ? Rm(O, !0) : Rm(T.stateNode, !1);
                } catch (Q) {
                  Tt(T, T.return, Q);
                }
              }
            } else if (
              ((e.tag !== 22 && e.tag !== 23) ||
                e.memoizedState === null ||
                e === t) &&
              e.child !== null
            ) {
              ((e.child.return = e), (e = e.child));
              continue;
            }
            if (e === t) break t;
            for (; e.sibling === null; ) {
              if (e.return === null || e.return === t) break t;
              (n === e && (n = null), (e = e.return));
            }
            (n === e && (n = null),
              (e.sibling.return = e.return),
              (e = e.sibling));
          }
        i & 4 &&
          ((i = t.updateQueue),
          i !== null &&
            ((n = i.retryQueue),
            n !== null && ((i.retryQueue = null), ps(t, n))));
        break;
      case 19:
        (fe(e, t),
          he(t),
          i & 4 &&
            ((i = t.updateQueue),
            i !== null && ((t.updateQueue = null), ps(t, i))));
        break;
      case 30:
        break;
      case 21:
        break;
      default:
        (fe(e, t), he(t));
    }
  }
  function he(t) {
    var e = t.flags;
    if (e & 2) {
      try {
        for (var n, i = t.return; i !== null; ) {
          if (_d(i)) {
            n = i;
            break;
          }
          i = i.return;
        }
        if (n == null) throw Error(r(160));
        switch (n.tag) {
          case 27:
            var s = n.stateNode,
              o = Xo(t);
            ys(t, o, s);
            break;
          case 5:
            var f = n.stateNode;
            n.flags & 32 && (Di(f, ""), (n.flags &= -33));
            var m = Xo(t);
            ys(t, m, f);
            break;
          case 3:
          case 4:
            var T = n.stateNode.containerInfo,
              D = Xo(t);
            Qo(t, D, T);
            break;
          default:
            throw Error(r(161));
        }
      } catch (R) {
        Tt(t, t.return, R);
      }
      t.flags &= -3;
    }
    e & 4096 && (t.flags &= -4097);
  }
  function qd(t) {
    if (t.subtreeFlags & 1024)
      for (t = t.child; t !== null; ) {
        var e = t;
        (qd(e),
          e.tag === 5 && e.flags & 1024 && e.stateNode.reset(),
          (t = t.sibling));
      }
  }
  function hn(t, e) {
    if (e.subtreeFlags & 8772)
      for (e = e.child; e !== null; ) (Nd(t, e.alternate, e), (e = e.sibling));
  }
  function hi(t) {
    for (t = t.child; t !== null; ) {
      var e = t;
      switch (e.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          (Vn(4, e, e.return), hi(e));
          break;
        case 1:
          Fe(e, e.return);
          var n = e.stateNode;
          (typeof n.componentWillUnmount == "function" && Rd(e, e.return, n),
            hi(e));
          break;
        case 27:
          Ia(e.stateNode);
        case 26:
        case 5:
          (Fe(e, e.return), hi(e));
          break;
        case 22:
          e.memoizedState === null && hi(e);
          break;
        case 30:
          hi(e);
          break;
        default:
          hi(e);
      }
      t = t.sibling;
    }
  }
  function dn(t, e, n) {
    for (n = n && (e.subtreeFlags & 8772) !== 0, e = e.child; e !== null; ) {
      var i = e.alternate,
        s = t,
        o = e,
        f = o.flags;
      switch (o.tag) {
        case 0:
        case 11:
        case 15:
          (dn(s, o, n), Xa(4, o));
          break;
        case 1:
          if (
            (dn(s, o, n),
            (i = o),
            (s = i.stateNode),
            typeof s.componentDidMount == "function")
          )
            try {
              s.componentDidMount();
            } catch (D) {
              Tt(i, i.return, D);
            }
          if (((i = o), (s = i.updateQueue), s !== null)) {
            var m = i.stateNode;
            try {
              var T = s.shared.hiddenCallbacks;
              if (T !== null)
                for (s.shared.hiddenCallbacks = null, s = 0; s < T.length; s++)
                  vh(T[s], m);
            } catch (D) {
              Tt(i, i.return, D);
            }
          }
          (n && f & 64 && Od(o), Qa(o, o.return));
          break;
        case 27:
          Ud(o);
        case 26:
        case 5:
          (dn(s, o, n), n && i === null && f & 4 && Vd(o), Qa(o, o.return));
          break;
        case 12:
          dn(s, o, n);
          break;
        case 31:
          (dn(s, o, n), n && f & 4 && Hd(s, o));
          break;
        case 13:
          (dn(s, o, n), n && f & 4 && wd(s, o));
          break;
        case 22:
          (o.memoizedState === null && dn(s, o, n), Qa(o, o.return));
          break;
        case 30:
          break;
        default:
          dn(s, o, n);
      }
      e = e.sibling;
    }
  }
  function Ko(t, e) {
    var n = null;
    (t !== null &&
      t.memoizedState !== null &&
      t.memoizedState.cachePool !== null &&
      (n = t.memoizedState.cachePool.pool),
      (t = null),
      e.memoizedState !== null &&
        e.memoizedState.cachePool !== null &&
        (t = e.memoizedState.cachePool.pool),
      t !== n && (t != null && t.refCount++, n != null && Ra(n)));
  }
  function Jo(t, e) {
    ((t = null),
      e.alternate !== null && (t = e.alternate.memoizedState.cache),
      (e = e.memoizedState.cache),
      e !== t && (e.refCount++, t != null && Ra(t)));
  }
  function Xe(t, e, n, i) {
    if (e.subtreeFlags & 10256)
      for (e = e.child; e !== null; ) (Gd(t, e, n, i), (e = e.sibling));
  }
  function Gd(t, e, n, i) {
    var s = e.flags;
    switch (e.tag) {
      case 0:
      case 11:
      case 15:
        (Xe(t, e, n, i), s & 2048 && Xa(9, e));
        break;
      case 1:
        Xe(t, e, n, i);
        break;
      case 3:
        (Xe(t, e, n, i),
          s & 2048 &&
            ((t = null),
            e.alternate !== null && (t = e.alternate.memoizedState.cache),
            (e = e.memoizedState.cache),
            e !== t && (e.refCount++, t != null && Ra(t))));
        break;
      case 12:
        if (s & 2048) {
          (Xe(t, e, n, i), (t = e.stateNode));
          try {
            var o = e.memoizedProps,
              f = o.id,
              m = o.onPostCommit;
            typeof m == "function" &&
              m(
                f,
                e.alternate === null ? "mount" : "update",
                t.passiveEffectDuration,
                -0,
              );
          } catch (T) {
            Tt(e, e.return, T);
          }
        } else Xe(t, e, n, i);
        break;
      case 31:
        Xe(t, e, n, i);
        break;
      case 13:
        Xe(t, e, n, i);
        break;
      case 23:
        break;
      case 22:
        ((o = e.stateNode),
          (f = e.alternate),
          e.memoizedState !== null
            ? o._visibility & 2
              ? Xe(t, e, n, i)
              : Za(t, e)
            : o._visibility & 2
              ? Xe(t, e, n, i)
              : ((o._visibility |= 2),
                Ki(t, e, n, i, (e.subtreeFlags & 10256) !== 0 || !1)),
          s & 2048 && Ko(f, e));
        break;
      case 24:
        (Xe(t, e, n, i), s & 2048 && Jo(e.alternate, e));
        break;
      default:
        Xe(t, e, n, i);
    }
  }
  function Ki(t, e, n, i, s) {
    for (
      s = s && ((e.subtreeFlags & 10256) !== 0 || !1), e = e.child;
      e !== null;
    ) {
      var o = t,
        f = e,
        m = n,
        T = i,
        D = f.flags;
      switch (f.tag) {
        case 0:
        case 11:
        case 15:
          (Ki(o, f, m, T, s), Xa(8, f));
          break;
        case 23:
          break;
        case 22:
          var R = f.stateNode;
          (f.memoizedState !== null
            ? R._visibility & 2
              ? Ki(o, f, m, T, s)
              : Za(o, f)
            : ((R._visibility |= 2), Ki(o, f, m, T, s)),
            s && D & 2048 && Ko(f.alternate, f));
          break;
        case 24:
          (Ki(o, f, m, T, s), s && D & 2048 && Jo(f.alternate, f));
          break;
        default:
          Ki(o, f, m, T, s);
      }
      e = e.sibling;
    }
  }
  function Za(t, e) {
    if (e.subtreeFlags & 10256)
      for (e = e.child; e !== null; ) {
        var n = t,
          i = e,
          s = i.flags;
        switch (i.tag) {
          case 22:
            (Za(n, i), s & 2048 && Ko(i.alternate, i));
            break;
          case 24:
            (Za(n, i), s & 2048 && Jo(i.alternate, i));
            break;
          default:
            Za(n, i);
        }
        e = e.sibling;
      }
  }
  var Ka = 8192;
  function Ji(t, e, n) {
    if (t.subtreeFlags & Ka)
      for (t = t.child; t !== null; ) (Xd(t, e, n), (t = t.sibling));
  }
  function Xd(t, e, n) {
    switch (t.tag) {
      case 26:
        (Ji(t, e, n),
          t.flags & Ka &&
            t.memoizedState !== null &&
            M1(n, Ge, t.memoizedState, t.memoizedProps));
        break;
      case 5:
        Ji(t, e, n);
        break;
      case 3:
      case 4:
        var i = Ge;
        ((Ge = Rs(t.stateNode.containerInfo)), Ji(t, e, n), (Ge = i));
        break;
      case 22:
        t.memoizedState === null &&
          ((i = t.alternate),
          i !== null && i.memoizedState !== null
            ? ((i = Ka), (Ka = 16777216), Ji(t, e, n), (Ka = i))
            : Ji(t, e, n));
        break;
      default:
        Ji(t, e, n);
    }
  }
  function Qd(t) {
    var e = t.alternate;
    if (e !== null && ((t = e.child), t !== null)) {
      e.child = null;
      do ((e = t.sibling), (t.sibling = null), (t = e));
      while (t !== null);
    }
  }
  function Ja(t) {
    var e = t.deletions;
    if ((t.flags & 16) !== 0) {
      if (e !== null)
        for (var n = 0; n < e.length; n++) {
          var i = e[n];
          ((Ft = i), Kd(i, t));
        }
      Qd(t);
    }
    if (t.subtreeFlags & 10256)
      for (t = t.child; t !== null; ) (Zd(t), (t = t.sibling));
  }
  function Zd(t) {
    switch (t.tag) {
      case 0:
      case 11:
      case 15:
        (Ja(t), t.flags & 2048 && Vn(9, t, t.return));
        break;
      case 3:
        Ja(t);
        break;
      case 12:
        Ja(t);
        break;
      case 22:
        var e = t.stateNode;
        t.memoizedState !== null &&
        e._visibility & 2 &&
        (t.return === null || t.return.tag !== 13)
          ? ((e._visibility &= -3), gs(t))
          : Ja(t);
        break;
      default:
        Ja(t);
    }
  }
  function gs(t) {
    var e = t.deletions;
    if ((t.flags & 16) !== 0) {
      if (e !== null)
        for (var n = 0; n < e.length; n++) {
          var i = e[n];
          ((Ft = i), Kd(i, t));
        }
      Qd(t);
    }
    for (t = t.child; t !== null; ) {
      switch (((e = t), e.tag)) {
        case 0:
        case 11:
        case 15:
          (Vn(8, e, e.return), gs(e));
          break;
        case 22:
          ((n = e.stateNode),
            n._visibility & 2 && ((n._visibility &= -3), gs(e)));
          break;
        default:
          gs(e);
      }
      t = t.sibling;
    }
  }
  function Kd(t, e) {
    for (; Ft !== null; ) {
      var n = Ft;
      switch (n.tag) {
        case 0:
        case 11:
        case 15:
          Vn(8, n, e);
          break;
        case 23:
        case 22:
          if (n.memoizedState !== null && n.memoizedState.cachePool !== null) {
            var i = n.memoizedState.cachePool.pool;
            i != null && i.refCount++;
          }
          break;
        case 24:
          Ra(n.memoizedState.cache);
      }
      if (((i = n.child), i !== null)) ((i.return = n), (Ft = i));
      else
        t: for (n = t; Ft !== null; ) {
          i = Ft;
          var s = i.sibling,
            o = i.return;
          if ((jd(i), i === n)) {
            Ft = null;
            break t;
          }
          if (s !== null) {
            ((s.return = o), (Ft = s));
            break t;
          }
          Ft = o;
        }
    }
  }
  var wv = {
      getCacheForType: function (t) {
        var e = Pt(Yt),
          n = e.data.get(t);
        return (n === void 0 && ((n = t()), e.data.set(t, n)), n);
      },
      cacheSignal: function () {
        return Pt(Yt).controller.signal;
      },
    },
    Yv = typeof WeakMap == "function" ? WeakMap : Map,
    gt = 0,
    Mt = null,
    ot = null,
    ft = 0,
    St = 0,
    Ae = null,
    _n = !1,
    Fi = !1,
    Fo = !1,
    mn = 0,
    _t = 0,
    Un = 0,
    di = 0,
    ko = 0,
    Ee = 0,
    ki = 0,
    Fa = null,
    de = null,
    Wo = !1,
    vs = 0,
    Jd = 0,
    Ss = 1 / 0,
    Ts = null,
    Bn = null,
    Zt = 0,
    Nn = null,
    Wi = null,
    yn = 0,
    Po = 0,
    $o = null,
    Fd = null,
    ka = 0,
    Io = null;
  function Me() {
    return (gt & 2) !== 0 && ft !== 0 ? ft & -ft : V.T !== null ? lr() : cf();
  }
  function kd() {
    if (Ee === 0)
      if ((ft & 536870912) === 0 || dt) {
        var t = zl;
        ((zl <<= 1), (zl & 3932160) === 0 && (zl = 262144), (Ee = t));
      } else Ee = 536870912;
    return ((t = Te.current), t !== null && (t.flags |= 32), Ee);
  }
  function me(t, e, n) {
    (((t === Mt && (St === 2 || St === 9)) || t.cancelPendingCommit !== null) &&
      (Pi(t, 0), jn(t, ft, Ee, !1)),
      pa(t, n),
      ((gt & 2) === 0 || t !== Mt) &&
        (t === Mt &&
          ((gt & 2) === 0 && (di |= n), _t === 4 && jn(t, ft, Ee, !1)),
        ke(t)));
  }
  function Wd(t, e, n) {
    if ((gt & 6) !== 0) throw Error(r(327));
    var i = (!n && (e & 127) === 0 && (e & t.expiredLanes) === 0) || ya(t, e),
      s = i ? Xv(t, e) : er(t, e, !0),
      o = i;
    do {
      if (s === 0) {
        Fi && !i && jn(t, e, 0, !1);
        break;
      } else {
        if (((n = t.current.alternate), o && !qv(n))) {
          ((s = er(t, e, !1)), (o = !1));
          continue;
        }
        if (s === 2) {
          if (((o = e), t.errorRecoveryDisabledLanes & o)) var f = 0;
          else
            ((f = t.pendingLanes & -536870913),
              (f = f !== 0 ? f : f & 536870912 ? 536870912 : 0));
          if (f !== 0) {
            e = f;
            t: {
              var m = t;
              s = Fa;
              var T = m.current.memoizedState.isDehydrated;
              if ((T && (Pi(m, f).flags |= 256), (f = er(m, f, !1)), f !== 2)) {
                if (Fo && !T) {
                  ((m.errorRecoveryDisabledLanes |= o), (di |= o), (s = 4));
                  break t;
                }
                ((o = de),
                  (de = s),
                  o !== null &&
                    (de === null ? (de = o) : de.push.apply(de, o)));
              }
              s = f;
            }
            if (((o = !1), s !== 2)) continue;
          }
        }
        if (s === 1) {
          (Pi(t, 0), jn(t, e, 0, !0));
          break;
        }
        t: {
          switch (((i = t), (o = s), o)) {
            case 0:
            case 1:
              throw Error(r(345));
            case 4:
              if ((e & 4194048) !== e) break;
            case 6:
              jn(i, e, Ee, !_n);
              break t;
            case 2:
              de = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(r(329));
          }
          if ((e & 62914560) === e && ((s = vs + 300 - ye()), 10 < s)) {
            if ((jn(i, e, Ee, !_n), Rl(i, 0, !0) !== 0)) break t;
            ((yn = e),
              (i.timeoutHandle = Cm(
                Pd.bind(
                  null,
                  i,
                  n,
                  de,
                  Ts,
                  Wo,
                  e,
                  Ee,
                  di,
                  ki,
                  _n,
                  o,
                  "Throttled",
                  -0,
                  0,
                ),
                s,
              )));
            break t;
          }
          Pd(i, n, de, Ts, Wo, e, Ee, di, ki, _n, o, null, -0, 0);
        }
      }
      break;
    } while (!0);
    ke(t);
  }
  function Pd(t, e, n, i, s, o, f, m, T, D, R, B, C, O) {
    if (
      ((t.timeoutHandle = -1),
      (B = e.subtreeFlags),
      B & 8192 || (B & 16785408) === 16785408)
    ) {
      ((B = {
        stylesheets: null,
        count: 0,
        imgCount: 0,
        imgBytes: 0,
        suspenseyImages: [],
        waitingForImages: !0,
        waitingForViewTransition: !1,
        unsuspend: Ie,
      }),
        Xd(e, o, B));
      var Q =
        (o & 62914560) === o ? vs - ye() : (o & 4194048) === o ? Jd - ye() : 0;
      if (((Q = x1(B, Q)), Q !== null)) {
        ((yn = o),
          (t.cancelPendingCommit = Q(
            lm.bind(null, t, e, o, n, i, s, f, m, T, R, B, null, C, O),
          )),
          jn(t, o, f, !D));
        return;
      }
    }
    lm(t, e, o, n, i, s, f, m, T);
  }
  function qv(t) {
    for (var e = t; ; ) {
      var n = e.tag;
      if (
        (n === 0 || n === 11 || n === 15) &&
        e.flags & 16384 &&
        ((n = e.updateQueue), n !== null && ((n = n.stores), n !== null))
      )
        for (var i = 0; i < n.length; i++) {
          var s = n[i],
            o = s.getSnapshot;
          s = s.value;
          try {
            if (!ve(o(), s)) return !1;
          } catch {
            return !1;
          }
        }
      if (((n = e.child), e.subtreeFlags & 16384 && n !== null))
        ((n.return = e), (e = n));
      else {
        if (e === t) break;
        for (; e.sibling === null; ) {
          if (e.return === null || e.return === t) return !0;
          e = e.return;
        }
        ((e.sibling.return = e.return), (e = e.sibling));
      }
    }
    return !0;
  }
  function jn(t, e, n, i) {
    ((e &= ~ko),
      (e &= ~di),
      (t.suspendedLanes |= e),
      (t.pingedLanes &= ~e),
      i && (t.warmLanes |= e),
      (i = t.expirationTimes));
    for (var s = e; 0 < s; ) {
      var o = 31 - ge(s),
        f = 1 << o;
      ((i[o] = -1), (s &= ~f));
    }
    n !== 0 && uf(t, n, e);
  }
  function bs() {
    return (gt & 6) === 0 ? (Wa(0), !1) : !0;
  }
  function tr() {
    if (ot !== null) {
      if (St === 0) var t = ot.return;
      else ((t = ot), (an = ai = null), po(t), (qi = null), (_a = 0), (t = ot));
      for (; t !== null; ) (zd(t.alternate, t), (t = t.return));
      ot = null;
    }
  }
  function Pi(t, e) {
    var n = t.timeoutHandle;
    (n !== -1 && ((t.timeoutHandle = -1), u1(n)),
      (n = t.cancelPendingCommit),
      n !== null && ((t.cancelPendingCommit = null), n()),
      (yn = 0),
      tr(),
      (Mt = t),
      (ot = n = en(t.current, null)),
      (ft = e),
      (St = 0),
      (Ae = null),
      (_n = !1),
      (Fi = ya(t, e)),
      (Fo = !1),
      (ki = Ee = ko = di = Un = _t = 0),
      (de = Fa = null),
      (Wo = !1),
      (e & 8) !== 0 && (e |= e & 32));
    var i = t.entangledLanes;
    if (i !== 0)
      for (t = t.entanglements, i &= e; 0 < i; ) {
        var s = 31 - ge(i),
          o = 1 << s;
        ((e |= t[s]), (i &= ~o));
      }
    return ((mn = e), Gl(), n);
  }
  function $d(t, e) {
    ((lt = null),
      (V.H = Ya),
      e === Yi || e === Wl
        ? ((e = mh()), (St = 3))
        : e === io
          ? ((e = mh()), (St = 4))
          : (St =
              e === _o
                ? 8
                : e !== null &&
                    typeof e == "object" &&
                    typeof e.then == "function"
                  ? 6
                  : 1),
      (Ae = e),
      ot === null && ((_t = 1), cs(t, Re(e, t.current))));
  }
  function Id() {
    var t = Te.current;
    return t === null
      ? !0
      : (ft & 4194048) === ft
        ? Be === null
        : (ft & 62914560) === ft || (ft & 536870912) !== 0
          ? t === Be
          : !1;
  }
  function tm() {
    var t = V.H;
    return ((V.H = Ya), t === null ? Ya : t);
  }
  function em() {
    var t = V.A;
    return ((V.A = wv), t);
  }
  function As() {
    ((_t = 4),
      _n || ((ft & 4194048) !== ft && Te.current !== null) || (Fi = !0),
      ((Un & 134217727) === 0 && (di & 134217727) === 0) ||
        Mt === null ||
        jn(Mt, ft, Ee, !1));
  }
  function er(t, e, n) {
    var i = gt;
    gt |= 2;
    var s = tm(),
      o = em();
    ((Mt !== t || ft !== e) && ((Ts = null), Pi(t, e)), (e = !1));
    var f = _t;
    t: do
      try {
        if (St !== 0 && ot !== null) {
          var m = ot,
            T = Ae;
          switch (St) {
            case 8:
              (tr(), (f = 6));
              break t;
            case 3:
            case 2:
            case 9:
            case 6:
              Te.current === null && (e = !0);
              var D = St;
              if (((St = 0), (Ae = null), $i(t, m, T, D), n && Fi)) {
                f = 0;
                break t;
              }
              break;
            default:
              ((D = St), (St = 0), (Ae = null), $i(t, m, T, D));
          }
        }
        (Gv(), (f = _t));
        break;
      } catch (R) {
        $d(t, R);
      }
    while (!0);
    return (
      e && t.shellSuspendCounter++,
      (an = ai = null),
      (gt = i),
      (V.H = s),
      (V.A = o),
      ot === null && ((Mt = null), (ft = 0), Gl()),
      f
    );
  }
  function Gv() {
    for (; ot !== null; ) nm(ot);
  }
  function Xv(t, e) {
    var n = gt;
    gt |= 2;
    var i = tm(),
      s = em();
    Mt !== t || ft !== e
      ? ((Ts = null), (Ss = ye() + 500), Pi(t, e))
      : (Fi = ya(t, e));
    t: do
      try {
        if (St !== 0 && ot !== null) {
          e = ot;
          var o = Ae;
          e: switch (St) {
            case 1:
              ((St = 0), (Ae = null), $i(t, e, o, 1));
              break;
            case 2:
            case 9:
              if (hh(o)) {
                ((St = 0), (Ae = null), im(e));
                break;
              }
              ((e = function () {
                ((St !== 2 && St !== 9) || Mt !== t || (St = 7), ke(t));
              }),
                o.then(e, e));
              break t;
            case 3:
              St = 7;
              break t;
            case 4:
              St = 5;
              break t;
            case 7:
              hh(o)
                ? ((St = 0), (Ae = null), im(e))
                : ((St = 0), (Ae = null), $i(t, e, o, 7));
              break;
            case 5:
              var f = null;
              switch (ot.tag) {
                case 26:
                  f = ot.memoizedState;
                case 5:
                case 27:
                  var m = ot;
                  if (f ? Gm(f) : m.stateNode.complete) {
                    ((St = 0), (Ae = null));
                    var T = m.sibling;
                    if (T !== null) ot = T;
                    else {
                      var D = m.return;
                      D !== null ? ((ot = D), Es(D)) : (ot = null);
                    }
                    break e;
                  }
              }
              ((St = 0), (Ae = null), $i(t, e, o, 5));
              break;
            case 6:
              ((St = 0), (Ae = null), $i(t, e, o, 6));
              break;
            case 8:
              (tr(), (_t = 6));
              break t;
            default:
              throw Error(r(462));
          }
        }
        Qv();
        break;
      } catch (R) {
        $d(t, R);
      }
    while (!0);
    return (
      (an = ai = null),
      (V.H = i),
      (V.A = s),
      (gt = n),
      ot !== null ? 0 : ((Mt = null), (ft = 0), Gl(), _t)
    );
  }
  function Qv() {
    for (; ot !== null && !d0(); ) nm(ot);
  }
  function nm(t) {
    var e = Dd(t.alternate, t, mn);
    ((t.memoizedProps = t.pendingProps), e === null ? Es(t) : (ot = e));
  }
  function im(t) {
    var e = t,
      n = e.alternate;
    switch (e.tag) {
      case 15:
      case 0:
        e = Td(n, e, e.pendingProps, e.type, void 0, ft);
        break;
      case 11:
        e = Td(n, e, e.pendingProps, e.type.render, e.ref, ft);
        break;
      case 5:
        po(e);
      default:
        (zd(n, e), (e = ot = eh(e, mn)), (e = Dd(n, e, mn)));
    }
    ((t.memoizedProps = t.pendingProps), e === null ? Es(t) : (ot = e));
  }
  function $i(t, e, n, i) {
    ((an = ai = null), po(e), (qi = null), (_a = 0));
    var s = e.return;
    try {
      if (_v(t, s, e, n, ft)) {
        ((_t = 1), cs(t, Re(n, t.current)), (ot = null));
        return;
      }
    } catch (o) {
      if (s !== null) throw ((ot = s), o);
      ((_t = 1), cs(t, Re(n, t.current)), (ot = null));
      return;
    }
    e.flags & 32768
      ? (dt || i === 1
          ? (t = !0)
          : Fi || (ft & 536870912) !== 0
            ? (t = !1)
            : ((_n = t = !0),
              (i === 2 || i === 9 || i === 3 || i === 6) &&
                ((i = Te.current),
                i !== null && i.tag === 13 && (i.flags |= 16384))),
        am(e, t))
      : Es(e);
  }
  function Es(t) {
    var e = t;
    do {
      if ((e.flags & 32768) !== 0) {
        am(e, _n);
        return;
      }
      t = e.return;
      var n = Nv(e.alternate, e, mn);
      if (n !== null) {
        ot = n;
        return;
      }
      if (((e = e.sibling), e !== null)) {
        ot = e;
        return;
      }
      ot = e = t;
    } while (e !== null);
    _t === 0 && (_t = 5);
  }
  function am(t, e) {
    do {
      var n = jv(t.alternate, t);
      if (n !== null) {
        ((n.flags &= 32767), (ot = n));
        return;
      }
      if (
        ((n = t.return),
        n !== null &&
          ((n.flags |= 32768), (n.subtreeFlags = 0), (n.deletions = null)),
        !e && ((t = t.sibling), t !== null))
      ) {
        ot = t;
        return;
      }
      ot = t = n;
    } while (t !== null);
    ((_t = 6), (ot = null));
  }
  function lm(t, e, n, i, s, o, f, m, T) {
    t.cancelPendingCommit = null;
    do Ms();
    while (Zt !== 0);
    if ((gt & 6) !== 0) throw Error(r(327));
    if (e !== null) {
      if (e === t.current) throw Error(r(177));
      if (
        ((o = e.lanes | e.childLanes),
        (o |= Gu),
        E0(t, n, o, f, m, T),
        t === Mt && ((ot = Mt = null), (ft = 0)),
        (Wi = e),
        (Nn = t),
        (yn = n),
        (Po = o),
        ($o = s),
        (Fd = i),
        (e.subtreeFlags & 10256) !== 0 || (e.flags & 10256) !== 0
          ? ((t.callbackNode = null),
            (t.callbackPriority = 0),
            Fv(Dl, function () {
              return (cm(), null);
            }))
          : ((t.callbackNode = null), (t.callbackPriority = 0)),
        (i = (e.flags & 13878) !== 0),
        (e.subtreeFlags & 13878) !== 0 || i)
      ) {
        ((i = V.T), (V.T = null), (s = w.p), (w.p = 2), (f = gt), (gt |= 4));
        try {
          Lv(t, e, n);
        } finally {
          ((gt = f), (w.p = s), (V.T = i));
        }
      }
      ((Zt = 1), sm(), um(), om());
    }
  }
  function sm() {
    if (Zt === 1) {
      Zt = 0;
      var t = Nn,
        e = Wi,
        n = (e.flags & 13878) !== 0;
      if ((e.subtreeFlags & 13878) !== 0 || n) {
        ((n = V.T), (V.T = null));
        var i = w.p;
        w.p = 2;
        var s = gt;
        gt |= 4;
        try {
          Yd(e, t);
          var o = dr,
            f = Kf(t.containerInfo),
            m = o.focusedElem,
            T = o.selectionRange;
          if (
            f !== m &&
            m &&
            m.ownerDocument &&
            Zf(m.ownerDocument.documentElement, m)
          ) {
            if (T !== null && Lu(m)) {
              var D = T.start,
                R = T.end;
              if ((R === void 0 && (R = D), "selectionStart" in m))
                ((m.selectionStart = D),
                  (m.selectionEnd = Math.min(R, m.value.length)));
              else {
                var B = m.ownerDocument || document,
                  C = (B && B.defaultView) || window;
                if (C.getSelection) {
                  var O = C.getSelection(),
                    Q = m.textContent.length,
                    tt = Math.min(T.start, Q),
                    Et = T.end === void 0 ? tt : Math.min(T.end, Q);
                  !O.extend && tt > Et && ((f = Et), (Et = tt), (tt = f));
                  var M = Qf(m, tt),
                    b = Qf(m, Et);
                  if (
                    M &&
                    b &&
                    (O.rangeCount !== 1 ||
                      O.anchorNode !== M.node ||
                      O.anchorOffset !== M.offset ||
                      O.focusNode !== b.node ||
                      O.focusOffset !== b.offset)
                  ) {
                    var x = B.createRange();
                    (x.setStart(M.node, M.offset),
                      O.removeAllRanges(),
                      tt > Et
                        ? (O.addRange(x), O.extend(b.node, b.offset))
                        : (x.setEnd(b.node, b.offset), O.addRange(x)));
                  }
                }
              }
            }
            for (B = [], O = m; (O = O.parentNode); )
              O.nodeType === 1 &&
                B.push({ element: O, left: O.scrollLeft, top: O.scrollTop });
            for (
              typeof m.focus == "function" && m.focus(), m = 0;
              m < B.length;
              m++
            ) {
              var U = B[m];
              ((U.element.scrollLeft = U.left), (U.element.scrollTop = U.top));
            }
          }
          ((js = !!hr), (dr = hr = null));
        } finally {
          ((gt = s), (w.p = i), (V.T = n));
        }
      }
      ((t.current = e), (Zt = 2));
    }
  }
  function um() {
    if (Zt === 2) {
      Zt = 0;
      var t = Nn,
        e = Wi,
        n = (e.flags & 8772) !== 0;
      if ((e.subtreeFlags & 8772) !== 0 || n) {
        ((n = V.T), (V.T = null));
        var i = w.p;
        w.p = 2;
        var s = gt;
        gt |= 4;
        try {
          Nd(t, e.alternate, e);
        } finally {
          ((gt = s), (w.p = i), (V.T = n));
        }
      }
      Zt = 3;
    }
  }
  function om() {
    if (Zt === 4 || Zt === 3) {
      ((Zt = 0), m0());
      var t = Nn,
        e = Wi,
        n = yn,
        i = Fd;
      (e.subtreeFlags & 10256) !== 0 || (e.flags & 10256) !== 0
        ? (Zt = 5)
        : ((Zt = 0), (Wi = Nn = null), rm(t, t.pendingLanes));
      var s = t.pendingLanes;
      if (
        (s === 0 && (Bn = null),
        vu(n),
        (e = e.stateNode),
        pe && typeof pe.onCommitFiberRoot == "function")
      )
        try {
          pe.onCommitFiberRoot(ma, e, void 0, (e.current.flags & 128) === 128);
        } catch {}
      if (i !== null) {
        ((e = V.T), (s = w.p), (w.p = 2), (V.T = null));
        try {
          for (var o = t.onRecoverableError, f = 0; f < i.length; f++) {
            var m = i[f];
            o(m.value, { componentStack: m.stack });
          }
        } finally {
          ((V.T = e), (w.p = s));
        }
      }
      ((yn & 3) !== 0 && Ms(),
        ke(t),
        (s = t.pendingLanes),
        (n & 261930) !== 0 && (s & 42) !== 0
          ? t === Io
            ? ka++
            : ((ka = 0), (Io = t))
          : (ka = 0),
        Wa(0));
    }
  }
  function rm(t, e) {
    (t.pooledCacheLanes &= e) === 0 &&
      ((e = t.pooledCache), e != null && ((t.pooledCache = null), Ra(e)));
  }
  function Ms() {
    return (sm(), um(), om(), cm());
  }
  function cm() {
    if (Zt !== 5) return !1;
    var t = Nn,
      e = Po;
    Po = 0;
    var n = vu(yn),
      i = V.T,
      s = w.p;
    try {
      ((w.p = 32 > n ? 32 : n), (V.T = null), (n = $o), ($o = null));
      var o = Nn,
        f = yn;
      if (((Zt = 0), (Wi = Nn = null), (yn = 0), (gt & 6) !== 0))
        throw Error(r(331));
      var m = gt;
      if (
        ((gt |= 4),
        Zd(o.current),
        Gd(o, o.current, f, n),
        (gt = m),
        Wa(0, !1),
        pe && typeof pe.onPostCommitFiberRoot == "function")
      )
        try {
          pe.onPostCommitFiberRoot(ma, o);
        } catch {}
      return !0;
    } finally {
      ((w.p = s), (V.T = i), rm(t, e));
    }
  }
  function fm(t, e, n) {
    ((e = Re(n, e)),
      (e = Vo(t.stateNode, e, 2)),
      (t = zn(t, e, 2)),
      t !== null && (pa(t, 2), ke(t)));
  }
  function Tt(t, e, n) {
    if (t.tag === 3) fm(t, t, n);
    else
      for (; e !== null; ) {
        if (e.tag === 3) {
          fm(e, t, n);
          break;
        } else if (e.tag === 1) {
          var i = e.stateNode;
          if (
            typeof e.type.getDerivedStateFromError == "function" ||
            (typeof i.componentDidCatch == "function" &&
              (Bn === null || !Bn.has(i)))
          ) {
            ((t = Re(n, t)),
              (n = hd(2)),
              (i = zn(e, n, 2)),
              i !== null && (dd(n, i, e, t), pa(i, 2), ke(i)));
            break;
          }
        }
        e = e.return;
      }
  }
  function nr(t, e, n) {
    var i = t.pingCache;
    if (i === null) {
      i = t.pingCache = new Yv();
      var s = new Set();
      i.set(e, s);
    } else ((s = i.get(e)), s === void 0 && ((s = new Set()), i.set(e, s)));
    s.has(n) ||
      ((Fo = !0), s.add(n), (t = Zv.bind(null, t, e, n)), e.then(t, t));
  }
  function Zv(t, e, n) {
    var i = t.pingCache;
    (i !== null && i.delete(e),
      (t.pingedLanes |= t.suspendedLanes & n),
      (t.warmLanes &= ~n),
      Mt === t &&
        (ft & n) === n &&
        (_t === 4 || (_t === 3 && (ft & 62914560) === ft && 300 > ye() - vs)
          ? (gt & 2) === 0 && Pi(t, 0)
          : (ko |= n),
        ki === ft && (ki = 0)),
      ke(t));
  }
  function hm(t, e) {
    (e === 0 && (e = sf()), (t = ei(t, e)), t !== null && (pa(t, e), ke(t)));
  }
  function Kv(t) {
    var e = t.memoizedState,
      n = 0;
    (e !== null && (n = e.retryLane), hm(t, n));
  }
  function Jv(t, e) {
    var n = 0;
    switch (t.tag) {
      case 31:
      case 13:
        var i = t.stateNode,
          s = t.memoizedState;
        s !== null && (n = s.retryLane);
        break;
      case 19:
        i = t.stateNode;
        break;
      case 22:
        i = t.stateNode._retryCache;
        break;
      default:
        throw Error(r(314));
    }
    (i !== null && i.delete(e), hm(t, n));
  }
  function Fv(t, e) {
    return mu(t, e);
  }
  var xs = null,
    Ii = null,
    ir = !1,
    Ds = !1,
    ar = !1,
    Ln = 0;
  function ke(t) {
    (t !== Ii &&
      t.next === null &&
      (Ii === null ? (xs = Ii = t) : (Ii = Ii.next = t)),
      (Ds = !0),
      ir || ((ir = !0), Wv()));
  }
  function Wa(t, e) {
    if (!ar && Ds) {
      ar = !0;
      do
        for (var n = !1, i = xs; i !== null; ) {
          if (t !== 0) {
            var s = i.pendingLanes;
            if (s === 0) var o = 0;
            else {
              var f = i.suspendedLanes,
                m = i.pingedLanes;
              ((o = (1 << (31 - ge(42 | t) + 1)) - 1),
                (o &= s & ~(f & ~m)),
                (o = o & 201326741 ? (o & 201326741) | 1 : o ? o | 2 : 0));
            }
            o !== 0 && ((n = !0), pm(i, o));
          } else
            ((o = ft),
              (o = Rl(
                i,
                i === Mt ? o : 0,
                i.cancelPendingCommit !== null || i.timeoutHandle !== -1,
              )),
              (o & 3) === 0 || ya(i, o) || ((n = !0), pm(i, o)));
          i = i.next;
        }
      while (n);
      ar = !1;
    }
  }
  function kv() {
    dm();
  }
  function dm() {
    Ds = ir = !1;
    var t = 0;
    Ln !== 0 && s1() && (t = Ln);
    for (var e = ye(), n = null, i = xs; i !== null; ) {
      var s = i.next,
        o = mm(i, e);
      (o === 0
        ? ((i.next = null),
          n === null ? (xs = s) : (n.next = s),
          s === null && (Ii = n))
        : ((n = i), (t !== 0 || (o & 3) !== 0) && (Ds = !0)),
        (i = s));
    }
    ((Zt !== 0 && Zt !== 5) || Wa(t), Ln !== 0 && (Ln = 0));
  }
  function mm(t, e) {
    for (
      var n = t.suspendedLanes,
        i = t.pingedLanes,
        s = t.expirationTimes,
        o = t.pendingLanes & -62914561;
      0 < o;
    ) {
      var f = 31 - ge(o),
        m = 1 << f,
        T = s[f];
      (T === -1
        ? ((m & n) === 0 || (m & i) !== 0) && (s[f] = A0(m, e))
        : T <= e && (t.expiredLanes |= m),
        (o &= ~m));
    }
    if (
      ((e = Mt),
      (n = ft),
      (n = Rl(
        t,
        t === e ? n : 0,
        t.cancelPendingCommit !== null || t.timeoutHandle !== -1,
      )),
      (i = t.callbackNode),
      n === 0 ||
        (t === e && (St === 2 || St === 9)) ||
        t.cancelPendingCommit !== null)
    )
      return (
        i !== null && i !== null && yu(i),
        (t.callbackNode = null),
        (t.callbackPriority = 0)
      );
    if ((n & 3) === 0 || ya(t, n)) {
      if (((e = n & -n), e === t.callbackPriority)) return e;
      switch ((i !== null && yu(i), vu(n))) {
        case 2:
        case 8:
          n = af;
          break;
        case 32:
          n = Dl;
          break;
        case 268435456:
          n = lf;
          break;
        default:
          n = Dl;
      }
      return (
        (i = ym.bind(null, t)),
        (n = mu(n, i)),
        (t.callbackPriority = e),
        (t.callbackNode = n),
        e
      );
    }
    return (
      i !== null && i !== null && yu(i),
      (t.callbackPriority = 2),
      (t.callbackNode = null),
      2
    );
  }
  function ym(t, e) {
    if (Zt !== 0 && Zt !== 5)
      return ((t.callbackNode = null), (t.callbackPriority = 0), null);
    var n = t.callbackNode;
    if (Ms() && t.callbackNode !== n) return null;
    var i = ft;
    return (
      (i = Rl(
        t,
        t === Mt ? i : 0,
        t.cancelPendingCommit !== null || t.timeoutHandle !== -1,
      )),
      i === 0
        ? null
        : (Wd(t, i, e),
          mm(t, ye()),
          t.callbackNode != null && t.callbackNode === n
            ? ym.bind(null, t)
            : null)
    );
  }
  function pm(t, e) {
    if (Ms()) return null;
    Wd(t, e, !0);
  }
  function Wv() {
    o1(function () {
      (gt & 6) !== 0 ? mu(nf, kv) : dm();
    });
  }
  function lr() {
    if (Ln === 0) {
      var t = Hi;
      (t === 0 && ((t = Cl), (Cl <<= 1), (Cl & 261888) === 0 && (Cl = 256)),
        (Ln = t));
    }
    return Ln;
  }
  function gm(t) {
    return t == null || typeof t == "symbol" || typeof t == "boolean"
      ? null
      : typeof t == "function"
        ? t
        : Bl("" + t);
  }
  function vm(t, e) {
    var n = e.ownerDocument.createElement("input");
    return (
      (n.name = e.name),
      (n.value = e.value),
      t.id && n.setAttribute("form", t.id),
      e.parentNode.insertBefore(n, e),
      (t = new FormData(t)),
      n.parentNode.removeChild(n),
      t
    );
  }
  function Pv(t, e, n, i, s) {
    if (e === "submit" && n && n.stateNode === s) {
      var o = gm((s[oe] || null).action),
        f = i.submitter;
      f &&
        ((e = (e = f[oe] || null)
          ? gm(e.formAction)
          : f.getAttribute("formAction")),
        e !== null && ((o = e), (f = null)));
      var m = new Hl("action", "action", null, i, s);
      t.push({
        event: m,
        listeners: [
          {
            instance: null,
            listener: function () {
              if (i.defaultPrevented) {
                if (Ln !== 0) {
                  var T = f ? vm(s, f) : new FormData(s);
                  xo(
                    n,
                    { pending: !0, data: T, method: s.method, action: o },
                    null,
                    T,
                  );
                }
              } else
                typeof o == "function" &&
                  (m.preventDefault(),
                  (T = f ? vm(s, f) : new FormData(s)),
                  xo(
                    n,
                    { pending: !0, data: T, method: s.method, action: o },
                    o,
                    T,
                  ));
            },
            currentTarget: s,
          },
        ],
      });
    }
  }
  for (var sr = 0; sr < qu.length; sr++) {
    var ur = qu[sr],
      $v = ur.toLowerCase(),
      Iv = ur[0].toUpperCase() + ur.slice(1);
    qe($v, "on" + Iv);
  }
  (qe(kf, "onAnimationEnd"),
    qe(Wf, "onAnimationIteration"),
    qe(Pf, "onAnimationStart"),
    qe("dblclick", "onDoubleClick"),
    qe("focusin", "onFocus"),
    qe("focusout", "onBlur"),
    qe(yv, "onTransitionRun"),
    qe(pv, "onTransitionStart"),
    qe(gv, "onTransitionCancel"),
    qe($f, "onTransitionEnd"),
    Mi("onMouseEnter", ["mouseout", "mouseover"]),
    Mi("onMouseLeave", ["mouseout", "mouseover"]),
    Mi("onPointerEnter", ["pointerout", "pointerover"]),
    Mi("onPointerLeave", ["pointerout", "pointerover"]),
    Pn(
      "onChange",
      "change click focusin focusout input keydown keyup selectionchange".split(
        " ",
      ),
    ),
    Pn(
      "onSelect",
      "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
        " ",
      ),
    ),
    Pn("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]),
    Pn(
      "onCompositionEnd",
      "compositionend focusout keydown keypress keyup mousedown".split(" "),
    ),
    Pn(
      "onCompositionStart",
      "compositionstart focusout keydown keypress keyup mousedown".split(" "),
    ),
    Pn(
      "onCompositionUpdate",
      "compositionupdate focusout keydown keypress keyup mousedown".split(" "),
    ));
  var Pa =
      "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
        " ",
      ),
    t1 = new Set(
      "beforetoggle cancel close invalid load scroll scrollend toggle"
        .split(" ")
        .concat(Pa),
    );
  function Sm(t, e) {
    e = (e & 4) !== 0;
    for (var n = 0; n < t.length; n++) {
      var i = t[n],
        s = i.event;
      i = i.listeners;
      t: {
        var o = void 0;
        if (e)
          for (var f = i.length - 1; 0 <= f; f--) {
            var m = i[f],
              T = m.instance,
              D = m.currentTarget;
            if (((m = m.listener), T !== o && s.isPropagationStopped()))
              break t;
            ((o = m), (s.currentTarget = D));
            try {
              o(s);
            } catch (R) {
              ql(R);
            }
            ((s.currentTarget = null), (o = T));
          }
        else
          for (f = 0; f < i.length; f++) {
            if (
              ((m = i[f]),
              (T = m.instance),
              (D = m.currentTarget),
              (m = m.listener),
              T !== o && s.isPropagationStopped())
            )
              break t;
            ((o = m), (s.currentTarget = D));
            try {
              o(s);
            } catch (R) {
              ql(R);
            }
            ((s.currentTarget = null), (o = T));
          }
      }
    }
  }
  function rt(t, e) {
    var n = e[Su];
    n === void 0 && (n = e[Su] = new Set());
    var i = t + "__bubble";
    n.has(i) || (Tm(e, t, 2, !1), n.add(i));
  }
  function or(t, e, n) {
    var i = 0;
    (e && (i |= 4), Tm(n, t, i, e));
  }
  var Cs = "_reactListening" + Math.random().toString(36).slice(2);
  function rr(t) {
    if (!t[Cs]) {
      ((t[Cs] = !0),
        df.forEach(function (n) {
          n !== "selectionchange" && (t1.has(n) || or(n, !1, t), or(n, !0, t));
        }));
      var e = t.nodeType === 9 ? t : t.ownerDocument;
      e === null || e[Cs] || ((e[Cs] = !0), or("selectionchange", !1, e));
    }
  }
  function Tm(t, e, n, i) {
    switch (km(e)) {
      case 2:
        var s = z1;
        break;
      case 8:
        s = O1;
        break;
      default:
        s = Mr;
    }
    ((n = s.bind(null, e, n, t)),
      (s = void 0),
      !zu ||
        (e !== "touchstart" && e !== "touchmove" && e !== "wheel") ||
        (s = !0),
      i
        ? s !== void 0
          ? t.addEventListener(e, n, { capture: !0, passive: s })
          : t.addEventListener(e, n, !0)
        : s !== void 0
          ? t.addEventListener(e, n, { passive: s })
          : t.addEventListener(e, n, !1));
  }
  function cr(t, e, n, i, s) {
    var o = i;
    if ((e & 1) === 0 && (e & 2) === 0 && i !== null)
      t: for (;;) {
        if (i === null) return;
        var f = i.tag;
        if (f === 3 || f === 4) {
          var m = i.stateNode.containerInfo;
          if (m === s) break;
          if (f === 4)
            for (f = i.return; f !== null; ) {
              var T = f.tag;
              if ((T === 3 || T === 4) && f.stateNode.containerInfo === s)
                return;
              f = f.return;
            }
          for (; m !== null; ) {
            if (((f = bi(m)), f === null)) return;
            if (((T = f.tag), T === 5 || T === 6 || T === 26 || T === 27)) {
              i = o = f;
              continue t;
            }
            m = m.parentNode;
          }
        }
        i = i.return;
      }
    xf(function () {
      var D = o,
        R = Du(n),
        B = [];
      t: {
        var C = If.get(t);
        if (C !== void 0) {
          var O = Hl,
            Q = t;
          switch (t) {
            case "keypress":
              if (jl(n) === 0) break t;
            case "keydown":
            case "keyup":
              O = J0;
              break;
            case "focusin":
              ((Q = "focus"), (O = _u));
              break;
            case "focusout":
              ((Q = "blur"), (O = _u));
              break;
            case "beforeblur":
            case "afterblur":
              O = _u;
              break;
            case "click":
              if (n.button === 2) break t;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              O = zf;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              O = N0;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              O = W0;
              break;
            case kf:
            case Wf:
            case Pf:
              O = H0;
              break;
            case $f:
              O = $0;
              break;
            case "scroll":
            case "scrollend":
              O = U0;
              break;
            case "wheel":
              O = tv;
              break;
            case "copy":
            case "cut":
            case "paste":
              O = Y0;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              O = Rf;
              break;
            case "toggle":
            case "beforetoggle":
              O = nv;
          }
          var tt = (e & 4) !== 0,
            Et = !tt && (t === "scroll" || t === "scrollend"),
            M = tt ? (C !== null ? C + "Capture" : null) : C;
          tt = [];
          for (var b = D, x; b !== null; ) {
            var U = b;
            if (
              ((x = U.stateNode),
              (U = U.tag),
              (U !== 5 && U !== 26 && U !== 27) ||
                x === null ||
                M === null ||
                ((U = Sa(b, M)), U != null && tt.push($a(b, U, x))),
              Et)
            )
              break;
            b = b.return;
          }
          0 < tt.length &&
            ((C = new O(C, Q, null, n, R)),
            B.push({ event: C, listeners: tt }));
        }
      }
      if ((e & 7) === 0) {
        t: {
          if (
            ((C = t === "mouseover" || t === "pointerover"),
            (O = t === "mouseout" || t === "pointerout"),
            C &&
              n !== xu &&
              (Q = n.relatedTarget || n.fromElement) &&
              (bi(Q) || Q[Ti]))
          )
            break t;
          if (
            (O || C) &&
            ((C =
              R.window === R
                ? R
                : (C = R.ownerDocument)
                  ? C.defaultView || C.parentWindow
                  : window),
            O
              ? ((Q = n.relatedTarget || n.toElement),
                (O = D),
                (Q = Q ? bi(Q) : null),
                Q !== null &&
                  ((Et = d(Q)),
                  (tt = Q.tag),
                  Q !== Et || (tt !== 5 && tt !== 27 && tt !== 6)) &&
                  (Q = null))
              : ((O = null), (Q = D)),
            O !== Q)
          ) {
            if (
              ((tt = zf),
              (U = "onMouseLeave"),
              (M = "onMouseEnter"),
              (b = "mouse"),
              (t === "pointerout" || t === "pointerover") &&
                ((tt = Rf),
                (U = "onPointerLeave"),
                (M = "onPointerEnter"),
                (b = "pointer")),
              (Et = O == null ? C : va(O)),
              (x = Q == null ? C : va(Q)),
              (C = new tt(U, b + "leave", O, n, R)),
              (C.target = Et),
              (C.relatedTarget = x),
              (U = null),
              bi(R) === D &&
                ((tt = new tt(M, b + "enter", Q, n, R)),
                (tt.target = x),
                (tt.relatedTarget = Et),
                (U = tt)),
              (Et = U),
              O && Q)
            )
              e: {
                for (tt = e1, M = O, b = Q, x = 0, U = M; U; U = tt(U)) x++;
                U = 0;
                for (var I = b; I; I = tt(I)) U++;
                for (; 0 < x - U; ) ((M = tt(M)), x--);
                for (; 0 < U - x; ) ((b = tt(b)), U--);
                for (; x--; ) {
                  if (M === b || (b !== null && M === b.alternate)) {
                    tt = M;
                    break e;
                  }
                  ((M = tt(M)), (b = tt(b)));
                }
                tt = null;
              }
            else tt = null;
            (O !== null && bm(B, C, O, tt, !1),
              Q !== null && Et !== null && bm(B, Et, Q, tt, !0));
          }
        }
        t: {
          if (
            ((C = D ? va(D) : window),
            (O = C.nodeName && C.nodeName.toLowerCase()),
            O === "select" || (O === "input" && C.type === "file"))
          )
            var yt = Hf;
          else if (jf(C))
            if (wf) yt = hv;
            else {
              yt = cv;
              var k = rv;
            }
          else
            ((O = C.nodeName),
              !O ||
              O.toLowerCase() !== "input" ||
              (C.type !== "checkbox" && C.type !== "radio")
                ? D && Mu(D.elementType) && (yt = Hf)
                : (yt = fv));
          if (yt && (yt = yt(t, D))) {
            Lf(B, yt, n, R);
            break t;
          }
          (k && k(t, C, D),
            t === "focusout" &&
              D &&
              C.type === "number" &&
              D.memoizedProps.value != null &&
              Eu(C, "number", C.value));
        }
        switch (((k = D ? va(D) : window), t)) {
          case "focusin":
            (jf(k) || k.contentEditable === "true") &&
              ((Ri = k), (Hu = D), (Ca = null));
            break;
          case "focusout":
            Ca = Hu = Ri = null;
            break;
          case "mousedown":
            wu = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            ((wu = !1), Jf(B, n, R));
            break;
          case "selectionchange":
            if (mv) break;
          case "keydown":
          case "keyup":
            Jf(B, n, R);
        }
        var st;
        if (Bu)
          t: {
            switch (t) {
              case "compositionstart":
                var ht = "onCompositionStart";
                break t;
              case "compositionend":
                ht = "onCompositionEnd";
                break t;
              case "compositionupdate":
                ht = "onCompositionUpdate";
                break t;
            }
            ht = void 0;
          }
        else
          Oi
            ? Bf(t, n) && (ht = "onCompositionEnd")
            : t === "keydown" &&
              n.keyCode === 229 &&
              (ht = "onCompositionStart");
        (ht &&
          (Vf &&
            n.locale !== "ko" &&
            (Oi || ht !== "onCompositionStart"
              ? ht === "onCompositionEnd" && Oi && (st = Df())
              : ((bn = R),
                (Ou = "value" in bn ? bn.value : bn.textContent),
                (Oi = !0))),
          (k = zs(D, ht)),
          0 < k.length &&
            ((ht = new Of(ht, t, null, n, R)),
            B.push({ event: ht, listeners: k }),
            st
              ? (ht.data = st)
              : ((st = Nf(n)), st !== null && (ht.data = st)))),
          (st = av ? lv(t, n) : sv(t, n)) &&
            ((ht = zs(D, "onBeforeInput")),
            0 < ht.length &&
              ((k = new Of("onBeforeInput", "beforeinput", null, n, R)),
              B.push({ event: k, listeners: ht }),
              (k.data = st))),
          Pv(B, t, D, n, R));
      }
      Sm(B, e);
    });
  }
  function $a(t, e, n) {
    return { instance: t, listener: e, currentTarget: n };
  }
  function zs(t, e) {
    for (var n = e + "Capture", i = []; t !== null; ) {
      var s = t,
        o = s.stateNode;
      if (
        ((s = s.tag),
        (s !== 5 && s !== 26 && s !== 27) ||
          o === null ||
          ((s = Sa(t, n)),
          s != null && i.unshift($a(t, s, o)),
          (s = Sa(t, e)),
          s != null && i.push($a(t, s, o))),
        t.tag === 3)
      )
        return i;
      t = t.return;
    }
    return [];
  }
  function e1(t) {
    if (t === null) return null;
    do t = t.return;
    while (t && t.tag !== 5 && t.tag !== 27);
    return t || null;
  }
  function bm(t, e, n, i, s) {
    for (var o = e._reactName, f = []; n !== null && n !== i; ) {
      var m = n,
        T = m.alternate,
        D = m.stateNode;
      if (((m = m.tag), T !== null && T === i)) break;
      ((m !== 5 && m !== 26 && m !== 27) ||
        D === null ||
        ((T = D),
        s
          ? ((D = Sa(n, o)), D != null && f.unshift($a(n, D, T)))
          : s || ((D = Sa(n, o)), D != null && f.push($a(n, D, T)))),
        (n = n.return));
    }
    f.length !== 0 && t.push({ event: e, listeners: f });
  }
  var n1 = /\r\n?/g,
    i1 = /\u0000|\uFFFD/g;
  function Am(t) {
    return (typeof t == "string" ? t : "" + t)
      .replace(
        n1,
        `
`,
      )
      .replace(i1, "");
  }
  function Em(t, e) {
    return ((e = Am(e)), Am(t) === e);
  }
  function At(t, e, n, i, s, o) {
    switch (n) {
      case "children":
        typeof i == "string"
          ? e === "body" || (e === "textarea" && i === "") || Di(t, i)
          : (typeof i == "number" || typeof i == "bigint") &&
            e !== "body" &&
            Di(t, "" + i);
        break;
      case "className":
        _l(t, "class", i);
        break;
      case "tabIndex":
        _l(t, "tabindex", i);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        _l(t, n, i);
        break;
      case "style":
        Ef(t, i, o);
        break;
      case "data":
        if (e !== "object") {
          _l(t, "data", i);
          break;
        }
      case "src":
      case "href":
        if (i === "" && (e !== "a" || n !== "href")) {
          t.removeAttribute(n);
          break;
        }
        if (
          i == null ||
          typeof i == "function" ||
          typeof i == "symbol" ||
          typeof i == "boolean"
        ) {
          t.removeAttribute(n);
          break;
        }
        ((i = Bl("" + i)), t.setAttribute(n, i));
        break;
      case "action":
      case "formAction":
        if (typeof i == "function") {
          t.setAttribute(
            n,
            "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')",
          );
          break;
        } else
          typeof o == "function" &&
            (n === "formAction"
              ? (e !== "input" && At(t, e, "name", s.name, s, null),
                At(t, e, "formEncType", s.formEncType, s, null),
                At(t, e, "formMethod", s.formMethod, s, null),
                At(t, e, "formTarget", s.formTarget, s, null))
              : (At(t, e, "encType", s.encType, s, null),
                At(t, e, "method", s.method, s, null),
                At(t, e, "target", s.target, s, null)));
        if (i == null || typeof i == "symbol" || typeof i == "boolean") {
          t.removeAttribute(n);
          break;
        }
        ((i = Bl("" + i)), t.setAttribute(n, i));
        break;
      case "onClick":
        i != null && (t.onclick = Ie);
        break;
      case "onScroll":
        i != null && rt("scroll", t);
        break;
      case "onScrollEnd":
        i != null && rt("scrollend", t);
        break;
      case "dangerouslySetInnerHTML":
        if (i != null) {
          if (typeof i != "object" || !("__html" in i)) throw Error(r(61));
          if (((n = i.__html), n != null)) {
            if (s.children != null) throw Error(r(60));
            t.innerHTML = n;
          }
        }
        break;
      case "multiple":
        t.multiple = i && typeof i != "function" && typeof i != "symbol";
        break;
      case "muted":
        t.muted = i && typeof i != "function" && typeof i != "symbol";
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "ref":
        break;
      case "autoFocus":
        break;
      case "xlinkHref":
        if (
          i == null ||
          typeof i == "function" ||
          typeof i == "boolean" ||
          typeof i == "symbol"
        ) {
          t.removeAttribute("xlink:href");
          break;
        }
        ((n = Bl("" + i)),
          t.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", n));
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        i != null && typeof i != "function" && typeof i != "symbol"
          ? t.setAttribute(n, "" + i)
          : t.removeAttribute(n);
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        i && typeof i != "function" && typeof i != "symbol"
          ? t.setAttribute(n, "")
          : t.removeAttribute(n);
        break;
      case "capture":
      case "download":
        i === !0
          ? t.setAttribute(n, "")
          : i !== !1 &&
              i != null &&
              typeof i != "function" &&
              typeof i != "symbol"
            ? t.setAttribute(n, i)
            : t.removeAttribute(n);
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        i != null &&
        typeof i != "function" &&
        typeof i != "symbol" &&
        !isNaN(i) &&
        1 <= i
          ? t.setAttribute(n, i)
          : t.removeAttribute(n);
        break;
      case "rowSpan":
      case "start":
        i == null || typeof i == "function" || typeof i == "symbol" || isNaN(i)
          ? t.removeAttribute(n)
          : t.setAttribute(n, i);
        break;
      case "popover":
        (rt("beforetoggle", t), rt("toggle", t), Vl(t, "popover", i));
        break;
      case "xlinkActuate":
        $e(t, "http://www.w3.org/1999/xlink", "xlink:actuate", i);
        break;
      case "xlinkArcrole":
        $e(t, "http://www.w3.org/1999/xlink", "xlink:arcrole", i);
        break;
      case "xlinkRole":
        $e(t, "http://www.w3.org/1999/xlink", "xlink:role", i);
        break;
      case "xlinkShow":
        $e(t, "http://www.w3.org/1999/xlink", "xlink:show", i);
        break;
      case "xlinkTitle":
        $e(t, "http://www.w3.org/1999/xlink", "xlink:title", i);
        break;
      case "xlinkType":
        $e(t, "http://www.w3.org/1999/xlink", "xlink:type", i);
        break;
      case "xmlBase":
        $e(t, "http://www.w3.org/XML/1998/namespace", "xml:base", i);
        break;
      case "xmlLang":
        $e(t, "http://www.w3.org/XML/1998/namespace", "xml:lang", i);
        break;
      case "xmlSpace":
        $e(t, "http://www.w3.org/XML/1998/namespace", "xml:space", i);
        break;
      case "is":
        Vl(t, "is", i);
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        (!(2 < n.length) ||
          (n[0] !== "o" && n[0] !== "O") ||
          (n[1] !== "n" && n[1] !== "N")) &&
          ((n = V0.get(n) || n), Vl(t, n, i));
    }
  }
  function fr(t, e, n, i, s, o) {
    switch (n) {
      case "style":
        Ef(t, i, o);
        break;
      case "dangerouslySetInnerHTML":
        if (i != null) {
          if (typeof i != "object" || !("__html" in i)) throw Error(r(61));
          if (((n = i.__html), n != null)) {
            if (s.children != null) throw Error(r(60));
            t.innerHTML = n;
          }
        }
        break;
      case "children":
        typeof i == "string"
          ? Di(t, i)
          : (typeof i == "number" || typeof i == "bigint") && Di(t, "" + i);
        break;
      case "onScroll":
        i != null && rt("scroll", t);
        break;
      case "onScrollEnd":
        i != null && rt("scrollend", t);
        break;
      case "onClick":
        i != null && (t.onclick = Ie);
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "innerHTML":
      case "ref":
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!mf.hasOwnProperty(n))
          t: {
            if (
              n[0] === "o" &&
              n[1] === "n" &&
              ((s = n.endsWith("Capture")),
              (e = n.slice(2, s ? n.length - 7 : void 0)),
              (o = t[oe] || null),
              (o = o != null ? o[n] : null),
              typeof o == "function" && t.removeEventListener(e, o, s),
              typeof i == "function")
            ) {
              (typeof o != "function" &&
                o !== null &&
                (n in t
                  ? (t[n] = null)
                  : t.hasAttribute(n) && t.removeAttribute(n)),
                t.addEventListener(e, i, s));
              break t;
            }
            n in t
              ? (t[n] = i)
              : i === !0
                ? t.setAttribute(n, "")
                : Vl(t, n, i);
          }
    }
  }
  function It(t, e, n) {
    switch (e) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "img":
        (rt("error", t), rt("load", t));
        var i = !1,
          s = !1,
          o;
        for (o in n)
          if (n.hasOwnProperty(o)) {
            var f = n[o];
            if (f != null)
              switch (o) {
                case "src":
                  i = !0;
                  break;
                case "srcSet":
                  s = !0;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(r(137, e));
                default:
                  At(t, e, o, f, n, null);
              }
          }
        (s && At(t, e, "srcSet", n.srcSet, n, null),
          i && At(t, e, "src", n.src, n, null));
        return;
      case "input":
        rt("invalid", t);
        var m = (o = f = s = null),
          T = null,
          D = null;
        for (i in n)
          if (n.hasOwnProperty(i)) {
            var R = n[i];
            if (R != null)
              switch (i) {
                case "name":
                  s = R;
                  break;
                case "type":
                  f = R;
                  break;
                case "checked":
                  T = R;
                  break;
                case "defaultChecked":
                  D = R;
                  break;
                case "value":
                  o = R;
                  break;
                case "defaultValue":
                  m = R;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (R != null) throw Error(r(137, e));
                  break;
                default:
                  At(t, e, i, R, n, null);
              }
          }
        Sf(t, o, m, T, D, f, s, !1);
        return;
      case "select":
        (rt("invalid", t), (i = f = o = null));
        for (s in n)
          if (n.hasOwnProperty(s) && ((m = n[s]), m != null))
            switch (s) {
              case "value":
                o = m;
                break;
              case "defaultValue":
                f = m;
                break;
              case "multiple":
                i = m;
              default:
                At(t, e, s, m, n, null);
            }
        ((e = o),
          (n = f),
          (t.multiple = !!i),
          e != null ? xi(t, !!i, e, !1) : n != null && xi(t, !!i, n, !0));
        return;
      case "textarea":
        (rt("invalid", t), (o = s = i = null));
        for (f in n)
          if (n.hasOwnProperty(f) && ((m = n[f]), m != null))
            switch (f) {
              case "value":
                i = m;
                break;
              case "defaultValue":
                s = m;
                break;
              case "children":
                o = m;
                break;
              case "dangerouslySetInnerHTML":
                if (m != null) throw Error(r(91));
                break;
              default:
                At(t, e, f, m, n, null);
            }
        bf(t, i, s, o);
        return;
      case "option":
        for (T in n)
          n.hasOwnProperty(T) &&
            ((i = n[T]), i != null) &&
            (T === "selected"
              ? (t.selected =
                  i && typeof i != "function" && typeof i != "symbol")
              : At(t, e, T, i, n, null));
        return;
      case "dialog":
        (rt("beforetoggle", t),
          rt("toggle", t),
          rt("cancel", t),
          rt("close", t));
        break;
      case "iframe":
      case "object":
        rt("load", t);
        break;
      case "video":
      case "audio":
        for (i = 0; i < Pa.length; i++) rt(Pa[i], t);
        break;
      case "image":
        (rt("error", t), rt("load", t));
        break;
      case "details":
        rt("toggle", t);
        break;
      case "embed":
      case "source":
      case "link":
        (rt("error", t), rt("load", t));
      case "area":
      case "base":
      case "br":
      case "col":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "track":
      case "wbr":
      case "menuitem":
        for (D in n)
          if (n.hasOwnProperty(D) && ((i = n[D]), i != null))
            switch (D) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(r(137, e));
              default:
                At(t, e, D, i, n, null);
            }
        return;
      default:
        if (Mu(e)) {
          for (R in n)
            n.hasOwnProperty(R) &&
              ((i = n[R]), i !== void 0 && fr(t, e, R, i, n, void 0));
          return;
        }
    }
    for (m in n)
      n.hasOwnProperty(m) && ((i = n[m]), i != null && At(t, e, m, i, n, null));
  }
  function a1(t, e, n, i) {
    switch (e) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "input":
        var s = null,
          o = null,
          f = null,
          m = null,
          T = null,
          D = null,
          R = null;
        for (O in n) {
          var B = n[O];
          if (n.hasOwnProperty(O) && B != null)
            switch (O) {
              case "checked":
                break;
              case "value":
                break;
              case "defaultValue":
                T = B;
              default:
                i.hasOwnProperty(O) || At(t, e, O, null, i, B);
            }
        }
        for (var C in i) {
          var O = i[C];
          if (((B = n[C]), i.hasOwnProperty(C) && (O != null || B != null)))
            switch (C) {
              case "type":
                o = O;
                break;
              case "name":
                s = O;
                break;
              case "checked":
                D = O;
                break;
              case "defaultChecked":
                R = O;
                break;
              case "value":
                f = O;
                break;
              case "defaultValue":
                m = O;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                if (O != null) throw Error(r(137, e));
                break;
              default:
                O !== B && At(t, e, C, O, i, B);
            }
        }
        Au(t, f, m, T, D, R, o, s);
        return;
      case "select":
        O = f = m = C = null;
        for (o in n)
          if (((T = n[o]), n.hasOwnProperty(o) && T != null))
            switch (o) {
              case "value":
                break;
              case "multiple":
                O = T;
              default:
                i.hasOwnProperty(o) || At(t, e, o, null, i, T);
            }
        for (s in i)
          if (
            ((o = i[s]),
            (T = n[s]),
            i.hasOwnProperty(s) && (o != null || T != null))
          )
            switch (s) {
              case "value":
                C = o;
                break;
              case "defaultValue":
                m = o;
                break;
              case "multiple":
                f = o;
              default:
                o !== T && At(t, e, s, o, i, T);
            }
        ((e = m),
          (n = f),
          (i = O),
          C != null
            ? xi(t, !!n, C, !1)
            : !!i != !!n &&
              (e != null ? xi(t, !!n, e, !0) : xi(t, !!n, n ? [] : "", !1)));
        return;
      case "textarea":
        O = C = null;
        for (m in n)
          if (
            ((s = n[m]),
            n.hasOwnProperty(m) && s != null && !i.hasOwnProperty(m))
          )
            switch (m) {
              case "value":
                break;
              case "children":
                break;
              default:
                At(t, e, m, null, i, s);
            }
        for (f in i)
          if (
            ((s = i[f]),
            (o = n[f]),
            i.hasOwnProperty(f) && (s != null || o != null))
          )
            switch (f) {
              case "value":
                C = s;
                break;
              case "defaultValue":
                O = s;
                break;
              case "children":
                break;
              case "dangerouslySetInnerHTML":
                if (s != null) throw Error(r(91));
                break;
              default:
                s !== o && At(t, e, f, s, i, o);
            }
        Tf(t, C, O);
        return;
      case "option":
        for (var Q in n)
          ((C = n[Q]),
            n.hasOwnProperty(Q) &&
              C != null &&
              !i.hasOwnProperty(Q) &&
              (Q === "selected" ? (t.selected = !1) : At(t, e, Q, null, i, C)));
        for (T in i)
          ((C = i[T]),
            (O = n[T]),
            i.hasOwnProperty(T) &&
              C !== O &&
              (C != null || O != null) &&
              (T === "selected"
                ? (t.selected =
                    C && typeof C != "function" && typeof C != "symbol")
                : At(t, e, T, C, i, O)));
        return;
      case "img":
      case "link":
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
      case "menuitem":
        for (var tt in n)
          ((C = n[tt]),
            n.hasOwnProperty(tt) &&
              C != null &&
              !i.hasOwnProperty(tt) &&
              At(t, e, tt, null, i, C));
        for (D in i)
          if (
            ((C = i[D]),
            (O = n[D]),
            i.hasOwnProperty(D) && C !== O && (C != null || O != null))
          )
            switch (D) {
              case "children":
              case "dangerouslySetInnerHTML":
                if (C != null) throw Error(r(137, e));
                break;
              default:
                At(t, e, D, C, i, O);
            }
        return;
      default:
        if (Mu(e)) {
          for (var Et in n)
            ((C = n[Et]),
              n.hasOwnProperty(Et) &&
                C !== void 0 &&
                !i.hasOwnProperty(Et) &&
                fr(t, e, Et, void 0, i, C));
          for (R in i)
            ((C = i[R]),
              (O = n[R]),
              !i.hasOwnProperty(R) ||
                C === O ||
                (C === void 0 && O === void 0) ||
                fr(t, e, R, C, i, O));
          return;
        }
    }
    for (var M in n)
      ((C = n[M]),
        n.hasOwnProperty(M) &&
          C != null &&
          !i.hasOwnProperty(M) &&
          At(t, e, M, null, i, C));
    for (B in i)
      ((C = i[B]),
        (O = n[B]),
        !i.hasOwnProperty(B) ||
          C === O ||
          (C == null && O == null) ||
          At(t, e, B, C, i, O));
  }
  function Mm(t) {
    switch (t) {
      case "css":
      case "script":
      case "font":
      case "img":
      case "image":
      case "input":
      case "link":
        return !0;
      default:
        return !1;
    }
  }
  function l1() {
    if (typeof performance.getEntriesByType == "function") {
      for (
        var t = 0, e = 0, n = performance.getEntriesByType("resource"), i = 0;
        i < n.length;
        i++
      ) {
        var s = n[i],
          o = s.transferSize,
          f = s.initiatorType,
          m = s.duration;
        if (o && m && Mm(f)) {
          for (f = 0, m = s.responseEnd, i += 1; i < n.length; i++) {
            var T = n[i],
              D = T.startTime;
            if (D > m) break;
            var R = T.transferSize,
              B = T.initiatorType;
            R &&
              Mm(B) &&
              ((T = T.responseEnd), (f += R * (T < m ? 1 : (m - D) / (T - D))));
          }
          if ((--i, (e += (8 * (o + f)) / (s.duration / 1e3)), t++, 10 < t))
            break;
        }
      }
      if (0 < t) return e / t / 1e6;
    }
    return navigator.connection &&
      ((t = navigator.connection.downlink), typeof t == "number")
      ? t
      : 5;
  }
  var hr = null,
    dr = null;
  function Os(t) {
    return t.nodeType === 9 ? t : t.ownerDocument;
  }
  function xm(t) {
    switch (t) {
      case "http://www.w3.org/2000/svg":
        return 1;
      case "http://www.w3.org/1998/Math/MathML":
        return 2;
      default:
        return 0;
    }
  }
  function Dm(t, e) {
    if (t === 0)
      switch (e) {
        case "svg":
          return 1;
        case "math":
          return 2;
        default:
          return 0;
      }
    return t === 1 && e === "foreignObject" ? 0 : t;
  }
  function mr(t, e) {
    return (
      t === "textarea" ||
      t === "noscript" ||
      typeof e.children == "string" ||
      typeof e.children == "number" ||
      typeof e.children == "bigint" ||
      (typeof e.dangerouslySetInnerHTML == "object" &&
        e.dangerouslySetInnerHTML !== null &&
        e.dangerouslySetInnerHTML.__html != null)
    );
  }
  var yr = null;
  function s1() {
    var t = window.event;
    return t && t.type === "popstate"
      ? t === yr
        ? !1
        : ((yr = t), !0)
      : ((yr = null), !1);
  }
  var Cm = typeof setTimeout == "function" ? setTimeout : void 0,
    u1 = typeof clearTimeout == "function" ? clearTimeout : void 0,
    zm = typeof Promise == "function" ? Promise : void 0,
    o1 =
      typeof queueMicrotask == "function"
        ? queueMicrotask
        : typeof zm < "u"
          ? function (t) {
              return zm.resolve(null).then(t).catch(r1);
            }
          : Cm;
  function r1(t) {
    setTimeout(function () {
      throw t;
    });
  }
  function Hn(t) {
    return t === "head";
  }
  function Om(t, e) {
    var n = e,
      i = 0;
    do {
      var s = n.nextSibling;
      if ((t.removeChild(n), s && s.nodeType === 8))
        if (((n = s.data), n === "/$" || n === "/&")) {
          if (i === 0) {
            (t.removeChild(s), ia(e));
            return;
          }
          i--;
        } else if (
          n === "$" ||
          n === "$?" ||
          n === "$~" ||
          n === "$!" ||
          n === "&"
        )
          i++;
        else if (n === "html") Ia(t.ownerDocument.documentElement);
        else if (n === "head") {
          ((n = t.ownerDocument.head), Ia(n));
          for (var o = n.firstChild; o; ) {
            var f = o.nextSibling,
              m = o.nodeName;
            (o[ga] ||
              m === "SCRIPT" ||
              m === "STYLE" ||
              (m === "LINK" && o.rel.toLowerCase() === "stylesheet") ||
              n.removeChild(o),
              (o = f));
          }
        } else n === "body" && Ia(t.ownerDocument.body);
      n = s;
    } while (n);
    ia(e);
  }
  function Rm(t, e) {
    var n = t;
    t = 0;
    do {
      var i = n.nextSibling;
      if (
        (n.nodeType === 1
          ? e
            ? ((n._stashedDisplay = n.style.display),
              (n.style.display = "none"))
            : ((n.style.display = n._stashedDisplay || ""),
              n.getAttribute("style") === "" && n.removeAttribute("style"))
          : n.nodeType === 3 &&
            (e
              ? ((n._stashedText = n.nodeValue), (n.nodeValue = ""))
              : (n.nodeValue = n._stashedText || "")),
        i && i.nodeType === 8)
      )
        if (((n = i.data), n === "/$")) {
          if (t === 0) break;
          t--;
        } else (n !== "$" && n !== "$?" && n !== "$~" && n !== "$!") || t++;
      n = i;
    } while (n);
  }
  function pr(t) {
    var e = t.firstChild;
    for (e && e.nodeType === 10 && (e = e.nextSibling); e; ) {
      var n = e;
      switch (((e = e.nextSibling), n.nodeName)) {
        case "HTML":
        case "HEAD":
        case "BODY":
          (pr(n), Tu(n));
          continue;
        case "SCRIPT":
        case "STYLE":
          continue;
        case "LINK":
          if (n.rel.toLowerCase() === "stylesheet") continue;
      }
      t.removeChild(n);
    }
  }
  function c1(t, e, n, i) {
    for (; t.nodeType === 1; ) {
      var s = n;
      if (t.nodeName.toLowerCase() !== e.toLowerCase()) {
        if (!i && (t.nodeName !== "INPUT" || t.type !== "hidden")) break;
      } else if (i) {
        if (!t[ga])
          switch (e) {
            case "meta":
              if (!t.hasAttribute("itemprop")) break;
              return t;
            case "link":
              if (
                ((o = t.getAttribute("rel")),
                o === "stylesheet" && t.hasAttribute("data-precedence"))
              )
                break;
              if (
                o !== s.rel ||
                t.getAttribute("href") !==
                  (s.href == null || s.href === "" ? null : s.href) ||
                t.getAttribute("crossorigin") !==
                  (s.crossOrigin == null ? null : s.crossOrigin) ||
                t.getAttribute("title") !== (s.title == null ? null : s.title)
              )
                break;
              return t;
            case "style":
              if (t.hasAttribute("data-precedence")) break;
              return t;
            case "script":
              if (
                ((o = t.getAttribute("src")),
                (o !== (s.src == null ? null : s.src) ||
                  t.getAttribute("type") !== (s.type == null ? null : s.type) ||
                  t.getAttribute("crossorigin") !==
                    (s.crossOrigin == null ? null : s.crossOrigin)) &&
                  o &&
                  t.hasAttribute("async") &&
                  !t.hasAttribute("itemprop"))
              )
                break;
              return t;
            default:
              return t;
          }
      } else if (e === "input" && t.type === "hidden") {
        var o = s.name == null ? null : "" + s.name;
        if (s.type === "hidden" && t.getAttribute("name") === o) return t;
      } else return t;
      if (((t = Ne(t.nextSibling)), t === null)) break;
    }
    return null;
  }
  function f1(t, e, n) {
    if (e === "") return null;
    for (; t.nodeType !== 3; )
      if (
        ((t.nodeType !== 1 || t.nodeName !== "INPUT" || t.type !== "hidden") &&
          !n) ||
        ((t = Ne(t.nextSibling)), t === null)
      )
        return null;
    return t;
  }
  function Vm(t, e) {
    for (; t.nodeType !== 8; )
      if (
        ((t.nodeType !== 1 || t.nodeName !== "INPUT" || t.type !== "hidden") &&
          !e) ||
        ((t = Ne(t.nextSibling)), t === null)
      )
        return null;
    return t;
  }
  function gr(t) {
    return t.data === "$?" || t.data === "$~";
  }
  function vr(t) {
    return (
      t.data === "$!" ||
      (t.data === "$?" && t.ownerDocument.readyState !== "loading")
    );
  }
  function h1(t, e) {
    var n = t.ownerDocument;
    if (t.data === "$~") t._reactRetry = e;
    else if (t.data !== "$?" || n.readyState !== "loading") e();
    else {
      var i = function () {
        (e(), n.removeEventListener("DOMContentLoaded", i));
      };
      (n.addEventListener("DOMContentLoaded", i), (t._reactRetry = i));
    }
  }
  function Ne(t) {
    for (; t != null; t = t.nextSibling) {
      var e = t.nodeType;
      if (e === 1 || e === 3) break;
      if (e === 8) {
        if (
          ((e = t.data),
          e === "$" ||
            e === "$!" ||
            e === "$?" ||
            e === "$~" ||
            e === "&" ||
            e === "F!" ||
            e === "F")
        )
          break;
        if (e === "/$" || e === "/&") return null;
      }
    }
    return t;
  }
  var Sr = null;
  function _m(t) {
    t = t.nextSibling;
    for (var e = 0; t; ) {
      if (t.nodeType === 8) {
        var n = t.data;
        if (n === "/$" || n === "/&") {
          if (e === 0) return Ne(t.nextSibling);
          e--;
        } else
          (n !== "$" && n !== "$!" && n !== "$?" && n !== "$~" && n !== "&") ||
            e++;
      }
      t = t.nextSibling;
    }
    return null;
  }
  function Um(t) {
    t = t.previousSibling;
    for (var e = 0; t; ) {
      if (t.nodeType === 8) {
        var n = t.data;
        if (n === "$" || n === "$!" || n === "$?" || n === "$~" || n === "&") {
          if (e === 0) return t;
          e--;
        } else (n !== "/$" && n !== "/&") || e++;
      }
      t = t.previousSibling;
    }
    return null;
  }
  function Bm(t, e, n) {
    switch (((e = Os(n)), t)) {
      case "html":
        if (((t = e.documentElement), !t)) throw Error(r(452));
        return t;
      case "head":
        if (((t = e.head), !t)) throw Error(r(453));
        return t;
      case "body":
        if (((t = e.body), !t)) throw Error(r(454));
        return t;
      default:
        throw Error(r(451));
    }
  }
  function Ia(t) {
    for (var e = t.attributes; e.length; ) t.removeAttributeNode(e[0]);
    Tu(t);
  }
  var je = new Map(),
    Nm = new Set();
  function Rs(t) {
    return typeof t.getRootNode == "function"
      ? t.getRootNode()
      : t.nodeType === 9
        ? t
        : t.ownerDocument;
  }
  var pn = w.d;
  w.d = { f: d1, r: m1, D: y1, C: p1, L: g1, m: v1, X: T1, S: S1, M: b1 };
  function d1() {
    var t = pn.f(),
      e = bs();
    return t || e;
  }
  function m1(t) {
    var e = Ai(t);
    e !== null && e.tag === 5 && e.type === "form" ? $h(e) : pn.r(t);
  }
  var ta = typeof document > "u" ? null : document;
  function jm(t, e, n) {
    var i = ta;
    if (i && typeof e == "string" && e) {
      var s = ze(e);
      ((s = 'link[rel="' + t + '"][href="' + s + '"]'),
        typeof n == "string" && (s += '[crossorigin="' + n + '"]'),
        Nm.has(s) ||
          (Nm.add(s),
          (t = { rel: t, crossOrigin: n, href: e }),
          i.querySelector(s) === null &&
            ((e = i.createElement("link")),
            It(e, "link", t),
            Jt(e),
            i.head.appendChild(e))));
    }
  }
  function y1(t) {
    (pn.D(t), jm("dns-prefetch", t, null));
  }
  function p1(t, e) {
    (pn.C(t, e), jm("preconnect", t, e));
  }
  function g1(t, e, n) {
    pn.L(t, e, n);
    var i = ta;
    if (i && t && e) {
      var s = 'link[rel="preload"][as="' + ze(e) + '"]';
      e === "image" && n && n.imageSrcSet
        ? ((s += '[imagesrcset="' + ze(n.imageSrcSet) + '"]'),
          typeof n.imageSizes == "string" &&
            (s += '[imagesizes="' + ze(n.imageSizes) + '"]'))
        : (s += '[href="' + ze(t) + '"]');
      var o = s;
      switch (e) {
        case "style":
          o = ea(t);
          break;
        case "script":
          o = na(t);
      }
      je.has(o) ||
        ((t = S(
          {
            rel: "preload",
            href: e === "image" && n && n.imageSrcSet ? void 0 : t,
            as: e,
          },
          n,
        )),
        je.set(o, t),
        i.querySelector(s) !== null ||
          (e === "style" && i.querySelector(tl(o))) ||
          (e === "script" && i.querySelector(el(o))) ||
          ((e = i.createElement("link")),
          It(e, "link", t),
          Jt(e),
          i.head.appendChild(e)));
    }
  }
  function v1(t, e) {
    pn.m(t, e);
    var n = ta;
    if (n && t) {
      var i = e && typeof e.as == "string" ? e.as : "script",
        s =
          'link[rel="modulepreload"][as="' + ze(i) + '"][href="' + ze(t) + '"]',
        o = s;
      switch (i) {
        case "audioworklet":
        case "paintworklet":
        case "serviceworker":
        case "sharedworker":
        case "worker":
        case "script":
          o = na(t);
      }
      if (
        !je.has(o) &&
        ((t = S({ rel: "modulepreload", href: t }, e)),
        je.set(o, t),
        n.querySelector(s) === null)
      ) {
        switch (i) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            if (n.querySelector(el(o))) return;
        }
        ((i = n.createElement("link")),
          It(i, "link", t),
          Jt(i),
          n.head.appendChild(i));
      }
    }
  }
  function S1(t, e, n) {
    pn.S(t, e, n);
    var i = ta;
    if (i && t) {
      var s = Ei(i).hoistableStyles,
        o = ea(t);
      e = e || "default";
      var f = s.get(o);
      if (!f) {
        var m = { loading: 0, preload: null };
        if ((f = i.querySelector(tl(o)))) m.loading = 5;
        else {
          ((t = S({ rel: "stylesheet", href: t, "data-precedence": e }, n)),
            (n = je.get(o)) && Tr(t, n));
          var T = (f = i.createElement("link"));
          (Jt(T),
            It(T, "link", t),
            (T._p = new Promise(function (D, R) {
              ((T.onload = D), (T.onerror = R));
            })),
            T.addEventListener("load", function () {
              m.loading |= 1;
            }),
            T.addEventListener("error", function () {
              m.loading |= 2;
            }),
            (m.loading |= 4),
            Vs(f, e, i));
        }
        ((f = { type: "stylesheet", instance: f, count: 1, state: m }),
          s.set(o, f));
      }
    }
  }
  function T1(t, e) {
    pn.X(t, e);
    var n = ta;
    if (n && t) {
      var i = Ei(n).hoistableScripts,
        s = na(t),
        o = i.get(s);
      o ||
        ((o = n.querySelector(el(s))),
        o ||
          ((t = S({ src: t, async: !0 }, e)),
          (e = je.get(s)) && br(t, e),
          (o = n.createElement("script")),
          Jt(o),
          It(o, "link", t),
          n.head.appendChild(o)),
        (o = { type: "script", instance: o, count: 1, state: null }),
        i.set(s, o));
    }
  }
  function b1(t, e) {
    pn.M(t, e);
    var n = ta;
    if (n && t) {
      var i = Ei(n).hoistableScripts,
        s = na(t),
        o = i.get(s);
      o ||
        ((o = n.querySelector(el(s))),
        o ||
          ((t = S({ src: t, async: !0, type: "module" }, e)),
          (e = je.get(s)) && br(t, e),
          (o = n.createElement("script")),
          Jt(o),
          It(o, "link", t),
          n.head.appendChild(o)),
        (o = { type: "script", instance: o, count: 1, state: null }),
        i.set(s, o));
    }
  }
  function Lm(t, e, n, i) {
    var s = (s = ut.current) ? Rs(s) : null;
    if (!s) throw Error(r(446));
    switch (t) {
      case "meta":
      case "title":
        return null;
      case "style":
        return typeof n.precedence == "string" && typeof n.href == "string"
          ? ((e = ea(n.href)),
            (n = Ei(s).hoistableStyles),
            (i = n.get(e)),
            i ||
              ((i = { type: "style", instance: null, count: 0, state: null }),
              n.set(e, i)),
            i)
          : { type: "void", instance: null, count: 0, state: null };
      case "link":
        if (
          n.rel === "stylesheet" &&
          typeof n.href == "string" &&
          typeof n.precedence == "string"
        ) {
          t = ea(n.href);
          var o = Ei(s).hoistableStyles,
            f = o.get(t);
          if (
            (f ||
              ((s = s.ownerDocument || s),
              (f = {
                type: "stylesheet",
                instance: null,
                count: 0,
                state: { loading: 0, preload: null },
              }),
              o.set(t, f),
              (o = s.querySelector(tl(t))) &&
                !o._p &&
                ((f.instance = o), (f.state.loading = 5)),
              je.has(t) ||
                ((n = {
                  rel: "preload",
                  as: "style",
                  href: n.href,
                  crossOrigin: n.crossOrigin,
                  integrity: n.integrity,
                  media: n.media,
                  hrefLang: n.hrefLang,
                  referrerPolicy: n.referrerPolicy,
                }),
                je.set(t, n),
                o || A1(s, t, n, f.state))),
            e && i === null)
          )
            throw Error(r(528, ""));
          return f;
        }
        if (e && i !== null) throw Error(r(529, ""));
        return null;
      case "script":
        return (
          (e = n.async),
          (n = n.src),
          typeof n == "string" &&
          e &&
          typeof e != "function" &&
          typeof e != "symbol"
            ? ((e = na(n)),
              (n = Ei(s).hoistableScripts),
              (i = n.get(e)),
              i ||
                ((i = {
                  type: "script",
                  instance: null,
                  count: 0,
                  state: null,
                }),
                n.set(e, i)),
              i)
            : { type: "void", instance: null, count: 0, state: null }
        );
      default:
        throw Error(r(444, t));
    }
  }
  function ea(t) {
    return 'href="' + ze(t) + '"';
  }
  function tl(t) {
    return 'link[rel="stylesheet"][' + t + "]";
  }
  function Hm(t) {
    return S({}, t, { "data-precedence": t.precedence, precedence: null });
  }
  function A1(t, e, n, i) {
    t.querySelector('link[rel="preload"][as="style"][' + e + "]")
      ? (i.loading = 1)
      : ((e = t.createElement("link")),
        (i.preload = e),
        e.addEventListener("load", function () {
          return (i.loading |= 1);
        }),
        e.addEventListener("error", function () {
          return (i.loading |= 2);
        }),
        It(e, "link", n),
        Jt(e),
        t.head.appendChild(e));
  }
  function na(t) {
    return '[src="' + ze(t) + '"]';
  }
  function el(t) {
    return "script[async]" + t;
  }
  function wm(t, e, n) {
    if ((e.count++, e.instance === null))
      switch (e.type) {
        case "style":
          var i = t.querySelector('style[data-href~="' + ze(n.href) + '"]');
          if (i) return ((e.instance = i), Jt(i), i);
          var s = S({}, n, {
            "data-href": n.href,
            "data-precedence": n.precedence,
            href: null,
            precedence: null,
          });
          return (
            (i = (t.ownerDocument || t).createElement("style")),
            Jt(i),
            It(i, "style", s),
            Vs(i, n.precedence, t),
            (e.instance = i)
          );
        case "stylesheet":
          s = ea(n.href);
          var o = t.querySelector(tl(s));
          if (o) return ((e.state.loading |= 4), (e.instance = o), Jt(o), o);
          ((i = Hm(n)),
            (s = je.get(s)) && Tr(i, s),
            (o = (t.ownerDocument || t).createElement("link")),
            Jt(o));
          var f = o;
          return (
            (f._p = new Promise(function (m, T) {
              ((f.onload = m), (f.onerror = T));
            })),
            It(o, "link", i),
            (e.state.loading |= 4),
            Vs(o, n.precedence, t),
            (e.instance = o)
          );
        case "script":
          return (
            (o = na(n.src)),
            (s = t.querySelector(el(o)))
              ? ((e.instance = s), Jt(s), s)
              : ((i = n),
                (s = je.get(o)) && ((i = S({}, n)), br(i, s)),
                (t = t.ownerDocument || t),
                (s = t.createElement("script")),
                Jt(s),
                It(s, "link", i),
                t.head.appendChild(s),
                (e.instance = s))
          );
        case "void":
          return null;
        default:
          throw Error(r(443, e.type));
      }
    else
      e.type === "stylesheet" &&
        (e.state.loading & 4) === 0 &&
        ((i = e.instance), (e.state.loading |= 4), Vs(i, n.precedence, t));
    return e.instance;
  }
  function Vs(t, e, n) {
    for (
      var i = n.querySelectorAll(
          'link[rel="stylesheet"][data-precedence],style[data-precedence]',
        ),
        s = i.length ? i[i.length - 1] : null,
        o = s,
        f = 0;
      f < i.length;
      f++
    ) {
      var m = i[f];
      if (m.dataset.precedence === e) o = m;
      else if (o !== s) break;
    }
    o
      ? o.parentNode.insertBefore(t, o.nextSibling)
      : ((e = n.nodeType === 9 ? n.head : n), e.insertBefore(t, e.firstChild));
  }
  function Tr(t, e) {
    (t.crossOrigin == null && (t.crossOrigin = e.crossOrigin),
      t.referrerPolicy == null && (t.referrerPolicy = e.referrerPolicy),
      t.title == null && (t.title = e.title));
  }
  function br(t, e) {
    (t.crossOrigin == null && (t.crossOrigin = e.crossOrigin),
      t.referrerPolicy == null && (t.referrerPolicy = e.referrerPolicy),
      t.integrity == null && (t.integrity = e.integrity));
  }
  var _s = null;
  function Ym(t, e, n) {
    if (_s === null) {
      var i = new Map(),
        s = (_s = new Map());
      s.set(n, i);
    } else ((s = _s), (i = s.get(n)), i || ((i = new Map()), s.set(n, i)));
    if (i.has(t)) return i;
    for (
      i.set(t, null), n = n.getElementsByTagName(t), s = 0;
      s < n.length;
      s++
    ) {
      var o = n[s];
      if (
        !(
          o[ga] ||
          o[kt] ||
          (t === "link" && o.getAttribute("rel") === "stylesheet")
        ) &&
        o.namespaceURI !== "http://www.w3.org/2000/svg"
      ) {
        var f = o.getAttribute(e) || "";
        f = t + f;
        var m = i.get(f);
        m ? m.push(o) : i.set(f, [o]);
      }
    }
    return i;
  }
  function qm(t, e, n) {
    ((t = t.ownerDocument || t),
      t.head.insertBefore(
        n,
        e === "title" ? t.querySelector("head > title") : null,
      ));
  }
  function E1(t, e, n) {
    if (n === 1 || e.itemProp != null) return !1;
    switch (t) {
      case "meta":
      case "title":
        return !0;
      case "style":
        if (
          typeof e.precedence != "string" ||
          typeof e.href != "string" ||
          e.href === ""
        )
          break;
        return !0;
      case "link":
        if (
          typeof e.rel != "string" ||
          typeof e.href != "string" ||
          e.href === "" ||
          e.onLoad ||
          e.onError
        )
          break;
        return e.rel === "stylesheet"
          ? ((t = e.disabled), typeof e.precedence == "string" && t == null)
          : !0;
      case "script":
        if (
          e.async &&
          typeof e.async != "function" &&
          typeof e.async != "symbol" &&
          !e.onLoad &&
          !e.onError &&
          e.src &&
          typeof e.src == "string"
        )
          return !0;
    }
    return !1;
  }
  function Gm(t) {
    return !(t.type === "stylesheet" && (t.state.loading & 3) === 0);
  }
  function M1(t, e, n, i) {
    if (
      n.type === "stylesheet" &&
      (typeof i.media != "string" || matchMedia(i.media).matches !== !1) &&
      (n.state.loading & 4) === 0
    ) {
      if (n.instance === null) {
        var s = ea(i.href),
          o = e.querySelector(tl(s));
        if (o) {
          ((e = o._p),
            e !== null &&
              typeof e == "object" &&
              typeof e.then == "function" &&
              (t.count++, (t = Us.bind(t)), e.then(t, t)),
            (n.state.loading |= 4),
            (n.instance = o),
            Jt(o));
          return;
        }
        ((o = e.ownerDocument || e),
          (i = Hm(i)),
          (s = je.get(s)) && Tr(i, s),
          (o = o.createElement("link")),
          Jt(o));
        var f = o;
        ((f._p = new Promise(function (m, T) {
          ((f.onload = m), (f.onerror = T));
        })),
          It(o, "link", i),
          (n.instance = o));
      }
      (t.stylesheets === null && (t.stylesheets = new Map()),
        t.stylesheets.set(n, e),
        (e = n.state.preload) &&
          (n.state.loading & 3) === 0 &&
          (t.count++,
          (n = Us.bind(t)),
          e.addEventListener("load", n),
          e.addEventListener("error", n)));
    }
  }
  var Ar = 0;
  function x1(t, e) {
    return (
      t.stylesheets && t.count === 0 && Ns(t, t.stylesheets),
      0 < t.count || 0 < t.imgCount
        ? function (n) {
            var i = setTimeout(function () {
              if ((t.stylesheets && Ns(t, t.stylesheets), t.unsuspend)) {
                var o = t.unsuspend;
                ((t.unsuspend = null), o());
              }
            }, 6e4 + e);
            0 < t.imgBytes && Ar === 0 && (Ar = 62500 * l1());
            var s = setTimeout(
              function () {
                if (
                  ((t.waitingForImages = !1),
                  t.count === 0 &&
                    (t.stylesheets && Ns(t, t.stylesheets), t.unsuspend))
                ) {
                  var o = t.unsuspend;
                  ((t.unsuspend = null), o());
                }
              },
              (t.imgBytes > Ar ? 50 : 800) + e,
            );
            return (
              (t.unsuspend = n),
              function () {
                ((t.unsuspend = null), clearTimeout(i), clearTimeout(s));
              }
            );
          }
        : null
    );
  }
  function Us() {
    if (
      (this.count--,
      this.count === 0 && (this.imgCount === 0 || !this.waitingForImages))
    ) {
      if (this.stylesheets) Ns(this, this.stylesheets);
      else if (this.unsuspend) {
        var t = this.unsuspend;
        ((this.unsuspend = null), t());
      }
    }
  }
  var Bs = null;
  function Ns(t, e) {
    ((t.stylesheets = null),
      t.unsuspend !== null &&
        (t.count++,
        (Bs = new Map()),
        e.forEach(D1, t),
        (Bs = null),
        Us.call(t)));
  }
  function D1(t, e) {
    if (!(e.state.loading & 4)) {
      var n = Bs.get(t);
      if (n) var i = n.get(null);
      else {
        ((n = new Map()), Bs.set(t, n));
        for (
          var s = t.querySelectorAll(
              "link[data-precedence],style[data-precedence]",
            ),
            o = 0;
          o < s.length;
          o++
        ) {
          var f = s[o];
          (f.nodeName === "LINK" || f.getAttribute("media") !== "not all") &&
            (n.set(f.dataset.precedence, f), (i = f));
        }
        i && n.set(null, i);
      }
      ((s = e.instance),
        (f = s.getAttribute("data-precedence")),
        (o = n.get(f) || i),
        o === i && n.set(null, s),
        n.set(f, s),
        this.count++,
        (i = Us.bind(this)),
        s.addEventListener("load", i),
        s.addEventListener("error", i),
        o
          ? o.parentNode.insertBefore(s, o.nextSibling)
          : ((t = t.nodeType === 9 ? t.head : t),
            t.insertBefore(s, t.firstChild)),
        (e.state.loading |= 4));
    }
  }
  var nl = {
    $$typeof: L,
    Provider: null,
    Consumer: null,
    _currentValue: F,
    _currentValue2: F,
    _threadCount: 0,
  };
  function C1(t, e, n, i, s, o, f, m, T) {
    ((this.tag = 1),
      (this.containerInfo = t),
      (this.pingCache = this.current = this.pendingChildren = null),
      (this.timeoutHandle = -1),
      (this.callbackNode =
        this.next =
        this.pendingContext =
        this.context =
        this.cancelPendingCommit =
          null),
      (this.callbackPriority = 0),
      (this.expirationTimes = pu(-1)),
      (this.entangledLanes =
        this.shellSuspendCounter =
        this.errorRecoveryDisabledLanes =
        this.expiredLanes =
        this.warmLanes =
        this.pingedLanes =
        this.suspendedLanes =
        this.pendingLanes =
          0),
      (this.entanglements = pu(0)),
      (this.hiddenUpdates = pu(null)),
      (this.identifierPrefix = i),
      (this.onUncaughtError = s),
      (this.onCaughtError = o),
      (this.onRecoverableError = f),
      (this.pooledCache = null),
      (this.pooledCacheLanes = 0),
      (this.formState = T),
      (this.incompleteTransitions = new Map()));
  }
  function Xm(t, e, n, i, s, o, f, m, T, D, R, B) {
    return (
      (t = new C1(t, e, n, f, T, D, R, B, m)),
      (e = 1),
      o === !0 && (e |= 24),
      (o = Se(3, null, null, e)),
      (t.current = o),
      (o.stateNode = t),
      (e = to()),
      e.refCount++,
      (t.pooledCache = e),
      e.refCount++,
      (o.memoizedState = { element: i, isDehydrated: n, cache: e }),
      ao(o),
      t
    );
  }
  function Qm(t) {
    return t ? ((t = Ui), t) : Ui;
  }
  function Zm(t, e, n, i, s, o) {
    ((s = Qm(s)),
      i.context === null ? (i.context = s) : (i.pendingContext = s),
      (i = Cn(e)),
      (i.payload = { element: n }),
      (o = o === void 0 ? null : o),
      o !== null && (i.callback = o),
      (n = zn(t, i, e)),
      n !== null && (me(n, t, e), Ba(n, t, e)));
  }
  function Km(t, e) {
    if (((t = t.memoizedState), t !== null && t.dehydrated !== null)) {
      var n = t.retryLane;
      t.retryLane = n !== 0 && n < e ? n : e;
    }
  }
  function Er(t, e) {
    (Km(t, e), (t = t.alternate) && Km(t, e));
  }
  function Jm(t) {
    if (t.tag === 13 || t.tag === 31) {
      var e = ei(t, 67108864);
      (e !== null && me(e, t, 67108864), Er(t, 67108864));
    }
  }
  function Fm(t) {
    if (t.tag === 13 || t.tag === 31) {
      var e = Me();
      e = gu(e);
      var n = ei(t, e);
      (n !== null && me(n, t, e), Er(t, e));
    }
  }
  var js = !0;
  function z1(t, e, n, i) {
    var s = V.T;
    V.T = null;
    var o = w.p;
    try {
      ((w.p = 2), Mr(t, e, n, i));
    } finally {
      ((w.p = o), (V.T = s));
    }
  }
  function O1(t, e, n, i) {
    var s = V.T;
    V.T = null;
    var o = w.p;
    try {
      ((w.p = 8), Mr(t, e, n, i));
    } finally {
      ((w.p = o), (V.T = s));
    }
  }
  function Mr(t, e, n, i) {
    if (js) {
      var s = xr(i);
      if (s === null) (cr(t, e, i, Ls, n), Wm(t, i));
      else if (V1(s, t, e, n, i)) i.stopPropagation();
      else if ((Wm(t, i), e & 4 && -1 < R1.indexOf(t))) {
        for (; s !== null; ) {
          var o = Ai(s);
          if (o !== null)
            switch (o.tag) {
              case 3:
                if (((o = o.stateNode), o.current.memoizedState.isDehydrated)) {
                  var f = Wn(o.pendingLanes);
                  if (f !== 0) {
                    var m = o;
                    for (m.pendingLanes |= 2, m.entangledLanes |= 2; f; ) {
                      var T = 1 << (31 - ge(f));
                      ((m.entanglements[1] |= T), (f &= ~T));
                    }
                    (ke(o), (gt & 6) === 0 && ((Ss = ye() + 500), Wa(0)));
                  }
                }
                break;
              case 31:
              case 13:
                ((m = ei(o, 2)), m !== null && me(m, o, 2), bs(), Er(o, 2));
            }
          if (((o = xr(i)), o === null && cr(t, e, i, Ls, n), o === s)) break;
          s = o;
        }
        s !== null && i.stopPropagation();
      } else cr(t, e, i, null, n);
    }
  }
  function xr(t) {
    return ((t = Du(t)), Dr(t));
  }
  var Ls = null;
  function Dr(t) {
    if (((Ls = null), (t = bi(t)), t !== null)) {
      var e = d(t);
      if (e === null) t = null;
      else {
        var n = e.tag;
        if (n === 13) {
          if (((t = h(e)), t !== null)) return t;
          t = null;
        } else if (n === 31) {
          if (((t = g(e)), t !== null)) return t;
          t = null;
        } else if (n === 3) {
          if (e.stateNode.current.memoizedState.isDehydrated)
            return e.tag === 3 ? e.stateNode.containerInfo : null;
          t = null;
        } else e !== t && (t = null);
      }
    }
    return ((Ls = t), null);
  }
  function km(t) {
    switch (t) {
      case "beforetoggle":
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "toggle":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 2;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 8;
      case "message":
        switch (y0()) {
          case nf:
            return 2;
          case af:
            return 8;
          case Dl:
          case p0:
            return 32;
          case lf:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var Cr = !1,
    wn = null,
    Yn = null,
    qn = null,
    il = new Map(),
    al = new Map(),
    Gn = [],
    R1 =
      "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
        " ",
      );
  function Wm(t, e) {
    switch (t) {
      case "focusin":
      case "focusout":
        wn = null;
        break;
      case "dragenter":
      case "dragleave":
        Yn = null;
        break;
      case "mouseover":
      case "mouseout":
        qn = null;
        break;
      case "pointerover":
      case "pointerout":
        il.delete(e.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        al.delete(e.pointerId);
    }
  }
  function ll(t, e, n, i, s, o) {
    return t === null || t.nativeEvent !== o
      ? ((t = {
          blockedOn: e,
          domEventName: n,
          eventSystemFlags: i,
          nativeEvent: o,
          targetContainers: [s],
        }),
        e !== null && ((e = Ai(e)), e !== null && Jm(e)),
        t)
      : ((t.eventSystemFlags |= i),
        (e = t.targetContainers),
        s !== null && e.indexOf(s) === -1 && e.push(s),
        t);
  }
  function V1(t, e, n, i, s) {
    switch (e) {
      case "focusin":
        return ((wn = ll(wn, t, e, n, i, s)), !0);
      case "dragenter":
        return ((Yn = ll(Yn, t, e, n, i, s)), !0);
      case "mouseover":
        return ((qn = ll(qn, t, e, n, i, s)), !0);
      case "pointerover":
        var o = s.pointerId;
        return (il.set(o, ll(il.get(o) || null, t, e, n, i, s)), !0);
      case "gotpointercapture":
        return (
          (o = s.pointerId),
          al.set(o, ll(al.get(o) || null, t, e, n, i, s)),
          !0
        );
    }
    return !1;
  }
  function Pm(t) {
    var e = bi(t.target);
    if (e !== null) {
      var n = d(e);
      if (n !== null) {
        if (((e = n.tag), e === 13)) {
          if (((e = h(n)), e !== null)) {
            ((t.blockedOn = e),
              ff(t.priority, function () {
                Fm(n);
              }));
            return;
          }
        } else if (e === 31) {
          if (((e = g(n)), e !== null)) {
            ((t.blockedOn = e),
              ff(t.priority, function () {
                Fm(n);
              }));
            return;
          }
        } else if (e === 3 && n.stateNode.current.memoizedState.isDehydrated) {
          t.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
          return;
        }
      }
    }
    t.blockedOn = null;
  }
  function Hs(t) {
    if (t.blockedOn !== null) return !1;
    for (var e = t.targetContainers; 0 < e.length; ) {
      var n = xr(t.nativeEvent);
      if (n === null) {
        n = t.nativeEvent;
        var i = new n.constructor(n.type, n);
        ((xu = i), n.target.dispatchEvent(i), (xu = null));
      } else return ((e = Ai(n)), e !== null && Jm(e), (t.blockedOn = n), !1);
      e.shift();
    }
    return !0;
  }
  function $m(t, e, n) {
    Hs(t) && n.delete(e);
  }
  function _1() {
    ((Cr = !1),
      wn !== null && Hs(wn) && (wn = null),
      Yn !== null && Hs(Yn) && (Yn = null),
      qn !== null && Hs(qn) && (qn = null),
      il.forEach($m),
      al.forEach($m));
  }
  function ws(t, e) {
    t.blockedOn === e &&
      ((t.blockedOn = null),
      Cr ||
        ((Cr = !0),
        a.unstable_scheduleCallback(a.unstable_NormalPriority, _1)));
  }
  var Ys = null;
  function Im(t) {
    Ys !== t &&
      ((Ys = t),
      a.unstable_scheduleCallback(a.unstable_NormalPriority, function () {
        Ys === t && (Ys = null);
        for (var e = 0; e < t.length; e += 3) {
          var n = t[e],
            i = t[e + 1],
            s = t[e + 2];
          if (typeof i != "function") {
            if (Dr(i || n) === null) continue;
            break;
          }
          var o = Ai(n);
          o !== null &&
            (t.splice(e, 3),
            (e -= 3),
            xo(o, { pending: !0, data: s, method: n.method, action: i }, i, s));
        }
      }));
  }
  function ia(t) {
    function e(T) {
      return ws(T, t);
    }
    (wn !== null && ws(wn, t),
      Yn !== null && ws(Yn, t),
      qn !== null && ws(qn, t),
      il.forEach(e),
      al.forEach(e));
    for (var n = 0; n < Gn.length; n++) {
      var i = Gn[n];
      i.blockedOn === t && (i.blockedOn = null);
    }
    for (; 0 < Gn.length && ((n = Gn[0]), n.blockedOn === null); )
      (Pm(n), n.blockedOn === null && Gn.shift());
    if (((n = (t.ownerDocument || t).$$reactFormReplay), n != null))
      for (i = 0; i < n.length; i += 3) {
        var s = n[i],
          o = n[i + 1],
          f = s[oe] || null;
        if (typeof o == "function") f || Im(n);
        else if (f) {
          var m = null;
          if (o && o.hasAttribute("formAction")) {
            if (((s = o), (f = o[oe] || null))) m = f.formAction;
            else if (Dr(s) !== null) continue;
          } else m = f.action;
          (typeof m == "function" ? (n[i + 1] = m) : (n.splice(i, 3), (i -= 3)),
            Im(n));
        }
      }
  }
  function ty() {
    function t(o) {
      o.canIntercept &&
        o.info === "react-transition" &&
        o.intercept({
          handler: function () {
            return new Promise(function (f) {
              return (s = f);
            });
          },
          focusReset: "manual",
          scroll: "manual",
        });
    }
    function e() {
      (s !== null && (s(), (s = null)), i || setTimeout(n, 20));
    }
    function n() {
      if (!i && !navigation.transition) {
        var o = navigation.currentEntry;
        o &&
          o.url != null &&
          navigation.navigate(o.url, {
            state: o.getState(),
            info: "react-transition",
            history: "replace",
          });
      }
    }
    if (typeof navigation == "object") {
      var i = !1,
        s = null;
      return (
        navigation.addEventListener("navigate", t),
        navigation.addEventListener("navigatesuccess", e),
        navigation.addEventListener("navigateerror", e),
        setTimeout(n, 100),
        function () {
          ((i = !0),
            navigation.removeEventListener("navigate", t),
            navigation.removeEventListener("navigatesuccess", e),
            navigation.removeEventListener("navigateerror", e),
            s !== null && (s(), (s = null)));
        }
      );
    }
  }
  function zr(t) {
    this._internalRoot = t;
  }
  ((qs.prototype.render = zr.prototype.render =
    function (t) {
      var e = this._internalRoot;
      if (e === null) throw Error(r(409));
      var n = e.current,
        i = Me();
      Zm(n, i, t, e, null, null);
    }),
    (qs.prototype.unmount = zr.prototype.unmount =
      function () {
        var t = this._internalRoot;
        if (t !== null) {
          this._internalRoot = null;
          var e = t.containerInfo;
          (Zm(t.current, 2, null, t, null, null), bs(), (e[Ti] = null));
        }
      }));
  function qs(t) {
    this._internalRoot = t;
  }
  qs.prototype.unstable_scheduleHydration = function (t) {
    if (t) {
      var e = cf();
      t = { blockedOn: null, target: t, priority: e };
      for (var n = 0; n < Gn.length && e !== 0 && e < Gn[n].priority; n++);
      (Gn.splice(n, 0, t), n === 0 && Pm(t));
    }
  };
  var ey = l.version;
  if (ey !== "19.2.3") throw Error(r(527, ey, "19.2.3"));
  w.findDOMNode = function (t) {
    var e = t._reactInternals;
    if (e === void 0)
      throw typeof t.render == "function"
        ? Error(r(188))
        : ((t = Object.keys(t).join(",")), Error(r(268, t)));
    return (
      (t = y(e)),
      (t = t !== null ? v(t) : null),
      (t = t === null ? null : t.stateNode),
      t
    );
  };
  var U1 = {
    bundleType: 0,
    version: "19.2.3",
    rendererPackageName: "react-dom",
    currentDispatcherRef: V,
    reconcilerVersion: "19.2.3",
  };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var Gs = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!Gs.isDisabled && Gs.supportsFiber)
      try {
        ((ma = Gs.inject(U1)), (pe = Gs));
      } catch {}
  }
  return (
    (ul.createRoot = function (t, e) {
      if (!c(t)) throw Error(r(299));
      var n = !1,
        i = "",
        s = od,
        o = rd,
        f = cd;
      return (
        e != null &&
          (e.unstable_strictMode === !0 && (n = !0),
          e.identifierPrefix !== void 0 && (i = e.identifierPrefix),
          e.onUncaughtError !== void 0 && (s = e.onUncaughtError),
          e.onCaughtError !== void 0 && (o = e.onCaughtError),
          e.onRecoverableError !== void 0 && (f = e.onRecoverableError)),
        (e = Xm(t, 1, !1, null, null, n, i, null, s, o, f, ty)),
        (t[Ti] = e.current),
        rr(t),
        new zr(e)
      );
    }),
    (ul.hydrateRoot = function (t, e, n) {
      if (!c(t)) throw Error(r(299));
      var i = !1,
        s = "",
        o = od,
        f = rd,
        m = cd,
        T = null;
      return (
        n != null &&
          (n.unstable_strictMode === !0 && (i = !0),
          n.identifierPrefix !== void 0 && (s = n.identifierPrefix),
          n.onUncaughtError !== void 0 && (o = n.onUncaughtError),
          n.onCaughtError !== void 0 && (f = n.onCaughtError),
          n.onRecoverableError !== void 0 && (m = n.onRecoverableError),
          n.formState !== void 0 && (T = n.formState)),
        (e = Xm(t, 1, !0, e, n ?? null, i, s, T, o, f, m, ty)),
        (e.context = Qm(null)),
        (n = e.current),
        (i = Me()),
        (i = gu(i)),
        (s = Cn(i)),
        (s.callback = null),
        zn(n, s, i),
        (n = i),
        (e.current.lanes = n),
        pa(e, n),
        ke(e),
        (t[Ti] = e.current),
        rr(t),
        new qs(e)
      );
    }),
    (ul.version = "19.2.3"),
    ul
  );
}
var fy;
function Q1() {
  if (fy) return Rr.exports;
  fy = 1;
  function a() {
    if (
      !(
        typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" ||
        typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"
      )
    )
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(a);
      } catch (l) {
        console.error(l);
      }
  }
  return (a(), (Rr.exports = X1()), Rr.exports);
}
var Z1 = Q1(),
  X = bc();
const Cp = N1(X);
var K1 = Object.defineProperty,
  J1 = (a, l, u) =>
    l in a
      ? K1(a, l, { enumerable: !0, configurable: !0, writable: !0, value: u })
      : (a[l] = u),
  Xs = (a, l, u) => J1(a, typeof l != "symbol" ? l + "" : l, u);
const F1 = {
    stringify: (a) => (a ? "true" : "false"),
    parse: (a) => /^[ty1-9]/i.test(a),
  },
  k1 = {
    stringify: (a) => a.name,
    parse: (a, l, u) => {
      const r = (() => {
        if (typeof window < "u" && a in window) return window[a];
        if (typeof global < "u" && a in global) return global[a];
      })();
      return typeof r == "function" ? r.bind(u) : void 0;
    },
  },
  W1 = { stringify: (a) => JSON.stringify(a), parse: (a) => JSON.parse(a) };
function P1(a) {
  return a.replace(
    /([a-z0-9])([A-Z])/g,
    (l, u, r) => `${u}-${r.toLowerCase()}`,
  );
}
function zp(a) {
  return a.replace(/[-:]([a-z])/g, (l, u) => `${u.toUpperCase()}`);
}
const $1 = {
    stringify: (a) => a.name,
    parse: (a, l, u) => {
      const r = (() => {
        const c = zp(l);
        if (typeof u < "u" && c in u.container) return u.container[c];
      })();
      return typeof r == "function" ? r.bind(u) : void 0;
    },
  },
  I1 = { stringify: (a) => `${a}`, parse: (a) => parseFloat(a) },
  tS = { stringify: (a) => a, parse: (a) => a },
  Nr = {
    string: tS,
    number: I1,
    boolean: F1,
    function: k1,
    method: $1,
    json: W1,
  },
  ol = Symbol.for("r2wc.render"),
  Qs = Symbol.for("r2wc.connected"),
  mi = Symbol.for("r2wc.context"),
  xe = Symbol.for("r2wc.props");
function eS(a, l, u) {
  var r, c, d;
  (l.props || (l.props = a.propTypes ? Object.keys(a.propTypes) : []),
    l.events || (l.events = []));
  const h = Array.isArray(l.props) ? l.props.slice() : Object.keys(l.props),
    g = Array.isArray(l.events) ? l.events.slice() : Object.keys(l.events),
    p = {},
    y = {},
    v = {},
    S = {};
  for (const z of h) {
    p[z] = Array.isArray(l.props) ? "string" : l.props[z];
    const _ = P1(z);
    ((v[z] = _), (S[_] = z));
  }
  for (const z of g) y[z] = Array.isArray(l.events) ? {} : l.events[z];
  class E extends HTMLElement {
    constructor() {
      (super(),
        Xs(this, d, !0),
        Xs(this, c),
        Xs(this, r, {}),
        Xs(this, "container"),
        l.shadow
          ? (this.container = this.attachShadow({ mode: l.shadow }))
          : (this.container = this),
        (this[xe].container = this.container));
      for (const _ of h) {
        const j = v[_],
          Y = this.getAttribute(j),
          H = p[_],
          q = H ? Nr[H] : null;
        if (H === "method") {
          const L = zp(j);
          (Object.defineProperty(this[xe].container, L, {
            enumerable: !0,
            configurable: !0,
            get() {
              return this[xe][L];
            },
            set(W) {
              ((this[xe][L] = W), this[ol]());
            },
          }),
            (this[xe][_] = q.parse(Y, j, this)));
        }
        q != null && q.parse && Y && (this[xe][_] = q.parse(Y, j, this));
      }
      for (const _ of g)
        this[xe][_] = (j) => {
          const Y = _.replace(/^on/, "").toLowerCase();
          this.dispatchEvent(new CustomEvent(Y, { detail: j, ...y[_] }));
        };
    }
    static get observedAttributes() {
      return Object.keys(S);
    }
    connectedCallback() {
      ((this[Qs] = !0), this[ol]());
    }
    disconnectedCallback() {
      ((this[Qs] = !1), this[mi] && u.unmount(this[mi]), delete this[mi]);
    }
    attributeChangedCallback(_, j, Y) {
      const H = S[_],
        q = p[H],
        L = q ? Nr[q] : null;
      H in p &&
        L != null &&
        L.parse &&
        Y &&
        ((this[xe][H] = L.parse(Y, _, this)), this[ol]());
    }
    [((d = Qs), (c = mi), (r = xe), ol)]() {
      this[Qs] &&
        (this[mi]
          ? u.update(this[mi], this[xe])
          : (this[mi] = u.mount(this.container, a, this[xe])));
    }
  }
  for (const z of h) {
    const _ = v[z],
      j = p[z];
    Object.defineProperty(E.prototype, z, {
      enumerable: !0,
      configurable: !0,
      get() {
        return this[xe][z];
      },
      set(Y) {
        this[xe][z] = Y;
        const H = j ? Nr[j] : null;
        if (H != null && H.stringify) {
          const q = H.stringify(Y, _, this);
          this.getAttribute(_) !== q && this.setAttribute(_, q);
        } else this[ol]();
      },
    });
  }
  return E;
}
function nS(a, l, u) {
  const r = Z1.createRoot(a),
    c = Cp.createElement(l, u);
  return (r.render(c), { root: r, ReactComponent: l });
}
function iS({ root: a, ReactComponent: l }, u) {
  const r = Cp.createElement(l, u);
  a.render(r);
}
function aS({ root: a }) {
  a.unmount();
}
function lS(a, l = {}) {
  return eS(a, l, { mount: nS, update: iS, unmount: aS });
}
const Ac = X.createContext({});
function Ec(a) {
  const l = X.useRef(null);
  return (l.current === null && (l.current = a()), l.current);
}
const Op = typeof window < "u",
  Rp = Op ? X.useLayoutEffect : X.useEffect,
  su = X.createContext(null);
function Mc(a, l) {
  a.indexOf(l) === -1 && a.push(l);
}
function xc(a, l) {
  const u = a.indexOf(l);
  u > -1 && a.splice(u, 1);
}
const Pe = (a, l, u) => (u > l ? l : u < a ? a : u);
let Dc = () => {};
const vn = {},
  Vp = (a) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(a);
function _p(a) {
  return typeof a == "object" && a !== null;
}
const Up = (a) => /^0[^.\s]+$/u.test(a);
function Cc(a) {
  let l;
  return () => (l === void 0 && (l = a()), l);
}
const we = (a) => a,
  sS = (a, l) => (u) => l(a(u)),
  bl = (...a) => a.reduce(sS),
  pl = (a, l, u) => {
    const r = l - a;
    return r === 0 ? 1 : (u - a) / r;
  };
class zc {
  constructor() {
    this.subscriptions = [];
  }
  add(l) {
    return (Mc(this.subscriptions, l), () => xc(this.subscriptions, l));
  }
  notify(l, u, r) {
    const c = this.subscriptions.length;
    if (c)
      if (c === 1) this.subscriptions[0](l, u, r);
      else
        for (let d = 0; d < c; d++) {
          const h = this.subscriptions[d];
          h && h(l, u, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const gn = (a) => a * 1e3,
  He = (a) => a / 1e3;
function Bp(a, l) {
  return l ? a * (1e3 / l) : 0;
}
const Np = (a, l, u) =>
    (((1 - 3 * u + 3 * l) * a + (3 * u - 6 * l)) * a + 3 * l) * a,
  uS = 1e-7,
  oS = 12;
function rS(a, l, u, r, c) {
  let d,
    h,
    g = 0;
  do ((h = l + (u - l) / 2), (d = Np(h, r, c) - a), d > 0 ? (u = h) : (l = h));
  while (Math.abs(d) > uS && ++g < oS);
  return h;
}
function Al(a, l, u, r) {
  if (a === l && u === r) return we;
  const c = (d) => rS(d, 0, 1, a, u);
  return (d) => (d === 0 || d === 1 ? d : Np(c(d), l, r));
}
const jp = (a) => (l) => (l <= 0.5 ? a(2 * l) / 2 : (2 - a(2 * (1 - l))) / 2),
  Lp = (a) => (l) => 1 - a(1 - l),
  Hp = Al(0.33, 1.53, 0.69, 0.99),
  Oc = Lp(Hp),
  wp = jp(Oc),
  Yp = (a) =>
    (a *= 2) < 1 ? 0.5 * Oc(a) : 0.5 * (2 - Math.pow(2, -10 * (a - 1))),
  Rc = (a) => 1 - Math.sin(Math.acos(a)),
  qp = Lp(Rc),
  Gp = jp(Rc),
  cS = Al(0.42, 0, 1, 1),
  fS = Al(0, 0, 0.58, 1),
  Xp = Al(0.42, 0, 0.58, 1),
  hS = (a) => Array.isArray(a) && typeof a[0] != "number",
  Qp = (a) => Array.isArray(a) && typeof a[0] == "number",
  dS = {
    linear: we,
    easeIn: cS,
    easeInOut: Xp,
    easeOut: fS,
    circIn: Rc,
    circInOut: Gp,
    circOut: qp,
    backIn: Oc,
    backInOut: wp,
    backOut: Hp,
    anticipate: Yp,
  },
  mS = (a) => typeof a == "string",
  hy = (a) => {
    if (Qp(a)) {
      Dc(a.length === 4);
      const [l, u, r, c] = a;
      return Al(l, u, r, c);
    } else if (mS(a)) return dS[a];
    return a;
  },
  Zs = [
    "setup",
    "read",
    "resolveKeyframes",
    "preUpdate",
    "update",
    "preRender",
    "render",
    "postRender",
  ];
function yS(a, l) {
  let u = new Set(),
    r = new Set(),
    c = !1,
    d = !1;
  const h = new WeakSet();
  let g = { delta: 0, timestamp: 0, isProcessing: !1 };
  function p(v) {
    (h.has(v) && (y.schedule(v), a()), v(g));
  }
  const y = {
    schedule: (v, S = !1, E = !1) => {
      const _ = E && c ? u : r;
      return (S && h.add(v), _.has(v) || _.add(v), v);
    },
    cancel: (v) => {
      (r.delete(v), h.delete(v));
    },
    process: (v) => {
      if (((g = v), c)) {
        d = !0;
        return;
      }
      ((c = !0),
        ([u, r] = [r, u]),
        u.forEach(p),
        u.clear(),
        (c = !1),
        d && ((d = !1), y.process(v)));
    },
  };
  return y;
}
const pS = 40;
function Zp(a, l) {
  let u = !1,
    r = !0;
  const c = { delta: 0, timestamp: 0, isProcessing: !1 },
    d = () => (u = !0),
    h = Zs.reduce((L, W) => ((L[W] = yS(d)), L), {}),
    {
      setup: g,
      read: p,
      resolveKeyframes: y,
      preUpdate: v,
      update: S,
      preRender: E,
      render: z,
      postRender: _,
    } = h,
    j = () => {
      const L = vn.useManualTiming ? c.timestamp : performance.now();
      ((u = !1),
        vn.useManualTiming ||
          (c.delta = r ? 1e3 / 60 : Math.max(Math.min(L - c.timestamp, pS), 1)),
        (c.timestamp = L),
        (c.isProcessing = !0),
        g.process(c),
        p.process(c),
        y.process(c),
        v.process(c),
        S.process(c),
        E.process(c),
        z.process(c),
        _.process(c),
        (c.isProcessing = !1),
        u && l && ((r = !1), a(j)));
    },
    Y = () => {
      ((u = !0), (r = !0), c.isProcessing || a(j));
    };
  return {
    schedule: Zs.reduce((L, W) => {
      const P = h[W];
      return (
        (L[W] = (et, $ = !1, K = !1) => (u || Y(), P.schedule(et, $, K))),
        L
      );
    }, {}),
    cancel: (L) => {
      for (let W = 0; W < Zs.length; W++) h[Zs[W]].cancel(L);
    },
    state: c,
    steps: h,
  };
}
const {
  schedule: zt,
  cancel: Kn,
  state: te,
  steps: jr,
} = Zp(typeof requestAnimationFrame < "u" ? requestAnimationFrame : we, !0);
let ks;
function gS() {
  ks = void 0;
}
const le = {
    now: () => (
      ks === void 0 &&
        le.set(
          te.isProcessing || vn.useManualTiming
            ? te.timestamp
            : performance.now(),
        ),
      ks
    ),
    set: (a) => {
      ((ks = a), queueMicrotask(gS));
    },
  },
  Kp = (a) => (l) => typeof l == "string" && l.startsWith(a),
  Jp = Kp("--"),
  vS = Kp("var(--"),
  Vc = (a) => (vS(a) ? SS.test(a.split("/*")[0].trim()) : !1),
  SS =
    /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;
function dy(a) {
  return typeof a != "string" ? !1 : a.split("/*")[0].includes("var(--");
}
const ca = {
    test: (a) => typeof a == "number",
    parse: parseFloat,
    transform: (a) => a,
  },
  gl = { ...ca, transform: (a) => Pe(0, 1, a) },
  Ks = { ...ca, default: 1 },
  hl = (a) => Math.round(a * 1e5) / 1e5,
  _c = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function TS(a) {
  return a == null;
}
const bS =
    /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu,
  Uc = (a, l) => (u) =>
    !!(
      (typeof u == "string" && bS.test(u) && u.startsWith(a)) ||
      (l && !TS(u) && Object.prototype.hasOwnProperty.call(u, l))
    ),
  Fp = (a, l, u) => (r) => {
    if (typeof r != "string") return r;
    const [c, d, h, g] = r.match(_c);
    return {
      [a]: parseFloat(c),
      [l]: parseFloat(d),
      [u]: parseFloat(h),
      alpha: g !== void 0 ? parseFloat(g) : 1,
    };
  },
  AS = (a) => Pe(0, 255, a),
  Lr = { ...ca, transform: (a) => Math.round(AS(a)) },
  gi = {
    test: Uc("rgb", "red"),
    parse: Fp("red", "green", "blue"),
    transform: ({ red: a, green: l, blue: u, alpha: r = 1 }) =>
      "rgba(" +
      Lr.transform(a) +
      ", " +
      Lr.transform(l) +
      ", " +
      Lr.transform(u) +
      ", " +
      hl(gl.transform(r)) +
      ")",
  };
function ES(a) {
  let l = "",
    u = "",
    r = "",
    c = "";
  return (
    a.length > 5
      ? ((l = a.substring(1, 3)),
        (u = a.substring(3, 5)),
        (r = a.substring(5, 7)),
        (c = a.substring(7, 9)))
      : ((l = a.substring(1, 2)),
        (u = a.substring(2, 3)),
        (r = a.substring(3, 4)),
        (c = a.substring(4, 5)),
        (l += l),
        (u += u),
        (r += r),
        (c += c)),
    {
      red: parseInt(l, 16),
      green: parseInt(u, 16),
      blue: parseInt(r, 16),
      alpha: c ? parseInt(c, 16) / 255 : 1,
    }
  );
}
const $r = { test: Uc("#"), parse: ES, transform: gi.transform },
  El = (a) => ({
    test: (l) =>
      typeof l == "string" && l.endsWith(a) && l.split(" ").length === 1,
    parse: parseFloat,
    transform: (l) => `${l}${a}`,
  }),
  Qn = El("deg"),
  We = El("%"),
  Z = El("px"),
  MS = El("vh"),
  xS = El("vw"),
  my = {
    ...We,
    parse: (a) => We.parse(a) / 100,
    transform: (a) => We.transform(a * 100),
  },
  aa = {
    test: Uc("hsl", "hue"),
    parse: Fp("hue", "saturation", "lightness"),
    transform: ({ hue: a, saturation: l, lightness: u, alpha: r = 1 }) =>
      "hsla(" +
      Math.round(a) +
      ", " +
      We.transform(hl(l)) +
      ", " +
      We.transform(hl(u)) +
      ", " +
      hl(gl.transform(r)) +
      ")",
  },
  Qt = {
    test: (a) => gi.test(a) || $r.test(a) || aa.test(a),
    parse: (a) =>
      gi.test(a) ? gi.parse(a) : aa.test(a) ? aa.parse(a) : $r.parse(a),
    transform: (a) =>
      typeof a == "string"
        ? a
        : a.hasOwnProperty("red")
          ? gi.transform(a)
          : aa.transform(a),
    getAnimatableNone: (a) => {
      const l = Qt.parse(a);
      return ((l.alpha = 0), Qt.transform(l));
    },
  },
  DS =
    /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function CS(a) {
  return (
    isNaN(a) &&
    typeof a == "string" &&
    (a.match(_c)?.length || 0) + (a.match(DS)?.length || 0) > 0
  );
}
const kp = "number",
  Wp = "color",
  zS = "var",
  OS = "var(",
  yy = "${}",
  RS =
    /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function vl(a) {
  const l = a.toString(),
    u = [],
    r = { color: [], number: [], var: [] },
    c = [];
  let d = 0;
  const g = l
    .replace(
      RS,
      (p) => (
        Qt.test(p)
          ? (r.color.push(d), c.push(Wp), u.push(Qt.parse(p)))
          : p.startsWith(OS)
            ? (r.var.push(d), c.push(zS), u.push(p))
            : (r.number.push(d), c.push(kp), u.push(parseFloat(p))),
        ++d,
        yy
      ),
    )
    .split(yy);
  return { values: u, split: g, indexes: r, types: c };
}
function Pp(a) {
  return vl(a).values;
}
function $p(a) {
  const { split: l, types: u } = vl(a),
    r = l.length;
  return (c) => {
    let d = "";
    for (let h = 0; h < r; h++)
      if (((d += l[h]), c[h] !== void 0)) {
        const g = u[h];
        g === kp
          ? (d += hl(c[h]))
          : g === Wp
            ? (d += Qt.transform(c[h]))
            : (d += c[h]);
      }
    return d;
  };
}
const VS = (a) =>
  typeof a == "number" ? 0 : Qt.test(a) ? Qt.getAnimatableNone(a) : a;
function _S(a) {
  const l = Pp(a);
  return $p(a)(l.map(VS));
}
const Jn = {
  test: CS,
  parse: Pp,
  createTransformer: $p,
  getAnimatableNone: _S,
};
function Hr(a, l, u) {
  return (
    u < 0 && (u += 1),
    u > 1 && (u -= 1),
    u < 1 / 6
      ? a + (l - a) * 6 * u
      : u < 1 / 2
        ? l
        : u < 2 / 3
          ? a + (l - a) * (2 / 3 - u) * 6
          : a
  );
}
function US({ hue: a, saturation: l, lightness: u, alpha: r }) {
  ((a /= 360), (l /= 100), (u /= 100));
  let c = 0,
    d = 0,
    h = 0;
  if (!l) c = d = h = u;
  else {
    const g = u < 0.5 ? u * (1 + l) : u + l - u * l,
      p = 2 * u - g;
    ((c = Hr(p, g, a + 1 / 3)), (d = Hr(p, g, a)), (h = Hr(p, g, a - 1 / 3)));
  }
  return {
    red: Math.round(c * 255),
    green: Math.round(d * 255),
    blue: Math.round(h * 255),
    alpha: r,
  };
}
function Is(a, l) {
  return (u) => (u > 0 ? l : a);
}
const Rt = (a, l, u) => a + (l - a) * u,
  wr = (a, l, u) => {
    const r = a * a,
      c = u * (l * l - r) + r;
    return c < 0 ? 0 : Math.sqrt(c);
  },
  BS = [$r, gi, aa],
  NS = (a) => BS.find((l) => l.test(a));
function py(a) {
  const l = NS(a);
  if (!l) return !1;
  let u = l.parse(a);
  return (l === aa && (u = US(u)), u);
}
const gy = (a, l) => {
    const u = py(a),
      r = py(l);
    if (!u || !r) return Is(a, l);
    const c = { ...u };
    return (d) => (
      (c.red = wr(u.red, r.red, d)),
      (c.green = wr(u.green, r.green, d)),
      (c.blue = wr(u.blue, r.blue, d)),
      (c.alpha = Rt(u.alpha, r.alpha, d)),
      gi.transform(c)
    );
  },
  Ir = new Set(["none", "hidden"]);
function jS(a, l) {
  return Ir.has(a) ? (u) => (u <= 0 ? a : l) : (u) => (u >= 1 ? l : a);
}
function LS(a, l) {
  return (u) => Rt(a, l, u);
}
function Bc(a) {
  return typeof a == "number"
    ? LS
    : typeof a == "string"
      ? Vc(a)
        ? Is
        : Qt.test(a)
          ? gy
          : YS
      : Array.isArray(a)
        ? Ip
        : typeof a == "object"
          ? Qt.test(a)
            ? gy
            : HS
          : Is;
}
function Ip(a, l) {
  const u = [...a],
    r = u.length,
    c = a.map((d, h) => Bc(d)(d, l[h]));
  return (d) => {
    for (let h = 0; h < r; h++) u[h] = c[h](d);
    return u;
  };
}
function HS(a, l) {
  const u = { ...a, ...l },
    r = {};
  for (const c in u)
    a[c] !== void 0 && l[c] !== void 0 && (r[c] = Bc(a[c])(a[c], l[c]));
  return (c) => {
    for (const d in r) u[d] = r[d](c);
    return u;
  };
}
function wS(a, l) {
  const u = [],
    r = { color: 0, var: 0, number: 0 };
  for (let c = 0; c < l.values.length; c++) {
    const d = l.types[c],
      h = a.indexes[d][r[d]],
      g = a.values[h] ?? 0;
    ((u[c] = g), r[d]++);
  }
  return u;
}
const YS = (a, l) => {
  const u = Jn.createTransformer(l),
    r = vl(a),
    c = vl(l);
  return r.indexes.var.length === c.indexes.var.length &&
    r.indexes.color.length === c.indexes.color.length &&
    r.indexes.number.length >= c.indexes.number.length
    ? (Ir.has(a) && !c.values.length) || (Ir.has(l) && !r.values.length)
      ? jS(a, l)
      : bl(Ip(wS(r, c), c.values), u)
    : Is(a, l);
};
function tg(a, l, u) {
  return typeof a == "number" && typeof l == "number" && typeof u == "number"
    ? Rt(a, l, u)
    : Bc(a)(a, l);
}
const qS = (a) => {
    const l = ({ timestamp: u }) => a(u);
    return {
      start: (u = !0) => zt.update(l, u),
      stop: () => Kn(l),
      now: () => (te.isProcessing ? te.timestamp : le.now()),
    };
  },
  eg = (a, l, u = 10) => {
    let r = "";
    const c = Math.max(Math.round(l / u), 2);
    for (let d = 0; d < c; d++)
      r += Math.round(a(d / (c - 1)) * 1e4) / 1e4 + ", ";
    return `linear(${r.substring(0, r.length - 2)})`;
  },
  tu = 2e4;
function Nc(a) {
  let l = 0;
  const u = 50;
  let r = a.next(l);
  for (; !r.done && l < tu; ) ((l += u), (r = a.next(l)));
  return l >= tu ? 1 / 0 : l;
}
function GS(a, l = 100, u) {
  const r = u({ ...a, keyframes: [0, l] }),
    c = Math.min(Nc(r), tu);
  return {
    type: "keyframes",
    ease: (d) => r.next(c * d).value / l,
    duration: He(c),
  };
}
const XS = 5;
function ng(a, l, u) {
  const r = Math.max(l - XS, 0);
  return Bp(u - a(r), l - r);
}
const Ut = {
    stiffness: 100,
    damping: 10,
    mass: 1,
    velocity: 0,
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    restSpeed: { granular: 0.01, default: 2 },
    restDelta: { granular: 0.005, default: 0.5 },
    minDuration: 0.01,
    maxDuration: 10,
    minDamping: 0.05,
    maxDamping: 1,
  },
  Yr = 0.001;
function QS({
  duration: a = Ut.duration,
  bounce: l = Ut.bounce,
  velocity: u = Ut.velocity,
  mass: r = Ut.mass,
}) {
  let c,
    d,
    h = 1 - l;
  ((h = Pe(Ut.minDamping, Ut.maxDamping, h)),
    (a = Pe(Ut.minDuration, Ut.maxDuration, He(a))),
    h < 1
      ? ((c = (y) => {
          const v = y * h,
            S = v * a,
            E = v - u,
            z = tc(y, h),
            _ = Math.exp(-S);
          return Yr - (E / z) * _;
        }),
        (d = (y) => {
          const S = y * h * a,
            E = S * u + u,
            z = Math.pow(h, 2) * Math.pow(y, 2) * a,
            _ = Math.exp(-S),
            j = tc(Math.pow(y, 2), h);
          return ((-c(y) + Yr > 0 ? -1 : 1) * ((E - z) * _)) / j;
        }))
      : ((c = (y) => {
          const v = Math.exp(-y * a),
            S = (y - u) * a + 1;
          return -Yr + v * S;
        }),
        (d = (y) => {
          const v = Math.exp(-y * a),
            S = (u - y) * (a * a);
          return v * S;
        })));
  const g = 5 / a,
    p = KS(c, d, g);
  if (((a = gn(a)), isNaN(p)))
    return { stiffness: Ut.stiffness, damping: Ut.damping, duration: a };
  {
    const y = Math.pow(p, 2) * r;
    return { stiffness: y, damping: h * 2 * Math.sqrt(r * y), duration: a };
  }
}
const ZS = 12;
function KS(a, l, u) {
  let r = u;
  for (let c = 1; c < ZS; c++) r = r - a(r) / l(r);
  return r;
}
function tc(a, l) {
  return a * Math.sqrt(1 - l * l);
}
const JS = ["duration", "bounce"],
  FS = ["stiffness", "damping", "mass"];
function vy(a, l) {
  return l.some((u) => a[u] !== void 0);
}
function kS(a) {
  let l = {
    velocity: Ut.velocity,
    stiffness: Ut.stiffness,
    damping: Ut.damping,
    mass: Ut.mass,
    isResolvedFromDuration: !1,
    ...a,
  };
  if (!vy(a, FS) && vy(a, JS))
    if (a.visualDuration) {
      const u = a.visualDuration,
        r = (2 * Math.PI) / (u * 1.2),
        c = r * r,
        d = 2 * Pe(0.05, 1, 1 - (a.bounce || 0)) * Math.sqrt(c);
      l = { ...l, mass: Ut.mass, stiffness: c, damping: d };
    } else {
      const u = QS(a);
      ((l = { ...l, ...u, mass: Ut.mass }), (l.isResolvedFromDuration = !0));
    }
  return l;
}
function eu(a = Ut.visualDuration, l = Ut.bounce) {
  const u =
    typeof a != "object"
      ? { visualDuration: a, keyframes: [0, 1], bounce: l }
      : a;
  let { restSpeed: r, restDelta: c } = u;
  const d = u.keyframes[0],
    h = u.keyframes[u.keyframes.length - 1],
    g = { done: !1, value: d },
    {
      stiffness: p,
      damping: y,
      mass: v,
      duration: S,
      velocity: E,
      isResolvedFromDuration: z,
    } = kS({ ...u, velocity: -He(u.velocity || 0) }),
    _ = E || 0,
    j = y / (2 * Math.sqrt(p * v)),
    Y = h - d,
    H = He(Math.sqrt(p / v)),
    q = Math.abs(Y) < 5;
  (r || (r = q ? Ut.restSpeed.granular : Ut.restSpeed.default),
    c || (c = q ? Ut.restDelta.granular : Ut.restDelta.default));
  let L;
  if (j < 1) {
    const P = tc(H, j);
    L = (et) => {
      const $ = Math.exp(-j * H * et);
      return (
        h -
        $ * (((_ + j * H * Y) / P) * Math.sin(P * et) + Y * Math.cos(P * et))
      );
    };
  } else if (j === 1) L = (P) => h - Math.exp(-H * P) * (Y + (_ + H * Y) * P);
  else {
    const P = H * Math.sqrt(j * j - 1);
    L = (et) => {
      const $ = Math.exp(-j * H * et),
        K = Math.min(P * et, 300);
      return (
        h - ($ * ((_ + j * H * Y) * Math.sinh(K) + P * Y * Math.cosh(K))) / P
      );
    };
  }
  const W = {
    calculatedDuration: (z && S) || null,
    next: (P) => {
      const et = L(P);
      if (z) g.done = P >= S;
      else {
        let $ = P === 0 ? _ : 0;
        j < 1 && ($ = P === 0 ? gn(_) : ng(L, P, et));
        const K = Math.abs($) <= r,
          it = Math.abs(h - et) <= c;
        g.done = K && it;
      }
      return ((g.value = g.done ? h : et), g);
    },
    toString: () => {
      const P = Math.min(Nc(W), tu),
        et = eg(($) => W.next(P * $).value, P, 30);
      return P + "ms " + et;
    },
    toTransition: () => {},
  };
  return W;
}
eu.applyToOptions = (a) => {
  const l = GS(a, 100, eu);
  return (
    (a.ease = l.ease),
    (a.duration = gn(l.duration)),
    (a.type = "keyframes"),
    a
  );
};
function ec({
  keyframes: a,
  velocity: l = 0,
  power: u = 0.8,
  timeConstant: r = 325,
  bounceDamping: c = 10,
  bounceStiffness: d = 500,
  modifyTarget: h,
  min: g,
  max: p,
  restDelta: y = 0.5,
  restSpeed: v,
}) {
  const S = a[0],
    E = { done: !1, value: S },
    z = (K) => (g !== void 0 && K < g) || (p !== void 0 && K > p),
    _ = (K) =>
      g === void 0
        ? p
        : p === void 0 || Math.abs(g - K) < Math.abs(p - K)
          ? g
          : p;
  let j = u * l;
  const Y = S + j,
    H = h === void 0 ? Y : h(Y);
  H !== Y && (j = H - S);
  const q = (K) => -j * Math.exp(-K / r),
    L = (K) => H + q(K),
    W = (K) => {
      const it = q(K),
        xt = L(K);
      ((E.done = Math.abs(it) <= y), (E.value = E.done ? H : xt));
    };
  let P, et;
  const $ = (K) => {
    z(E.value) &&
      ((P = K),
      (et = eu({
        keyframes: [E.value, _(E.value)],
        velocity: ng(L, K, E.value),
        damping: c,
        stiffness: d,
        restDelta: y,
        restSpeed: v,
      })));
  };
  return (
    $(0),
    {
      calculatedDuration: null,
      next: (K) => {
        let it = !1;
        return (
          !et && P === void 0 && ((it = !0), W(K), $(K)),
          P !== void 0 && K >= P ? et.next(K - P) : (!it && W(K), E)
        );
      },
    }
  );
}
function WS(a, l, u) {
  const r = [],
    c = u || vn.mix || tg,
    d = a.length - 1;
  for (let h = 0; h < d; h++) {
    let g = c(a[h], a[h + 1]);
    if (l) {
      const p = Array.isArray(l) ? l[h] || we : l;
      g = bl(p, g);
    }
    r.push(g);
  }
  return r;
}
function PS(a, l, { clamp: u = !0, ease: r, mixer: c } = {}) {
  const d = a.length;
  if ((Dc(d === l.length), d === 1)) return () => l[0];
  if (d === 2 && l[0] === l[1]) return () => l[1];
  const h = a[0] === a[1];
  a[0] > a[d - 1] && ((a = [...a].reverse()), (l = [...l].reverse()));
  const g = WS(l, r, c),
    p = g.length,
    y = (v) => {
      if (h && v < a[0]) return l[0];
      let S = 0;
      if (p > 1) for (; S < a.length - 2 && !(v < a[S + 1]); S++);
      const E = pl(a[S], a[S + 1], v);
      return g[S](E);
    };
  return u ? (v) => y(Pe(a[0], a[d - 1], v)) : y;
}
function $S(a, l) {
  const u = a[a.length - 1];
  for (let r = 1; r <= l; r++) {
    const c = pl(0, l, r);
    a.push(Rt(u, 1, c));
  }
}
function IS(a) {
  const l = [0];
  return ($S(l, a.length - 1), l);
}
function tT(a, l) {
  return a.map((u) => u * l);
}
function eT(a, l) {
  return a.map(() => l || Xp).splice(0, a.length - 1);
}
function dl({
  duration: a = 300,
  keyframes: l,
  times: u,
  ease: r = "easeInOut",
}) {
  const c = hS(r) ? r.map(hy) : hy(r),
    d = { done: !1, value: l[0] },
    h = tT(u && u.length === l.length ? u : IS(l), a),
    g = PS(h, l, { ease: Array.isArray(c) ? c : eT(l, c) });
  return {
    calculatedDuration: a,
    next: (p) => ((d.value = g(p)), (d.done = p >= a), d),
  };
}
const nT = (a) => a !== null;
function jc(a, { repeat: l, repeatType: u = "loop" }, r, c = 1) {
  const d = a.filter(nT),
    g = c < 0 || (l && u !== "loop" && l % 2 === 1) ? 0 : d.length - 1;
  return !g || r === void 0 ? d[g] : r;
}
const iT = { decay: ec, inertia: ec, tween: dl, keyframes: dl, spring: eu };
function ig(a) {
  typeof a.type == "string" && (a.type = iT[a.type]);
}
class Lc {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise((l) => {
      this.resolve = l;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  then(l, u) {
    return this.finished.then(l, u);
  }
}
const aT = (a) => a / 100;
class Hc extends Lc {
  constructor(l) {
    (super(),
      (this.state = "idle"),
      (this.startTime = null),
      (this.isStopped = !1),
      (this.currentTime = 0),
      (this.holdTime = null),
      (this.playbackSpeed = 1),
      (this.stop = () => {
        const { motionValue: u } = this.options;
        (u && u.updatedAt !== le.now() && this.tick(le.now()),
          (this.isStopped = !0),
          this.state !== "idle" && (this.teardown(), this.options.onStop?.()));
      }),
      (this.options = l),
      this.initAnimation(),
      this.play(),
      l.autoplay === !1 && this.pause());
  }
  initAnimation() {
    const { options: l } = this;
    ig(l);
    const {
      type: u = dl,
      repeat: r = 0,
      repeatDelay: c = 0,
      repeatType: d,
      velocity: h = 0,
    } = l;
    let { keyframes: g } = l;
    const p = u || dl;
    p !== dl &&
      typeof g[0] != "number" &&
      ((this.mixKeyframes = bl(aT, tg(g[0], g[1]))), (g = [0, 100]));
    const y = p({ ...l, keyframes: g });
    (d === "mirror" &&
      (this.mirroredGenerator = p({
        ...l,
        keyframes: [...g].reverse(),
        velocity: -h,
      })),
      y.calculatedDuration === null && (y.calculatedDuration = Nc(y)));
    const { calculatedDuration: v } = y;
    ((this.calculatedDuration = v),
      (this.resolvedDuration = v + c),
      (this.totalDuration = this.resolvedDuration * (r + 1) - c),
      (this.generator = y));
  }
  updateTime(l) {
    const u = Math.round(l - this.startTime) * this.playbackSpeed;
    this.holdTime !== null
      ? (this.currentTime = this.holdTime)
      : (this.currentTime = u);
  }
  tick(l, u = !1) {
    const {
      generator: r,
      totalDuration: c,
      mixKeyframes: d,
      mirroredGenerator: h,
      resolvedDuration: g,
      calculatedDuration: p,
    } = this;
    if (this.startTime === null) return r.next(0);
    const {
      delay: y = 0,
      keyframes: v,
      repeat: S,
      repeatType: E,
      repeatDelay: z,
      type: _,
      onUpdate: j,
      finalKeyframe: Y,
    } = this.options;
    (this.speed > 0
      ? (this.startTime = Math.min(this.startTime, l))
      : this.speed < 0 &&
        (this.startTime = Math.min(l - c / this.speed, this.startTime)),
      u ? (this.currentTime = l) : this.updateTime(l));
    const H = this.currentTime - y * (this.playbackSpeed >= 0 ? 1 : -1),
      q = this.playbackSpeed >= 0 ? H < 0 : H > c;
    ((this.currentTime = Math.max(H, 0)),
      this.state === "finished" &&
        this.holdTime === null &&
        (this.currentTime = c));
    let L = this.currentTime,
      W = r;
    if (S) {
      const K = Math.min(this.currentTime, c) / g;
      let it = Math.floor(K),
        xt = K % 1;
      (!xt && K >= 1 && (xt = 1),
        xt === 1 && it--,
        (it = Math.min(it, S + 1)),
        it % 2 &&
          (E === "reverse"
            ? ((xt = 1 - xt), z && (xt -= z / g))
            : E === "mirror" && (W = h)),
        (L = Pe(0, 1, xt) * g));
    }
    const P = q ? { done: !1, value: v[0] } : W.next(L);
    d && (P.value = d(P.value));
    let { done: et } = P;
    !q &&
      p !== null &&
      (et =
        this.playbackSpeed >= 0
          ? this.currentTime >= c
          : this.currentTime <= 0);
    const $ =
      this.holdTime === null &&
      (this.state === "finished" || (this.state === "running" && et));
    return (
      $ && _ !== ec && (P.value = jc(v, this.options, Y, this.speed)),
      j && j(P.value),
      $ && this.finish(),
      P
    );
  }
  then(l, u) {
    return this.finished.then(l, u);
  }
  get duration() {
    return He(this.calculatedDuration);
  }
  get iterationDuration() {
    const { delay: l = 0 } = this.options || {};
    return this.duration + He(l);
  }
  get time() {
    return He(this.currentTime);
  }
  set time(l) {
    ((l = gn(l)),
      (this.currentTime = l),
      this.startTime === null ||
      this.holdTime !== null ||
      this.playbackSpeed === 0
        ? (this.holdTime = l)
        : this.driver &&
          (this.startTime = this.driver.now() - l / this.playbackSpeed),
      this.driver?.start(!1));
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(l) {
    this.updateTime(le.now());
    const u = this.playbackSpeed !== l;
    ((this.playbackSpeed = l), u && (this.time = He(this.currentTime)));
  }
  play() {
    if (this.isStopped) return;
    const { driver: l = qS, startTime: u } = this.options;
    (this.driver || (this.driver = l((c) => this.tick(c))),
      this.options.onPlay?.());
    const r = this.driver.now();
    (this.state === "finished"
      ? (this.updateFinished(), (this.startTime = r))
      : this.holdTime !== null
        ? (this.startTime = r - this.holdTime)
        : this.startTime || (this.startTime = u ?? r),
      this.state === "finished" &&
        this.speed < 0 &&
        (this.startTime += this.calculatedDuration),
      (this.holdTime = null),
      (this.state = "running"),
      this.driver.start());
  }
  pause() {
    ((this.state = "paused"),
      this.updateTime(le.now()),
      (this.holdTime = this.currentTime));
  }
  complete() {
    (this.state !== "running" && this.play(),
      (this.state = "finished"),
      (this.holdTime = null));
  }
  finish() {
    (this.notifyFinished(),
      this.teardown(),
      (this.state = "finished"),
      this.options.onComplete?.());
  }
  cancel() {
    ((this.holdTime = null),
      (this.startTime = 0),
      this.tick(0),
      this.teardown(),
      this.options.onCancel?.());
  }
  teardown() {
    ((this.state = "idle"),
      this.stopDriver(),
      (this.startTime = this.holdTime = null));
  }
  stopDriver() {
    this.driver && (this.driver.stop(), (this.driver = void 0));
  }
  sample(l) {
    return ((this.startTime = 0), this.tick(l, !0));
  }
  attachTimeline(l) {
    return (
      this.options.allowFlatten &&
        ((this.options.type = "keyframes"),
        (this.options.ease = "linear"),
        this.initAnimation()),
      this.driver?.stop(),
      l.observe(this)
    );
  }
}
function lT(a) {
  for (let l = 1; l < a.length; l++) a[l] ?? (a[l] = a[l - 1]);
}
const vi = (a) => (a * 180) / Math.PI,
  nc = (a) => {
    const l = vi(Math.atan2(a[1], a[0]));
    return ic(l);
  },
  sT = {
    x: 4,
    y: 5,
    translateX: 4,
    translateY: 5,
    scaleX: 0,
    scaleY: 3,
    scale: (a) => (Math.abs(a[0]) + Math.abs(a[3])) / 2,
    rotate: nc,
    rotateZ: nc,
    skewX: (a) => vi(Math.atan(a[1])),
    skewY: (a) => vi(Math.atan(a[2])),
    skew: (a) => (Math.abs(a[1]) + Math.abs(a[2])) / 2,
  },
  ic = (a) => ((a = a % 360), a < 0 && (a += 360), a),
  Sy = nc,
  Ty = (a) => Math.sqrt(a[0] * a[0] + a[1] * a[1]),
  by = (a) => Math.sqrt(a[4] * a[4] + a[5] * a[5]),
  uT = {
    x: 12,
    y: 13,
    z: 14,
    translateX: 12,
    translateY: 13,
    translateZ: 14,
    scaleX: Ty,
    scaleY: by,
    scale: (a) => (Ty(a) + by(a)) / 2,
    rotateX: (a) => ic(vi(Math.atan2(a[6], a[5]))),
    rotateY: (a) => ic(vi(Math.atan2(-a[2], a[0]))),
    rotateZ: Sy,
    rotate: Sy,
    skewX: (a) => vi(Math.atan(a[4])),
    skewY: (a) => vi(Math.atan(a[1])),
    skew: (a) => (Math.abs(a[1]) + Math.abs(a[4])) / 2,
  };
function ac(a) {
  return a.includes("scale") ? 1 : 0;
}
function lc(a, l) {
  if (!a || a === "none") return ac(l);
  const u = a.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let r, c;
  if (u) ((r = uT), (c = u));
  else {
    const g = a.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    ((r = sT), (c = g));
  }
  if (!c) return ac(l);
  const d = r[l],
    h = c[1].split(",").map(rT);
  return typeof d == "function" ? d(h) : h[d];
}
const oT = (a, l) => {
  const { transform: u = "none" } = getComputedStyle(a);
  return lc(u, l);
};
function rT(a) {
  return parseFloat(a.trim());
}
const fa = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY",
  ],
  ha = new Set(fa),
  Ay = (a) => a === ca || a === Z,
  cT = new Set(["x", "y", "z"]),
  fT = fa.filter((a) => !cT.has(a));
function hT(a) {
  const l = [];
  return (
    fT.forEach((u) => {
      const r = a.getValue(u);
      r !== void 0 &&
        (l.push([u, r.get()]), r.set(u.startsWith("scale") ? 1 : 0));
    }),
    l
  );
}
const Zn = {
  width: ({ x: a }, { paddingLeft: l = "0", paddingRight: u = "0" }) =>
    a.max - a.min - parseFloat(l) - parseFloat(u),
  height: ({ y: a }, { paddingTop: l = "0", paddingBottom: u = "0" }) =>
    a.max - a.min - parseFloat(l) - parseFloat(u),
  top: (a, { top: l }) => parseFloat(l),
  left: (a, { left: l }) => parseFloat(l),
  bottom: ({ y: a }, { top: l }) => parseFloat(l) + (a.max - a.min),
  right: ({ x: a }, { left: l }) => parseFloat(l) + (a.max - a.min),
  x: (a, { transform: l }) => lc(l, "x"),
  y: (a, { transform: l }) => lc(l, "y"),
};
Zn.translateX = Zn.x;
Zn.translateY = Zn.y;
const Si = new Set();
let sc = !1,
  uc = !1,
  oc = !1;
function ag() {
  if (uc) {
    const a = Array.from(Si).filter((r) => r.needsMeasurement),
      l = new Set(a.map((r) => r.element)),
      u = new Map();
    (l.forEach((r) => {
      const c = hT(r);
      c.length && (u.set(r, c), r.render());
    }),
      a.forEach((r) => r.measureInitialState()),
      l.forEach((r) => {
        r.render();
        const c = u.get(r);
        c &&
          c.forEach(([d, h]) => {
            r.getValue(d)?.set(h);
          });
      }),
      a.forEach((r) => r.measureEndState()),
      a.forEach((r) => {
        r.suspendedScrollY !== void 0 && window.scrollTo(0, r.suspendedScrollY);
      }));
  }
  ((uc = !1), (sc = !1), Si.forEach((a) => a.complete(oc)), Si.clear());
}
function lg() {
  Si.forEach((a) => {
    (a.readKeyframes(), a.needsMeasurement && (uc = !0));
  });
}
function dT() {
  ((oc = !0), lg(), ag(), (oc = !1));
}
class wc {
  constructor(l, u, r, c, d, h = !1) {
    ((this.state = "pending"),
      (this.isAsync = !1),
      (this.needsMeasurement = !1),
      (this.unresolvedKeyframes = [...l]),
      (this.onComplete = u),
      (this.name = r),
      (this.motionValue = c),
      (this.element = d),
      (this.isAsync = h));
  }
  scheduleResolve() {
    ((this.state = "scheduled"),
      this.isAsync
        ? (Si.add(this),
          sc || ((sc = !0), zt.read(lg), zt.resolveKeyframes(ag)))
        : (this.readKeyframes(), this.complete()));
  }
  readKeyframes() {
    const {
      unresolvedKeyframes: l,
      name: u,
      element: r,
      motionValue: c,
    } = this;
    if (l[0] === null) {
      const d = c?.get(),
        h = l[l.length - 1];
      if (d !== void 0) l[0] = d;
      else if (r && u) {
        const g = r.readValue(u, h);
        g != null && (l[0] = g);
      }
      (l[0] === void 0 && (l[0] = h), c && d === void 0 && c.set(l[0]));
    }
    lT(l);
  }
  setFinalKeyframe() {}
  measureInitialState() {}
  renderEndStyles() {}
  measureEndState() {}
  complete(l = !1) {
    ((this.state = "complete"),
      this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, l),
      Si.delete(this));
  }
  cancel() {
    this.state === "scheduled" && (Si.delete(this), (this.state = "pending"));
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const mT = (a) => a.startsWith("--");
function yT(a, l, u) {
  mT(l) ? a.style.setProperty(l, u) : (a.style[l] = u);
}
const pT = Cc(() => window.ScrollTimeline !== void 0),
  gT = {};
function vT(a, l) {
  const u = Cc(a);
  return () => gT[l] ?? u();
}
const sg = vT(() => {
    try {
      document
        .createElement("div")
        .animate({ opacity: 0 }, { easing: "linear(0, 1)" });
    } catch {
      return !1;
    }
    return !0;
  }, "linearEasing"),
  cl = ([a, l, u, r]) => `cubic-bezier(${a}, ${l}, ${u}, ${r})`,
  Ey = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: cl([0, 0.65, 0.55, 1]),
    circOut: cl([0.55, 0, 1, 0.45]),
    backIn: cl([0.31, 0.01, 0.66, -0.59]),
    backOut: cl([0.33, 1.53, 0.69, 0.99]),
  };
function ug(a, l) {
  if (a)
    return typeof a == "function"
      ? sg()
        ? eg(a, l)
        : "ease-out"
      : Qp(a)
        ? cl(a)
        : Array.isArray(a)
          ? a.map((u) => ug(u, l) || Ey.easeOut)
          : Ey[a];
}
function ST(
  a,
  l,
  u,
  {
    delay: r = 0,
    duration: c = 300,
    repeat: d = 0,
    repeatType: h = "loop",
    ease: g = "easeOut",
    times: p,
  } = {},
  y = void 0,
) {
  const v = { [l]: u };
  p && (v.offset = p);
  const S = ug(g, c);
  Array.isArray(S) && (v.easing = S);
  const E = {
    delay: r,
    duration: c,
    easing: Array.isArray(S) ? "linear" : S,
    fill: "both",
    iterations: d + 1,
    direction: h === "reverse" ? "alternate" : "normal",
  };
  return (y && (E.pseudoElement = y), a.animate(v, E));
}
function og(a) {
  return typeof a == "function" && "applyToOptions" in a;
}
function TT({ type: a, ...l }) {
  return og(a) && sg()
    ? a.applyToOptions(l)
    : (l.duration ?? (l.duration = 300), l.ease ?? (l.ease = "easeOut"), l);
}
class bT extends Lc {
  constructor(l) {
    if (
      (super(),
      (this.finishedTime = null),
      (this.isStopped = !1),
      (this.manualStartTime = null),
      !l)
    )
      return;
    const {
      element: u,
      name: r,
      keyframes: c,
      pseudoElement: d,
      allowFlatten: h = !1,
      finalKeyframe: g,
      onComplete: p,
    } = l;
    ((this.isPseudoElement = !!d),
      (this.allowFlatten = h),
      (this.options = l),
      Dc(typeof l.type != "string"));
    const y = TT(l);
    ((this.animation = ST(u, r, c, y, d)),
      y.autoplay === !1 && this.animation.pause(),
      (this.animation.onfinish = () => {
        if (((this.finishedTime = this.time), !d)) {
          const v = jc(c, this.options, g, this.speed);
          (this.updateMotionValue ? this.updateMotionValue(v) : yT(u, r, v),
            this.animation.cancel());
        }
        (p?.(), this.notifyFinished());
      }));
  }
  play() {
    this.isStopped ||
      ((this.manualStartTime = null),
      this.animation.play(),
      this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.finish?.();
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {}
  }
  stop() {
    if (this.isStopped) return;
    this.isStopped = !0;
    const { state: l } = this;
    l === "idle" ||
      l === "finished" ||
      (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(),
      this.isPseudoElement || this.cancel());
  }
  commitStyles() {
    this.isPseudoElement || this.animation.commitStyles?.();
  }
  get duration() {
    const l = this.animation.effect?.getComputedTiming?.().duration || 0;
    return He(Number(l));
  }
  get iterationDuration() {
    const { delay: l = 0 } = this.options || {};
    return this.duration + He(l);
  }
  get time() {
    return He(Number(this.animation.currentTime) || 0);
  }
  set time(l) {
    ((this.manualStartTime = null),
      (this.finishedTime = null),
      (this.animation.currentTime = gn(l)));
  }
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(l) {
    (l < 0 && (this.finishedTime = null), (this.animation.playbackRate = l));
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return this.manualStartTime ?? Number(this.animation.startTime);
  }
  set startTime(l) {
    this.manualStartTime = this.animation.startTime = l;
  }
  attachTimeline({ timeline: l, observe: u }) {
    return (
      this.allowFlatten &&
        this.animation.effect?.updateTiming({ easing: "linear" }),
      (this.animation.onfinish = null),
      l && pT() ? ((this.animation.timeline = l), we) : u(this)
    );
  }
}
const rg = { anticipate: Yp, backInOut: wp, circInOut: Gp };
function AT(a) {
  return a in rg;
}
function ET(a) {
  typeof a.ease == "string" && AT(a.ease) && (a.ease = rg[a.ease]);
}
const qr = 10;
class MT extends bT {
  constructor(l) {
    (ET(l),
      ig(l),
      super(l),
      l.startTime !== void 0 && (this.startTime = l.startTime),
      (this.options = l));
  }
  updateMotionValue(l) {
    const {
      motionValue: u,
      onUpdate: r,
      onComplete: c,
      element: d,
      ...h
    } = this.options;
    if (!u) return;
    if (l !== void 0) {
      u.set(l);
      return;
    }
    const g = new Hc({ ...h, autoplay: !1 }),
      p = Math.max(qr, le.now() - this.startTime),
      y = Pe(0, qr, p - qr);
    (u.setWithVelocity(
      g.sample(Math.max(0, p - y)).value,
      g.sample(p).value,
      y,
    ),
      g.stop());
  }
}
const My = (a, l) =>
  l === "zIndex"
    ? !1
    : !!(
        typeof a == "number" ||
        Array.isArray(a) ||
        (typeof a == "string" &&
          (Jn.test(a) || a === "0") &&
          !a.startsWith("url("))
      );
function xT(a) {
  const l = a[0];
  if (a.length === 1) return !0;
  for (let u = 0; u < a.length; u++) if (a[u] !== l) return !0;
}
function DT(a, l, u, r) {
  const c = a[0];
  if (c === null) return !1;
  if (l === "display" || l === "visibility") return !0;
  const d = a[a.length - 1],
    h = My(c, l),
    g = My(d, l);
  return !h || !g ? !1 : xT(a) || ((u === "spring" || og(u)) && r);
}
function rc(a) {
  ((a.duration = 0), (a.type = "keyframes"));
}
const CT = new Set(["opacity", "clipPath", "filter", "transform"]),
  zT = Cc(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function OT(a) {
  const {
    motionValue: l,
    name: u,
    repeatDelay: r,
    repeatType: c,
    damping: d,
    type: h,
  } = a;
  if (!(l?.owner?.current instanceof HTMLElement)) return !1;
  const { onUpdate: p, transformTemplate: y } = l.owner.getProps();
  return (
    zT() &&
    u &&
    CT.has(u) &&
    (u !== "transform" || !y) &&
    !p &&
    !r &&
    c !== "mirror" &&
    d !== 0 &&
    h !== "inertia"
  );
}
const RT = 40;
class VT extends Lc {
  constructor({
    autoplay: l = !0,
    delay: u = 0,
    type: r = "keyframes",
    repeat: c = 0,
    repeatDelay: d = 0,
    repeatType: h = "loop",
    keyframes: g,
    name: p,
    motionValue: y,
    element: v,
    ...S
  }) {
    (super(),
      (this.stop = () => {
        (this._animation && (this._animation.stop(), this.stopTimeline?.()),
          this.keyframeResolver?.cancel());
      }),
      (this.createdAt = le.now()));
    const E = {
        autoplay: l,
        delay: u,
        type: r,
        repeat: c,
        repeatDelay: d,
        repeatType: h,
        name: p,
        motionValue: y,
        element: v,
        ...S,
      },
      z = v?.KeyframeResolver || wc;
    ((this.keyframeResolver = new z(
      g,
      (_, j, Y) => this.onKeyframesResolved(_, j, E, !Y),
      p,
      y,
      v,
    )),
      this.keyframeResolver?.scheduleResolve());
  }
  onKeyframesResolved(l, u, r, c) {
    this.keyframeResolver = void 0;
    const {
      name: d,
      type: h,
      velocity: g,
      delay: p,
      isHandoff: y,
      onUpdate: v,
    } = r;
    ((this.resolvedAt = le.now()),
      DT(l, d, h, g) ||
        ((vn.instantAnimations || !p) && v?.(jc(l, r, u)),
        (l[0] = l[l.length - 1]),
        rc(r),
        (r.repeat = 0)));
    const E = {
        startTime: c
          ? this.resolvedAt
            ? this.resolvedAt - this.createdAt > RT
              ? this.resolvedAt
              : this.createdAt
            : this.createdAt
          : void 0,
        finalKeyframe: u,
        ...r,
        keyframes: l,
      },
      z = !y && OT(E),
      _ = E.motionValue?.owner?.current,
      j = z ? new MT({ ...E, element: _ }) : new Hc(E);
    (j.finished
      .then(() => {
        this.notifyFinished();
      })
      .catch(we),
      this.pendingTimeline &&
        ((this.stopTimeline = j.attachTimeline(this.pendingTimeline)),
        (this.pendingTimeline = void 0)),
      (this._animation = j));
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(l, u) {
    return this.finished.finally(l).then(() => {});
  }
  get animation() {
    return (
      this._animation || (this.keyframeResolver?.resume(), dT()),
      this._animation
    );
  }
  get duration() {
    return this.animation.duration;
  }
  get iterationDuration() {
    return this.animation.iterationDuration;
  }
  get time() {
    return this.animation.time;
  }
  set time(l) {
    this.animation.time = l;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(l) {
    this.animation.speed = l;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(l) {
    return (
      this._animation
        ? (this.stopTimeline = this.animation.attachTimeline(l))
        : (this.pendingTimeline = l),
      () => this.stop()
    );
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    (this._animation && this.animation.cancel(),
      this.keyframeResolver?.cancel());
  }
}
function cg(a, l, u, r = 0, c = 1) {
  const d = Array.from(a)
      .sort((y, v) => y.sortNodePosition(v))
      .indexOf(l),
    h = a.size,
    g = (h - 1) * r;
  return typeof u == "function" ? u(d, h) : c === 1 ? d * r : g - d * r;
}
const _T = /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function UT(a) {
  const l = _T.exec(a);
  if (!l) return [,];
  const [, u, r, c] = l;
  return [`--${u ?? r}`, c];
}
function fg(a, l, u = 1) {
  const [r, c] = UT(a);
  if (!r) return;
  const d = window.getComputedStyle(l).getPropertyValue(r);
  if (d) {
    const h = d.trim();
    return Vp(h) ? parseFloat(h) : h;
  }
  return Vc(c) ? fg(c, l, u + 1) : c;
}
const BT = { type: "spring", stiffness: 500, damping: 25, restSpeed: 10 },
  NT = (a) => ({
    type: "spring",
    stiffness: 550,
    damping: a === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10,
  }),
  jT = { type: "keyframes", duration: 0.8 },
  LT = { type: "keyframes", ease: [0.25, 0.1, 0.35, 1], duration: 0.3 },
  HT = (a, { keyframes: l }) =>
    l.length > 2
      ? jT
      : ha.has(a)
        ? a.startsWith("scale")
          ? NT(l[1])
          : BT
        : LT,
  wT = (a) => a !== null;
function YT(a, { repeat: l, repeatType: u = "loop" }, r) {
  const c = a.filter(wT),
    d = l && u !== "loop" && l % 2 === 1 ? 0 : c.length - 1;
  return c[d];
}
function Yc(a, l) {
  return a?.[l] ?? a?.default ?? a;
}
function qT({
  when: a,
  delay: l,
  delayChildren: u,
  staggerChildren: r,
  staggerDirection: c,
  repeat: d,
  repeatType: h,
  repeatDelay: g,
  from: p,
  elapsed: y,
  ...v
}) {
  return !!Object.keys(v).length;
}
const qc =
  (a, l, u, r = {}, c, d) =>
  (h) => {
    const g = Yc(r, a) || {},
      p = g.delay || r.delay || 0;
    let { elapsed: y = 0 } = r;
    y = y - gn(p);
    const v = {
      keyframes: Array.isArray(u) ? u : [null, u],
      ease: "easeOut",
      velocity: l.getVelocity(),
      ...g,
      delay: -y,
      onUpdate: (E) => {
        (l.set(E), g.onUpdate && g.onUpdate(E));
      },
      onComplete: () => {
        (h(), g.onComplete && g.onComplete());
      },
      name: a,
      motionValue: l,
      element: d ? void 0 : c,
    };
    (qT(g) || Object.assign(v, HT(a, v)),
      v.duration && (v.duration = gn(v.duration)),
      v.repeatDelay && (v.repeatDelay = gn(v.repeatDelay)),
      v.from !== void 0 && (v.keyframes[0] = v.from));
    let S = !1;
    if (
      ((v.type === !1 || (v.duration === 0 && !v.repeatDelay)) &&
        (rc(v), v.delay === 0 && (S = !0)),
      (vn.instantAnimations || vn.skipAnimations) &&
        ((S = !0), rc(v), (v.delay = 0)),
      (v.allowFlatten = !g.type && !g.ease),
      S && !d && l.get() !== void 0)
    ) {
      const E = YT(v.keyframes, g);
      if (E !== void 0) {
        zt.update(() => {
          (v.onUpdate(E), v.onComplete());
        });
        return;
      }
    }
    return g.isSync ? new Hc(v) : new VT(v);
  };
function xy(a) {
  const l = [{}, {}];
  return (
    a?.values.forEach((u, r) => {
      ((l[0][r] = u.get()), (l[1][r] = u.getVelocity()));
    }),
    l
  );
}
function Gc(a, l, u, r) {
  if (typeof l == "function") {
    const [c, d] = xy(r);
    l = l(u !== void 0 ? u : a.custom, c, d);
  }
  if (
    (typeof l == "string" && (l = a.variants && a.variants[l]),
    typeof l == "function")
  ) {
    const [c, d] = xy(r);
    l = l(u !== void 0 ? u : a.custom, c, d);
  }
  return l;
}
function oa(a, l, u) {
  const r = a.getProps();
  return Gc(r, l, u !== void 0 ? u : r.custom, a);
}
const hg = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    ...fa,
  ]),
  Dy = 30,
  GT = (a) => !isNaN(parseFloat(a));
class XT {
  constructor(l, u = {}) {
    ((this.canTrackVelocity = null),
      (this.events = {}),
      (this.updateAndNotify = (r) => {
        const c = le.now();
        if (
          (this.updatedAt !== c && this.setPrevFrameValue(),
          (this.prev = this.current),
          this.setCurrent(r),
          this.current !== this.prev &&
            (this.events.change?.notify(this.current), this.dependents))
        )
          for (const d of this.dependents) d.dirty();
      }),
      (this.hasAnimated = !1),
      this.setCurrent(l),
      (this.owner = u.owner));
  }
  setCurrent(l) {
    ((this.current = l),
      (this.updatedAt = le.now()),
      this.canTrackVelocity === null &&
        l !== void 0 &&
        (this.canTrackVelocity = GT(this.current)));
  }
  setPrevFrameValue(l = this.current) {
    ((this.prevFrameValue = l), (this.prevUpdatedAt = this.updatedAt));
  }
  onChange(l) {
    return this.on("change", l);
  }
  on(l, u) {
    this.events[l] || (this.events[l] = new zc());
    const r = this.events[l].add(u);
    return l === "change"
      ? () => {
          (r(),
            zt.read(() => {
              this.events.change.getSize() || this.stop();
            }));
        }
      : r;
  }
  clearListeners() {
    for (const l in this.events) this.events[l].clear();
  }
  attach(l, u) {
    ((this.passiveEffect = l), (this.stopPassiveEffect = u));
  }
  set(l) {
    this.passiveEffect
      ? this.passiveEffect(l, this.updateAndNotify)
      : this.updateAndNotify(l);
  }
  setWithVelocity(l, u, r) {
    (this.set(u),
      (this.prev = void 0),
      (this.prevFrameValue = l),
      (this.prevUpdatedAt = this.updatedAt - r));
  }
  jump(l, u = !0) {
    (this.updateAndNotify(l),
      (this.prev = l),
      (this.prevUpdatedAt = this.prevFrameValue = void 0),
      u && this.stop(),
      this.stopPassiveEffect && this.stopPassiveEffect());
  }
  dirty() {
    this.events.change?.notify(this.current);
  }
  addDependent(l) {
    (this.dependents || (this.dependents = new Set()), this.dependents.add(l));
  }
  removeDependent(l) {
    this.dependents && this.dependents.delete(l);
  }
  get() {
    return this.current;
  }
  getPrevious() {
    return this.prev;
  }
  getVelocity() {
    const l = le.now();
    if (
      !this.canTrackVelocity ||
      this.prevFrameValue === void 0 ||
      l - this.updatedAt > Dy
    )
      return 0;
    const u = Math.min(this.updatedAt - this.prevUpdatedAt, Dy);
    return Bp(parseFloat(this.current) - parseFloat(this.prevFrameValue), u);
  }
  start(l) {
    return (
      this.stop(),
      new Promise((u) => {
        ((this.hasAnimated = !0),
          (this.animation = l(u)),
          this.events.animationStart && this.events.animationStart.notify());
      }).then(() => {
        (this.events.animationComplete &&
          this.events.animationComplete.notify(),
          this.clearAnimation());
      })
    );
  }
  stop() {
    (this.animation &&
      (this.animation.stop(),
      this.events.animationCancel && this.events.animationCancel.notify()),
      this.clearAnimation());
  }
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  destroy() {
    (this.dependents?.clear(),
      this.events.destroy?.notify(),
      this.clearListeners(),
      this.stop(),
      this.stopPassiveEffect && this.stopPassiveEffect());
  }
}
function ra(a, l) {
  return new XT(a, l);
}
const cc = (a) => Array.isArray(a);
function QT(a, l, u) {
  a.hasValue(l) ? a.getValue(l).set(u) : a.addValue(l, ra(u));
}
function ZT(a) {
  return cc(a) ? a[a.length - 1] || 0 : a;
}
function KT(a, l) {
  const u = oa(a, l);
  let { transitionEnd: r = {}, transition: c = {}, ...d } = u || {};
  d = { ...d, ...r };
  for (const h in d) {
    const g = ZT(d[h]);
    QT(a, h, g);
  }
}
const ne = (a) => !!(a && a.getVelocity);
function JT(a) {
  return !!(ne(a) && a.add);
}
function fc(a, l) {
  const u = a.getValue("willChange");
  if (JT(u)) return u.add(l);
  if (!u && vn.WillChange) {
    const r = new vn.WillChange("auto");
    (a.addValue("willChange", r), r.add(l));
  }
}
function Xc(a) {
  return a.replace(/([A-Z])/g, (l) => `-${l.toLowerCase()}`);
}
const FT = "framerAppearId",
  dg = "data-" + Xc(FT);
function mg(a) {
  return a.props[dg];
}
function kT({ protectedKeys: a, needsAnimating: l }, u) {
  const r = a.hasOwnProperty(u) && l[u] !== !0;
  return ((l[u] = !1), r);
}
function yg(a, l, { delay: u = 0, transitionOverride: r, type: c } = {}) {
  let { transition: d = a.getDefaultTransition(), transitionEnd: h, ...g } = l;
  r && (d = r);
  const p = [],
    y = c && a.animationState && a.animationState.getState()[c];
  for (const v in g) {
    const S = a.getValue(v, a.latestValues[v] ?? null),
      E = g[v];
    if (E === void 0 || (y && kT(y, v))) continue;
    const z = { delay: u, ...Yc(d || {}, v) },
      _ = S.get();
    if (
      _ !== void 0 &&
      !S.isAnimating &&
      !Array.isArray(E) &&
      E === _ &&
      !z.velocity
    )
      continue;
    let j = !1;
    if (window.MotionHandoffAnimation) {
      const H = mg(a);
      if (H) {
        const q = window.MotionHandoffAnimation(H, v, zt);
        q !== null && ((z.startTime = q), (j = !0));
      }
    }
    (fc(a, v),
      S.start(
        qc(v, S, E, a.shouldReduceMotion && hg.has(v) ? { type: !1 } : z, a, j),
      ));
    const Y = S.animation;
    Y && p.push(Y);
  }
  return (
    h &&
      Promise.all(p).then(() => {
        zt.update(() => {
          h && KT(a, h);
        });
      }),
    p
  );
}
function hc(a, l, u = {}) {
  const r = oa(a, l, u.type === "exit" ? a.presenceContext?.custom : void 0);
  let { transition: c = a.getDefaultTransition() || {} } = r || {};
  u.transitionOverride && (c = u.transitionOverride);
  const d = r ? () => Promise.all(yg(a, r, u)) : () => Promise.resolve(),
    h =
      a.variantChildren && a.variantChildren.size
        ? (p = 0) => {
            const {
              delayChildren: y = 0,
              staggerChildren: v,
              staggerDirection: S,
            } = c;
            return WT(a, l, p, y, v, S, u);
          }
        : () => Promise.resolve(),
    { when: g } = c;
  if (g) {
    const [p, y] = g === "beforeChildren" ? [d, h] : [h, d];
    return p().then(() => y());
  } else return Promise.all([d(), h(u.delay)]);
}
function WT(a, l, u = 0, r = 0, c = 0, d = 1, h) {
  const g = [];
  for (const p of a.variantChildren)
    (p.notify("AnimationStart", l),
      g.push(
        hc(p, l, {
          ...h,
          delay:
            u +
            (typeof r == "function" ? 0 : r) +
            cg(a.variantChildren, p, r, c, d),
        }).then(() => p.notify("AnimationComplete", l)),
      ));
  return Promise.all(g);
}
function PT(a, l, u = {}) {
  a.notify("AnimationStart", l);
  let r;
  if (Array.isArray(l)) {
    const c = l.map((d) => hc(a, d, u));
    r = Promise.all(c);
  } else if (typeof l == "string") r = hc(a, l, u);
  else {
    const c = typeof l == "function" ? oa(a, l, u.custom) : l;
    r = Promise.all(yg(a, c, u));
  }
  return r.then(() => {
    a.notify("AnimationComplete", l);
  });
}
const $T = { test: (a) => a === "auto", parse: (a) => a },
  pg = (a) => (l) => l.test(a),
  gg = [ca, Z, We, Qn, xS, MS, $T],
  Cy = (a) => gg.find(pg(a));
function IT(a) {
  return typeof a == "number"
    ? a === 0
    : a !== null
      ? a === "none" || a === "0" || Up(a)
      : !0;
}
const tb = new Set(["brightness", "contrast", "saturate", "opacity"]);
function eb(a) {
  const [l, u] = a.slice(0, -1).split("(");
  if (l === "drop-shadow") return a;
  const [r] = u.match(_c) || [];
  if (!r) return a;
  const c = u.replace(r, "");
  let d = tb.has(l) ? 1 : 0;
  return (r !== u && (d *= 100), l + "(" + d + c + ")");
}
const nb = /\b([a-z-]*)\(.*?\)/gu,
  dc = {
    ...Jn,
    getAnimatableNone: (a) => {
      const l = a.match(nb);
      return l ? l.map(eb).join(" ") : a;
    },
  },
  zy = { ...ca, transform: Math.round },
  ib = {
    rotate: Qn,
    rotateX: Qn,
    rotateY: Qn,
    rotateZ: Qn,
    scale: Ks,
    scaleX: Ks,
    scaleY: Ks,
    scaleZ: Ks,
    skew: Qn,
    skewX: Qn,
    skewY: Qn,
    distance: Z,
    translateX: Z,
    translateY: Z,
    translateZ: Z,
    x: Z,
    y: Z,
    z: Z,
    perspective: Z,
    transformPerspective: Z,
    opacity: gl,
    originX: my,
    originY: my,
    originZ: Z,
  },
  Qc = {
    borderWidth: Z,
    borderTopWidth: Z,
    borderRightWidth: Z,
    borderBottomWidth: Z,
    borderLeftWidth: Z,
    borderRadius: Z,
    radius: Z,
    borderTopLeftRadius: Z,
    borderTopRightRadius: Z,
    borderBottomRightRadius: Z,
    borderBottomLeftRadius: Z,
    width: Z,
    maxWidth: Z,
    height: Z,
    maxHeight: Z,
    top: Z,
    right: Z,
    bottom: Z,
    left: Z,
    inset: Z,
    insetBlock: Z,
    insetBlockStart: Z,
    insetBlockEnd: Z,
    insetInline: Z,
    insetInlineStart: Z,
    insetInlineEnd: Z,
    padding: Z,
    paddingTop: Z,
    paddingRight: Z,
    paddingBottom: Z,
    paddingLeft: Z,
    paddingBlock: Z,
    paddingBlockStart: Z,
    paddingBlockEnd: Z,
    paddingInline: Z,
    paddingInlineStart: Z,
    paddingInlineEnd: Z,
    margin: Z,
    marginTop: Z,
    marginRight: Z,
    marginBottom: Z,
    marginLeft: Z,
    marginBlock: Z,
    marginBlockStart: Z,
    marginBlockEnd: Z,
    marginInline: Z,
    marginInlineStart: Z,
    marginInlineEnd: Z,
    backgroundPositionX: Z,
    backgroundPositionY: Z,
    ...ib,
    zIndex: zy,
    fillOpacity: gl,
    strokeOpacity: gl,
    numOctaves: zy,
  },
  ab = {
    ...Qc,
    color: Qt,
    backgroundColor: Qt,
    outlineColor: Qt,
    fill: Qt,
    stroke: Qt,
    borderColor: Qt,
    borderTopColor: Qt,
    borderRightColor: Qt,
    borderBottomColor: Qt,
    borderLeftColor: Qt,
    filter: dc,
    WebkitFilter: dc,
  },
  vg = (a) => ab[a];
function Sg(a, l) {
  let u = vg(a);
  return (
    u !== dc && (u = Jn),
    u.getAnimatableNone ? u.getAnimatableNone(l) : void 0
  );
}
const lb = new Set(["auto", "none", "0"]);
function sb(a, l, u) {
  let r = 0,
    c;
  for (; r < a.length && !c; ) {
    const d = a[r];
    (typeof d == "string" && !lb.has(d) && vl(d).values.length && (c = a[r]),
      r++);
  }
  if (c && u) for (const d of l) a[d] = Sg(u, c);
}
class ub extends wc {
  constructor(l, u, r, c, d) {
    super(l, u, r, c, d, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: l, element: u, name: r } = this;
    if (!u || !u.current) return;
    super.readKeyframes();
    for (let v = 0; v < l.length; v++) {
      let S = l[v];
      if (typeof S == "string" && ((S = S.trim()), Vc(S))) {
        const E = fg(S, u.current);
        (E !== void 0 && (l[v] = E),
          v === l.length - 1 && (this.finalKeyframe = S));
      }
    }
    if ((this.resolveNoneKeyframes(), !hg.has(r) || l.length !== 2)) return;
    const [c, d] = l,
      h = Cy(c),
      g = Cy(d),
      p = dy(c),
      y = dy(d);
    if (p !== y && Zn[r]) {
      this.needsMeasurement = !0;
      return;
    }
    if (h !== g)
      if (Ay(h) && Ay(g))
        for (let v = 0; v < l.length; v++) {
          const S = l[v];
          typeof S == "string" && (l[v] = parseFloat(S));
        }
      else Zn[r] && (this.needsMeasurement = !0);
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: l, name: u } = this,
      r = [];
    for (let c = 0; c < l.length; c++) (l[c] === null || IT(l[c])) && r.push(c);
    r.length && sb(l, r, u);
  }
  measureInitialState() {
    const { element: l, unresolvedKeyframes: u, name: r } = this;
    if (!l || !l.current) return;
    (r === "height" && (this.suspendedScrollY = window.pageYOffset),
      (this.measuredOrigin = Zn[r](
        l.measureViewportBox(),
        window.getComputedStyle(l.current),
      )),
      (u[0] = this.measuredOrigin));
    const c = u[u.length - 1];
    c !== void 0 && l.getValue(r, c).jump(c, !1);
  }
  measureEndState() {
    const { element: l, name: u, unresolvedKeyframes: r } = this;
    if (!l || !l.current) return;
    const c = l.getValue(u);
    c && c.jump(this.measuredOrigin, !1);
    const d = r.length - 1,
      h = r[d];
    ((r[d] = Zn[u](l.measureViewportBox(), window.getComputedStyle(l.current))),
      h !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = h),
      this.removedTransforms?.length &&
        this.removedTransforms.forEach(([g, p]) => {
          l.getValue(g).set(p);
        }),
      this.resolveNoneKeyframes());
  }
}
function ob(a, l, u) {
  if (a == null) return [];
  if (a instanceof EventTarget) return [a];
  if (typeof a == "string") {
    let r = document;
    const c = u?.[a] ?? r.querySelectorAll(a);
    return c ? Array.from(c) : [];
  }
  return Array.from(a).filter((r) => r != null);
}
const Tg = (a, l) => (l && typeof a == "number" ? l.transform(a) : a);
function mc(a) {
  return _p(a) && "offsetHeight" in a;
}
const { schedule: Zc } = Zp(queueMicrotask, !1),
  Ze = { x: !1, y: !1 };
function bg() {
  return Ze.x || Ze.y;
}
function rb(a) {
  return a === "x" || a === "y"
    ? Ze[a]
      ? null
      : ((Ze[a] = !0),
        () => {
          Ze[a] = !1;
        })
    : Ze.x || Ze.y
      ? null
      : ((Ze.x = Ze.y = !0),
        () => {
          Ze.x = Ze.y = !1;
        });
}
function Ag(a, l) {
  const u = ob(a),
    r = new AbortController(),
    c = { passive: !0, ...l, signal: r.signal };
  return [u, c, () => r.abort()];
}
function Oy(a) {
  return !(a.pointerType === "touch" || bg());
}
function cb(a, l, u = {}) {
  const [r, c, d] = Ag(a, u),
    h = (g) => {
      if (!Oy(g)) return;
      const { target: p } = g,
        y = l(p, g);
      if (typeof y != "function" || !p) return;
      const v = (S) => {
        Oy(S) && (y(S), p.removeEventListener("pointerleave", v));
      };
      p.addEventListener("pointerleave", v, c);
    };
  return (
    r.forEach((g) => {
      g.addEventListener("pointerenter", h, c);
    }),
    d
  );
}
const Eg = (a, l) => (l ? (a === l ? !0 : Eg(a, l.parentElement)) : !1),
  Kc = (a) =>
    a.pointerType === "mouse"
      ? typeof a.button != "number" || a.button <= 0
      : a.isPrimary !== !1,
  fb = new Set(["BUTTON", "INPUT", "SELECT", "TEXTAREA", "A"]);
function Mg(a) {
  return fb.has(a.tagName) || a.isContentEditable === !0;
}
const Ws = new WeakSet();
function Ry(a) {
  return (l) => {
    l.key === "Enter" && a(l);
  };
}
function Gr(a, l) {
  a.dispatchEvent(
    new PointerEvent("pointer" + l, { isPrimary: !0, bubbles: !0 }),
  );
}
const hb = (a, l) => {
  const u = a.currentTarget;
  if (!u) return;
  const r = Ry(() => {
    if (Ws.has(u)) return;
    Gr(u, "down");
    const c = Ry(() => {
        Gr(u, "up");
      }),
      d = () => Gr(u, "cancel");
    (u.addEventListener("keyup", c, l), u.addEventListener("blur", d, l));
  });
  (u.addEventListener("keydown", r, l),
    u.addEventListener("blur", () => u.removeEventListener("keydown", r), l));
};
function Vy(a) {
  return Kc(a) && !bg();
}
function db(a, l, u = {}) {
  const [r, c, d] = Ag(a, u),
    h = (g) => {
      const p = g.currentTarget;
      if (!Vy(g)) return;
      Ws.add(p);
      const y = l(p, g),
        v = (z, _) => {
          (window.removeEventListener("pointerup", S),
            window.removeEventListener("pointercancel", E),
            Ws.has(p) && Ws.delete(p),
            Vy(z) && typeof y == "function" && y(z, { success: _ }));
        },
        S = (z) => {
          v(
            z,
            p === window ||
              p === document ||
              u.useGlobalTarget ||
              Eg(p, z.target),
          );
        },
        E = (z) => {
          v(z, !1);
        };
      (window.addEventListener("pointerup", S, c),
        window.addEventListener("pointercancel", E, c));
    };
  return (
    r.forEach((g) => {
      ((u.useGlobalTarget ? window : g).addEventListener("pointerdown", h, c),
        mc(g) &&
          (g.addEventListener("focus", (y) => hb(y, c)),
          !Mg(g) && !g.hasAttribute("tabindex") && (g.tabIndex = 0)));
    }),
    d
  );
}
function xg(a) {
  return _p(a) && "ownerSVGElement" in a;
}
function mb(a) {
  return xg(a) && a.tagName === "svg";
}
const yb = [...gg, Qt, Jn],
  pb = (a) => yb.find(pg(a)),
  _y = () => ({ translate: 0, scale: 1, origin: 0, originPoint: 0 }),
  la = () => ({ x: _y(), y: _y() }),
  Uy = () => ({ min: 0, max: 0 }),
  Kt = () => ({ x: Uy(), y: Uy() }),
  yc = { current: null },
  Dg = { current: !1 },
  gb = typeof window < "u";
function vb() {
  if (((Dg.current = !0), !!gb))
    if (window.matchMedia) {
      const a = window.matchMedia("(prefers-reduced-motion)"),
        l = () => (yc.current = a.matches);
      (a.addEventListener("change", l), l());
    } else yc.current = !1;
}
const Sb = new WeakMap();
function uu(a) {
  return a !== null && typeof a == "object" && typeof a.start == "function";
}
function Sl(a) {
  return typeof a == "string" || Array.isArray(a);
}
const Jc = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit",
  ],
  Fc = ["initial", ...Jc];
function ou(a) {
  return uu(a.animate) || Fc.some((l) => Sl(a[l]));
}
function Cg(a) {
  return !!(ou(a) || a.variants);
}
function Tb(a, l, u) {
  for (const r in l) {
    const c = l[r],
      d = u[r];
    if (ne(c)) a.addValue(r, c);
    else if (ne(d)) a.addValue(r, ra(c, { owner: a }));
    else if (d !== c)
      if (a.hasValue(r)) {
        const h = a.getValue(r);
        h.liveStyle === !0 ? h.jump(c) : h.hasAnimated || h.set(c);
      } else {
        const h = a.getStaticValue(r);
        a.addValue(r, ra(h !== void 0 ? h : c, { owner: a }));
      }
  }
  for (const r in u) l[r] === void 0 && a.removeValue(r);
  return l;
}
const By = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete",
];
let nu = {};
function zg(a) {
  nu = a;
}
function bb() {
  return nu;
}
class Ab {
  scrapeMotionValuesFromProps(l, u, r) {
    return {};
  }
  constructor(
    {
      parent: l,
      props: u,
      presenceContext: r,
      reducedMotionConfig: c,
      blockInitialAnimation: d,
      visualState: h,
    },
    g = {},
  ) {
    ((this.current = null),
      (this.children = new Set()),
      (this.isVariantNode = !1),
      (this.isControllingVariants = !1),
      (this.shouldReduceMotion = null),
      (this.values = new Map()),
      (this.KeyframeResolver = wc),
      (this.features = {}),
      (this.valueSubscriptions = new Map()),
      (this.prevMotionValues = {}),
      (this.events = {}),
      (this.propEventSubscriptions = {}),
      (this.notifyUpdate = () => this.notify("Update", this.latestValues)),
      (this.render = () => {
        this.current &&
          (this.triggerBuild(),
          this.renderInstance(
            this.current,
            this.renderState,
            this.props.style,
            this.projection,
          ));
      }),
      (this.renderScheduledAt = 0),
      (this.scheduleRender = () => {
        const E = le.now();
        this.renderScheduledAt < E &&
          ((this.renderScheduledAt = E), zt.render(this.render, !1, !0));
      }));
    const { latestValues: p, renderState: y } = h;
    ((this.latestValues = p),
      (this.baseTarget = { ...p }),
      (this.initialValues = u.initial ? { ...p } : {}),
      (this.renderState = y),
      (this.parent = l),
      (this.props = u),
      (this.presenceContext = r),
      (this.depth = l ? l.depth + 1 : 0),
      (this.reducedMotionConfig = c),
      (this.options = g),
      (this.blockInitialAnimation = !!d),
      (this.isControllingVariants = ou(u)),
      (this.isVariantNode = Cg(u)),
      this.isVariantNode && (this.variantChildren = new Set()),
      (this.manuallyAnimateOnMount = !!(l && l.current)));
    const { willChange: v, ...S } = this.scrapeMotionValuesFromProps(
      u,
      {},
      this,
    );
    for (const E in S) {
      const z = S[E];
      p[E] !== void 0 && ne(z) && z.set(p[E]);
    }
  }
  mount(l) {
    ((this.current = l),
      Sb.set(l, this),
      this.projection && !this.projection.instance && this.projection.mount(l),
      this.parent &&
        this.isVariantNode &&
        !this.isControllingVariants &&
        (this.removeFromVariantTree = this.parent.addVariantChild(this)),
      this.values.forEach((u, r) => this.bindToMotionValue(r, u)),
      this.reducedMotionConfig === "never"
        ? (this.shouldReduceMotion = !1)
        : this.reducedMotionConfig === "always"
          ? (this.shouldReduceMotion = !0)
          : (Dg.current || vb(), (this.shouldReduceMotion = yc.current)),
      this.parent?.addChild(this),
      this.update(this.props, this.presenceContext));
  }
  unmount() {
    (this.projection && this.projection.unmount(),
      Kn(this.notifyUpdate),
      Kn(this.render),
      this.valueSubscriptions.forEach((l) => l()),
      this.valueSubscriptions.clear(),
      this.removeFromVariantTree && this.removeFromVariantTree(),
      this.parent?.removeChild(this));
    for (const l in this.events) this.events[l].clear();
    for (const l in this.features) {
      const u = this.features[l];
      u && (u.unmount(), (u.isMounted = !1));
    }
    this.current = null;
  }
  addChild(l) {
    (this.children.add(l),
      this.enteringChildren ?? (this.enteringChildren = new Set()),
      this.enteringChildren.add(l));
  }
  removeChild(l) {
    (this.children.delete(l),
      this.enteringChildren && this.enteringChildren.delete(l));
  }
  bindToMotionValue(l, u) {
    this.valueSubscriptions.has(l) && this.valueSubscriptions.get(l)();
    const r = ha.has(l);
    r && this.onBindTransform && this.onBindTransform();
    const c = u.on("change", (h) => {
      ((this.latestValues[l] = h),
        this.props.onUpdate && zt.preRender(this.notifyUpdate),
        r && this.projection && (this.projection.isTransformDirty = !0),
        this.scheduleRender());
    });
    let d;
    (typeof window < "u" &&
      window.MotionCheckAppearSync &&
      (d = window.MotionCheckAppearSync(this, l, u)),
      this.valueSubscriptions.set(l, () => {
        (c(), d && d(), u.owner && u.stop());
      }));
  }
  sortNodePosition(l) {
    return !this.current ||
      !this.sortInstanceNodePosition ||
      this.type !== l.type
      ? 0
      : this.sortInstanceNodePosition(this.current, l.current);
  }
  updateFeatures() {
    let l = "animation";
    for (l in nu) {
      const u = nu[l];
      if (!u) continue;
      const { isEnabled: r, Feature: c } = u;
      if (
        (!this.features[l] &&
          c &&
          r(this.props) &&
          (this.features[l] = new c(this)),
        this.features[l])
      ) {
        const d = this.features[l];
        d.isMounted ? d.update() : (d.mount(), (d.isMounted = !0));
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  measureViewportBox() {
    return this.current
      ? this.measureInstanceViewportBox(this.current, this.props)
      : Kt();
  }
  getStaticValue(l) {
    return this.latestValues[l];
  }
  setStaticValue(l, u) {
    this.latestValues[l] = u;
  }
  update(l, u) {
    ((l.transformTemplate || this.props.transformTemplate) &&
      this.scheduleRender(),
      (this.prevProps = this.props),
      (this.props = l),
      (this.prevPresenceContext = this.presenceContext),
      (this.presenceContext = u));
    for (let r = 0; r < By.length; r++) {
      const c = By[r];
      this.propEventSubscriptions[c] &&
        (this.propEventSubscriptions[c](),
        delete this.propEventSubscriptions[c]);
      const d = "on" + c,
        h = l[d];
      h && (this.propEventSubscriptions[c] = this.on(c, h));
    }
    ((this.prevMotionValues = Tb(
      this,
      this.scrapeMotionValuesFromProps(l, this.prevProps || {}, this),
      this.prevMotionValues,
    )),
      this.handleChildMotionValue && this.handleChildMotionValue());
  }
  getProps() {
    return this.props;
  }
  getVariant(l) {
    return this.props.variants ? this.props.variants[l] : void 0;
  }
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode
      ? this
      : this.parent
        ? this.parent.getClosestVariantNode()
        : void 0;
  }
  addVariantChild(l) {
    const u = this.getClosestVariantNode();
    if (u)
      return (
        u.variantChildren && u.variantChildren.add(l),
        () => u.variantChildren.delete(l)
      );
  }
  addValue(l, u) {
    const r = this.values.get(l);
    u !== r &&
      (r && this.removeValue(l),
      this.bindToMotionValue(l, u),
      this.values.set(l, u),
      (this.latestValues[l] = u.get()));
  }
  removeValue(l) {
    this.values.delete(l);
    const u = this.valueSubscriptions.get(l);
    (u && (u(), this.valueSubscriptions.delete(l)),
      delete this.latestValues[l],
      this.removeValueFromRenderState(l, this.renderState));
  }
  hasValue(l) {
    return this.values.has(l);
  }
  getValue(l, u) {
    if (this.props.values && this.props.values[l]) return this.props.values[l];
    let r = this.values.get(l);
    return (
      r === void 0 &&
        u !== void 0 &&
        ((r = ra(u === null ? void 0 : u, { owner: this })),
        this.addValue(l, r)),
      r
    );
  }
  readValue(l, u) {
    let r =
      this.latestValues[l] !== void 0 || !this.current
        ? this.latestValues[l]
        : (this.getBaseTargetFromProps(this.props, l) ??
          this.readValueFromInstance(this.current, l, this.options));
    return (
      r != null &&
        (typeof r == "string" && (Vp(r) || Up(r))
          ? (r = parseFloat(r))
          : !pb(r) && Jn.test(u) && (r = Sg(l, u)),
        this.setBaseTarget(l, ne(r) ? r.get() : r)),
      ne(r) ? r.get() : r
    );
  }
  setBaseTarget(l, u) {
    this.baseTarget[l] = u;
  }
  getBaseTarget(l) {
    const { initial: u } = this.props;
    let r;
    if (typeof u == "string" || typeof u == "object") {
      const d = Gc(this.props, u, this.presenceContext?.custom);
      d && (r = d[l]);
    }
    if (u && r !== void 0) return r;
    const c = this.getBaseTargetFromProps(this.props, l);
    return c !== void 0 && !ne(c)
      ? c
      : this.initialValues[l] !== void 0 && r === void 0
        ? void 0
        : this.baseTarget[l];
  }
  on(l, u) {
    return (
      this.events[l] || (this.events[l] = new zc()),
      this.events[l].add(u)
    );
  }
  notify(l, ...u) {
    this.events[l] && this.events[l].notify(...u);
  }
  scheduleRenderMicrotask() {
    Zc.render(this.render);
  }
}
class Og extends Ab {
  constructor() {
    (super(...arguments), (this.KeyframeResolver = ub));
  }
  sortInstanceNodePosition(l, u) {
    return l.compareDocumentPosition(u) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(l, u) {
    const r = l.style;
    return r ? r[u] : void 0;
  }
  removeValueFromRenderState(l, { vars: u, style: r }) {
    (delete u[l], delete r[l]);
  }
  handleChildMotionValue() {
    this.childSubscription &&
      (this.childSubscription(), delete this.childSubscription);
    const { children: l } = this.props;
    ne(l) &&
      (this.childSubscription = l.on("change", (u) => {
        this.current && (this.current.textContent = `${u}`);
      }));
  }
}
class Fn {
  constructor(l) {
    ((this.isMounted = !1), (this.node = l));
  }
  update() {}
}
function Rg({ top: a, left: l, right: u, bottom: r }) {
  return { x: { min: l, max: u }, y: { min: a, max: r } };
}
function Eb({ x: a, y: l }) {
  return { top: l.min, right: a.max, bottom: l.max, left: a.min };
}
function Mb(a, l) {
  if (!l) return a;
  const u = l({ x: a.left, y: a.top }),
    r = l({ x: a.right, y: a.bottom });
  return { top: u.y, left: u.x, bottom: r.y, right: r.x };
}
function Xr(a) {
  return a === void 0 || a === 1;
}
function pc({ scale: a, scaleX: l, scaleY: u }) {
  return !Xr(a) || !Xr(l) || !Xr(u);
}
function pi(a) {
  return (
    pc(a) ||
    Vg(a) ||
    a.z ||
    a.rotate ||
    a.rotateX ||
    a.rotateY ||
    a.skewX ||
    a.skewY
  );
}
function Vg(a) {
  return Ny(a.x) || Ny(a.y);
}
function Ny(a) {
  return a && a !== "0%";
}
function iu(a, l, u) {
  const r = a - u,
    c = l * r;
  return u + c;
}
function jy(a, l, u, r, c) {
  return (c !== void 0 && (a = iu(a, c, r)), iu(a, u, r) + l);
}
function gc(a, l = 0, u = 1, r, c) {
  ((a.min = jy(a.min, l, u, r, c)), (a.max = jy(a.max, l, u, r, c)));
}
function _g(a, { x: l, y: u }) {
  (gc(a.x, l.translate, l.scale, l.originPoint),
    gc(a.y, u.translate, u.scale, u.originPoint));
}
const Ly = 0.999999999999,
  Hy = 1.0000000000001;
function xb(a, l, u, r = !1) {
  const c = u.length;
  if (!c) return;
  l.x = l.y = 1;
  let d, h;
  for (let g = 0; g < c; g++) {
    ((d = u[g]), (h = d.projectionDelta));
    const { visualElement: p } = d.options;
    (p && p.props.style && p.props.style.display === "contents") ||
      (r &&
        d.options.layoutScroll &&
        d.scroll &&
        d !== d.root &&
        ua(a, { x: -d.scroll.offset.x, y: -d.scroll.offset.y }),
      h && ((l.x *= h.x.scale), (l.y *= h.y.scale), _g(a, h)),
      r && pi(d.latestValues) && ua(a, d.latestValues));
  }
  (l.x < Hy && l.x > Ly && (l.x = 1), l.y < Hy && l.y > Ly && (l.y = 1));
}
function sa(a, l) {
  ((a.min = a.min + l), (a.max = a.max + l));
}
function wy(a, l, u, r, c = 0.5) {
  const d = Rt(a.min, a.max, c);
  gc(a, l, u, d, r);
}
function ua(a, l) {
  (wy(a.x, l.x, l.scaleX, l.scale, l.originX),
    wy(a.y, l.y, l.scaleY, l.scale, l.originY));
}
function Ug(a, l) {
  return Rg(Mb(a.getBoundingClientRect(), l));
}
function Db(a, l, u) {
  const r = Ug(a, u),
    { scroll: c } = l;
  return (c && (sa(r.x, c.offset.x), sa(r.y, c.offset.y)), r);
}
const Cb = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective",
  },
  zb = fa.length;
function Ob(a, l, u) {
  let r = "",
    c = !0;
  for (let d = 0; d < zb; d++) {
    const h = fa[d],
      g = a[h];
    if (g === void 0) continue;
    let p = !0;
    if (
      (typeof g == "number"
        ? (p = g === (h.startsWith("scale") ? 1 : 0))
        : (p = parseFloat(g) === 0),
      !p || u)
    ) {
      const y = Tg(g, Qc[h]);
      if (!p) {
        c = !1;
        const v = Cb[h] || h;
        r += `${v}(${y}) `;
      }
      u && (l[h] = y);
    }
  }
  return ((r = r.trim()), u ? (r = u(l, c ? "" : r)) : c && (r = "none"), r);
}
function kc(a, l, u) {
  const { style: r, vars: c, transformOrigin: d } = a;
  let h = !1,
    g = !1;
  for (const p in l) {
    const y = l[p];
    if (ha.has(p)) {
      h = !0;
      continue;
    } else if (Jp(p)) {
      c[p] = y;
      continue;
    } else {
      const v = Tg(y, Qc[p]);
      p.startsWith("origin") ? ((g = !0), (d[p] = v)) : (r[p] = v);
    }
  }
  if (
    (l.transform ||
      (h || u
        ? (r.transform = Ob(l, a.transform, u))
        : r.transform && (r.transform = "none")),
    g)
  ) {
    const { originX: p = "50%", originY: y = "50%", originZ: v = 0 } = d;
    r.transformOrigin = `${p} ${y} ${v}`;
  }
}
function Bg(a, { style: l, vars: u }, r, c) {
  const d = a.style;
  let h;
  for (h in l) d[h] = l[h];
  c?.applyProjectionStyles(d, r);
  for (h in u) d.setProperty(h, u[h]);
}
function Yy(a, l) {
  return l.max === l.min ? 0 : (a / (l.max - l.min)) * 100;
}
const rl = {
    correct: (a, l) => {
      if (!l.target) return a;
      if (typeof a == "string")
        if (Z.test(a)) a = parseFloat(a);
        else return a;
      const u = Yy(a, l.target.x),
        r = Yy(a, l.target.y);
      return `${u}% ${r}%`;
    },
  },
  Rb = {
    correct: (a, { treeScale: l, projectionDelta: u }) => {
      const r = a,
        c = Jn.parse(a);
      if (c.length > 5) return r;
      const d = Jn.createTransformer(a),
        h = typeof c[0] != "number" ? 1 : 0,
        g = u.x.scale * l.x,
        p = u.y.scale * l.y;
      ((c[0 + h] /= g), (c[1 + h] /= p));
      const y = Rt(g, p, 0.5);
      return (
        typeof c[2 + h] == "number" && (c[2 + h] /= y),
        typeof c[3 + h] == "number" && (c[3 + h] /= y),
        d(c)
      );
    },
  },
  vc = {
    borderRadius: {
      ...rl,
      applyTo: [
        "borderTopLeftRadius",
        "borderTopRightRadius",
        "borderBottomLeftRadius",
        "borderBottomRightRadius",
      ],
    },
    borderTopLeftRadius: rl,
    borderTopRightRadius: rl,
    borderBottomLeftRadius: rl,
    borderBottomRightRadius: rl,
    boxShadow: Rb,
  };
function Ng(a, { layout: l, layoutId: u }) {
  return (
    ha.has(a) ||
    a.startsWith("origin") ||
    ((l || u !== void 0) && (!!vc[a] || a === "opacity"))
  );
}
function Wc(a, l, u) {
  const r = a.style,
    c = l?.style,
    d = {};
  if (!r) return d;
  for (const h in r)
    (ne(r[h]) ||
      (c && ne(c[h])) ||
      Ng(h, a) ||
      u?.getValue(h)?.liveStyle !== void 0) &&
      (d[h] = r[h]);
  return d;
}
function Vb(a) {
  return window.getComputedStyle(a);
}
class _b extends Og {
  constructor() {
    (super(...arguments), (this.type = "html"), (this.renderInstance = Bg));
  }
  readValueFromInstance(l, u) {
    if (ha.has(u)) return this.projection?.isProjecting ? ac(u) : oT(l, u);
    {
      const r = Vb(l),
        c = (Jp(u) ? r.getPropertyValue(u) : r[u]) || 0;
      return typeof c == "string" ? c.trim() : c;
    }
  }
  measureInstanceViewportBox(l, { transformPagePoint: u }) {
    return Ug(l, u);
  }
  build(l, u, r) {
    kc(l, u, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(l, u, r) {
    return Wc(l, u, r);
  }
}
const Ub = { offset: "stroke-dashoffset", array: "stroke-dasharray" },
  Bb = { offset: "strokeDashoffset", array: "strokeDasharray" };
function Nb(a, l, u = 1, r = 0, c = !0) {
  a.pathLength = 1;
  const d = c ? Ub : Bb;
  ((a[d.offset] = `${-r}`), (a[d.array] = `${l} ${u}`));
}
const jb = ["offsetDistance", "offsetPath", "offsetRotate", "offsetAnchor"];
function jg(
  a,
  {
    attrX: l,
    attrY: u,
    attrScale: r,
    pathLength: c,
    pathSpacing: d = 1,
    pathOffset: h = 0,
    ...g
  },
  p,
  y,
  v,
) {
  if ((kc(a, g, y), p)) {
    a.style.viewBox && (a.attrs.viewBox = a.style.viewBox);
    return;
  }
  ((a.attrs = a.style), (a.style = {}));
  const { attrs: S, style: E } = a;
  (S.transform && ((E.transform = S.transform), delete S.transform),
    (E.transform || S.transformOrigin) &&
      ((E.transformOrigin = S.transformOrigin ?? "50% 50%"),
      delete S.transformOrigin),
    E.transform &&
      ((E.transformBox = v?.transformBox ?? "fill-box"),
      delete S.transformBox));
  for (const z of jb) S[z] !== void 0 && ((E[z] = S[z]), delete S[z]);
  (l !== void 0 && (S.x = l),
    u !== void 0 && (S.y = u),
    r !== void 0 && (S.scale = r),
    c !== void 0 && Nb(S, c, d, h, !1));
}
const Lg = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust",
  ]),
  Hg = (a) => typeof a == "string" && a.toLowerCase() === "svg";
function Lb(a, l, u, r) {
  Bg(a, l, void 0, r);
  for (const c in l.attrs) a.setAttribute(Lg.has(c) ? c : Xc(c), l.attrs[c]);
}
function wg(a, l, u) {
  const r = Wc(a, l, u);
  for (const c in a)
    if (ne(a[c]) || ne(l[c])) {
      const d =
        fa.indexOf(c) !== -1
          ? "attr" + c.charAt(0).toUpperCase() + c.substring(1)
          : c;
      r[d] = a[c];
    }
  return r;
}
class Hb extends Og {
  constructor() {
    (super(...arguments),
      (this.type = "svg"),
      (this.isSVGTag = !1),
      (this.measureInstanceViewportBox = Kt));
  }
  getBaseTargetFromProps(l, u) {
    return l[u];
  }
  readValueFromInstance(l, u) {
    if (ha.has(u)) {
      const r = vg(u);
      return (r && r.default) || 0;
    }
    return ((u = Lg.has(u) ? u : Xc(u)), l.getAttribute(u));
  }
  scrapeMotionValuesFromProps(l, u, r) {
    return wg(l, u, r);
  }
  build(l, u, r) {
    jg(l, u, this.isSVGTag, r.transformTemplate, r.style);
  }
  renderInstance(l, u, r, c) {
    Lb(l, u, r, c);
  }
  mount(l) {
    ((this.isSVGTag = Hg(l.tagName)), super.mount(l));
  }
}
const wb = Fc.length;
function Yg(a) {
  if (!a) return;
  if (!a.isControllingVariants) {
    const u = a.parent ? Yg(a.parent) || {} : {};
    return (a.props.initial !== void 0 && (u.initial = a.props.initial), u);
  }
  const l = {};
  for (let u = 0; u < wb; u++) {
    const r = Fc[u],
      c = a.props[r];
    (Sl(c) || c === !1) && (l[r] = c);
  }
  return l;
}
function qg(a, l) {
  if (!Array.isArray(l)) return !1;
  const u = l.length;
  if (u !== a.length) return !1;
  for (let r = 0; r < u; r++) if (l[r] !== a[r]) return !1;
  return !0;
}
const Yb = [...Jc].reverse(),
  qb = Jc.length;
function Gb(a) {
  return (l) =>
    Promise.all(l.map(({ animation: u, options: r }) => PT(a, u, r)));
}
function Xb(a) {
  let l = Gb(a),
    u = qy(),
    r = !0;
  const c = (p) => (y, v) => {
    const S = oa(a, v, p === "exit" ? a.presenceContext?.custom : void 0);
    if (S) {
      const { transition: E, transitionEnd: z, ..._ } = S;
      y = { ...y, ..._, ...z };
    }
    return y;
  };
  function d(p) {
    l = p(a);
  }
  function h(p) {
    const { props: y } = a,
      v = Yg(a.parent) || {},
      S = [],
      E = new Set();
    let z = {},
      _ = 1 / 0;
    for (let Y = 0; Y < qb; Y++) {
      const H = Yb[Y],
        q = u[H],
        L = y[H] !== void 0 ? y[H] : v[H],
        W = Sl(L),
        P = H === p ? q.isActive : null;
      P === !1 && (_ = Y);
      let et = L === v[H] && L !== y[H] && W;
      if (
        (et && r && a.manuallyAnimateOnMount && (et = !1),
        (q.protectedKeys = { ...z }),
        (!q.isActive && P === null) ||
          (!L && !q.prevProp) ||
          uu(L) ||
          typeof L == "boolean")
      )
        continue;
      const $ = Qb(q.prevProp, L);
      let K = $ || (H === p && q.isActive && !et && W) || (Y > _ && W),
        it = !1;
      const xt = Array.isArray(L) ? L : [L];
      let Bt = xt.reduce(c(H), {});
      P === !1 && (Bt = {});
      const { prevResolvedValues: wt = {} } = q,
        Ye = { ...wt, ...Bt },
        De = (w) => {
          ((K = !0),
            E.has(w) && ((it = !0), E.delete(w)),
            (q.needsAnimating[w] = !0));
          const F = a.getValue(w);
          F && (F.liveStyle = !1);
        };
      for (const w in Ye) {
        const F = Bt[w],
          ct = wt[w];
        if (z.hasOwnProperty(w)) continue;
        let mt = !1;
        (cc(F) && cc(ct) ? (mt = !qg(F, ct)) : (mt = F !== ct),
          mt
            ? F != null
              ? De(w)
              : E.add(w)
            : F !== void 0 && E.has(w)
              ? De(w)
              : (q.protectedKeys[w] = !0));
      }
      ((q.prevProp = L),
        (q.prevResolvedValues = Bt),
        q.isActive && (z = { ...z, ...Bt }),
        r && a.blockInitialAnimation && (K = !1));
      const ue = et && $;
      K &&
        (!ue || it) &&
        S.push(
          ...xt.map((w) => {
            const F = { type: H };
            if (
              typeof w == "string" &&
              r &&
              !ue &&
              a.manuallyAnimateOnMount &&
              a.parent
            ) {
              const { parent: ct } = a,
                mt = oa(ct, w);
              if (ct.enteringChildren && mt) {
                const { delayChildren: A } = mt.transition || {};
                F.delay = cg(ct.enteringChildren, a, A);
              }
            }
            return { animation: w, options: F };
          }),
        );
    }
    if (E.size) {
      const Y = {};
      if (typeof y.initial != "boolean") {
        const H = oa(a, Array.isArray(y.initial) ? y.initial[0] : y.initial);
        H && H.transition && (Y.transition = H.transition);
      }
      (E.forEach((H) => {
        const q = a.getBaseTarget(H),
          L = a.getValue(H);
        (L && (L.liveStyle = !0), (Y[H] = q ?? null));
      }),
        S.push({ animation: Y }));
    }
    let j = !!S.length;
    return (
      r &&
        (y.initial === !1 || y.initial === y.animate) &&
        !a.manuallyAnimateOnMount &&
        (j = !1),
      (r = !1),
      j ? l(S) : Promise.resolve()
    );
  }
  function g(p, y) {
    if (u[p].isActive === y) return Promise.resolve();
    (a.variantChildren?.forEach((S) => S.animationState?.setActive(p, y)),
      (u[p].isActive = y));
    const v = h(p);
    for (const S in u) u[S].protectedKeys = {};
    return v;
  }
  return {
    animateChanges: h,
    setActive: g,
    setAnimateFunction: d,
    getState: () => u,
    reset: () => {
      u = qy();
    },
  };
}
function Qb(a, l) {
  return typeof l == "string" ? l !== a : Array.isArray(l) ? !qg(l, a) : !1;
}
function yi(a = !1) {
  return {
    isActive: a,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {},
  };
}
function qy() {
  return {
    animate: yi(!0),
    whileInView: yi(),
    whileHover: yi(),
    whileTap: yi(),
    whileDrag: yi(),
    whileFocus: yi(),
    exit: yi(),
  };
}
function Gy(a, l) {
  ((a.min = l.min), (a.max = l.max));
}
function Qe(a, l) {
  (Gy(a.x, l.x), Gy(a.y, l.y));
}
function Xy(a, l) {
  ((a.translate = l.translate),
    (a.scale = l.scale),
    (a.originPoint = l.originPoint),
    (a.origin = l.origin));
}
const Gg = 1e-4,
  Zb = 1 - Gg,
  Kb = 1 + Gg,
  Xg = 0.01,
  Jb = 0 - Xg,
  Fb = 0 + Xg;
function se(a) {
  return a.max - a.min;
}
function kb(a, l, u) {
  return Math.abs(a - l) <= u;
}
function Qy(a, l, u, r = 0.5) {
  ((a.origin = r),
    (a.originPoint = Rt(l.min, l.max, a.origin)),
    (a.scale = se(u) / se(l)),
    (a.translate = Rt(u.min, u.max, a.origin) - a.originPoint),
    ((a.scale >= Zb && a.scale <= Kb) || isNaN(a.scale)) && (a.scale = 1),
    ((a.translate >= Jb && a.translate <= Fb) || isNaN(a.translate)) &&
      (a.translate = 0));
}
function ml(a, l, u, r) {
  (Qy(a.x, l.x, u.x, r ? r.originX : void 0),
    Qy(a.y, l.y, u.y, r ? r.originY : void 0));
}
function Zy(a, l, u) {
  ((a.min = u.min + l.min), (a.max = a.min + se(l)));
}
function Wb(a, l, u) {
  (Zy(a.x, l.x, u.x), Zy(a.y, l.y, u.y));
}
function Ky(a, l, u) {
  ((a.min = l.min - u.min), (a.max = a.min + se(l)));
}
function au(a, l, u) {
  (Ky(a.x, l.x, u.x), Ky(a.y, l.y, u.y));
}
function Jy(a, l, u, r, c) {
  return (
    (a -= l),
    (a = iu(a, 1 / u, r)),
    c !== void 0 && (a = iu(a, 1 / c, r)),
    a
  );
}
function Pb(a, l = 0, u = 1, r = 0.5, c, d = a, h = a) {
  if (
    (We.test(l) &&
      ((l = parseFloat(l)), (l = Rt(h.min, h.max, l / 100) - h.min)),
    typeof l != "number")
  )
    return;
  let g = Rt(d.min, d.max, r);
  (a === d && (g -= l),
    (a.min = Jy(a.min, l, u, g, c)),
    (a.max = Jy(a.max, l, u, g, c)));
}
function Fy(a, l, [u, r, c], d, h) {
  Pb(a, l[u], l[r], l[c], l.scale, d, h);
}
const $b = ["x", "scaleX", "originX"],
  Ib = ["y", "scaleY", "originY"];
function ky(a, l, u, r) {
  (Fy(a.x, l, $b, u ? u.x : void 0, r ? r.x : void 0),
    Fy(a.y, l, Ib, u ? u.y : void 0, r ? r.y : void 0));
}
function Wy(a) {
  return a.translate === 0 && a.scale === 1;
}
function Qg(a) {
  return Wy(a.x) && Wy(a.y);
}
function Py(a, l) {
  return a.min === l.min && a.max === l.max;
}
function tA(a, l) {
  return Py(a.x, l.x) && Py(a.y, l.y);
}
function $y(a, l) {
  return (
    Math.round(a.min) === Math.round(l.min) &&
    Math.round(a.max) === Math.round(l.max)
  );
}
function Zg(a, l) {
  return $y(a.x, l.x) && $y(a.y, l.y);
}
function Iy(a) {
  return se(a.x) / se(a.y);
}
function tp(a, l) {
  return (
    a.translate === l.translate &&
    a.scale === l.scale &&
    a.originPoint === l.originPoint
  );
}
function Le(a) {
  return [a("x"), a("y")];
}
function eA(a, l, u) {
  let r = "";
  const c = a.x.translate / l.x,
    d = a.y.translate / l.y,
    h = u?.z || 0;
  if (
    ((c || d || h) && (r = `translate3d(${c}px, ${d}px, ${h}px) `),
    (l.x !== 1 || l.y !== 1) && (r += `scale(${1 / l.x}, ${1 / l.y}) `),
    u)
  ) {
    const {
      transformPerspective: y,
      rotate: v,
      rotateX: S,
      rotateY: E,
      skewX: z,
      skewY: _,
    } = u;
    (y && (r = `perspective(${y}px) ${r}`),
      v && (r += `rotate(${v}deg) `),
      S && (r += `rotateX(${S}deg) `),
      E && (r += `rotateY(${E}deg) `),
      z && (r += `skewX(${z}deg) `),
      _ && (r += `skewY(${_}deg) `));
  }
  const g = a.x.scale * l.x,
    p = a.y.scale * l.y;
  return ((g !== 1 || p !== 1) && (r += `scale(${g}, ${p})`), r || "none");
}
const Kg = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"],
  nA = Kg.length,
  ep = (a) => (typeof a == "string" ? parseFloat(a) : a),
  np = (a) => typeof a == "number" || Z.test(a);
function iA(a, l, u, r, c, d) {
  c
    ? ((a.opacity = Rt(0, u.opacity ?? 1, aA(r))),
      (a.opacityExit = Rt(l.opacity ?? 1, 0, lA(r))))
    : d && (a.opacity = Rt(l.opacity ?? 1, u.opacity ?? 1, r));
  for (let h = 0; h < nA; h++) {
    const g = `border${Kg[h]}Radius`;
    let p = ip(l, g),
      y = ip(u, g);
    if (p === void 0 && y === void 0) continue;
    (p || (p = 0),
      y || (y = 0),
      p === 0 || y === 0 || np(p) === np(y)
        ? ((a[g] = Math.max(Rt(ep(p), ep(y), r), 0)),
          (We.test(y) || We.test(p)) && (a[g] += "%"))
        : (a[g] = y));
  }
  (l.rotate || u.rotate) && (a.rotate = Rt(l.rotate || 0, u.rotate || 0, r));
}
function ip(a, l) {
  return a[l] !== void 0 ? a[l] : a.borderRadius;
}
const aA = Jg(0, 0.5, qp),
  lA = Jg(0.5, 0.95, we);
function Jg(a, l, u) {
  return (r) => (r < a ? 0 : r > l ? 1 : u(pl(a, l, r)));
}
function sA(a, l, u) {
  const r = ne(a) ? a : ra(a);
  return (r.start(qc("", r, l, u)), r.animation);
}
function Tl(a, l, u, r = { passive: !0 }) {
  return (a.addEventListener(l, u, r), () => a.removeEventListener(l, u));
}
const uA = (a, l) => a.depth - l.depth;
class oA {
  constructor() {
    ((this.children = []), (this.isDirty = !1));
  }
  add(l) {
    (Mc(this.children, l), (this.isDirty = !0));
  }
  remove(l) {
    (xc(this.children, l), (this.isDirty = !0));
  }
  forEach(l) {
    (this.isDirty && this.children.sort(uA),
      (this.isDirty = !1),
      this.children.forEach(l));
  }
}
function rA(a, l) {
  const u = le.now(),
    r = ({ timestamp: c }) => {
      const d = c - u;
      d >= l && (Kn(r), a(d - l));
    };
  return (zt.setup(r, !0), () => Kn(r));
}
function Ps(a) {
  return ne(a) ? a.get() : a;
}
class cA {
  constructor() {
    this.members = [];
  }
  add(l) {
    (Mc(this.members, l), l.scheduleRender());
  }
  remove(l) {
    if (
      (xc(this.members, l),
      l === this.prevLead && (this.prevLead = void 0),
      l === this.lead)
    ) {
      const u = this.members[this.members.length - 1];
      u && this.promote(u);
    }
  }
  relegate(l) {
    const u = this.members.findIndex((c) => l === c);
    if (u === 0) return !1;
    let r;
    for (let c = u; c >= 0; c--) {
      const d = this.members[c];
      if (d.isPresent !== !1) {
        r = d;
        break;
      }
    }
    return r ? (this.promote(r), !0) : !1;
  }
  promote(l, u) {
    const r = this.lead;
    if (l !== r && ((this.prevLead = r), (this.lead = l), l.show(), r)) {
      (r.instance && r.scheduleRender(),
        l.scheduleRender(),
        (l.resumeFrom = r),
        u && (l.resumeFrom.preserveOpacity = !0),
        r.snapshot &&
          ((l.snapshot = r.snapshot),
          (l.snapshot.latestValues = r.animationValues || r.latestValues)),
        l.root && l.root.isUpdating && (l.isLayoutDirty = !0));
      const { crossfade: c } = l.options;
      c === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((l) => {
      const { options: u, resumingFrom: r } = l;
      (u.onExitComplete && u.onExitComplete(),
        r && r.options.onExitComplete && r.options.onExitComplete());
    });
  }
  scheduleRender() {
    this.members.forEach((l) => {
      l.instance && l.scheduleRender(!1);
    });
  }
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
const $s = { hasAnimatedSinceResize: !0, hasEverUpdated: !1 },
  Qr = ["", "X", "Y", "Z"],
  fA = 1e3;
let hA = 0;
function Zr(a, l, u, r) {
  const { latestValues: c } = l;
  c[a] && ((u[a] = c[a]), l.setStaticValue(a, 0), r && (r[a] = 0));
}
function Fg(a) {
  if (((a.hasCheckedOptimisedAppear = !0), a.root === a)) return;
  const { visualElement: l } = a.options;
  if (!l) return;
  const u = mg(l);
  if (window.MotionHasOptimisedAnimation(u, "transform")) {
    const { layout: c, layoutId: d } = a.options;
    window.MotionCancelOptimisedAnimation(u, "transform", zt, !(c || d));
  }
  const { parent: r } = a;
  r && !r.hasCheckedOptimisedAppear && Fg(r);
}
function kg({
  attachResizeListener: a,
  defaultParent: l,
  measureScroll: u,
  checkIsScrollRoot: r,
  resetTransform: c,
}) {
  return class {
    constructor(h = {}, g = l?.()) {
      ((this.id = hA++),
        (this.animationId = 0),
        (this.animationCommitId = 0),
        (this.children = new Set()),
        (this.options = {}),
        (this.isTreeAnimating = !1),
        (this.isAnimationBlocked = !1),
        (this.isLayoutDirty = !1),
        (this.isProjectionDirty = !1),
        (this.isSharedProjectionDirty = !1),
        (this.isTransformDirty = !1),
        (this.updateManuallyBlocked = !1),
        (this.updateBlockedByResize = !1),
        (this.isUpdating = !1),
        (this.isSVG = !1),
        (this.needsReset = !1),
        (this.shouldResetTransform = !1),
        (this.hasCheckedOptimisedAppear = !1),
        (this.treeScale = { x: 1, y: 1 }),
        (this.eventHandlers = new Map()),
        (this.hasTreeAnimated = !1),
        (this.layoutVersion = 0),
        (this.updateScheduled = !1),
        (this.scheduleUpdate = () => this.update()),
        (this.projectionUpdateScheduled = !1),
        (this.checkUpdateFailed = () => {
          this.isUpdating && ((this.isUpdating = !1), this.clearAllSnapshots());
        }),
        (this.updateProjection = () => {
          ((this.projectionUpdateScheduled = !1),
            this.nodes.forEach(yA),
            this.nodes.forEach(SA),
            this.nodes.forEach(TA),
            this.nodes.forEach(pA));
        }),
        (this.resolvedRelativeTargetAt = 0),
        (this.linkedParentVersion = 0),
        (this.hasProjected = !1),
        (this.isVisible = !0),
        (this.animationProgress = 0),
        (this.sharedNodes = new Map()),
        (this.latestValues = h),
        (this.root = g ? g.root || g : this),
        (this.path = g ? [...g.path, g] : []),
        (this.parent = g),
        (this.depth = g ? g.depth + 1 : 0));
      for (let p = 0; p < this.path.length; p++)
        this.path[p].shouldResetTransform = !0;
      this.root === this && (this.nodes = new oA());
    }
    addEventListener(h, g) {
      return (
        this.eventHandlers.has(h) || this.eventHandlers.set(h, new zc()),
        this.eventHandlers.get(h).add(g)
      );
    }
    notifyListeners(h, ...g) {
      const p = this.eventHandlers.get(h);
      p && p.notify(...g);
    }
    hasListeners(h) {
      return this.eventHandlers.has(h);
    }
    mount(h) {
      if (this.instance) return;
      ((this.isSVG = xg(h) && !mb(h)), (this.instance = h));
      const { layoutId: g, layout: p, visualElement: y } = this.options;
      if (
        (y && !y.current && y.mount(h),
        this.root.nodes.add(this),
        this.parent && this.parent.children.add(this),
        this.root.hasTreeAnimated && (p || g) && (this.isLayoutDirty = !0),
        a)
      ) {
        let v,
          S = 0;
        const E = () => (this.root.updateBlockedByResize = !1);
        (zt.read(() => {
          S = window.innerWidth;
        }),
          a(h, () => {
            const z = window.innerWidth;
            z !== S &&
              ((S = z),
              (this.root.updateBlockedByResize = !0),
              v && v(),
              (v = rA(E, 250)),
              $s.hasAnimatedSinceResize &&
                (($s.hasAnimatedSinceResize = !1), this.nodes.forEach(sp)));
          }));
      }
      (g && this.root.registerSharedNode(g, this),
        this.options.animate !== !1 &&
          y &&
          (g || p) &&
          this.addEventListener(
            "didUpdate",
            ({
              delta: v,
              hasLayoutChanged: S,
              hasRelativeLayoutChanged: E,
              layout: z,
            }) => {
              if (this.isTreeAnimationBlocked()) {
                ((this.target = void 0), (this.relativeTarget = void 0));
                return;
              }
              const _ =
                  this.options.transition || y.getDefaultTransition() || xA,
                { onLayoutAnimationStart: j, onLayoutAnimationComplete: Y } =
                  y.getProps(),
                H = !this.targetLayout || !Zg(this.targetLayout, z),
                q = !S && E;
              if (
                this.options.layoutRoot ||
                this.resumeFrom ||
                q ||
                (S && (H || !this.currentAnimation))
              ) {
                this.resumeFrom &&
                  ((this.resumingFrom = this.resumeFrom),
                  (this.resumingFrom.resumingFrom = void 0));
                const L = { ...Yc(_, "layout"), onPlay: j, onComplete: Y };
                ((y.shouldReduceMotion || this.options.layoutRoot) &&
                  ((L.delay = 0), (L.type = !1)),
                  this.startAnimation(L),
                  this.setAnimationOrigin(v, q));
              } else
                (S || sp(this),
                  this.isLead() &&
                    this.options.onExitComplete &&
                    this.options.onExitComplete());
              this.targetLayout = z;
            },
          ));
    }
    unmount() {
      (this.options.layoutId && this.willUpdate(),
        this.root.nodes.remove(this));
      const h = this.getStack();
      (h && h.remove(this),
        this.parent && this.parent.children.delete(this),
        (this.instance = void 0),
        this.eventHandlers.clear(),
        Kn(this.updateProjection));
    }
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return (
        this.isAnimationBlocked ||
        (this.parent && this.parent.isTreeAnimationBlocked()) ||
        !1
      );
    }
    startUpdate() {
      this.isUpdateBlocked() ||
        ((this.isUpdating = !0),
        this.nodes && this.nodes.forEach(bA),
        this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: h } = this.options;
      return h && h.getProps().transformTemplate;
    }
    willUpdate(h = !0) {
      if (((this.root.hasTreeAnimated = !0), this.root.isUpdateBlocked())) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (
        (window.MotionCancelOptimisedAnimation &&
          !this.hasCheckedOptimisedAppear &&
          Fg(this),
        !this.root.isUpdating && this.root.startUpdate(),
        this.isLayoutDirty)
      )
        return;
      this.isLayoutDirty = !0;
      for (let v = 0; v < this.path.length; v++) {
        const S = this.path[v];
        ((S.shouldResetTransform = !0),
          S.updateScroll("snapshot"),
          S.options.layoutRoot && S.willUpdate(!1));
      }
      const { layoutId: g, layout: p } = this.options;
      if (g === void 0 && !p) return;
      const y = this.getTransformTemplate();
      ((this.prevTransformTemplateValue = y
        ? y(this.latestValues, "")
        : void 0),
        this.updateSnapshot(),
        h && this.notifyListeners("willUpdate"));
    }
    update() {
      if (((this.updateScheduled = !1), this.isUpdateBlocked())) {
        (this.unblockUpdate(),
          this.clearAllSnapshots(),
          this.nodes.forEach(ap));
        return;
      }
      if (this.animationId <= this.animationCommitId) {
        this.nodes.forEach(lp);
        return;
      }
      ((this.animationCommitId = this.animationId),
        this.isUpdating
          ? ((this.isUpdating = !1),
            this.nodes.forEach(vA),
            this.nodes.forEach(dA),
            this.nodes.forEach(mA))
          : this.nodes.forEach(lp),
        this.clearAllSnapshots());
      const g = le.now();
      ((te.delta = Pe(0, 1e3 / 60, g - te.timestamp)),
        (te.timestamp = g),
        (te.isProcessing = !0),
        jr.update.process(te),
        jr.preRender.process(te),
        jr.render.process(te),
        (te.isProcessing = !1));
    }
    didUpdate() {
      this.updateScheduled ||
        ((this.updateScheduled = !0), Zc.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      (this.nodes.forEach(gA), this.sharedNodes.forEach(AA));
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled ||
        ((this.projectionUpdateScheduled = !0),
        zt.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      zt.postRender(() => {
        this.isLayoutDirty
          ? this.root.didUpdate()
          : this.root.checkUpdateFailed();
      });
    }
    updateSnapshot() {
      this.snapshot ||
        !this.instance ||
        ((this.snapshot = this.measure()),
        this.snapshot &&
          !se(this.snapshot.measuredBox.x) &&
          !se(this.snapshot.measuredBox.y) &&
          (this.snapshot = void 0));
    }
    updateLayout() {
      if (
        !this.instance ||
        (this.updateScroll(),
        !(this.options.alwaysMeasureLayout && this.isLead()) &&
          !this.isLayoutDirty)
      )
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let p = 0; p < this.path.length; p++) this.path[p].updateScroll();
      const h = this.layout;
      ((this.layout = this.measure(!1)),
        this.layoutVersion++,
        (this.layoutCorrected = Kt()),
        (this.isLayoutDirty = !1),
        (this.projectionDelta = void 0),
        this.notifyListeners("measure", this.layout.layoutBox));
      const { visualElement: g } = this.options;
      g &&
        g.notify(
          "LayoutMeasure",
          this.layout.layoutBox,
          h ? h.layoutBox : void 0,
        );
    }
    updateScroll(h = "measure") {
      let g = !!(this.options.layoutScroll && this.instance);
      if (
        (this.scroll &&
          this.scroll.animationId === this.root.animationId &&
          this.scroll.phase === h &&
          (g = !1),
        g && this.instance)
      ) {
        const p = r(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: h,
          isRoot: p,
          offset: u(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : p,
        };
      }
    }
    resetTransform() {
      if (!c) return;
      const h =
          this.isLayoutDirty ||
          this.shouldResetTransform ||
          this.options.alwaysMeasureLayout,
        g = this.projectionDelta && !Qg(this.projectionDelta),
        p = this.getTransformTemplate(),
        y = p ? p(this.latestValues, "") : void 0,
        v = y !== this.prevTransformTemplateValue;
      h &&
        this.instance &&
        (g || pi(this.latestValues) || v) &&
        (c(this.instance, y),
        (this.shouldResetTransform = !1),
        this.scheduleRender());
    }
    measure(h = !0) {
      const g = this.measurePageBox();
      let p = this.removeElementScroll(g);
      return (
        h && (p = this.removeTransform(p)),
        DA(p),
        {
          animationId: this.root.animationId,
          measuredBox: g,
          layoutBox: p,
          latestValues: {},
          source: this.id,
        }
      );
    }
    measurePageBox() {
      const { visualElement: h } = this.options;
      if (!h) return Kt();
      const g = h.measureViewportBox();
      if (!(this.scroll?.wasRoot || this.path.some(CA))) {
        const { scroll: y } = this.root;
        y && (sa(g.x, y.offset.x), sa(g.y, y.offset.y));
      }
      return g;
    }
    removeElementScroll(h) {
      const g = Kt();
      if ((Qe(g, h), this.scroll?.wasRoot)) return g;
      for (let p = 0; p < this.path.length; p++) {
        const y = this.path[p],
          { scroll: v, options: S } = y;
        y !== this.root &&
          v &&
          S.layoutScroll &&
          (v.wasRoot && Qe(g, h), sa(g.x, v.offset.x), sa(g.y, v.offset.y));
      }
      return g;
    }
    applyTransform(h, g = !1) {
      const p = Kt();
      Qe(p, h);
      for (let y = 0; y < this.path.length; y++) {
        const v = this.path[y];
        (!g &&
          v.options.layoutScroll &&
          v.scroll &&
          v !== v.root &&
          ua(p, { x: -v.scroll.offset.x, y: -v.scroll.offset.y }),
          pi(v.latestValues) && ua(p, v.latestValues));
      }
      return (pi(this.latestValues) && ua(p, this.latestValues), p);
    }
    removeTransform(h) {
      const g = Kt();
      Qe(g, h);
      for (let p = 0; p < this.path.length; p++) {
        const y = this.path[p];
        if (!y.instance || !pi(y.latestValues)) continue;
        pc(y.latestValues) && y.updateSnapshot();
        const v = Kt(),
          S = y.measurePageBox();
        (Qe(v, S),
          ky(g, y.latestValues, y.snapshot ? y.snapshot.layoutBox : void 0, v));
      }
      return (pi(this.latestValues) && ky(g, this.latestValues), g);
    }
    setTargetDelta(h) {
      ((this.targetDelta = h),
        this.root.scheduleUpdateProjection(),
        (this.isProjectionDirty = !0));
    }
    setOptions(h) {
      this.options = {
        ...this.options,
        ...h,
        crossfade: h.crossfade !== void 0 ? h.crossfade : !0,
      };
    }
    clearMeasurements() {
      ((this.scroll = void 0),
        (this.layout = void 0),
        (this.snapshot = void 0),
        (this.prevTransformTemplateValue = void 0),
        (this.targetDelta = void 0),
        (this.target = void 0),
        (this.isLayoutDirty = !1));
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent &&
        this.relativeParent.resolvedRelativeTargetAt !== te.timestamp &&
        this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(h = !1) {
      const g = this.getLead();
      (this.isProjectionDirty || (this.isProjectionDirty = g.isProjectionDirty),
        this.isTransformDirty || (this.isTransformDirty = g.isTransformDirty),
        this.isSharedProjectionDirty ||
          (this.isSharedProjectionDirty = g.isSharedProjectionDirty));
      const p = !!this.resumingFrom || this !== g;
      if (
        !(
          h ||
          (p && this.isSharedProjectionDirty) ||
          this.isProjectionDirty ||
          this.parent?.isProjectionDirty ||
          this.attemptToResolveRelativeTarget ||
          this.root.updateBlockedByResize
        )
      )
        return;
      const { layout: v, layoutId: S } = this.options;
      if (!this.layout || !(v || S)) return;
      this.resolvedRelativeTargetAt = te.timestamp;
      const E = this.getClosestProjectingParent();
      (E &&
        this.linkedParentVersion !== E.layoutVersion &&
        !E.options.layoutRoot &&
        this.removeRelativeTarget(),
        !this.targetDelta &&
          !this.relativeTarget &&
          (E && E.layout
            ? this.createRelativeTarget(
                E,
                this.layout.layoutBox,
                E.layout.layoutBox,
              )
            : this.removeRelativeTarget()),
        !(!this.relativeTarget && !this.targetDelta) &&
          (this.target ||
            ((this.target = Kt()), (this.targetWithTransforms = Kt())),
          this.relativeTarget &&
          this.relativeTargetOrigin &&
          this.relativeParent &&
          this.relativeParent.target
            ? (this.forceRelativeParentToResolveTarget(),
              Wb(this.target, this.relativeTarget, this.relativeParent.target))
            : this.targetDelta
              ? (this.resumingFrom
                  ? (this.target = this.applyTransform(this.layout.layoutBox))
                  : Qe(this.target, this.layout.layoutBox),
                _g(this.target, this.targetDelta))
              : Qe(this.target, this.layout.layoutBox),
          this.attemptToResolveRelativeTarget &&
            ((this.attemptToResolveRelativeTarget = !1),
            E &&
            !!E.resumingFrom == !!this.resumingFrom &&
            !E.options.layoutScroll &&
            E.target &&
            this.animationProgress !== 1
              ? this.createRelativeTarget(E, this.target, E.target)
              : (this.relativeParent = this.relativeTarget = void 0))));
    }
    getClosestProjectingParent() {
      if (
        !(
          !this.parent ||
          pc(this.parent.latestValues) ||
          Vg(this.parent.latestValues)
        )
      )
        return this.parent.isProjecting()
          ? this.parent
          : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!(
        (this.relativeTarget || this.targetDelta || this.options.layoutRoot) &&
        this.layout
      );
    }
    createRelativeTarget(h, g, p) {
      ((this.relativeParent = h),
        (this.linkedParentVersion = h.layoutVersion),
        this.forceRelativeParentToResolveTarget(),
        (this.relativeTarget = Kt()),
        (this.relativeTargetOrigin = Kt()),
        au(this.relativeTargetOrigin, g, p),
        Qe(this.relativeTarget, this.relativeTargetOrigin));
    }
    removeRelativeTarget() {
      this.relativeParent = this.relativeTarget = void 0;
    }
    calcProjection() {
      const h = this.getLead(),
        g = !!this.resumingFrom || this !== h;
      let p = !0;
      if (
        ((this.isProjectionDirty || this.parent?.isProjectionDirty) && (p = !1),
        g &&
          (this.isSharedProjectionDirty || this.isTransformDirty) &&
          (p = !1),
        this.resolvedRelativeTargetAt === te.timestamp && (p = !1),
        p)
      )
        return;
      const { layout: y, layoutId: v } = this.options;
      if (
        ((this.isTreeAnimating = !!(
          (this.parent && this.parent.isTreeAnimating) ||
          this.currentAnimation ||
          this.pendingAnimation
        )),
        this.isTreeAnimating ||
          (this.targetDelta = this.relativeTarget = void 0),
        !this.layout || !(y || v))
      )
        return;
      Qe(this.layoutCorrected, this.layout.layoutBox);
      const S = this.treeScale.x,
        E = this.treeScale.y;
      (xb(this.layoutCorrected, this.treeScale, this.path, g),
        h.layout &&
          !h.target &&
          (this.treeScale.x !== 1 || this.treeScale.y !== 1) &&
          ((h.target = h.layout.layoutBox), (h.targetWithTransforms = Kt())));
      const { target: z } = h;
      if (!z) {
        this.prevProjectionDelta &&
          (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      (!this.projectionDelta || !this.prevProjectionDelta
        ? this.createProjectionDeltas()
        : (Xy(this.prevProjectionDelta.x, this.projectionDelta.x),
          Xy(this.prevProjectionDelta.y, this.projectionDelta.y)),
        ml(this.projectionDelta, this.layoutCorrected, z, this.latestValues),
        (this.treeScale.x !== S ||
          this.treeScale.y !== E ||
          !tp(this.projectionDelta.x, this.prevProjectionDelta.x) ||
          !tp(this.projectionDelta.y, this.prevProjectionDelta.y)) &&
          ((this.hasProjected = !0),
          this.scheduleRender(),
          this.notifyListeners("projectionUpdate", z)));
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(h = !0) {
      if ((this.options.visualElement?.scheduleRender(), h)) {
        const g = this.getStack();
        g && g.scheduleRender();
      }
      this.resumingFrom &&
        !this.resumingFrom.instance &&
        (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      ((this.prevProjectionDelta = la()),
        (this.projectionDelta = la()),
        (this.projectionDeltaWithTransform = la()));
    }
    setAnimationOrigin(h, g = !1) {
      const p = this.snapshot,
        y = p ? p.latestValues : {},
        v = { ...this.latestValues },
        S = la();
      ((!this.relativeParent || !this.relativeParent.options.layoutRoot) &&
        (this.relativeTarget = this.relativeTargetOrigin = void 0),
        (this.attemptToResolveRelativeTarget = !g));
      const E = Kt(),
        z = p ? p.source : void 0,
        _ = this.layout ? this.layout.source : void 0,
        j = z !== _,
        Y = this.getStack(),
        H = !Y || Y.members.length <= 1,
        q = !!(j && !H && this.options.crossfade === !0 && !this.path.some(MA));
      this.animationProgress = 0;
      let L;
      ((this.mixTargetDelta = (W) => {
        const P = W / 1e3;
        (up(S.x, h.x, P),
          up(S.y, h.y, P),
          this.setTargetDelta(S),
          this.relativeTarget &&
            this.relativeTargetOrigin &&
            this.layout &&
            this.relativeParent &&
            this.relativeParent.layout &&
            (au(E, this.layout.layoutBox, this.relativeParent.layout.layoutBox),
            EA(this.relativeTarget, this.relativeTargetOrigin, E, P),
            L && tA(this.relativeTarget, L) && (this.isProjectionDirty = !1),
            L || (L = Kt()),
            Qe(L, this.relativeTarget)),
          j &&
            ((this.animationValues = v), iA(v, y, this.latestValues, P, q, H)),
          this.root.scheduleUpdateProjection(),
          this.scheduleRender(),
          (this.animationProgress = P));
      }),
        this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0));
    }
    startAnimation(h) {
      (this.notifyListeners("animationStart"),
        this.currentAnimation?.stop(),
        this.resumingFrom?.currentAnimation?.stop(),
        this.pendingAnimation &&
          (Kn(this.pendingAnimation), (this.pendingAnimation = void 0)),
        (this.pendingAnimation = zt.update(() => {
          (($s.hasAnimatedSinceResize = !0),
            this.motionValue || (this.motionValue = ra(0)),
            (this.currentAnimation = sA(this.motionValue, [0, 1e3], {
              ...h,
              velocity: 0,
              isSync: !0,
              onUpdate: (g) => {
                (this.mixTargetDelta(g), h.onUpdate && h.onUpdate(g));
              },
              onStop: () => {},
              onComplete: () => {
                (h.onComplete && h.onComplete(), this.completeAnimation());
              },
            })),
            this.resumingFrom &&
              (this.resumingFrom.currentAnimation = this.currentAnimation),
            (this.pendingAnimation = void 0));
        })));
    }
    completeAnimation() {
      this.resumingFrom &&
        ((this.resumingFrom.currentAnimation = void 0),
        (this.resumingFrom.preserveOpacity = void 0));
      const h = this.getStack();
      (h && h.exitAnimationComplete(),
        (this.resumingFrom =
          this.currentAnimation =
          this.animationValues =
            void 0),
        this.notifyListeners("animationComplete"));
    }
    finishAnimation() {
      (this.currentAnimation &&
        (this.mixTargetDelta && this.mixTargetDelta(fA),
        this.currentAnimation.stop()),
        this.completeAnimation());
    }
    applyTransformsToTarget() {
      const h = this.getLead();
      let {
        targetWithTransforms: g,
        target: p,
        layout: y,
        latestValues: v,
      } = h;
      if (!(!g || !p || !y)) {
        if (
          this !== h &&
          this.layout &&
          y &&
          Wg(this.options.animationType, this.layout.layoutBox, y.layoutBox)
        ) {
          p = this.target || Kt();
          const S = se(this.layout.layoutBox.x);
          ((p.x.min = h.target.x.min), (p.x.max = p.x.min + S));
          const E = se(this.layout.layoutBox.y);
          ((p.y.min = h.target.y.min), (p.y.max = p.y.min + E));
        }
        (Qe(g, p),
          ua(g, v),
          ml(this.projectionDeltaWithTransform, this.layoutCorrected, g, v));
      }
    }
    registerSharedNode(h, g) {
      (this.sharedNodes.has(h) || this.sharedNodes.set(h, new cA()),
        this.sharedNodes.get(h).add(g));
      const y = g.options.initialPromotionConfig;
      g.promote({
        transition: y ? y.transition : void 0,
        preserveFollowOpacity:
          y && y.shouldPreserveFollowOpacity
            ? y.shouldPreserveFollowOpacity(g)
            : void 0,
      });
    }
    isLead() {
      const h = this.getStack();
      return h ? h.lead === this : !0;
    }
    getLead() {
      const { layoutId: h } = this.options;
      return h ? this.getStack()?.lead || this : this;
    }
    getPrevLead() {
      const { layoutId: h } = this.options;
      return h ? this.getStack()?.prevLead : void 0;
    }
    getStack() {
      const { layoutId: h } = this.options;
      if (h) return this.root.sharedNodes.get(h);
    }
    promote({ needsReset: h, transition: g, preserveFollowOpacity: p } = {}) {
      const y = this.getStack();
      (y && y.promote(this, p),
        h && ((this.projectionDelta = void 0), (this.needsReset = !0)),
        g && this.setOptions({ transition: g }));
    }
    relegate() {
      const h = this.getStack();
      return h ? h.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: h } = this.options;
      if (!h) return;
      let g = !1;
      const { latestValues: p } = h;
      if (
        ((p.z ||
          p.rotate ||
          p.rotateX ||
          p.rotateY ||
          p.rotateZ ||
          p.skewX ||
          p.skewY) &&
          (g = !0),
        !g)
      )
        return;
      const y = {};
      p.z && Zr("z", h, y, this.animationValues);
      for (let v = 0; v < Qr.length; v++)
        (Zr(`rotate${Qr[v]}`, h, y, this.animationValues),
          Zr(`skew${Qr[v]}`, h, y, this.animationValues));
      h.render();
      for (const v in y)
        (h.setStaticValue(v, y[v]),
          this.animationValues && (this.animationValues[v] = y[v]));
      h.scheduleRender();
    }
    applyProjectionStyles(h, g) {
      if (!this.instance || this.isSVG) return;
      if (!this.isVisible) {
        h.visibility = "hidden";
        return;
      }
      const p = this.getTransformTemplate();
      if (this.needsReset) {
        ((this.needsReset = !1),
          (h.visibility = ""),
          (h.opacity = ""),
          (h.pointerEvents = Ps(g?.pointerEvents) || ""),
          (h.transform = p ? p(this.latestValues, "") : "none"));
        return;
      }
      const y = this.getLead();
      if (!this.projectionDelta || !this.layout || !y.target) {
        (this.options.layoutId &&
          ((h.opacity =
            this.latestValues.opacity !== void 0
              ? this.latestValues.opacity
              : 1),
          (h.pointerEvents = Ps(g?.pointerEvents) || "")),
          this.hasProjected &&
            !pi(this.latestValues) &&
            ((h.transform = p ? p({}, "") : "none"), (this.hasProjected = !1)));
        return;
      }
      h.visibility = "";
      const v = y.animationValues || y.latestValues;
      this.applyTransformsToTarget();
      let S = eA(this.projectionDeltaWithTransform, this.treeScale, v);
      (p && (S = p(v, S)), (h.transform = S));
      const { x: E, y: z } = this.projectionDelta;
      ((h.transformOrigin = `${E.origin * 100}% ${z.origin * 100}% 0`),
        y.animationValues
          ? (h.opacity =
              y === this
                ? (v.opacity ?? this.latestValues.opacity ?? 1)
                : this.preserveOpacity
                  ? this.latestValues.opacity
                  : v.opacityExit)
          : (h.opacity =
              y === this
                ? v.opacity !== void 0
                  ? v.opacity
                  : ""
                : v.opacityExit !== void 0
                  ? v.opacityExit
                  : 0));
      for (const _ in vc) {
        if (v[_] === void 0) continue;
        const { correct: j, applyTo: Y, isCSSVariable: H } = vc[_],
          q = S === "none" ? v[_] : j(v[_], y);
        if (Y) {
          const L = Y.length;
          for (let W = 0; W < L; W++) h[Y[W]] = q;
        } else
          H ? (this.options.visualElement.renderState.vars[_] = q) : (h[_] = q);
      }
      this.options.layoutId &&
        (h.pointerEvents = y === this ? Ps(g?.pointerEvents) || "" : "none");
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    resetTree() {
      (this.root.nodes.forEach((h) => h.currentAnimation?.stop()),
        this.root.nodes.forEach(ap),
        this.root.sharedNodes.clear());
    }
  };
}
function dA(a) {
  a.updateLayout();
}
function mA(a) {
  const l = a.resumeFrom?.snapshot || a.snapshot;
  if (a.isLead() && a.layout && l && a.hasListeners("didUpdate")) {
    const { layoutBox: u, measuredBox: r } = a.layout,
      { animationType: c } = a.options,
      d = l.source !== a.layout.source;
    c === "size"
      ? Le((v) => {
          const S = d ? l.measuredBox[v] : l.layoutBox[v],
            E = se(S);
          ((S.min = u[v].min), (S.max = S.min + E));
        })
      : Wg(c, l.layoutBox, u) &&
        Le((v) => {
          const S = d ? l.measuredBox[v] : l.layoutBox[v],
            E = se(u[v]);
          ((S.max = S.min + E),
            a.relativeTarget &&
              !a.currentAnimation &&
              ((a.isProjectionDirty = !0),
              (a.relativeTarget[v].max = a.relativeTarget[v].min + E)));
        });
    const h = la();
    ml(h, u, l.layoutBox);
    const g = la();
    d ? ml(g, a.applyTransform(r, !0), l.measuredBox) : ml(g, u, l.layoutBox);
    const p = !Qg(h);
    let y = !1;
    if (!a.resumeFrom) {
      const v = a.getClosestProjectingParent();
      if (v && !v.resumeFrom) {
        const { snapshot: S, layout: E } = v;
        if (S && E) {
          const z = Kt();
          au(z, l.layoutBox, S.layoutBox);
          const _ = Kt();
          (au(_, u, E.layoutBox),
            Zg(z, _) || (y = !0),
            v.options.layoutRoot &&
              ((a.relativeTarget = _),
              (a.relativeTargetOrigin = z),
              (a.relativeParent = v)));
        }
      }
    }
    a.notifyListeners("didUpdate", {
      layout: u,
      snapshot: l,
      delta: g,
      layoutDelta: h,
      hasLayoutChanged: p,
      hasRelativeLayoutChanged: y,
    });
  } else if (a.isLead()) {
    const { onExitComplete: u } = a.options;
    u && u();
  }
  a.options.transition = void 0;
}
function yA(a) {
  a.parent &&
    (a.isProjecting() || (a.isProjectionDirty = a.parent.isProjectionDirty),
    a.isSharedProjectionDirty ||
      (a.isSharedProjectionDirty = !!(
        a.isProjectionDirty ||
        a.parent.isProjectionDirty ||
        a.parent.isSharedProjectionDirty
      )),
    a.isTransformDirty || (a.isTransformDirty = a.parent.isTransformDirty));
}
function pA(a) {
  a.isProjectionDirty = a.isSharedProjectionDirty = a.isTransformDirty = !1;
}
function gA(a) {
  a.clearSnapshot();
}
function ap(a) {
  a.clearMeasurements();
}
function lp(a) {
  a.isLayoutDirty = !1;
}
function vA(a) {
  const { visualElement: l } = a.options;
  (l && l.getProps().onBeforeLayoutMeasure && l.notify("BeforeLayoutMeasure"),
    a.resetTransform());
}
function sp(a) {
  (a.finishAnimation(),
    (a.targetDelta = a.relativeTarget = a.target = void 0),
    (a.isProjectionDirty = !0));
}
function SA(a) {
  a.resolveTargetDelta();
}
function TA(a) {
  a.calcProjection();
}
function bA(a) {
  a.resetSkewAndRotation();
}
function AA(a) {
  a.removeLeadSnapshot();
}
function up(a, l, u) {
  ((a.translate = Rt(l.translate, 0, u)),
    (a.scale = Rt(l.scale, 1, u)),
    (a.origin = l.origin),
    (a.originPoint = l.originPoint));
}
function op(a, l, u, r) {
  ((a.min = Rt(l.min, u.min, r)), (a.max = Rt(l.max, u.max, r)));
}
function EA(a, l, u, r) {
  (op(a.x, l.x, u.x, r), op(a.y, l.y, u.y, r));
}
function MA(a) {
  return a.animationValues && a.animationValues.opacityExit !== void 0;
}
const xA = { duration: 0.45, ease: [0.4, 0, 0.1, 1] },
  rp = (a) =>
    typeof navigator < "u" &&
    navigator.userAgent &&
    navigator.userAgent.toLowerCase().includes(a),
  cp = rp("applewebkit/") && !rp("chrome/") ? Math.round : we;
function fp(a) {
  ((a.min = cp(a.min)), (a.max = cp(a.max)));
}
function DA(a) {
  (fp(a.x), fp(a.y));
}
function Wg(a, l, u) {
  return (
    a === "position" || (a === "preserve-aspect" && !kb(Iy(l), Iy(u), 0.2))
  );
}
function CA(a) {
  return a !== a.root && a.scroll?.wasRoot;
}
const zA = kg({
    attachResizeListener: (a, l) => Tl(a, "resize", l),
    measureScroll: () => ({
      x: document.documentElement.scrollLeft || document.body?.scrollLeft || 0,
      y: document.documentElement.scrollTop || document.body?.scrollTop || 0,
    }),
    checkIsScrollRoot: () => !0,
  }),
  Kr = { current: void 0 },
  Pg = kg({
    measureScroll: (a) => ({ x: a.scrollLeft, y: a.scrollTop }),
    defaultParent: () => {
      if (!Kr.current) {
        const a = new zA({});
        (a.mount(window), a.setOptions({ layoutScroll: !0 }), (Kr.current = a));
      }
      return Kr.current;
    },
    resetTransform: (a, l) => {
      a.style.transform = l !== void 0 ? l : "none";
    },
    checkIsScrollRoot: (a) => window.getComputedStyle(a).position === "fixed",
  }),
  Pc = X.createContext({
    transformPagePoint: (a) => a,
    isStatic: !1,
    reducedMotion: "never",
  });
function hp(a, l) {
  if (typeof a == "function") return a(l);
  a != null && (a.current = l);
}
function OA(...a) {
  return (l) => {
    let u = !1;
    const r = a.map((c) => {
      const d = hp(c, l);
      return (!u && typeof d == "function" && (u = !0), d);
    });
    if (u)
      return () => {
        for (let c = 0; c < r.length; c++) {
          const d = r[c];
          typeof d == "function" ? d() : hp(a[c], null);
        }
      };
  };
}
function RA(...a) {
  return X.useCallback(OA(...a), a);
}
class VA extends X.Component {
  getSnapshotBeforeUpdate(l) {
    const u = this.props.childRef.current;
    if (u && l.isPresent && !this.props.isPresent) {
      const r = u.offsetParent,
        c = (mc(r) && r.offsetWidth) || 0,
        d = (mc(r) && r.offsetHeight) || 0,
        h = this.props.sizeRef.current;
      ((h.height = u.offsetHeight || 0),
        (h.width = u.offsetWidth || 0),
        (h.top = u.offsetTop),
        (h.left = u.offsetLeft),
        (h.right = c - h.width - h.left),
        (h.bottom = d - h.height - h.top));
    }
    return null;
  }
  componentDidUpdate() {}
  render() {
    return this.props.children;
  }
}
function _A({ children: a, isPresent: l, anchorX: u, anchorY: r, root: c }) {
  const d = X.useId(),
    h = X.useRef(null),
    g = X.useRef({ width: 0, height: 0, top: 0, left: 0, right: 0, bottom: 0 }),
    { nonce: p } = X.useContext(Pc),
    y = a.props?.ref ?? a?.ref,
    v = RA(h, y);
  return (
    X.useInsertionEffect(() => {
      const {
        width: S,
        height: E,
        top: z,
        left: _,
        right: j,
        bottom: Y,
      } = g.current;
      if (l || !h.current || !S || !E) return;
      const H = u === "left" ? `left: ${_}` : `right: ${j}`,
        q = r === "bottom" ? `bottom: ${Y}` : `top: ${z}`;
      h.current.dataset.motionPopId = d;
      const L = document.createElement("style");
      p && (L.nonce = p);
      const W = c ?? document.head;
      return (
        W.appendChild(L),
        L.sheet &&
          L.sheet.insertRule(`
          [data-motion-pop-id="${d}"] {
            position: absolute !important;
            width: ${S}px !important;
            height: ${E}px !important;
            ${H}px !important;
            ${q}px !important;
          }
        `),
        () => {
          W.contains(L) && W.removeChild(L);
        }
      );
    }, [l]),
    Ht.jsx(VA, {
      isPresent: l,
      childRef: h,
      sizeRef: g,
      children: X.cloneElement(a, { ref: v }),
    })
  );
}
const UA = ({
  children: a,
  initial: l,
  isPresent: u,
  onExitComplete: r,
  custom: c,
  presenceAffectsLayout: d,
  mode: h,
  anchorX: g,
  anchorY: p,
  root: y,
}) => {
  const v = Ec(BA),
    S = X.useId();
  let E = !0,
    z = X.useMemo(
      () => (
        (E = !1),
        {
          id: S,
          initial: l,
          isPresent: u,
          custom: c,
          onExitComplete: (_) => {
            v.set(_, !0);
            for (const j of v.values()) if (!j) return;
            r && r();
          },
          register: (_) => (v.set(_, !1), () => v.delete(_)),
        }
      ),
      [u, v, r],
    );
  return (
    d && E && (z = { ...z }),
    X.useMemo(() => {
      v.forEach((_, j) => v.set(j, !1));
    }, [u]),
    X.useEffect(() => {
      !u && !v.size && r && r();
    }, [u]),
    h === "popLayout" &&
      (a = Ht.jsx(_A, {
        isPresent: u,
        anchorX: g,
        anchorY: p,
        root: y,
        children: a,
      })),
    Ht.jsx(su.Provider, { value: z, children: a })
  );
};
function BA() {
  return new Map();
}
function $g(a = !0) {
  const l = X.useContext(su);
  if (l === null) return [!0, null];
  const { isPresent: u, onExitComplete: r, register: c } = l,
    d = X.useId();
  X.useEffect(() => {
    if (a) return c(d);
  }, [a]);
  const h = X.useCallback(() => a && r && r(d), [d, r, a]);
  return !u && r ? [!1, h] : [!0];
}
const Js = (a) => a.key || "";
function dp(a) {
  const l = [];
  return (
    X.Children.forEach(a, (u) => {
      X.isValidElement(u) && l.push(u);
    }),
    l
  );
}
const NA = ({
    children: a,
    custom: l,
    initial: u = !0,
    onExitComplete: r,
    presenceAffectsLayout: c = !0,
    mode: d = "sync",
    propagate: h = !1,
    anchorX: g = "left",
    anchorY: p = "top",
    root: y,
  }) => {
    const [v, S] = $g(h),
      E = X.useMemo(() => dp(a), [a]),
      z = h && !v ? [] : E.map(Js),
      _ = X.useRef(!0),
      j = X.useRef(E),
      Y = Ec(() => new Map()),
      H = X.useRef(new Set()),
      [q, L] = X.useState(E),
      [W, P] = X.useState(E);
    Rp(() => {
      ((_.current = !1), (j.current = E));
      for (let K = 0; K < W.length; K++) {
        const it = Js(W[K]);
        z.includes(it)
          ? (Y.delete(it), H.current.delete(it))
          : Y.get(it) !== !0 && Y.set(it, !1);
      }
    }, [W, z.length, z.join("-")]);
    const et = [];
    if (E !== q) {
      let K = [...E];
      for (let it = 0; it < W.length; it++) {
        const xt = W[it],
          Bt = Js(xt);
        z.includes(Bt) || (K.splice(it, 0, xt), et.push(xt));
      }
      return (d === "wait" && et.length && (K = et), P(dp(K)), L(E), null);
    }
    const { forceRender: $ } = X.useContext(Ac);
    return Ht.jsx(Ht.Fragment, {
      children: W.map((K) => {
        const it = Js(K),
          xt = h && !v ? !1 : E === W || z.includes(it),
          Bt = () => {
            if (H.current.has(it)) return;
            if ((H.current.add(it), Y.has(it))) Y.set(it, !0);
            else return;
            let wt = !0;
            (Y.forEach((Ye) => {
              Ye || (wt = !1);
            }),
              wt && ($?.(), P(j.current), h && S?.(), r && r()));
          };
        return Ht.jsx(
          UA,
          {
            isPresent: xt,
            initial: !_.current || u ? void 0 : !1,
            custom: l,
            presenceAffectsLayout: c,
            mode: d,
            root: y,
            onExitComplete: xt ? void 0 : Bt,
            anchorX: g,
            anchorY: p,
            children: K,
          },
          it,
        );
      }),
    });
  },
  Ig = X.createContext({ strict: !1 }),
  mp = {
    animation: [
      "animate",
      "variants",
      "whileHover",
      "whileTap",
      "exit",
      "whileInView",
      "whileFocus",
      "whileDrag",
    ],
    exit: ["exit"],
    drag: ["drag", "dragControls"],
    focus: ["whileFocus"],
    hover: ["whileHover", "onHoverStart", "onHoverEnd"],
    tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
    pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
    inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
    layout: ["layout", "layoutId"],
  };
let yp = !1;
function jA() {
  if (yp) return;
  const a = {};
  for (const l in mp) a[l] = { isEnabled: (u) => mp[l].some((r) => !!u[r]) };
  (zg(a), (yp = !0));
}
function t0() {
  return (jA(), bb());
}
function LA(a) {
  const l = t0();
  for (const u in a) l[u] = { ...l[u], ...a[u] };
  zg(l);
}
const HA = new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport",
]);
function lu(a) {
  return (
    a.startsWith("while") ||
    (a.startsWith("drag") && a !== "draggable") ||
    a.startsWith("layout") ||
    a.startsWith("onTap") ||
    a.startsWith("onPan") ||
    a.startsWith("onLayout") ||
    HA.has(a)
  );
}
let e0 = (a) => !lu(a);
function wA(a) {
  typeof a == "function" && (e0 = (l) => (l.startsWith("on") ? !lu(l) : a(l)));
}
try {
  wA(require("@emotion/is-prop-valid").default);
} catch {}
function YA(a, l, u) {
  const r = {};
  for (const c in a)
    (c === "values" && typeof a.values == "object") ||
      ((e0(c) ||
        (u === !0 && lu(c)) ||
        (!l && !lu(c)) ||
        (a.draggable && c.startsWith("onDrag"))) &&
        (r[c] = a[c]));
  return r;
}
const ru = X.createContext({});
function qA(a, l) {
  if (ou(a)) {
    const { initial: u, animate: r } = a;
    return {
      initial: u === !1 || Sl(u) ? u : void 0,
      animate: Sl(r) ? r : void 0,
    };
  }
  return a.inherit !== !1 ? l : {};
}
function GA(a) {
  const { initial: l, animate: u } = qA(a, X.useContext(ru));
  return X.useMemo(() => ({ initial: l, animate: u }), [pp(l), pp(u)]);
}
function pp(a) {
  return Array.isArray(a) ? a.join(" ") : a;
}
const $c = () => ({ style: {}, transform: {}, transformOrigin: {}, vars: {} });
function n0(a, l, u) {
  for (const r in l) !ne(l[r]) && !Ng(r, u) && (a[r] = l[r]);
}
function XA({ transformTemplate: a }, l) {
  return X.useMemo(() => {
    const u = $c();
    return (kc(u, l, a), Object.assign({}, u.vars, u.style));
  }, [l]);
}
function QA(a, l) {
  const u = a.style || {},
    r = {};
  return (n0(r, u, a), Object.assign(r, XA(a, l)), r);
}
function ZA(a, l) {
  const u = {},
    r = QA(a, l);
  return (
    a.drag &&
      a.dragListener !== !1 &&
      ((u.draggable = !1),
      (r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none"),
      (r.touchAction =
        a.drag === !0 ? "none" : `pan-${a.drag === "x" ? "y" : "x"}`)),
    a.tabIndex === void 0 &&
      (a.onTap || a.onTapStart || a.whileTap) &&
      (u.tabIndex = 0),
    (u.style = r),
    u
  );
}
const i0 = () => ({ ...$c(), attrs: {} });
function KA(a, l, u, r) {
  const c = X.useMemo(() => {
    const d = i0();
    return (
      jg(d, l, Hg(r), a.transformTemplate, a.style),
      { ...d.attrs, style: { ...d.style } }
    );
  }, [l]);
  if (a.style) {
    const d = {};
    (n0(d, a.style, a), (c.style = { ...d, ...c.style }));
  }
  return c;
}
const JA = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view",
];
function Ic(a) {
  return typeof a != "string" || a.includes("-")
    ? !1
    : !!(JA.indexOf(a) > -1 || /[A-Z]/u.test(a));
}
function FA(a, l, u, { latestValues: r }, c, d = !1, h) {
  const p = ((h ?? Ic(a)) ? KA : ZA)(l, r, c, a),
    y = YA(l, typeof a == "string", d),
    v = a !== X.Fragment ? { ...y, ...p, ref: u } : {},
    { children: S } = l,
    E = X.useMemo(() => (ne(S) ? S.get() : S), [S]);
  return X.createElement(a, { ...v, children: E });
}
function kA({ scrapeMotionValuesFromProps: a, createRenderState: l }, u, r, c) {
  return { latestValues: WA(u, r, c, a), renderState: l() };
}
function WA(a, l, u, r) {
  const c = {},
    d = r(a, {});
  for (const E in d) c[E] = Ps(d[E]);
  let { initial: h, animate: g } = a;
  const p = ou(a),
    y = Cg(a);
  l &&
    y &&
    !p &&
    a.inherit !== !1 &&
    (h === void 0 && (h = l.initial), g === void 0 && (g = l.animate));
  let v = u ? u.initial === !1 : !1;
  v = v || h === !1;
  const S = v ? g : h;
  if (S && typeof S != "boolean" && !uu(S)) {
    const E = Array.isArray(S) ? S : [S];
    for (let z = 0; z < E.length; z++) {
      const _ = Gc(a, E[z]);
      if (_) {
        const { transitionEnd: j, transition: Y, ...H } = _;
        for (const q in H) {
          let L = H[q];
          if (Array.isArray(L)) {
            const W = v ? L.length - 1 : 0;
            L = L[W];
          }
          L !== null && (c[q] = L);
        }
        for (const q in j) c[q] = j[q];
      }
    }
  }
  return c;
}
const a0 = (a) => (l, u) => {
    const r = X.useContext(ru),
      c = X.useContext(su),
      d = () => kA(a, l, r, c);
    return u ? d() : Ec(d);
  },
  PA = a0({ scrapeMotionValuesFromProps: Wc, createRenderState: $c }),
  $A = a0({ scrapeMotionValuesFromProps: wg, createRenderState: i0 }),
  IA = Symbol.for("motionComponentSymbol");
function t2(a, l, u) {
  const r = X.useRef(u);
  X.useInsertionEffect(() => {
    r.current = u;
  });
  const c = X.useRef(null);
  return X.useCallback(
    (d) => {
      (d && a.onMount?.(d), l && (d ? l.mount(d) : l.unmount()));
      const h = r.current;
      if (typeof h == "function")
        if (d) {
          const g = h(d);
          typeof g == "function" && (c.current = g);
        } else c.current ? (c.current(), (c.current = null)) : h(d);
      else h && (h.current = d);
    },
    [l],
  );
}
const l0 = X.createContext({});
function fl(a) {
  return (
    a &&
    typeof a == "object" &&
    Object.prototype.hasOwnProperty.call(a, "current")
  );
}
function e2(a, l, u, r, c, d) {
  const { visualElement: h } = X.useContext(ru),
    g = X.useContext(Ig),
    p = X.useContext(su),
    y = X.useContext(Pc).reducedMotion,
    v = X.useRef(null);
  ((r = r || g.renderer),
    !v.current &&
      r &&
      (v.current = r(a, {
        visualState: l,
        parent: h,
        props: u,
        presenceContext: p,
        blockInitialAnimation: p ? p.initial === !1 : !1,
        reducedMotionConfig: y,
        isSVG: d,
      })));
  const S = v.current,
    E = X.useContext(l0);
  S &&
    !S.projection &&
    c &&
    (S.type === "html" || S.type === "svg") &&
    n2(v.current, u, c, E);
  const z = X.useRef(!1);
  X.useInsertionEffect(() => {
    S && z.current && S.update(u, p);
  });
  const _ = u[dg],
    j = X.useRef(
      !!_ &&
        !window.MotionHandoffIsComplete?.(_) &&
        window.MotionHasOptimisedAnimation?.(_),
    );
  return (
    Rp(() => {
      S &&
        ((z.current = !0),
        (window.MotionIsMounted = !0),
        S.updateFeatures(),
        S.scheduleRenderMicrotask(),
        j.current && S.animationState && S.animationState.animateChanges());
    }),
    X.useEffect(() => {
      S &&
        (!j.current && S.animationState && S.animationState.animateChanges(),
        j.current &&
          (queueMicrotask(() => {
            window.MotionHandoffMarkAsComplete?.(_);
          }),
          (j.current = !1)),
        (S.enteringChildren = void 0));
    }),
    S
  );
}
function n2(a, l, u, r) {
  const {
    layoutId: c,
    layout: d,
    drag: h,
    dragConstraints: g,
    layoutScroll: p,
    layoutRoot: y,
    layoutCrossfade: v,
  } = l;
  ((a.projection = new u(
    a.latestValues,
    l["data-framer-portal-id"] ? void 0 : s0(a.parent),
  )),
    a.projection.setOptions({
      layoutId: c,
      layout: d,
      alwaysMeasureLayout: !!h || (g && fl(g)),
      visualElement: a,
      animationType: typeof d == "string" ? d : "both",
      initialPromotionConfig: r,
      crossfade: v,
      layoutScroll: p,
      layoutRoot: y,
    }));
}
function s0(a) {
  if (a) return a.options.allowProjection !== !1 ? a.projection : s0(a.parent);
}
function Jr(a, { forwardMotionProps: l = !1, type: u } = {}, r, c) {
  r && LA(r);
  const d = u ? u === "svg" : Ic(a),
    h = d ? $A : PA;
  function g(y, v) {
    let S;
    const E = { ...X.useContext(Pc), ...y, layoutId: i2(y) },
      { isStatic: z } = E,
      _ = GA(y),
      j = h(y, z);
    if (!z && Op) {
      a2();
      const Y = l2(E);
      ((S = Y.MeasureLayout),
        (_.visualElement = e2(a, j, E, c, Y.ProjectionNode, d)));
    }
    return Ht.jsxs(ru.Provider, {
      value: _,
      children: [
        S && _.visualElement
          ? Ht.jsx(S, { visualElement: _.visualElement, ...E })
          : null,
        FA(a, y, t2(j, _.visualElement, v), j, z, l, d),
      ],
    });
  }
  g.displayName = `motion.${typeof a == "string" ? a : `create(${a.displayName ?? a.name ?? ""})`}`;
  const p = X.forwardRef(g);
  return ((p[IA] = a), p);
}
function i2({ layoutId: a }) {
  const l = X.useContext(Ac).id;
  return l && a !== void 0 ? l + "-" + a : a;
}
function a2(a, l) {
  X.useContext(Ig).strict;
}
function l2(a) {
  const l = t0(),
    { drag: u, layout: r } = l;
  if (!u && !r) return {};
  const c = { ...u, ...r };
  return {
    MeasureLayout:
      u?.isEnabled(a) || r?.isEnabled(a) ? c.MeasureLayout : void 0,
    ProjectionNode: c.ProjectionNode,
  };
}
function s2(a, l) {
  if (typeof Proxy > "u") return Jr;
  const u = new Map(),
    r = (d, h) => Jr(d, h, a, l),
    c = (d, h) => r(d, h);
  return new Proxy(c, {
    get: (d, h) =>
      h === "create"
        ? r
        : (u.has(h) || u.set(h, Jr(h, void 0, a, l)), u.get(h)),
  });
}
const u2 = (a, l) =>
  (l.isSVG ?? Ic(a))
    ? new Hb(l)
    : new _b(l, { allowProjection: a !== X.Fragment });
class o2 extends Fn {
  constructor(l) {
    (super(l), l.animationState || (l.animationState = Xb(l)));
  }
  updateAnimationControlsSubscription() {
    const { animate: l } = this.node.getProps();
    uu(l) && (this.unmountControls = l.subscribe(this.node));
  }
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: l } = this.node.getProps(),
      { animate: u } = this.node.prevProps || {};
    l !== u && this.updateAnimationControlsSubscription();
  }
  unmount() {
    (this.node.animationState.reset(), this.unmountControls?.());
  }
}
let r2 = 0;
class c2 extends Fn {
  constructor() {
    (super(...arguments), (this.id = r2++));
  }
  update() {
    if (!this.node.presenceContext) return;
    const { isPresent: l, onExitComplete: u } = this.node.presenceContext,
      { isPresent: r } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || l === r) return;
    const c = this.node.animationState.setActive("exit", !l);
    u &&
      !l &&
      c.then(() => {
        u(this.id);
      });
  }
  mount() {
    const { register: l, onExitComplete: u } = this.node.presenceContext || {};
    (u && u(this.id), l && (this.unmount = l(this.id)));
  }
  unmount() {}
}
const f2 = { animation: { Feature: o2 }, exit: { Feature: c2 } };
function Ml(a) {
  return { point: { x: a.pageX, y: a.pageY } };
}
const h2 = (a) => (l) => Kc(l) && a(l, Ml(l));
function yl(a, l, u, r) {
  return Tl(a, l, h2(u), r);
}
const u0 = ({ current: a }) => (a ? a.ownerDocument.defaultView : null),
  gp = (a, l) => Math.abs(a - l);
function d2(a, l) {
  const u = gp(a.x, l.x),
    r = gp(a.y, l.y);
  return Math.sqrt(u ** 2 + r ** 2);
}
const vp = new Set(["auto", "scroll"]);
class o0 {
  constructor(
    l,
    u,
    {
      transformPagePoint: r,
      contextWindow: c = window,
      dragSnapToOrigin: d = !1,
      distanceThreshold: h = 3,
      element: g,
    } = {},
  ) {
    if (
      ((this.startEvent = null),
      (this.lastMoveEvent = null),
      (this.lastMoveEventInfo = null),
      (this.handlers = {}),
      (this.contextWindow = window),
      (this.scrollPositions = new Map()),
      (this.removeScrollListeners = null),
      (this.onElementScroll = (z) => {
        this.handleScroll(z.target);
      }),
      (this.onWindowScroll = () => {
        this.handleScroll(window);
      }),
      (this.updatePoint = () => {
        if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
        const z = kr(this.lastMoveEventInfo, this.history),
          _ = this.startEvent !== null,
          j = d2(z.offset, { x: 0, y: 0 }) >= this.distanceThreshold;
        if (!_ && !j) return;
        const { point: Y } = z,
          { timestamp: H } = te;
        this.history.push({ ...Y, timestamp: H });
        const { onStart: q, onMove: L } = this.handlers;
        (_ ||
          (q && q(this.lastMoveEvent, z),
          (this.startEvent = this.lastMoveEvent)),
          L && L(this.lastMoveEvent, z));
      }),
      (this.handlePointerMove = (z, _) => {
        ((this.lastMoveEvent = z),
          (this.lastMoveEventInfo = Fr(_, this.transformPagePoint)),
          zt.update(this.updatePoint, !0));
      }),
      (this.handlePointerUp = (z, _) => {
        this.end();
        const { onEnd: j, onSessionEnd: Y, resumeAnimation: H } = this.handlers;
        if (
          ((this.dragSnapToOrigin || !this.startEvent) && H && H(),
          !(this.lastMoveEvent && this.lastMoveEventInfo))
        )
          return;
        const q = kr(
          z.type === "pointercancel"
            ? this.lastMoveEventInfo
            : Fr(_, this.transformPagePoint),
          this.history,
        );
        (this.startEvent && j && j(z, q), Y && Y(z, q));
      }),
      !Kc(l))
    )
      return;
    ((this.dragSnapToOrigin = d),
      (this.handlers = u),
      (this.transformPagePoint = r),
      (this.distanceThreshold = h),
      (this.contextWindow = c || window));
    const p = Ml(l),
      y = Fr(p, this.transformPagePoint),
      { point: v } = y,
      { timestamp: S } = te;
    this.history = [{ ...v, timestamp: S }];
    const { onSessionStart: E } = u;
    (E && E(l, kr(y, this.history)),
      (this.removeListeners = bl(
        yl(this.contextWindow, "pointermove", this.handlePointerMove),
        yl(this.contextWindow, "pointerup", this.handlePointerUp),
        yl(this.contextWindow, "pointercancel", this.handlePointerUp),
      )),
      g && this.startScrollTracking(g));
  }
  startScrollTracking(l) {
    let u = l.parentElement;
    for (; u; ) {
      const r = getComputedStyle(u);
      ((vp.has(r.overflowX) || vp.has(r.overflowY)) &&
        this.scrollPositions.set(u, { x: u.scrollLeft, y: u.scrollTop }),
        (u = u.parentElement));
    }
    (this.scrollPositions.set(window, { x: window.scrollX, y: window.scrollY }),
      window.addEventListener("scroll", this.onElementScroll, {
        capture: !0,
        passive: !0,
      }),
      window.addEventListener("scroll", this.onWindowScroll, { passive: !0 }),
      (this.removeScrollListeners = () => {
        (window.removeEventListener("scroll", this.onElementScroll, {
          capture: !0,
        }),
          window.removeEventListener("scroll", this.onWindowScroll));
      }));
  }
  handleScroll(l) {
    const u = this.scrollPositions.get(l);
    if (!u) return;
    const r = l === window,
      c = r
        ? { x: window.scrollX, y: window.scrollY }
        : { x: l.scrollLeft, y: l.scrollTop },
      d = { x: c.x - u.x, y: c.y - u.y };
    (d.x === 0 && d.y === 0) ||
      (r
        ? this.lastMoveEventInfo &&
          ((this.lastMoveEventInfo.point.x += d.x),
          (this.lastMoveEventInfo.point.y += d.y))
        : this.history.length > 0 &&
          ((this.history[0].x -= d.x), (this.history[0].y -= d.y)),
      this.scrollPositions.set(l, c),
      zt.update(this.updatePoint, !0));
  }
  updateHandlers(l) {
    this.handlers = l;
  }
  end() {
    (this.removeListeners && this.removeListeners(),
      this.removeScrollListeners && this.removeScrollListeners(),
      this.scrollPositions.clear(),
      Kn(this.updatePoint));
  }
}
function Fr(a, l) {
  return l ? { point: l(a.point) } : a;
}
function Sp(a, l) {
  return { x: a.x - l.x, y: a.y - l.y };
}
function kr({ point: a }, l) {
  return {
    point: a,
    delta: Sp(a, r0(l)),
    offset: Sp(a, m2(l)),
    velocity: y2(l, 0.1),
  };
}
function m2(a) {
  return a[0];
}
function r0(a) {
  return a[a.length - 1];
}
function y2(a, l) {
  if (a.length < 2) return { x: 0, y: 0 };
  let u = a.length - 1,
    r = null;
  const c = r0(a);
  for (; u >= 0 && ((r = a[u]), !(c.timestamp - r.timestamp > gn(l))); ) u--;
  if (!r) return { x: 0, y: 0 };
  const d = He(c.timestamp - r.timestamp);
  if (d === 0) return { x: 0, y: 0 };
  const h = { x: (c.x - r.x) / d, y: (c.y - r.y) / d };
  return (h.x === 1 / 0 && (h.x = 0), h.y === 1 / 0 && (h.y = 0), h);
}
function p2(a, { min: l, max: u }, r) {
  return (
    l !== void 0 && a < l
      ? (a = r ? Rt(l, a, r.min) : Math.max(a, l))
      : u !== void 0 && a > u && (a = r ? Rt(u, a, r.max) : Math.min(a, u)),
    a
  );
}
function Tp(a, l, u) {
  return {
    min: l !== void 0 ? a.min + l : void 0,
    max: u !== void 0 ? a.max + u - (a.max - a.min) : void 0,
  };
}
function g2(a, { top: l, left: u, bottom: r, right: c }) {
  return { x: Tp(a.x, u, c), y: Tp(a.y, l, r) };
}
function bp(a, l) {
  let u = l.min - a.min,
    r = l.max - a.max;
  return (
    l.max - l.min < a.max - a.min && ([u, r] = [r, u]),
    { min: u, max: r }
  );
}
function v2(a, l) {
  return { x: bp(a.x, l.x), y: bp(a.y, l.y) };
}
function S2(a, l) {
  let u = 0.5;
  const r = se(a),
    c = se(l);
  return (
    c > r
      ? (u = pl(l.min, l.max - r, a.min))
      : r > c && (u = pl(a.min, a.max - c, l.min)),
    Pe(0, 1, u)
  );
}
function T2(a, l) {
  const u = {};
  return (
    l.min !== void 0 && (u.min = l.min - a.min),
    l.max !== void 0 && (u.max = l.max - a.min),
    u
  );
}
const Sc = 0.35;
function b2(a = Sc) {
  return (
    a === !1 ? (a = 0) : a === !0 && (a = Sc),
    { x: Ap(a, "left", "right"), y: Ap(a, "top", "bottom") }
  );
}
function Ap(a, l, u) {
  return { min: Ep(a, l), max: Ep(a, u) };
}
function Ep(a, l) {
  return typeof a == "number" ? a : a[l] || 0;
}
const A2 = new WeakMap();
class E2 {
  constructor(l) {
    ((this.openDragLock = null),
      (this.isDragging = !1),
      (this.currentDirection = null),
      (this.originPoint = { x: 0, y: 0 }),
      (this.constraints = !1),
      (this.hasMutatedConstraints = !1),
      (this.elastic = Kt()),
      (this.latestPointerEvent = null),
      (this.latestPanInfo = null),
      (this.visualElement = l));
  }
  start(l, { snapToCursor: u = !1, distanceThreshold: r } = {}) {
    const { presenceContext: c } = this.visualElement;
    if (c && c.isPresent === !1) return;
    const d = (S) => {
        u
          ? (this.stopAnimation(), this.snapToCursor(Ml(S).point))
          : this.pauseAnimation();
      },
      h = (S, E) => {
        this.stopAnimation();
        const { drag: z, dragPropagation: _, onDragStart: j } = this.getProps();
        if (
          z &&
          !_ &&
          (this.openDragLock && this.openDragLock(),
          (this.openDragLock = rb(z)),
          !this.openDragLock)
        )
          return;
        ((this.latestPointerEvent = S),
          (this.latestPanInfo = E),
          (this.isDragging = !0),
          (this.currentDirection = null),
          this.resolveConstraints(),
          this.visualElement.projection &&
            ((this.visualElement.projection.isAnimationBlocked = !0),
            (this.visualElement.projection.target = void 0)),
          Le((H) => {
            let q = this.getAxisMotionValue(H).get() || 0;
            if (We.test(q)) {
              const { projection: L } = this.visualElement;
              if (L && L.layout) {
                const W = L.layout.layoutBox[H];
                W && (q = se(W) * (parseFloat(q) / 100));
              }
            }
            this.originPoint[H] = q;
          }),
          j && zt.postRender(() => j(S, E)),
          fc(this.visualElement, "transform"));
        const { animationState: Y } = this.visualElement;
        Y && Y.setActive("whileDrag", !0);
      },
      g = (S, E) => {
        ((this.latestPointerEvent = S), (this.latestPanInfo = E));
        const {
          dragPropagation: z,
          dragDirectionLock: _,
          onDirectionLock: j,
          onDrag: Y,
        } = this.getProps();
        if (!z && !this.openDragLock) return;
        const { offset: H } = E;
        if (_ && this.currentDirection === null) {
          ((this.currentDirection = M2(H)),
            this.currentDirection !== null && j && j(this.currentDirection));
          return;
        }
        (this.updateAxis("x", E.point, H),
          this.updateAxis("y", E.point, H),
          this.visualElement.render(),
          Y && Y(S, E));
      },
      p = (S, E) => {
        ((this.latestPointerEvent = S),
          (this.latestPanInfo = E),
          this.stop(S, E),
          (this.latestPointerEvent = null),
          (this.latestPanInfo = null));
      },
      y = () =>
        Le(
          (S) =>
            this.getAnimationState(S) === "paused" &&
            this.getAxisMotionValue(S).animation?.play(),
        ),
      { dragSnapToOrigin: v } = this.getProps();
    this.panSession = new o0(
      l,
      {
        onSessionStart: d,
        onStart: h,
        onMove: g,
        onSessionEnd: p,
        resumeAnimation: y,
      },
      {
        transformPagePoint: this.visualElement.getTransformPagePoint(),
        dragSnapToOrigin: v,
        distanceThreshold: r,
        contextWindow: u0(this.visualElement),
        element: this.visualElement.current,
      },
    );
  }
  stop(l, u) {
    const r = l || this.latestPointerEvent,
      c = u || this.latestPanInfo,
      d = this.isDragging;
    if ((this.cancel(), !d || !c || !r)) return;
    const { velocity: h } = c;
    this.startAnimation(h);
    const { onDragEnd: g } = this.getProps();
    g && zt.postRender(() => g(r, c));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: l, animationState: u } = this.visualElement;
    (l && (l.isAnimationBlocked = !1), this.endPanSession());
    const { dragPropagation: r } = this.getProps();
    (!r &&
      this.openDragLock &&
      (this.openDragLock(), (this.openDragLock = null)),
      u && u.setActive("whileDrag", !1));
  }
  endPanSession() {
    (this.panSession && this.panSession.end(), (this.panSession = void 0));
  }
  updateAxis(l, u, r) {
    const { drag: c } = this.getProps();
    if (!r || !Fs(l, c, this.currentDirection)) return;
    const d = this.getAxisMotionValue(l);
    let h = this.originPoint[l] + r[l];
    (this.constraints &&
      this.constraints[l] &&
      (h = p2(h, this.constraints[l], this.elastic[l])),
      d.set(h));
  }
  resolveConstraints() {
    const { dragConstraints: l, dragElastic: u } = this.getProps(),
      r =
        this.visualElement.projection && !this.visualElement.projection.layout
          ? this.visualElement.projection.measure(!1)
          : this.visualElement.projection?.layout,
      c = this.constraints;
    (l && fl(l)
      ? this.constraints || (this.constraints = this.resolveRefConstraints())
      : l && r
        ? (this.constraints = g2(r.layoutBox, l))
        : (this.constraints = !1),
      (this.elastic = b2(u)),
      c !== this.constraints &&
        r &&
        this.constraints &&
        !this.hasMutatedConstraints &&
        Le((d) => {
          this.constraints !== !1 &&
            this.getAxisMotionValue(d) &&
            (this.constraints[d] = T2(r.layoutBox[d], this.constraints[d]));
        }));
  }
  resolveRefConstraints() {
    const { dragConstraints: l, onMeasureDragConstraints: u } = this.getProps();
    if (!l || !fl(l)) return !1;
    const r = l.current,
      { projection: c } = this.visualElement;
    if (!c || !c.layout) return !1;
    const d = Db(r, c.root, this.visualElement.getTransformPagePoint());
    let h = v2(c.layout.layoutBox, d);
    if (u) {
      const g = u(Eb(h));
      ((this.hasMutatedConstraints = !!g), g && (h = Rg(g)));
    }
    return h;
  }
  startAnimation(l) {
    const {
        drag: u,
        dragMomentum: r,
        dragElastic: c,
        dragTransition: d,
        dragSnapToOrigin: h,
        onDragTransitionEnd: g,
      } = this.getProps(),
      p = this.constraints || {},
      y = Le((v) => {
        if (!Fs(v, u, this.currentDirection)) return;
        let S = (p && p[v]) || {};
        h && (S = { min: 0, max: 0 });
        const E = c ? 200 : 1e6,
          z = c ? 40 : 1e7,
          _ = {
            type: "inertia",
            velocity: r ? l[v] : 0,
            bounceStiffness: E,
            bounceDamping: z,
            timeConstant: 750,
            restDelta: 1,
            restSpeed: 10,
            ...d,
            ...S,
          };
        return this.startAxisValueAnimation(v, _);
      });
    return Promise.all(y).then(g);
  }
  startAxisValueAnimation(l, u) {
    const r = this.getAxisMotionValue(l);
    return (
      fc(this.visualElement, l),
      r.start(qc(l, r, 0, u, this.visualElement, !1))
    );
  }
  stopAnimation() {
    Le((l) => this.getAxisMotionValue(l).stop());
  }
  pauseAnimation() {
    Le((l) => this.getAxisMotionValue(l).animation?.pause());
  }
  getAnimationState(l) {
    return this.getAxisMotionValue(l).animation?.state;
  }
  getAxisMotionValue(l) {
    const u = `_drag${l.toUpperCase()}`,
      r = this.visualElement.getProps(),
      c = r[u];
    return (
      c ||
      this.visualElement.getValue(l, (r.initial ? r.initial[l] : void 0) || 0)
    );
  }
  snapToCursor(l) {
    Le((u) => {
      const { drag: r } = this.getProps();
      if (!Fs(u, r, this.currentDirection)) return;
      const { projection: c } = this.visualElement,
        d = this.getAxisMotionValue(u);
      if (c && c.layout) {
        const { min: h, max: g } = c.layout.layoutBox[u],
          p = d.get() || 0;
        d.set(l[u] - Rt(h, g, 0.5) + p);
      }
    });
  }
  scalePositionWithinConstraints() {
    if (!this.visualElement.current) return;
    const { drag: l, dragConstraints: u } = this.getProps(),
      { projection: r } = this.visualElement;
    if (!fl(u) || !r || !this.constraints) return;
    this.stopAnimation();
    const c = { x: 0, y: 0 };
    Le((h) => {
      const g = this.getAxisMotionValue(h);
      if (g && this.constraints !== !1) {
        const p = g.get();
        c[h] = S2({ min: p, max: p }, this.constraints[h]);
      }
    });
    const { transformTemplate: d } = this.visualElement.getProps();
    ((this.visualElement.current.style.transform = d ? d({}, "") : "none"),
      r.root && r.root.updateScroll(),
      r.updateLayout(),
      this.resolveConstraints(),
      Le((h) => {
        if (!Fs(h, l, null)) return;
        const g = this.getAxisMotionValue(h),
          { min: p, max: y } = this.constraints[h];
        g.set(Rt(p, y, c[h]));
      }));
  }
  addListeners() {
    if (!this.visualElement.current) return;
    A2.set(this.visualElement, this);
    const l = this.visualElement.current,
      u = yl(l, "pointerdown", (p) => {
        const { drag: y, dragListener: v = !0 } = this.getProps(),
          S = p.target,
          E = S !== l && Mg(S);
        y && v && !E && this.start(p);
      }),
      r = () => {
        const { dragConstraints: p } = this.getProps();
        fl(p) && p.current && (this.constraints = this.resolveRefConstraints());
      },
      { projection: c } = this.visualElement,
      d = c.addEventListener("measure", r);
    (c && !c.layout && (c.root && c.root.updateScroll(), c.updateLayout()),
      zt.read(r));
    const h = Tl(window, "resize", () => this.scalePositionWithinConstraints()),
      g = c.addEventListener(
        "didUpdate",
        ({ delta: p, hasLayoutChanged: y }) => {
          this.isDragging &&
            y &&
            (Le((v) => {
              const S = this.getAxisMotionValue(v);
              S &&
                ((this.originPoint[v] += p[v].translate),
                S.set(S.get() + p[v].translate));
            }),
            this.visualElement.render());
        },
      );
    return () => {
      (h(), u(), d(), g && g());
    };
  }
  getProps() {
    const l = this.visualElement.getProps(),
      {
        drag: u = !1,
        dragDirectionLock: r = !1,
        dragPropagation: c = !1,
        dragConstraints: d = !1,
        dragElastic: h = Sc,
        dragMomentum: g = !0,
      } = l;
    return {
      ...l,
      drag: u,
      dragDirectionLock: r,
      dragPropagation: c,
      dragConstraints: d,
      dragElastic: h,
      dragMomentum: g,
    };
  }
}
function Fs(a, l, u) {
  return (l === !0 || l === a) && (u === null || u === a);
}
function M2(a, l = 10) {
  let u = null;
  return (Math.abs(a.y) > l ? (u = "y") : Math.abs(a.x) > l && (u = "x"), u);
}
class x2 extends Fn {
  constructor(l) {
    (super(l),
      (this.removeGroupControls = we),
      (this.removeListeners = we),
      (this.controls = new E2(l)));
  }
  mount() {
    const { dragControls: l } = this.node.getProps();
    (l && (this.removeGroupControls = l.subscribe(this.controls)),
      (this.removeListeners = this.controls.addListeners() || we));
  }
  update() {
    const { dragControls: l } = this.node.getProps(),
      { dragControls: u } = this.node.prevProps || {};
    l !== u &&
      (this.removeGroupControls(),
      l && (this.removeGroupControls = l.subscribe(this.controls)));
  }
  unmount() {
    (this.removeGroupControls(),
      this.removeListeners(),
      this.controls.endPanSession());
  }
}
const Mp = (a) => (l, u) => {
  a && zt.postRender(() => a(l, u));
};
class D2 extends Fn {
  constructor() {
    (super(...arguments), (this.removePointerDownListener = we));
  }
  onPointerDown(l) {
    this.session = new o0(l, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: u0(this.node),
    });
  }
  createPanHandlers() {
    const {
      onPanSessionStart: l,
      onPanStart: u,
      onPan: r,
      onPanEnd: c,
    } = this.node.getProps();
    return {
      onSessionStart: Mp(l),
      onStart: Mp(u),
      onMove: r,
      onEnd: (d, h) => {
        (delete this.session, c && zt.postRender(() => c(d, h)));
      },
    };
  }
  mount() {
    this.removePointerDownListener = yl(this.node.current, "pointerdown", (l) =>
      this.onPointerDown(l),
    );
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    (this.removePointerDownListener(), this.session && this.session.end());
  }
}
let Wr = !1;
class C2 extends X.Component {
  componentDidMount() {
    const {
        visualElement: l,
        layoutGroup: u,
        switchLayoutGroup: r,
        layoutId: c,
      } = this.props,
      { projection: d } = l;
    (d &&
      (u.group && u.group.add(d),
      r && r.register && c && r.register(d),
      Wr && d.root.didUpdate(),
      d.addEventListener("animationComplete", () => {
        this.safeToRemove();
      }),
      d.setOptions({
        ...d.options,
        onExitComplete: () => this.safeToRemove(),
      })),
      ($s.hasEverUpdated = !0));
  }
  getSnapshotBeforeUpdate(l) {
    const {
        layoutDependency: u,
        visualElement: r,
        drag: c,
        isPresent: d,
      } = this.props,
      { projection: h } = r;
    return (
      h &&
        ((h.isPresent = d),
        (Wr = !0),
        c || l.layoutDependency !== u || u === void 0 || l.isPresent !== d
          ? h.willUpdate()
          : this.safeToRemove(),
        l.isPresent !== d &&
          (d
            ? h.promote()
            : h.relegate() ||
              zt.postRender(() => {
                const g = h.getStack();
                (!g || !g.members.length) && this.safeToRemove();
              }))),
      null
    );
  }
  componentDidUpdate() {
    const { projection: l } = this.props.visualElement;
    l &&
      (l.root.didUpdate(),
      Zc.postRender(() => {
        !l.currentAnimation && l.isLead() && this.safeToRemove();
      }));
  }
  componentWillUnmount() {
    const {
        visualElement: l,
        layoutGroup: u,
        switchLayoutGroup: r,
      } = this.props,
      { projection: c } = l;
    ((Wr = !0),
      c &&
        (c.scheduleCheckAfterUnmount(),
        u && u.group && u.group.remove(c),
        r && r.deregister && r.deregister(c)));
  }
  safeToRemove() {
    const { safeToRemove: l } = this.props;
    l && l();
  }
  render() {
    return null;
  }
}
function c0(a) {
  const [l, u] = $g(),
    r = X.useContext(Ac);
  return Ht.jsx(C2, {
    ...a,
    layoutGroup: r,
    switchLayoutGroup: X.useContext(l0),
    isPresent: l,
    safeToRemove: u,
  });
}
const z2 = {
  pan: { Feature: D2 },
  drag: { Feature: x2, ProjectionNode: Pg, MeasureLayout: c0 },
};
function xp(a, l, u) {
  const { props: r } = a;
  a.animationState &&
    r.whileHover &&
    a.animationState.setActive("whileHover", u === "Start");
  const c = "onHover" + u,
    d = r[c];
  d && zt.postRender(() => d(l, Ml(l)));
}
class O2 extends Fn {
  mount() {
    const { current: l } = this.node;
    l &&
      (this.unmount = cb(
        l,
        (u, r) => (xp(this.node, r, "Start"), (c) => xp(this.node, c, "End")),
      ));
  }
  unmount() {}
}
class R2 extends Fn {
  constructor() {
    (super(...arguments), (this.isActive = !1));
  }
  onFocus() {
    let l = !1;
    try {
      l = this.node.current.matches(":focus-visible");
    } catch {
      l = !0;
    }
    !l ||
      !this.node.animationState ||
      (this.node.animationState.setActive("whileFocus", !0),
      (this.isActive = !0));
  }
  onBlur() {
    !this.isActive ||
      !this.node.animationState ||
      (this.node.animationState.setActive("whileFocus", !1),
      (this.isActive = !1));
  }
  mount() {
    this.unmount = bl(
      Tl(this.node.current, "focus", () => this.onFocus()),
      Tl(this.node.current, "blur", () => this.onBlur()),
    );
  }
  unmount() {}
}
function Dp(a, l, u) {
  const { props: r } = a;
  if (a.current instanceof HTMLButtonElement && a.current.disabled) return;
  a.animationState &&
    r.whileTap &&
    a.animationState.setActive("whileTap", u === "Start");
  const c = "onTap" + (u === "End" ? "" : u),
    d = r[c];
  d && zt.postRender(() => d(l, Ml(l)));
}
class V2 extends Fn {
  mount() {
    const { current: l } = this.node;
    l &&
      (this.unmount = db(
        l,
        (u, r) => (
          Dp(this.node, r, "Start"),
          (c, { success: d }) => Dp(this.node, c, d ? "End" : "Cancel")
        ),
        { useGlobalTarget: this.node.props.globalTapTarget },
      ));
  }
  unmount() {}
}
const Tc = new WeakMap(),
  Pr = new WeakMap(),
  _2 = (a) => {
    const l = Tc.get(a.target);
    l && l(a);
  },
  U2 = (a) => {
    a.forEach(_2);
  };
function B2({ root: a, ...l }) {
  const u = a || document;
  Pr.has(u) || Pr.set(u, {});
  const r = Pr.get(u),
    c = JSON.stringify(l);
  return (
    r[c] || (r[c] = new IntersectionObserver(U2, { root: a, ...l })),
    r[c]
  );
}
function N2(a, l, u) {
  const r = B2(l);
  return (
    Tc.set(a, u),
    r.observe(a),
    () => {
      (Tc.delete(a), r.unobserve(a));
    }
  );
}
const j2 = { some: 0, all: 1 };
class L2 extends Fn {
  constructor() {
    (super(...arguments), (this.hasEnteredView = !1), (this.isInView = !1));
  }
  startObserver() {
    this.unmount();
    const { viewport: l = {} } = this.node.getProps(),
      { root: u, margin: r, amount: c = "some", once: d } = l,
      h = {
        root: u ? u.current : void 0,
        rootMargin: r,
        threshold: typeof c == "number" ? c : j2[c],
      },
      g = (p) => {
        const { isIntersecting: y } = p;
        if (
          this.isInView === y ||
          ((this.isInView = y), d && !y && this.hasEnteredView)
        )
          return;
        (y && (this.hasEnteredView = !0),
          this.node.animationState &&
            this.node.animationState.setActive("whileInView", y));
        const { onViewportEnter: v, onViewportLeave: S } = this.node.getProps(),
          E = y ? v : S;
        E && E(p);
      };
    return N2(this.node.current, h, g);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u") return;
    const { props: l, prevProps: u } = this.node;
    ["amount", "margin", "root"].some(H2(l, u)) && this.startObserver();
  }
  unmount() {}
}
function H2({ viewport: a = {} }, { viewport: l = {} } = {}) {
  return (u) => a[u] !== l[u];
}
const w2 = {
    inView: { Feature: L2 },
    tap: { Feature: V2 },
    focus: { Feature: R2 },
    hover: { Feature: O2 },
  },
  Y2 = { layout: { ProjectionNode: Pg, MeasureLayout: c0 } },
  q2 = { ...f2, ...w2, ...z2, ...Y2 },
  f0 = s2(q2, u2),
  G2 = ({ item: a, index: l, activeIndex: u, onClick: r }) => {
    const c = l - u,
      d = Math.abs(c),
      h = c === 0;
    return Ht.jsx(f0.div, {
      onClick: r,
      style: {
        position: "absolute",
        width: "280px",
        height: "380px",
        zIndex: 100 - d,
      },
      animate: {
        x: c * 70 + "%",
        scale: 1 - d * 0.15,
        opacity: 1 - d * 0.4,
        rotateY: c * -10,
      },
      transition: { type: "spring", stiffness: 200, damping: 25 },
      children: Ht.jsx("div", {
        style: {
          width: "100%",
          height: "100%",
          background: "#fff",
          border: h ? "1px solid #000" : "1px solid #eee",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        },
        children: Ht.jsx("img", {
          src: a.imageUrl,
          alt: a.title,
          style: { width: "90%", height: "90%", objectFit: "contain" },
        }),
      }),
    });
  },
  X2 = ({ itemsJson: a }) => {
    const l = X.useMemo(() => {
        try {
          return JSON.parse(a);
        } catch {
          return [];
        }
      }, [a]),
      [u, r] = X.useState(0);
    return Ht.jsxs("div", {
      style: {
        width: "100%",
        padding: "40px 0",
        background: "#f2f2f2",
        fontFamily: "Helvetica, Arial, sans-serif",
      },
      children: [
        Ht.jsx("div", {
          style: {
            position: "relative",
            height: "450px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
          },
          children: Ht.jsx("div", {
            style: { position: "relative", width: "280px", height: "380px" },
            children: Ht.jsx(NA, {
              children: l.map((c, d) =>
                Ht.jsx(
                  G2,
                  { item: c, index: d, activeIndex: u, onClick: () => r(d) },
                  d,
                ),
              ),
            }),
          }),
        }),
        Ht.jsx("div", {
          style: {
            textAlign: "center",
            marginTop: "30px",
            maxWidth: "400px",
            margin: "30px auto",
          },
          children: Ht.jsxs(
            f0.div,
            {
              initial: { opacity: 0, y: 10 },
              animate: { opacity: 1, y: 0 },
              transition: { duration: 0.4 },
              children: [
                Ht.jsx("h3", {
                  style: {
                    fontSize: "16px",
                    textTransform: "uppercase",
                    margin: "0 0 10px",
                  },
                  children: l[u]?.title,
                }),
                Ht.jsx("p", {
                  style: { fontSize: "14px", color: "#666", lineHeight: "1.5" },
                  children: l[u]?.description,
                }),
              ],
            },
            u,
          ),
        }),
      ],
    });
  },
  Q2 = lS(X2, { props: { itemsJson: "string" } });
customElements.get("tech-carousel") ||
  customElements.define("tech-carousel", Q2);
